import { getImgUrl } from "../Utility/Utility";

// start live shows
// export const ShowsPostsData = [

// 	{
// 		id:1,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Tom Jones \n Tel Aviv ",
//         smltitle: "The one and only Tom Jones returns to Tel Aviv for one live performance",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											28.06.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.tomjones.com/">
// 												www.tomjones.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/1/1.jpg"} class="img-responsive" />
// 						</div>

// 						<p>
// 							At the request of the audience and after the success of his sold-out show in 2013, the legendary performer Tom Jones returns to Israel for one live performance, to be held in Tel Aviv on Wednesday, June 28, 2017.
// 						</p>

// 						<p>
// 							Tom Jones, a world-famous living legend, is known for not allowing the diverse audience that fills his halls to sit quietly for a moment. He is a performer who captures the hearts of men and women of all ages, crosses generations and genres with his infinite inherent talent and his powerful and unique voice.
// 						</p>
// 						<p>
// 							Tom Jones has had an amazing stage career and sold over 100 million records. He has been awarded many titles including the Brit Awards for his immense musical contribution and Lifetime Achievement Award for his many achievements in the world of music and live performances at the Silver Clef (annual British Music Awards). For his contribution to the music industry, he won a star on the Hollywood Walk of Fame. In 1999, Tom Jones was awarded the Order of the British Empire (OBE) and in 2006 His Royal Highness Queen Elizabeth gave him the title of nobility and he became Sir Tom Jones.
// 						</p>

// 						<p>
// 							Jones, recognized across the world as a "hit machine", will be hitting the 24/7 city this June for the second time. As he did in his last sold out show in Tel Aviv to the delight of his audience, will be performing his all-time greatest hits.
// 						</p>
// 						`
// 			}
// 		}

//     },

//     {

//       id:2,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Britney Spears \n  Live in Concert",
//         smltitle: "Britney Spears- performing all her greatest hits in the fabulous city of Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											03.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.britneyspears.com">
// 												www.britneyspears.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/2/1.jpg"} class="img-responsive" />
// 						</div>

// 						<p>
// 							Pop Icon Britney Spears is coming to Tel Aviv for the first time ever, for one show only, as part of her international tour of Asia. The show will take place in stunning Ha’Yarkon Park in central Tel Aviv and will include the Pop Princesses’ greatest hits.
// 						</p>

// 						<p>
// 							Pop Icon Britney Spears will be coming to Israel for the first time ever for one show only as part of her international tour of Asia. The show will take place in Ha’Yarkon Park in central Tel Aviv and will include the Pop Princesses’ greatest hits.
// 						</p>
// 						<p>
// 							Multi-platinum, Grammy Award-winning pop icon Britney Spears was born in Mississippi and raised in Louisiana, Spears became a household name as a teenager when she released her first single “…Baby One More Time,” a Billboard Hot 100 No. 1 smash and international hit that broke sales records with more than 20 million copies sold worldwide and is currently 14x Platinum in the U.S.
// 						</p>

// 						<p>
// 							Spears is one of the most successful and celebrated entertainers in pop history with nearly 150 million records worldwide. In the U.S. alone, she has sold more than 70 million albums, singles and songs, according to Nielsen Music.
// 						</p>

// 						<p>
// 							Britney’s live concerts are renowned for their amazing production and nonstop energy. Her first ever show in Tel Aviv is likely to feature some of her most recent songs from her Glory Album, including massive 2016 hit ‘Slumber Party’, and also some of her massive all-time hits such as ‘Baby One More Time’ and ‘Oops I Did It Again’!
// 						</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:3,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Tears for Fears",
//         smltitle: "Tear for Fears in Tel Aviv for the first time ever!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											05.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.tearsforfears.com">
// 												www.tearsforfears.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 						<p>
// 							This summer, the trendy city of Tel Aviv is embracing it’s 80s vibe for one performance only by the incomparable Tears for Fears. The legendary British pop/rock band that is responsible for many unforgettable hits is coming to the rocking city of Tel Aviv for a single awesome performance!
// 						</p>

// 						<p>
// 							Originally from Bath, Avon, Tears for Fears was founded in 1981 and was associated at first with the new wave synthesizer bands but later on became a part of mainstream rock and pop and hit international success. During the 80's the band released 3 albums that were a combination of pop, new wave and rock. Their first album from 1983, "The Hurting", reached number one in the UK albums chart and was a platinum-selling album. It included major hits such as "Pale Shelter", "Change", and "Mad World". Their second album, "Songs from the Big Chair", followed the same path and reached number one on the US Billboard 200, getting multi-platinum status in the UK and the US. It contained unforgettable hits such as "Shout", "Head Over Heels" and "Everybody Wants to Rule the World" which won the Brit Award for best British single in 1986. Their third successful album "The Seeds of Love" that came out in 1989 included the epic songs "The Seeds of Love", "Sowing Woman in Chains" and many more.
// 						</p>
// 						<p>
// 							In the early 90's, Curt Smith left the band and Roland Orzabal kept releasing more albums under the name of the band. In 2004 the two went back to working together under the name "Tears for Fears" and released the album "Everybody Loves Happy Ending". Since then, the band has been touring around the world to the delight of their fans
// 						</p>
// 						<p>
// 						Tears for Fears’ albums and singles were sold in tens of millions of copies and their songs were covered by other artists countless times. Last year the band announced they are working on a new album to be released during 2017. This July they will be gracing the nonstop city of Tel Aviv for the first time with a single performance, guaranteed to be a night to remember.
// 						</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:4,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: " Guns N' Roses  \"Not in this Lifetime\"",
//         smltitle: "Legendary Guns N' Roses is Coming Back to Rock Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											15.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.gunsnroses.com">
// 											www.gunsnroses.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/4/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								After their celebrated reunion tour last summer, which became the most profitable musical rock concert in 2016, Guns N' Roses, one of the world's most important and beloved rock bands, is coming to Tel Aviv as part of its successful tour with has already added more than 30 shows in the US and Europe.
// 							</p>

// 							<p>
// 								The concert in Tel Aviv will take place on Saturday, July 15 and, 17 at the Yarkon Park, and will close the European tour.
// 							</p>
// 							<p>
// 								Twenty-three years after standing together on the stage in Tel Aviv for the first time, the three original members of the ensemble will come back again: vocalist Axel Rose, guitarist Slash and bassist Duff McGinn, along with an impressive ensemble of musicians including drummer Frank Ferrer, keyboardist Dizzy Red (who was an integral part of the band in the 1990s) Guitarist Richard Fortus and keyboardist Melissa Reyes.
// 							</p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/4/2.jpg"} class="img-responsive" />
// 							</div>

// 							<h3>
// 							"Not in this Lifetime"
// 							</h3>
// 							<p>
// 							Since their first reunion concert at Cochlea Festival last April, the band's tour has become one of the most sought-after shows in America with more than 2 million tickets sold.
// 							</p>
// 							<p>
// 								The success and numbers of the current tour show more than anything else that the audience's love of the band's music and rock music is more relevant and bigger than ever. The historic tour last summer visited 21 cities (25 performances) in North America.
// 							</p>
// 							<p>
// 								The band has recently completed a successful tour in South America, Brazil, Argentina and Mexico. All of band's new tour dates are completely sold out, generating massive interest among audiences. In January, the band will continue to Japan and from there to Australia, Thailand, Singapore, Dubai and will arrive in the “nonstop city” of Tel Aviv in July.
// 							</p>
// 						`
// 			}
// 		}

// 	},

// 	{
//         id:5,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: " RADIOHEAD  \n Tel Aviv",
//         smltitle: "The trailblazing RADIOHEAD bringing their iconic repertoire to Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											19.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.radiohead.com">
// 											www.radiohead.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/5/1.jpeg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Preforming in Tel Aviv for the second time ever, Radiohead has managed to remain innovative, relevant and especially moving since first visiting here 17 years ago . It is a band blessed with superhuman ability to meld together distant musical influences to create a new identity for themselves and their listeners; A band whose compulsive tendency to experiment with groundbreaking sound echoed the impact of entire generations of artists and shattered it to the walls of superfluous genres; A band that changed the way we listen to music, make music, see music, think music and even buy music. Now, 17 years after they last visited here, Radiohead is coming to a concert in Tel Aviv.
// 							</p>

// 							<p>
// 								Watching Radiohead's show, it becomes clear that first and foremost, they are the authors and performers of a huge amount of unforgettable songs. Their repertoire manages to be on the one hand familiar, classical - most of us know it by heart - and on the other hand revolutionary, developing and surprising. The tight performance of the ensemble, along with the unique energy of the soloist, Tom York, transforms each performance into a one-time live experience that attracts huge audiences, to participate in the celebration of artistic evolution, to see how they grew, evolved and reinvented themselves time and time again.
// 							</p>

// 							<p>
// 								Today's Radiohead is a band with a more contemporary presence than ever before, with a glorious past and a variety that transcends all cataloging: a band that began with the Immortal Grange anthem of Creep; Slapped critics over the head with the alternative masterpiece The Bends and then committed commercial suicide - and reached heaven - twice! - with two of the best albums of all time, OK Computer and Kid A.
// 							</p>

// 							<p>
// 								The new generations who discover Radiohead through their new works - In Rainbows a favorite in Israel or the new and acclaimed album A Moon Shaped Pool - discover a band whose influences have permeated every musical genre today: rock, electronic, world, hip hop. Today's Radiohead is more than just another band, it is a world - with a unique visual language, exceptional imagery, an unreplaceable atmosphere and inner humor. Especially in Israel - a country that has always enjoyed an intimate and warm relationship with the band - Radiohead's performance is a cultural experience of the rarest kind.
// 							</p>
// 							<p>
// 							This concert will not have assigned seats, Golden Ring, VIP, unfair prices or any other division of class. Anyone who wants to sit is welcome to bring a blanket, and anyone who wants to stand close to the stage is welcome to arrive early, the ticket price is equal to all, and as many people as possible will be able to enjoy this momentous musical event.
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:6,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Pixies",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											25-26.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.pixiesmusic.com">
// 											www.pixiesmusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<p>
// 								The Israeli summer is always hot, but the Pixies are returning to Tel Aviv after 3 years to make it even hotter!
// 							</p>

// 							<p>
// 								The famous rock band was founded in 1986 in Boston and released its first EP "Come on Pilgrim" in 1987. A year later, when their first album "Surfer Rose" came out, they became a unique voice in the American Rock. 2 years later, they released their second album "Doolittle" that is considered one of the best rock albums of all times. Their third album "Bossanova" came out in 1990 and included unforgettable songs such as "Hang Wire", "Stormy Weather", and "All Over the World".
// 							</p>
// 							<p>
// 							A year later they released their fourth album "Trompe le Monde" that featured songs such as "Planet of Sound", "Distance Equals Rate Times Time" and many more. They fell apart in 1993 but went back to performing together in 2004. After a decade of touring the world, they released their fifth album "Indie Cindy" which included songs like "Another Toe in The Ocean", "Blue Eyed Hexe", and "Jaime Bravo". To this date they released six albums, the last one, "Head Carrier" came out last year. Their biggest hits include "Hey", "Where Is My Mind", "Monkey Gone to Heaven" and "Here Comes Your Man".
// 							</p>
// 							<p>
// 								The band that is known to influence artists such as PJ Harvey and Kurt Kobain will perform this summer in Tel Aviv, giving only 7000 lucky fans the opportunity to see them live and after the rave reviews of their 2014 performance, it’s shaping up to be an unmissable night!
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:7,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Regina Spektor – Back in Israel",
//         smltitle: "Regina Spektor – Back in Israel",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											19.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.reginaspektor.com">
// 											www.reginaspektor.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<p>
// 								Beloved pianist, songwriter and singer Regina Spektor is coming back to Tel Aviv for the third time, closing the worldwide tour of her recent 2016 album “Remember Us to Life” that has gotten excellent reviews.
// 							</p>

// 							<p>
// 								Regina Spektor, whose past concerts in Israel were sold out in 2007 and 2013, will perform again for one time only in Ra’anana Amphitheater on Saturday, August 19.
// 							</p>
// 							<p>
// 								Grammy and VMA nominee Regina Spektor was born in Russia, where she started her classical music training at the age of six and immigrated shortly after to the New York, where she began writing her own original songs. Her first Album came out in 2001 and a year later she already released her second album, “songs”, but her real success started after her third album, Soviet Kitsch, was out in 2004 and the fans started pouring in.
// 							</p>
// 							<p>
// 								Her international breakthrough came in 2006 with her album “Begin to Hope” that reached gold status and sold more than 500,000 copies (!!!). The album includes the single “Fidelity” that is very popular in Israel and in the rest of the world to this day and was used as part of the soundtrack of TV shows such as “Grey’s Anatomy”. Her success only became stronger when her fifth album “Far” and her sixth album “What We Saw From The Cheap Seats” got to the third place in Billboard's album chart.
// 							</p>

// 							<p>
// 								In 2013 Spektor created the theme song of the successful Netflix series “Orange Is the New Black”, called “You’ve Got Time” that also became a radio hit and got her her first Grammy Award nomination. The following year, she sang “Love Me or Leave Me” for the HBO historical crime series “Boardwalk Empire”.
// 							</p>
// 							<p>
// 								Regina Spektor is coming to the non-stop city of Tel Aviv after her sold-out tour in the United States and her old and new fans can’t wait for her show, guaranteed to light up the beautiful summer night of Tel Aviv with it’s amazing infectious energy.
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:8,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Nick Cave & The Bad Seeds",
//         smltitle: "Rock legend Nick Cave & The Bad Seeds returning to Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											19-20.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.nick-cave.com">
// 											www.nick-cave.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<p>
// 								19 years after his last performance in Tel Aviv, the prince of darkness returns once again with his band The Bad Seeds for two shows only to the joy of his fans in what are set to be intimate and unique performances.
// 							</p>

// 							<p>
// 								Australian musician, singer-songwriter, author, screenwriter, composer and film actor Nick Cave is well known as rock musics' "Prince of Darkness" because of his dark, intense tunes. His music is known to be emotionally intense and is characterized by a variety of influences such as death, religion, love and violence. He was called by NME "the grand lord of gothic lushness".
// 							</p>

// 							<p>
// 							In the early 90's, Curt Smith left the band and Roland Orzabal kept releasing more albums under the name of the band. In 2004 the two went back to working together under the name "Tears for Fears" and released the album "Everybody Loves Happy Ending". Since then, the band has been touring around the world to the delight of their fans.
// 							</p>
// 							<p>
// 								Cave started his musical path in the 1970's when he formed "the Boys Next Door" which became a huge success in Melbourne's post-punk scene. Their name was changed to "the Birthday Party" and the band's sound and shows took a rather violent direction and they became known as one of the darkest groups of the 1980's, they fell apart in 1983
// 							</p>
// 							<p>
// 								The end of the Birthday Party was the beginning of Nick Cave and the Bad Seeds in 1983 and they released their debut album the following year. In 1996 the band released its album "Murder Ballads" which featured "Where the Wild Roses Grow", a duet with Kylie Minogue that is also Cave's biggest commercial success to date.
// 							</p>
// 							<p>
// 								Many artists have covered Cave's songs over the years, including Metallica, Johnny Cash, and even the Arctic Monkeys.
// 							</p>

// 							<p>
// 								Nick Cave & The Bad Seeds will perform at the Menora Arena in Tel Aviv on November 19 and an additional date has been added on November 20 due to high demand. For the mere 7,000 fans who will get the chance to look the legendary Nick Cave in the eyes, this is guaranteed to be an unforgettable show!
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:9,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Justin Bieber",
//         smltitle: "Justin Bieber, is landing in Tel Aviv for a single breathtaking concert",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											03.05.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.justinbiebermusic.com">
// 											www.justinbiebermusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/9/1.png"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The artist with the most followers on Twitter 90,149,014
// 								The artist with the most watched official music channel online 13,518,849,954
// 								The artist with the most mentions on Youtube music channel
// 							</p>

// 							<p>
// 							Justin Bieber, the biggest international star of our day, arrives in Israel for just one concert as part of the PURPOSE WORLD TOUR, a tour bearing the name of his last album, which has sold 640,000 copies in just a week and became his bestselling album.
// 							</p>
// 							<p>
// 								Bieber, born in Ontario, Canada, learned to play piano, guitar and drums as a child. At the age of 13, with the help of his mother, he began posting videos on YouTube where he sang covers to artists such as Asher, Stevie Wonder, Chris Brown and others.
// 							</p>

// 							<p>
// 								Scooter Browne, a former marketing director at “So So Def”, was the first to spot Bieber’s talent and invited him and his mother to recordings in Atlanta.
// 							</p>

// 							<p>
// 								In 2008, Bieber was signed by Universal Records, and in 2009, "My World", the first mini-album by Bieber, including "One Time Lonely", "Love Me" and "Favorite Girl" topped the Canadian Billboard charts and the top 40 Billboard Hot 100 hits
// 							</p>
// 							<p>
// 								In 2010, he released his second album, "My World 2.0" with the single "Baby", which became a huge hit and was accompanied by the most watched YouTube video by November 24, 2012.
// 							</p>
// 							<p>
// 								In October 2015, Bieber released the second single from the album "Sorry". The dance clip for the song accumulated over 10 million views in the first 24 hours since its release.
// 							</p>

// 							<p>
// 								In November 2015 he released his fourth album "Purpose", which sold 640,000 copies in the first week and became Bieber’s best-selling album with hits such as "Love Yourself." That same month Bieber made history by placing 17 songs on the American charts and breaking the record held by the Beatles since 1964.
// 							</p>

// 							<p>
// 								In December 2015, Bieber and Skrillex won the Grammy Award for "Where are You Now".
// 							</p>

// 							<p>
// 								Justin Bieber will be performing in Israel on May 3 at Hayarkon Park, with his latest hits "love yourself" and "Sorry" and with the hits "Baby" and "As long as you love me".
// 							</p>
// 						`
// 			}
// 		}

//     },

//     {

//         id:10,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "AEROSMITH \n \"AERO-VEDERCI BABY\" ",
//         smltitle: " Aerosmith launching its tour in the rocking city of Tel Aviv  ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											28.06.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.aerosmith.com">
// 											www.aerosmith.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/10/1.png"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Aerosmith’s farewell concerts began several months ago in South America and will continue in 2017 in the United States and Europe. the European leg of the tour will begin in Tel Aviv and the band will go on to perform in Georgia, Russia, Germany, Poland, Denmark, Ireland, Italy, Portugal and Spain, including appearances in some of the world's leading rock festivals.
// 							</p>
// 							<p>
// 								For over 45 years, Aerosmith has been the quintessential Rock & Roll band, becoming one of the most influential and loved groups in the world. An endless list of amazing songs, many of them becoming massive worldwide hits, and their groundbreaking live shows have gained the band mass appeal for nearly half a century. Rock & Roll Hall of Fame inductees, Aerosmith, have sold over 100 million albums and won countless awards (including four Grammy Awards, eight American Music Awards, six Billboard Awards, and 12 MTV Awards).
// 							</p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/10/2.jpg"} class="img-responsive" />
// 							</div>

// 							<p>
// 								<strong>Steven Tyler</strong> – "Aerosmith just got done ripping through South America like true ambassadors of rock...The band is unstoppable right now and in Europe, we're going to keep doing what we do best... Let The Music Do The Talking...Living On The Edge, and living to rock another day."
// 							</p>

// 							<p>
// 								<strong>Joe Perry </strong> – “It’s been 3 years since we have been on tour in Europe and I can speak for my brothers that we can’t wait to get over there and take it up a few notches. Last tour in South America we were running on all cylinders and I can see no reason to let up now." ;
// 							</p>

// 							<p>
// 							This May, the city of Tel Aviv will be hosting Steven Tyler, Joe Perry, Joey Kramer, Tom Hamilton and Brad Whitford in the beautiful Ganei Yehoshua Park for what promises to be an unforgettable experience and the concert of a lifetime.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:11,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Frankie Valli & The Four Seasons  ",
//         smltitle: " An American Legend in the heart of Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											4.007.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.frankievallifourseasons.com/">
// 											www.frankievallifourseasons.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/11/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The American legend comes to the rocking city of Tel Aviv for the first time ever for an unforgettable 4th of July celebration with the best timeless classics!
// 							</p>
// 							<p>
// 								The original Jersey boy, musical legend Frankie Valli, comes Tel Aviv for the first time for one single performance. Back in the 50’s, Valli started singing in harmonies with different bands in New Jersey, but the success only struck him when he grabbed the microphone in the early 60’s as the lead singer for The Four Seasons that rocked the music world in the next decades with major hits such as “Big Girls Don’t Cry”, “Sherry”, “Walk Like a Man” and more. Valli scored 29 Top 40 hits with The Four Seasons and nine Top 40 hits as a solo artist. The band sold more than 175 million albums and Valli, Tommy DeVito, Nick Massi and Bob Gaudio – the original members of The Four Seasons – were inducted into the Rock and Roll Hall of Fame in 1990 and the Vocal Group Hall of Fame in 1999.
// 							</p>

// 							<p>
// 								At the same time, Valli also has a successful solo career with songs such as the theme song for Grease, and “Can’t Take My Eyes Off You” that was covered by hundreds of artists, from The Pet Shop Boys to Muse. Younger generations got to know Valli from the remarkable musical “Jersey Boys” that tell the story of the band that is responsible for songs that became a part of our life’s soundtrack for over four decades and was turned into a movie which was directed by Clint Eastwood.
// 							</p>

// 							<p>
// 								Ever since he began, Frankie has been performing all over the world, and soon the magic will come to Tel Aviv for one unforgettable show.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:12,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Unite With Tomorrowland",
//         smltitle: "The world’s number one leading EDM festival is coming to Tel Aviv! ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											29.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.tomorrowland.com/en/unite-israel/en/welcome">
// 											www.tomorrowland.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/12/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The famous Tomorrowland festival might take place in Belgium, but Tel Aviv is also up for the party! Unite with Tomorrowland brings the party to the hottest city in the Middle East with live connection from the Tomorrowland Mainstage, live local and international DJ’s on the UNITE stage and of course – the magical Tomorrowland atmosphere.
// 							</p>
// 							<p>
// 								The live connection with the Mainstage in Belgium will give the People of Tomorrow the chance to connect with the crowd in Israel and vice versa. 3 mainstage headliners will be broadcasted live on a unique UNITE with Tomorrowland stage and special effects will be synchronized with the show in Belgium, creating a special global connection.
// 							</p>

// 							<p>
// 								The main headliners in Belgium will be Armin Van Buuren who has won best trance DJ at the DJ Awards 9 years in a row, was ranked among the world’s top 4 DJ’s at DJ Magazine 13 years in a row, the known electro-house duo Dimitri Vegas & Like Mike and the house sensation KSHMR. On the UNITE stage in Israel the DJs will be Steve Angello who won the DJ award for best house in 2010, the Israeli trance artist Alien Project, DJ Tomer Maizner, Dor Dekel, Teamworx, and TRIPL.
// 							</p>

// 							<p>
// 								EUnite with Tomorrowland isn’t just a livestream, it’s a one of a kind show that allows you to escape reality and join the magical world of tomorrow.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:13,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "The Chainsmokers",
//         smltitle: "The world’s number one leading EDM festival is coming to Tel Aviv! ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											NEAR Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											3.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.thechainsmokers.com/">
// 											www.thechainsmokers.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/13/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Tel Aviv is known for its great dance scene, so it makes perfect sense that the hottest DJ/production duo that everyone is talking about to come to get the city on its feet! The duo is responsible for many current hits such as “Don’t let me go”, “Roses”, and their recent collaboration with Coldplay “Something Just Like This”, and they will perform in Israel as part of their international tour “Memories Do Not Open”.
// 							</p>
// 							<p>
// 								The Chainsmokers consists of Andrew Taggart and Alex Pall. The duo performed live for the first time as the opening for Timeflies in 2014, and their single "#Selfie" was re-released at the same year, leading to breakthrough success as "#Selfie" became a worldwide hit and peaked on the Dance/Electronic chart. In 2015 they released their first EP “Bouquet”, featuring “New York City”, “Until You Were Gone, “Good Intentions” and “Roses”, all of which climbed the international charts and became major hits.
// 							</p>

// 							<p>
// 								A year later, the duo released their singles “Don’t Let Me Down” featuring Daya, “Inside Out”, featuring Charlee, and “Closer” featuring Halsey. The latter peaked at number one in the United Kingdom and the United States. Their success didn’t stop there and after releasing “All We Know” featuring Phoebe Ryan, they were ranked 18th in DJ Magazine’s annual list of “Top 100 DJ’s” in 2016. The same year the duo won favorite electronic/dance music artist at the American Music Awards and top dance/electronic artist at the Billboard Music Awards. A year later “Closer” also won top hot 100 songs, top collaboration and top electronic/dance song at the same Awards ceremony.  “Don’t Let Me Down” also won best dance recording in 2017 at the Grammy awards.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:14,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Dire Straits Experience",
//         smltitle: "Get a shiver in the dark in Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											14.09.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.direstraitsexperience.com/">
// 											www.direstraitsexperience.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/14/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								25 years have passed since Dire Straits disbanded and we last heard that unmistakable sound of Mark Knopfler’s guitar…
// 							</p>
// 							<p>
// 								Close your eyes and get transported back to an original Dire Straits gig. Beautiful inspiring tracks, quality sound, amazing atmosphere, spine tingling riffs, vocals, instrumentals and an outstanding performance.
// 							</p>

// 							<p>
// 								After selling over 25,000 tickets in Israel within the past three years, and in light of the high demand for yet another show, The Dire Straits Experience are coming to Tel Aviv for only one night.  A single performance on the 14th of September at the Menora Mivtachim Arena.
// 							</p>

// 							<p>
// 							   The Dire Straits Experience was founded by saxophonist Chris White after their successful debut playing for a charity event at the Royal Albert Hall where members of the legendary band got back together on stage. News travelled fast, and an increasing global demand to hear the most dramatic songs in rock history played live eventually led to a worldwide tour.
// 							</p>

// 							<p>
// 							    Chris White, who recorded and performed with the rock legends for over a decade, joined Dire Straits for their record breaking “Brothers in Arms” world tour in 1985. This included their famous performance at Live Aid and later the renowned Nelson Mandela 70th birthday concert. White has played with some of the greatest rock stars the world has known, such as Paul Mccartney, Joe Cocker, Mick Jagger, Robbie Williams and many others. Joining Chris White is a stellar band consisting of some of the finest professional musicians the UK has to offer.
// 							</p>

// 							<p>
// 							   “When I was first approached to put together a band to play Dire Straits songs, I didn’t believe it would be possible to find someone who would be able to stand in Mark’s shoes without sounding like an imposter. I was wrong. In Terence Reis, I think we may have found the only person on the planet that is able to play and sing like Mark but maintain his own integrity and identity.”
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:15,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Alan Parsons",
//         smltitle: "The man that said no to Pink Floyd, live in TA",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											11.11.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.alanparsonsmusic.com/">
// 											 www.alanparsonsmusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/15/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The musical legend Alan Parsons and his band are coming to Israel for two shows, the first at the Congress Centre in Haifa and the second at the Menorah Mivtachim Arena in Tel Aviv.
// 							</p>
// 							<p>
// 								Parsons has a large following in Israel. In fact, this will be his third visit to the country in order to play on stage. This time they’ll be performing their new “I Robot” tour, commemorating 40 years for the release of the similarly titled mythological album in 1977. You can expect to hear all of their greatest hits of course.
// 							</p>

// 							<p>
// 								Alan Parsons is a renowned musician and one of the most influential musical producers in history. He started out as a sound technician working in the notorious Abbey Road recording studio. Alan became famous after helping to produce Pink Floyd’s masterpiece album “Dark Side of the Moon”. He has worked as a sound technician with others such as The Beatles, Wings, Al Stewart and many more.
// 							</p>

// 							<p>
// 							   In 1975, Pink Floyd invited him to work on their next album “Wish You Were Here”. Alan declined the offer in order to form his progressive rock band “The Alan Parsons Project”. The band succeeded immediately, receiving international acclaim for their huge hits “Eye in the Sky”, “Time” and “Old and Wise” to name a few.
// 							</p>

// 							<p>
// 							   An accomplished vocalist, keyboardist, bassist, guitarist and flautist receiving gold and platinum awards from many nations, Parsons also has ten Grammy Award nominations for engineering and production. Up until today The Alan Parsons Project is one of the most popular events in Europe, with tickets being sold out within hours.
// 							</p>

// 							<p>
// 							   Come indulge your ears and listen firsthand to some of the classics of our time. You can catch the concerts either in Haifa on the 9th of November or in Tel Aviv on the 11th of November.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:16,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Bryan Adams",
//         smltitle: "Bryan Adams to warm our winter with 3 shows",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv & Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											4+5+6.12.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.bryanadams.co.il/">
// 											 www.bryanadams.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/16/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								With the summer days way behind us and the days getting shorter, a little winter comfort is necessary. What better way to warm up from the inside than with some romantic ballads and timeless rock anthems. Treat yourself (and someone you love) to a throwback of nostalgia from our younger days, reminding us those sweet moments of slow dancing, first crushes and innocent youth.
// 							</p>
// 							<p>
// 								The Canadian pop rock icon with hits spanning over four decades is coming to Israel for three consecutive shows! Two will performances in Tel Aviv on the 4th and 5th of December at the Menora Mivtachim Arena and one more concert in Jerusalem on the 6th of December at the Pais Arena.
// 							</p>

// 							<p>
// 								Born in 1959 in Kingston, Ontario, Bryan Adams’ music career took off in the early 80’s with the release of his third album “Cuts Like A Knife” which included the hit “Straight From The Heart”. It was his following album “Reckless” that skyrocketed his career and brought his rise to stardom with the hits “Run To You”, “Heaven” and “Summer of ‘69”. Following these hits Adams later brought us the U.S. Billboard Hot 100 number-one singles "Heaven", "All for Love" and "Have You Ever Really Loved a Woman?".
// 							</p>

// 							<p>
// 							  Besides topping the charts in North America and Europe, his songs were nominated for several Grammy, Golden Globe and Academy Awards. His records have collectively sold over 100 million copies worldwide, making him one of the best-selling music artists of all time.
// 							</p>

// 							<p>
// 							   He’ll be performing songs from the “Get Up” tour being held for his similarly titled thirteenth (and most recent) album from 2015. No reason to worry though, we’re sure he’ll serenade us with his biggest hits and favorite crowd pleasers.
// 							</p>

// 							<p>
// 							   He’ll be performing songs from the “Get Up” tour being held for his similarly titled thirteenth (and most recent) album from 2015. No reason to worry though, we’re sure he’ll serenade us with his biggest hits and favorite crowd pleasers.
// 							</p>

// 							<p>
// 							   Make sure you don’t miss this time-defying legend.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {
//         id:17,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Chris Rock",
//         smltitle: "Coming to Tel Aviv to rock your world ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											8+9.01.18
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.chrisrock.com/">
// 											 www.chrisrock.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/17/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Chris Rock, one of the greatest standup comedians of all time and the funniest people in the world is going on a rare, highly awaited tour for the first time in 9 years. One of his few stops will be in Tel Aviv.
// 							</p>
// 							<p>
// 								The hilarious comedian has put on a new live act, after nearly a decade of focusing on television and film. Chris Rock will make his first ever live on stage appearance in Israel as part of his 2017 “Total Blackout” tour.
// 							</p>

// 							<p>
// 								Born in 1965, he made his breakthrough on SNL (Saturday Night Live) starring next to Adam Sandler, David Spade and Chris Farley. Eddie Murphy helped accelerate his stardom by giving him a role in Beverly Hills Cop 2. Since then it’s been a long line of success, from Lethal Weapon 4, Madagascar, Scary Movie, Nurse Betty and the list goes on. He’s hosted the Academy Awards twice and has also written, directed and produced several movies and TV shows. Despite all this, Chris Rock has and always will shine brightest where he truly belongs, on stage with a microphone.
// 							</p>

// 							<p>
// 							  His previous standup acts: Bigger and Blacker, Born Suspect, Bring the Pain and Kill the Messenger all broke records and are considered to be classics, with bits that are still quoted today.
//                               Rock is often compared to the greatest comedians in the field, alongside Jerry Seinfeld, Louis CK and Dave Chappelle (all of which he’s also collaborated with).

// 							</p>

// 							<p>
// 							   He made it to the top 5 in Rolling Stone magazine’s 50 greatest comedians of all time.
// 							</p>

// 							<p>
// 							   When he gets on stage it’s like seeing a boxer, a preacher and a poet all bundled together into one man. Chris delivers powerful, fast paced, side-splitting punches. His views on relationships, race and politics challenge his listeners and make them rethink everything they know. Rock dares to cross boundaries with his material and is not afraid to shock and surprise.
// 							</p>

// 							<p>
// 							   In an interview he recently gave to Rolling Stone magazine, he talked about his divorce after 18 years of marriage and how he decided to devote himself to standup again. According to him, these events gave rise to the world tour in which he will be performing in Tel Aviv.
// 							</p>

// 							<p>
// 							   Catch Chris live on January 8th at the Menorah Mivtachim Arena.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:18,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Patricia Kaas",
//         smltitle: "The great French singer returns to the white city once again",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											28.09.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.patriciakaas.net/">
// 											  www.patriciakaas.net
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/18/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The famous French singer and actress Patricia Kaas is coming back to Tel Aviv for the third time after her previous performance three years ago became a huge success and recieved incredible reviews. Kaas is considered one of the all-time most successful French singers and her music is a mix of pop, cabaret, jazz, and chanson. She started her career in the late 80’s and very quickly she climbed the charts in France.
// 							</p>
// 							<p>
// 								Kaas’s first single “Mademoiselle chante le blues” that came out in 1987 became a huge hit and got to the top 10 in the French chart. A year later she released her second single “D’Allemagne”, followed by her first album “Mademoiselle chante…” that was ranked number two at the French chart. The album sold over 100,000 copies within less than two months and became a gold album. It didn’t take long and within less than three months more than 350,000 copies were sold and it became a platinum album. Kaas received a platinum album status in Belgium, Switzerland and Canada as well, and at the same year she won the most important French music award – Victories de la Musique.
// 							</p>

// 							<p>
// 								Since then the French phenomenon sold more than 17 million albums worldwide. Her third album “Je te dis vous” brought her major success in Germany, Belgium, Switzerland, Canada, Russia, Finland, Ukraine and Korea. In 2002 she acted in a movie for the first time, it was “And now… Ladies and Gentlemen” in which she performed with the British actor Jeremy Irons. In 2009 she represented France at the Eurovision contest and got to the 8th place.
// 							</p>

// 							<p>

//                                    Patricia Kaas is responsible for many hits and her songs became a part of our lives. The talented musician is coming back to Tel Aviv to sing her famous repertoire and bring back the nostalgia to the nonstop city.

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:19,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Blue Man Group",
//         smltitle: "The phenomenal musical group is returning to Tel Aviv once again for a show like no other!  ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											 7-23.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.blueman.com/">
// 											  www.blueman.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/19/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Blue Man Group is coming to Tel Aviv as a part of their 25 years of living in full-color tour! This is a show unlike anything you have ever seen before that combines music, theater, art and technology.
// 							</p>
// 							<p>
// 								Originally Formed in New York in 1988 by three close friends, Chris Wink, Matt Goldman and Phil Stanton, Blue Man Group originated as a celebration of the end of the 1980s. The three men wore blue masks and led a procession that included the burning of a Rambo doll and a piece of the Berlin Wall. They caught the eye of an MTV reporter and gained attention. They started with small acts on the streets of New York, growing into shows at downtown clubs, eventually becoming a full performance at the Astor Place Theatre in 1991.
// 							</p>

// 							<p>
// 								In 1999 the band released its first gold album “Audio” and it was nominated for the Grammy Award for Best Pop Instrumental Performance. Their second album, “The Complex” (2003), features collaborations with various musicians like Gavin Rossdale, Dave Matthews and many others. It charted four songs on the Billboard charts. In 2006 they released “Live at The Venetian – Las Vegas” which was an iTunes exclusive, and their most recent album, “THREE”, came out in 2016 and was also nominated for the Grammy Award.
// 							</p>

// 							<p>

//                                  Currently, the Blue Man Group is performing on a regular basis in five theaters around the world- in Vegas, New York, Boston, Orlando and Berlin. They recently launched their new book “Blue Man World” that tells the story of the blue man from their perspective.  Three blue people that will take you on a crazy adventure full of music, laughter and surprises. More than 35 million people worldwide have already seen them, not it’s your turn!

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:20,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Sean Paul",
//         smltitle: "The international mega star is coming to make our summer sizzle!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv Outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											22.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.allseanpaul.com/">
// 											  www.allseanpaul.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/20/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The Grammy winner dancehall artist, Sean Paul will return to Tel Aviv for a single hot hot hot hot performance.
// 							</p>
// 							<p>
// 								Sean Paul will arrive in Tel Aviv for the third time as part of his new international tour. The artist is currently storming the international charts with a string of hits that including collaborations with some of the most popular names in music including Sia, Anne-Marie and more.
// 							</p>
// 							<p>
// 							    His extraordinary voice, rhythms, catchy songs and super-polished productions all combine the winning recipe of the Grammy winner and international star - Sean Paul. Originally known as Sean Paul Ryan Francis Henriques, Sean Paul was born in Jamaica in 1973. His musical career soared in 2002 with the tremendous success of his second studio album, "Dutty Rock," mainly for the songs "Gimmie The Light" and "Get Busy" Hot 100 chart toppers). Sean Paul has managed to maintain his relevance in the music industry since breaking into fame in the year 2000 until now with a string hits such as Cheap Thrills, Rockabye, No Lie, and Body.
// 							</p>

// 							<p>
// 							   Sean Paul studied at the University of Technology in Jamaica with aspirations for a career in the hotel industry, but his passion for music took over. The single ‘Baby Girl’ was the first to mark his successful career as a recording artist and led to his debut album ‘Stage One’ at VP Records. To date, he has released six studio albums; the last five were all nominated for the Grammy Award.
// 							</p>
// 							<p>
// 							   The album "Dutty Rock," 2002, earned him the Grammy Best Reggae Album. "The Trinity," 2005, reached platinum status in Europe and the Recording Industry Association in the United States. His albums, "Imperial Blaze" in 2009 "Tomahawk Technique" in 2012, and the last one was released in 2014 - "Recent Full Frequency" – were all warmly received and highly acclaimed.
// 							</p>

// 							<p>

//                                   His hard work, perseverance, and dedication over the years have earned him several nominations for the Grammy and Billboard awards. His most notable accomplishments include An American Music Award, Mobo Awards, Soul Train Awards, MTV Music Awards, ASCAP Rhythm and Soul Music Awards, a Source Award and a BET Award.

// 							</p>

// 							<p>
//                                 Sean Paul maintains a multinational presence thanks to his collaborations with artists in a wide variety of genres such as EDM, Soca, Pop, Afro-Beat and Latin music. His icon status allows him to maintain an immense fan base in Latin America, Japan, Europe and the US and his relationship with the Spanish audience received a serious boost, following his collaboration with the singer Farruko in the single Passion Whine and of course the legendary collaboration with Enrico Iglesias ‘Bailando’ which became no.1 in 33 (!) countries and gained millions of views on YouTube.
// 							</p>

// 							<p>
//                                Sean's collaborations throughout his career include numerous international collaborations with hip-hop stars such as Busta Rhymes, Beyoncé, Rihanna, Keyshia Cole, Kelly Rowland, Juicy J, 2Chainz and Nicki Minaj.
// 							</p>

// 							<p>
//                                Sean Paul performs regularly on the biggest most respectable venues in the world and enjoys a huge following from a worldwide audience of all ages.
// 							</p>

// 							<p>
//                                His last performance in Tel Aviv received fantastic revues from critics and fans alike, and he is back on popular demand, promising to make the hot summer scorch even more with a what is guaranteed to be a party like no other!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:21,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "The Pretenders",
//         smltitle: "The legendary rock band and Chrissie Hynde are coming to rock out Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											23.09.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.thepretenders.com/">
// 											  www.thepretenders.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/21/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								For the past three decades Chrissie Hynde and The Pretenders stayed at the top of the British rock and won the hearts of millions of fans. Hynde took a long break from writing and recording new materials but after the raving reviews the band’s most recent album, “Alone” got, she and The Pretenders are back on a world tour and are now coming for one unforgettable show in Tel Aviv!
// 							</p>
// 							<p>
// 								The band started its way in the music world in England in 1978 and experienced numerous subsequent personnel changes, with Chrissie Hynde being the only consistent member. The original band was active until 1982 and released its first album (Pretenders) that was a success in the United Kingdom and the United States both critically and commercially. The band got to No. 1 in the UK with its single "Brass in Pocket", which was also successful in the US, reaching No. 14 on the Billboard Hot 100.
// 							</p>

// 							<p>
// 								Later on the band released nine more albums - Pretenders II (1981), Learning to Crawl (1984), Get Close (1986), Packed! (1990), Last of the Independents (1994) which was rated gold in the US, Viva el Amor (1999), Loose Screw (2002), Break Up the Concrete (2008) which was among the Top 40 album in the US, and The Pretenders’ most recent album - Alone (2016). During March 2005, the Pretenders were inducted into the Rock and Roll Hall of Fame. Among their most famous song one can remember “Brass in pocket”, “Hymn to her”, “Don’t get me wrong”, “I’ll stand by you”, and many others.
// 							</p>

// 							<p>

//                                   The Pretenders worked carefully on their new show and started their new tour at the Royal Albert Hall in London, which was full with fans that showed how much they missed the incredible band. Hynde and The Pretenders performed in music festivals all over the world, and they’ll start the second part of their tour right here in the rocking city of Tel Aviv, make sure not to miss it!

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:22,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Cliff Richard",
//         smltitle: "The incomparable Cliff Richard coming back to Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											10.10.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.cliffrichard.org/">
// 											  www.cliffrichard.org
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/22/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Cliff Richard, the beloved British artist who previously performed in the fabulous city of Tel Aviv more than 20 years back, is coming back to the delight of his local fans.
// 							</p>
// 							<p>
// 								Over his long and illustrious career, the 72-year-old Cliff Richard has sold more than 260 million records worldwide and is best known for his tunes "Fallen angel Woman," "We Don't Talk Anymore," "The Young Ones," "Summer Holiday," and "Congrats" .
// 							</p>

// 							<p>
// 								Richard has a long list of hits and is responsible for many worldwide beloved songs. He has sold over 21 million singles in the UK and has become an intrinsic part of the nation’s soundtrack.
// 							</p>

// 							<p>

//                                  Richard has had eight US Top 40 singles, including the million-offering "Demon Woman" and "We Don't Talk Anymore". In Canada, Richard made a real splash during the mid-1960s, and again in the late 1970s and mid-1980s with a few singles and collections achieving gold and platinum status. He has remained a prominent music, film, and TV character in Australia, New Zealand, South Africa, Northern Europe and Asia, and has a strong following.

// 							</p>

// 							<p>
// 							   Throughout his career, spanning over 50 years, Richard has amassed numerous gold and platinum records and awards, including three Brit Awards—winning Best British Male Singer twice and the Brit Award for Outstanding Contribution to Music, as well as two Ivor Novello Awards. He has had more than 130 singles, collections and EPs make the UK Top 20, more than any other artist.
// 							</p>

// 							<p>
// 							   Richard has had 67 UK top ten singles, including one written for the great Elvis Presley.  He has had 14 UK No. 1 singles and is the leading vocalist to have had a No. 1 single in the UK in five back to back decades: the 1950s through to the 1990s.
// 							</p>

// 							<p>
// 							   This October, after much anticipation, Cliff Richard is coming to Tel Aviv to sing his mind-blowing songs live, in his unmatchable performing style. Come watch the living legend himself on-stage in the exciting city of Tel-Aviv!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:23,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "DGTL Festival",
//         smltitle: "An awesome digital celebration in the one of the world’s Digital Capitals",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											05.10.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://tlv.dgtl.nl/en/?skip_portal=1">
// 											  www.tlv-digital.nl
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/23/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The first ever of its kind in the country, the DGTL festival is a dream come true for the music and nightlife scene of this buzzing metropolis. The DGTL festival is set to be by far the biggest electronic music event held in Tel Aviv, which is considered one of the nightlife capitals of the world.
// 							</p>
// 							<p>
// 								DGTL Festival, making its Tel Aviv debut this October originates in Holland and takes place each year in the most trendy capitals including Amsterdam, Sau Paulo, and Barcelona.
// 							</p>

// 							<p>
// 								The festival is an innovative technology centered event showcasing some of the world’s greatest biggest names in the digital scene alongside new hot up and comers from the industry. Tickets are often sold out in advance, and dozens of DJs and leading artists show off their talents in this a multi-sensory experience of art, music, lighting and uncompromising production standards throughout the:
// 							</p>

// 							<p>

//                                The festival has a unique and electrifying atmosphere, and audiences will also get to enjoy a variety of food stalls, art, and meticulous sound.

// 							</p>

// 							<p>
// 							   The festival will include three stages featuring excellent music at any given moment.
// 							</p>

// 							<p>
// 							   The fantastic international line up is set to include:
// 							</p>

// 							<p>
// 							  Maslow Flux, Marcel Dettman, John Talabot, Red Access, Jennifer Cardini, Avalon Emerson, Young Marko, Yotam Avni, Otarki, Joba Jobsa and many others.
// 							</p>

// 							<p>
// 							  This huge production will be launched for the first time in October 2017. In addition to being an innovative music festival, DGTL is held under the theme of environmental preservation and sustainability and is considered the greenest festival in Europe. Also, DGTL festival promotes vegetarian food only and develops a unique program for recycling materials. Alongside the local audience, the festival will be marketed in 50 countries, and thousands of music fans from all over the world are expected to arrive in Tel Aviv to take part in the party.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:24,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Richard Clayderman",
//         smltitle: "The famous pianist returns to perform in Israel with all his unforgettable hits!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											17.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.clayderman.co.uk/">
// 											  www.clayderman.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/24/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Romance lovers, prepare yourselves – after his last show in Israel three years ago, the famous French pianist Richard Clayderman returns to the holy land as a part of his new tour that marks 40 years of an outstanding career!
// 							</p>
// 							<p>
// 								Clayderman recently turned 63 and he is one of the world’s most successful pianists with a rich and diverse career that started four decades ago. He recorded over 1200 songs and his biggest hit ever is “Ballade Pour Adeline” that was sold in 22 million copies in 38 different countries. Clayderman is considered one of the world’s most successful instrumental artists along with others like Kenny G and more.
// 							</p>

// 							<p>
// 								During his career, Richard Clayderman sold more than 85 million albums and had more than 340 gold and platinum albums. He created a new romantic style through a repertoire that combines his original melodies with classics and pop standards. The phenomenal artist devoted much of his time to performing, going as far as playing 200 shows in 250 days. The Guinness Book of World Records noted him as “the most successful pianist in the world”.
// 							</p>

// 							<p>

//                                His previous visits in Israel were extremely successful with multiple sold out concerts. In his upcoming shows in Israel, Clayderman will play a selection of his best pieces, including the 12 minutes of the “Titanic Symphony”, “Don’t Cry for Me Argentina”, “Love Story”, “Ballade Pour Adeline”, and song from other famous movies such as “West Side Story”, “Harry Potter Melody” and “The Schindler List”. Come listen to the outstanding pianist who has touched the heart of millions around the world!

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:25,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Smokie",
//         smltitle: "Smokie, coming to light up the stage this fall in Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv + Jerusalim
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											28+31.10.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//smokie.co.uk/Band">
// 											  www.smokie.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/25/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Smokie, the iconic British rock band is coming back to Tel Aviv to rock it out in the city this fall.
// 							</p>
// 							<p>
// 								Smokie initially rose to fame in the 1970's and is most know for its chart topping hits 'Living Next Door to Alice', 'Lay Back in the Arms of Someone', and "If You Think You Know How to Love Me.'
// 							</p>

// 							<p>
// 								The band has had 13 top twenty hits during the 1970s and has sold more than 30 million albums.
// 							</p>

// 							<p>

//                               Initially formed in Yorkshire, England, in 1966, Smokie hit the British pop charts a few times amid the late '70s with a fresh pop style.  The quartet recorded many singles amid the late '60s and mid '70s, and in 1975 hit number three in the U.K. with "If You Think You Know How to Love Me."

// 							</p>

// 							<p>
// 							   After another Top Ten hit, "Don't Play Your Rock’n’ Roll to Me,” the band made it big with three Top 20 hits, including "Living Next Door to Alice." Smokie hit number five both in 1977 ("It's Your Life") and 1978 ("Oh Carol(".
// 							</p>

// 							<p>
// 							   The band has performed in Tel Aviv several times and are returning shortly after their last visit to the non stop city with an extremely successful run two years ago. The Tel Aviv concert will be a part of the band’s new tour which includes England and many countries around Europe and which also includes musicians Martin Bullard, Mick McConnell, Mike Craft, Steve Pinnell and Terry Uttley.
// 							</p>

// 							<p>

// 							    Smokie’s songs have gained iconic status over the years and have been covered multiple times due to their catchy style. The band enjoys a strong fan base in the country and regularly fills every seat in the house in each of their performances. The band will be playing its greatest hits to the joy of their fans which will flock to see the rock legends in action in Tel Aviv.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:26,
//         bgImage :"/posts/bank/15/1.jpg",
//         mobBgImage :"/posts/bank/15/M.jpg",
//         title: "Foreigner",
//         smltitle: "The 80's are back to rock Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											02.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.foreigneronline.com/">
// 											  www.foreigneronline.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/26/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The 80's are coming back! The British-American hard rock group is returning once again to the amazing city of Tel Aviv. The band is returning to Israel again after 3 sold out concerts in the past – one in 2014 and two in 2016, which got incredible reviews.
// 							</p>
// 							<p>
// 								Foreigner was founded in New York in 1976 by veteran English musician Mick Jones, ex-King Crimson member Ian McDonald and American vocalist Lou Gramm. The band focused more on commercial rock and is remembered mostly for its soft ballads that topped the charts worldwide.
// 							</p>

// 							<p>
// 								The rock group released its debut album in 1977 which provided one of its most popular hits "Cold As Ice", but the band's real breakthrough happened in the early 1980's when they released the album "4". Their success continued as they released their next album "Agent Provocateur" in 1984, as well as in their last one- "Can't Slow Down", in 2009.
// 							</p>

// 							<p>

//                               The band has sold over 80 million records worldwide in the past 3 decades, out of them 37.5 were sold in the United States alone, making it one of the bestselling bands in the history. Their most memorable hits include "Waiting for a Girl Like You", "I Want to Know What Love Is", "Urgent", "Juke Box Hero", and "That Was Yesterday".

// 							</p>

// 							<p>
// 							  Come rock with the American-British legend and bring the 80's back to life in a one of a kind concert!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:27,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Carcass",
//         smltitle: "The British metal legends are coming <br>to rock the city that never sleeps!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											09.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.facebook.com/OfficialCarcass/">
// 											  facebook.com/OfficialCarcass
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/27/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The British extreme metal band was formed in 1985. They started as a school band by Bill Steer and Ken Owen, and the latter left the band soon after. Steer then joined the D-beat band Disattack and played with drummer Middie, bassist Paul and the lead singer Andrew Pek. The band later changed its name to Carcass as the members changed their musical direction. The band recorder only one album with Pek, who changed his name to Sanjiv, and shortly after "Flesh Ripping Sonic Torment" was released he left the group.
// 							</p>
// 							<p>
// 								The vocal duties were shared between Walker, Steer and Owen, and together they recorded a debut album in only four days.  The band wasn't pleased with the poor production of their album "Reek of Putrefaction" but it became a favorite of Radio 1 DJ John Peel. His interest in them made them participate in his first "Peel Session", in which they released materials for their second album.
// 							</p>

// 							<p>
// 								Carcass are considered to be the pioneers of the grindcore genre, although their early work is considered to be more splatter death metal, hardgore and goregrind. The band also became one of the pioneers of melodic death metal with their album "Heartwork" which was released in 1993. Their lyrics usually focus on animal rights issues, as both Jeff Walker and Bill Steer are vegetarians.
// 							</p>

// 							<p>

//                               In 2013 the band signed with Nuclear Blast, and in Japan they signed with Trooper Entertainment for the release of their new album. They released "Surgical Steel", which received extremely positive reviews and earned Top 50 position on the US Billboard 200 charts. Soon afterward they headlined Damnation Festival in Leeds and then performed at 70000 Tons of Metal in 2014 and headlined the Agglutination Festival the same year.

// 							</p>
// 							<p>
// 							   The band is coming to give only one show in the nonstop city of Tel Aviv, which is guaranteed to be an extraordinary experience for all the metal fans out there, make sure to get your ticket now!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:28,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Kygo",
//         smltitle: "The Norwegian house phenomena for the first time ever in Tal Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											02.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.kygomusic.com/">
// 											  www.kygomusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/28/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Kygo, originally a Norwegian pianist, became a tropical house music producer in no time. "Spotify" announced him as the biggest discovery of 2015 after his songs "Firestone" and "Stole the Show" were played over a billion times. Both of these songs also received gold and platinum status in 16 countries.
// 							</p>
// 							<p>
// 								His first album, "Cloud Nine", reached the top of the dance albums chart on "Itunes" and also on the electronic albums chart of Nielsen Soundscan. The house sensation preformed in the most popular TV shows in the United States such as "The Late Late Show" with James Corden, "The Tonight Show", "Good Morning America" with Jimmy Fallon and on Ellen Degeneres. Moreover, he was on the cover of the biggest magazines – "The Billboard", "Haute Living Magazine", "LA Times", "USA Today", "The Wall Street Journal", "The Rolling Stones", "Forbes" and more.
// 							</p>

// 							<p>
// 								Kygo started his musical journey at the age of 6 when he started learning how to play the piano. It took almost a decade for the classical music to step aside and for the new love in his life to take over – Electronic music. He only decided that he wants a career in the music industry a moment before he was about to graduate from his economics and business degree.
// 							</p>

// 							<p>

//                               His first significant breakthrough was with the hit "Firestone" that shortly grabbed the attention of tens of millions of listeners. Aviici played it in his sets and in festivals. Afterwards Coldplay's lead singer, Chris Martin, gave him permission to create a remix of their song "Midnight". Kygo's unique sound led him to incredible achievements, such as the hit "ID" that was featured in Ultra Festival's official trailer and in the playlist of FIFA 2016.

// 							</p>
// 							<p>
// 							  The extraordinary house sensation is coming to rock Tel Aviv for the first time ever, for one show only. His shows in New York and Hollywood were sold out, and the reviews were incredible. This is guaranteed to be a night to remember, you definitely want to be there!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:29,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Led Zeppelin 2",
//         smltitle: "Don’t Miss the Zeps in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv, Haifa and Be'er Sheva
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											07-10.01.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//zep2.com/">
// 											  www.zep2.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/29/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The tribute band from Chicago Led Zeppelin 2, which was named after the mythological band's second album, is coming to Israel for 4 shows only. Come feel the old Led Zeppelin vibes and kick it with the ultimate Led Zeppelin experience here in rocking Tel Aviv
// 							</p>
// 							<p>
// 								Led Zeppelin 2 have been performing  for over a decade and are considered to be the ultimate Led Zeppelin experience. The band consists of 4 musicians from the indie-rock, jazz and metal scene in Chicago. The lead singer, Bruce Lamont, who took the place of the legendary Robert Plant, is also a part of the avant-garde metal group "Yakuza", and he has collaborated with bands like "Dyslexic Apaches", and "Circle of Animals". His solo album "Feral Songs for The Epic Decline" was recently rated among SPIN magazine's top 20 metal albums.
// 							</p>

// 							<p>
// 								Greg Fundis, the group's drummer, is playing with leading musicians among which one can find the singer and jazz guitarist George Benson, the musician Joey De Francesco, the saxophonist Joe Lovano and more. The bassist Matthew Longbons participates in more than 200 shows a year next to leading international artists such as Alice Cooper and Matt Walker from the "Smashing Pumpkins". Paul Kamp, the group's guitarist, is known mostly from his collaboration with "Busker Soundcheck", a well-known alternative rock band.
// 							</p>

// 							<p>

//                              Led Zeppelin is considered until today to be one of the most revolutionary, influencing and successful bands in the history. They sold more than 300 million albums worldwide, with 'Led Zeppelin IV' alone selling over 37 million copies and being ranked as the third all-time best-selling album in the U.S. All 9 of the band's albums were rated in the top 10 in the U.S. chart, and 6 of them even top over the top 5. Their second album that was recorded during their first tour was a huge success both in the U.S. and in the UK, and it featured the hit 'Whole Lotta Love' that sold over a million copies.

// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:30,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Oh Wonder",
//         smltitle: "Live in Tel Aviv for the first time ever!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											16.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//ohwondermusic.com/">
// 											  www.ohwondermusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/30/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Oh Wonder consist of Josephine Vander Gucht and Anthony West. In 2014 they started releasing singles every month and then they combined all of them and released a debut album that's named after them and sold over 500 million copies. This year they released their second album, "Ultralife", which had even a bigger success and reached the Top 10 in the UK charts.
// 							</p>
// 							<p>
// 								In 2015 the duo was announced by Billboard as one of the 5 biggest breakthroughs. They come to Israel this year after a long tour and performing in the biggest festivals around the world as part of the promotion of their new album, which includes hits such as "Without You" and "Drive".
// 							</p>

// 							<p>
// 								Gutcht and West played sold out shows in New York, Los Angeles, Paris and London, and now they're coming for one show only to give the people of Tel Aviv a taste of their alt-pop hits. The successful duo is guaranteed to get you dancing and give the ultimate pop experience, this will be one night in Tel Aviv you are sure to remember.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:31,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Ott & The All Seeing I",
//         smltitle: "Electro explosion in the city that never sleeps",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											15.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//ottsonic.com/">
// 											  www.ottsonic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/31/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Ott and the All Seeing I are coming to take Tel Aviv by a storm this December.
// 							</p>
// 							<p>
// 								Ott is considered to be one of the pioneers of calm, groovy electronic music and likes to record the sounds of nature in his mobile studio, with which he tours England. The British record producer and musician has worked with Sinead O'Connor, The Orb, Brian Eno and Embrace, and has achieved recognition since 2002. He's known for psychedelic dub tracks and his collaborations with other artists. He has released two albums on Twisted Records – "Blumenkraft" in 2003 and "Skylon" in 2008, and two other albums on Ottsonic – "Mir" in 2011 and "Fairchildren" in 2015.
// 							</p>

// 							<p>
// 								The electro genius performed at the Glastonbury Festival in 2007, and then in 2011 he performed at Glade Festival, a show that was described as "the perfect opening act" in an article at Virtual Festivals. The same publication also called Ott a "Psy-dub maestro" and ranked his performance 10/10. The Israeli crowd was first exposed to Ott in the early 2000's with the album "Hallucinogen in Dub", the remix album he produced for Simon Posford. All the albums he released later only enhanced the effect he has with his powerful and addictive music.
// 							</p>

// 							<p>
// 							   The All Seeing I are an English electronic music group from Sheffield, consisting of Dean Honer, Jason Buckle and DJ Parrot. Their first single "I Walk" came out in 1997, but it was only in the following year that they gained mainstream commercial success with the song "Beat Goes On". The trio worked with artists such as Tony Christie, Jarvis Cocker, Babybird, Phillip Oakey and many others.
// 							</p>

// 							 <p>
// 							    Ott has performed Tel Aviv twice in the past and his shows received incredible reviews. This is guaranteed to be a one of a kind night that you definitely don't want to miss!
// 							 </p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:32,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Take That",
//         smltitle: "Take That – Taking Tel Aviv By Storm!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											27.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//takethat.com/">
// 											  www.takethat.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/32/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The legendary British pop band is this coming November to rock Tel Aviv for one show only!
// 							</p>
// 							<p>
// 								Take That started in Manchester in 1990 and currently includes Mark Owen, Gary Barlow, and Howard Donald. The original band also featured Robbie Williams and Jason Orange. Barlow is the band's lead singer and songwriter, while Owen and Donald act as backing vocals.
// 							</p>

// 							<p>
// 								Their most memorable songs include "Pray" which won The Guardian Music Award for Best Number 1 Single, "Back For Good" which won BRIT Award for Best British Single, "Everything Changes" and "Could It Be Magic." The band released 28 top 40 singles and 17 top 5 singles in the United Kingdom, out of which 12 reached number one, and they have 7 number one albums. Internationally, the band released 56 number one singles and 37 number one albums. They won 8 Brit Awards, including awards for Best British Live Act and Best British Group.
// 							</p>

// 							<p>
// 							   The British pop sensation set the record in 2011 for the fastest-selling tour of all time in the United Kingdom with "Progress Live", beating their own personal record from 2009 with their "Circus Live Tour". They were named as Amazon's top-selling music artist of all time, and in 2012 Forbes announced them as the fifth highest-earning music stars in the world. During the same year, the Official Charts Company announced the biggest-selling singles artists in the British music chart history with Take That being placed at 15th overall and having four of the best-selling albums of the millennium, which makes them the most successful boy band in the UK chart history.
// 							</p>

// 							 <p>
// 							   The band will come to Israel as a part of its international tour in order to promote its last album "Wonderland". Their previous tours have gotten raving reviews, with "Progress" winning Audio Pro International Awards for Best Live Sound Event and Audio Pro International Awards Grand Prix Award. Their performance in Tel Aviv will for sure be a one to remember, don't miss out!
// 							 </p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:33,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Kooks",
//         smltitle: "Getting it on with the Kooks in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											27-28.01.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.thekooks.com/">
// 											  www.thekooks.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/33/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The Kooks – one of the ultimate British rock/pop bands of the century are coming this January to rock Tel Aviv as a part of "The Best of The Kooks" tour that marks a decade to their existence.
// 							</p>
// 							<p>
// 								The band was formed in Brighton, UK, in 2004 by lead singer Luke Pritchard and consists of Hugh Harris the lead guitarist, drummer Alexis Nunez and bassist Peter Denton. The band released its debut album, "Inside In/Inside Out" in 2006, which included hits such as "Ooh La" and "She Moves in Her Own Way" and achieved quadruple platinum status in the UK within a year and also abroad in the form of a platinum certification in Australia and two times platinum in Ireland.
// 							</p>

// 							<p>
// 								The group released its second album "Konk" in 2008 which debuted at number one on the UK Albums Chart and recorded first week sales of 65000, achieving gold status in both the UK and Ireland, which continued to establish their reputation as one of the world's most beloved brit-pop and post-punk bands. In 2011 their third album "Junk of the Heart" came out, followed by "Listen" in 2014 which debuted at No. 16 on the UK Albums Chart. Besides the fact that they quickly signed with "Virgin Records" only 3 months after forming, they also won several awards, such as MTV's best band of 2006 award, Best UK & Ireland Act at the MTV Europe Music Awards 2006 and even a nomination for the famous Brits award.
// 							</p>

// 							<p>
// 							  The band's music is primarily influenced by the 1960s British Invasion movement and post-punk revival of the new millennium. The Kooks have experimented in genres such as pop, reggae, ska, Britpop, rock, funk and hip-hop, and released songs that were describes as "catchy as hell".
// 							</p>

// 							 <p>
// 							  The Kooks are known for their amazing sold out shows and this one is due to be no different, so make sure to get your ticket now!
// 							 </p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:34,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Willy William and Farruko",
//         smltitle: "The reggaetón superstars coming to get you movin’ in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											  Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											28.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.reggaetontelaviv.co.il/indexEN.php">
// 											  www.reggaetontelaviv.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/34/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The reggaetón superstars coming to get you movin’ in Tel Aviv!
// 							</p>
// 							<p>
// 								Willy William and Farruko, the reggaeton megastars are coming this fall to perform as a part of the "Reggaeton Tel Aviv" festival and get the people of Tel Aviv on their feet in one extraordinary show only!
// 							</p>

// 							<p>
// 								Farruko , the 26-year-old world famous reggaton singer comes from Puerto Rico. He started his professional career in 2009 through Myspace. Since then, he released six albums and collaborated with Sean Paul, Daddy Yankee, Maluma, Don Omar, Shaggy, Nicky Jam, Ky-Many Marley, Chino&Nacho, J Balvin, Ozuna and many other successful reggaeton legends, and he was nominated for the Latin Grammy awards in 2012. His hits got millions of views on Youtube, and among them, one can find the famous "6 AM", "Passion Wine", "Me Voy Enamorando", "Krippy Kush", "Sunset" and "Chillax".
// 							</p>

// 							<p>
// 							  The 36-year-old singer, producer and DJ, Willy William is coming to Tel Aviv all the way from France. He's known for his remixes and collaborations with dance artists. His big breakthrough was in 2003 when he collaborated with DJ Flex and released his hit "B Boyz Shake da Body" and right afterwards his next song "Tragedie" and the name "Lord William". His most famous hits are "EGO" and "Mi Gente" which topped the charts in many radio stations worldwide, including Israel.
// 							</p>

// 							 <p>
// 							  Come get the addictive reggaetón vibes in you and dance the night away in the city that just won't quit!
// 							 </p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:35,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Buena Vista",
//         smltitle: "The ultimate Cuban experience in Tel Aviv & Jerusalem!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv and Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											21-26.12.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.pasion-de-buena-vista.com/">
// 											  www.pasion-de-buena-vista.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/35/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   The ultimate Cuban experience in Tel Aviv & Jerusalem!
// 							</p>
// 							<p>
// 								After 600 shows worldwide -  the extraordinary Buena Vista Cuban sensation is coming for first time to give Tel Aviv and Jerusalem a taste of Cuba!
// 							</p>
// 							<p>
// 								The show is a one-of-a-kind experience that expresses love to the Cuban culture with all the known Cuban hits such as La Vida es un Carnaval. The Buena Vista Band includes 11 talented musicians, working together with a group of unbelievable dancers to provide an experience you never had before.
// 							</p>

// 							<p>
// 								The show will be held in two separate dates in Tel Aviv and Jerusalem, both awesome choices offering a huge host of activities and experiences in a unique unrivaled atmosphere. Jerusalem is known for its rich history, interesting architecture and incredible cultural diversity, while Tel Aviv is known for its fast tempo, warm exotic weather, amazing beaches and non-stop nightlife! Whatever city you'll choose- you visit is bound to be exciting and packed with unforgettable experiences!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:36,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Jerry Seinfeld",
//         smltitle: "Comedy King Closing 2017 in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											30.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.jerryseinfeld.com/">
// 											  www.jerryseinfeld.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/36/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Comedy King Closing 2017 in Tel Aviv!
// 							</p>
// 							<p>
// 								Jerry Seinfeld, the undisputed king of American comedy is returning to Tel Aviv for two performances which will be held on the same night in Tel Aviv.
// 							</p>
// 							<p>
// 								Home to incredible comedy venues a sought-after location for many international comedians such as Eddie Izzard, Jim Jeffries, Chris Rock and many others, Tel Aviv has a hedonistic vibe, incredible vibrancy and energy and a liberal loose spirit making in a comedy heaven.
// 							</p>

// 							<p>
// 								Seinfeld, hailed as one of the top comedians of his generation has without a doubt shaped the way we watch television and sitcoms, with his iconic show “Seinfeld” which ran from 1990-1998 and reigned over primetime TV for nearly a decade.
// 							</p>

// 							<p>
// 							   However, Seinfeld is a man loyal to his roots and has often declared that performing live is one of his favorites and he’s coming to Tel Aviv to do Just that.
// 							</p>

// 							<p>
// 							  This December, Seinfeld will strut his stuff onstage live in his hilarious laugh- a – second style, performing two consecutive shows in the nonstop city of Tel Aviv, and what better city is there to close the 2017 with a smile?
// 							</p>

// 							<p>
// 							   For visitors coming to check out Seinfeld’s show, the city of Tel Aviv, with its winter sunshine and world-famous nightlife is without a doubt THE place to spend a fantastic and absolutely unforgettable Tel Aviv Style New Year’s Eve.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:37,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Alt-J",
//         smltitle: "Comedy King Closing 2017 in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											29.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.altjband.com/">
// 											  www.altjband.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/37/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  The British indie band is returning to Tel Aviv once again after their last successful sold-out show in Israel two years ago. The band was formed in 2007 in England, and their debut album “An Awesome Wave” was released in 2012 and won the Mercury award the same year. The band is a combination of electro-pop, psychedelic folk, African beats, post-dubstep and rock n’ roll. The band members met through their mutual love for Radiohead while they were in college, and their sound was affected by the fact that they weren’t allowed to use a bass guitar and drums when they were students.
// 							</p>
// 							<p>
// 								The band comes to rock Tel Aviv this spring and invites fans from all over the world to come and enjoy the wonderful alternative music scene that the city that never sleeps can offer. From extraordinary art galleries to unique theatre shows to live music concerts – the cultural scene in Tel Aviv is one of a kind. It’s a home for many musicians and artists, and now it welcomes every culture lover.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:38,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Ozzy Osbourne",
//         smltitle: "Ozzy O -  coming to say goodbye to Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											08.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.ozzy.com/">
// 											  www.ozzy.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/38/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Ozzy O -  coming to say goodbye to Tel Aviv!
// 							</p>
// 							<p>
// 								Ozzy Osbourne, the world-famous metal legend returns to Tel Aviv for the last time as part of his farewell tour. While known to younger audiences mainly from the reality show “The Osbournes”, Ozzy was already a musical icon and a huge star since way before – from his role as the lead singer for Black Sabbath, to being the headliner in the international metal festival that was named after him, the “Ozzfest”.
// 							</p>

// 							<p>
// 							   After 2500 shows all around the world, the star comes to say goodbye to his fans in Tel Aviv, a city known around the world for its rich rock and metal scene. Being the most liberal city in Israel, Tel Aviv is always full of action and attracts both younger and older visitors who craving a taste of the underground culture. The rocking city is full of bars with rock themes, alternative clubs, live music venues and is known to attract music lovers from every country.
// 							</p>

// 							<p>
// 							   Don’t miss your chance to see the metal star for the very last time, make sure to get your ticket now and come rock it with ozzy in rockin’ Tel Aviv!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:39,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Jim Jefferies",
//         smltitle: "Jim Jefferies Kicks Off 2018 in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											16.01.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//jimjefferies.com/">
// 											  www.jimjefferies.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/39/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Jim Jefferies Kicks Off 2018 in Tel Aviv!
// 							</p>
// 							<p>
// 								One of the most popular comedians worldwide, Jim Jefferies, is returning to Tel Aviv after only a year. He will be kicking off 2018 and unleashing his famous humor with new material in a new show, “The Unusual Punishment Tour”.
// 							</p>

// 							<p>
// 							  The show will take place on a special 360-degree platform at the Menorah Mivtachim Hall in Tel Aviv, the perfect location for a comedian of his stature. Catching the show with the hilarious Australian performer is just the right excuse to come visit Tel Aviv, renowned for its exciting atmosphere and diverse nightlife scene.
// 							</p>

// 							<p>
// 							  Take the opportunity to visit one of the exciting bars or clubs which attract top International DJs, or visit one of the smaller neighborhood bars or cafes with its atmospheres to suit all tastes. Whether it’s food, drink or dancing you are after, Tel Aviv has it all.
// 							</p>

// 							<p>
// 							    After creating, writing, producing and starring in the critically acclaimed FX series, Legit, Jefferies and his material have gained a cult following. His voice has become well-known in late-night entertainment, making his show a must-see in Tel Aviv. Those coming to the Tel Aviv for Jefferies’ show will enjoy some good laughs, set on a background of stunning warm winters and an exciting night vibe.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:40,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Gerard Depardieu & Isabelle Adjani",
//         smltitle: "“Love Letters” Coming to Tel Aviv from France!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											05.03.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/40/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 “Love Letters” Coming to Tel Aviv from France!
// 							</p>
// 							<p>
// 								From France with love! French actors, Gerard Depardieu and Isabelle Adjani, will be performing “Love Letters” in March in Tel Aviv. Written by the late A.R. Gurney, the show has been performed on and off-Broadway by actors and actresses around the world.
// 							</p>

// 							<p>
// 							 The Pulitzer Prize-nominated show is now coming to Israel and will be performed by Gerard Depardieu and Isabelle Adjani in French, with Hebrew and Russian subtitles. With the performance taking place in Tel Aviv, visitors to the city will have the chance to enjoy some of the exotic and exciting nightlife that makes Tel Aviv so popular.
// 							</p>

// 							<p>
// 							  With restaurants to suit all palettes, dinner is just the thing for before the show, and with a nightlife that just starts to come alive around midnight, those who are looking for some adventure after the show will have plenty of options open to them. Anyone visiting the city especially for the show is sure to come away dazzled, both by the liveliness of the atmosphere and from the two well-known French stars.
// 							</p>

// 							<p>
// 							   While this is Adjani’s first trip to Israel, Depardieu has been here a number of times, and this occasion is sure to be memorable.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:41,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "A-HA",
//         smltitle: "An Electric Summer with A-HA!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											21.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://a-ha.com/">
// 											  www.a-ha.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/41/1.gif"} class="img-responsive" />
// 							</div>

// 							<p>
// 							 An Electric Summer with A-HA!
// 							</p>
// 							<p>
// 								Israel will be treated to an exciting performance from Norwegian band, A-HA, in June, 2018. Coming to Israel as part of their Electric Summer Tour 2018, the band will perform in Tel Aviv at the Exhibition Grounds in a show that promises to be a hit.
// 							</p>

// 							<p>
// 							 Formed in Oslo in 1982, A-HA has been talked about for more than three decades, and since their hit “Take On Me” in 1985, they have grown to be one of the most popular Scandinavian bands in the world. While they originally split up in 2010, they have come back together again for a number of tours and Tel Aviv is honored to be among their stops this time around.
// 							</p>

// 							<p>
// 							 Fans of the band will be treated to an exciting performance by the well-known group, while having the chance to enjoy some of the best entertainment venues in the country. From museums to theatres, restaurants to clubs, there is something to suit everyone in the bustling city of Tel Aviv.
// 							</p>

// 							<p>
// 							  Take the opportunity to enjoy a walk along the brilliant beachfront as the city’s locals get ready for the summer sun, and enjoy the vibe as diverse cultures come together for the band’s latest show.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:42,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Ringo Starr",
//         smltitle: "Ringo’s All Starr Band Headed to Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											23-24.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.ringostarr.com/">
// 											 www.ringostarr.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/42/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Ringo’s All Starr Band Headed to Tel Aviv!
// 							</p>
// 							<p>
// 								It’s been a year of stars in Tel Aviv and the latest concert to come to the dynamic city, has everyone talking! Ringo Starr will be coming to Israel as part of his European Tour and will be performing two concerts with his All Starrs Band at the Menorah Mivtachim Arena in June 2018.
// 							</p>

// 							<p>
// 							Starr, an English songwriter, singer and actor, first became famous as the drummer for the Beatles; however, since 1989, he has toured with his All Starr Band. The 77-year old released his 19th studio album in September, known as “Give More Love.”
// 							</p>

// 							<p>
// 							Tel Aviv is the ideal location for a concert with such a big name. Known as the New York City of Israel, Tel Aviv is the center of excitement, fun and initiatives in the country. As the city that attracts over a million tourists each year, whether for business or pleasure, Tel Aviv offers a beautiful beach, unique restaurants, theatres, museums and pulsing bars.
// 							</p>

// 							<p>
// 							  If you are joining the many fans who are coming to Tel Aviv to hear Ringo and his All Starrs Band perform, make sure not to miss out on the rest of what Tel Aviv has to offer and come away with an experience to remember.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:43,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "The Scorpions",
//         smltitle: "Tel Aviv to Go Crazy in July with The Scorpions!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											19.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.the-scorpions.com/">
// 											 www.the-scorpions.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/43/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Tel Aviv to Go Crazy in July with The Scorpions!
// 							</p>
// 							<p>
// 								One of the most well-known heavy metal bands in history, The Scorpions, will be coming to the Menorah Mivtachim Arena in Tel Aviv in July 2018, as part of their Crazy World Tour.
// 							</p>

// 							<p>
// 							One of the most well-known heavy metal bands in history, The Scorpions, will be coming to the Menorah Mivtachim Arena in Tel Aviv in July 2018, as part of their Crazy World Tour.
// 							</p>

// 							<p>
// 							Those looking to make a day of it in Tel Aviv, will have their pick of food and entertainment venues. The spirited city has become a melting pot of cultures and this is reflected in the museums, restaurants and street stalls that can be found all around the city. Enjoy cuisine to suit every palate, stroll around the interesting streets or pop into one of the many unique exhibitions that can be found around the city.
// 							</p>

// 							<p>
// 							  With the show scheduled for the beginning of the summer, it will be daylight until late and the locals will be out enjoying the sunshine. Soak up the vibe before you go on to rock the night away with The Scorpions!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:44,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Natalia Oreiro",
//         smltitle: "Natalia to Wow Tel Aviv in March",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											20.03.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.nataliaoreiro.com/">
// 											 www.nataliaoreiro.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/44/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							Natalia to Wow Tel Aviv in March
// 							</p>
// 							<p>
// 								South American singer and actress, Natalia Oreiro, is headed to Israel in March, where she will be performing a live concert at Menora Mivtachim Arena in Tel Aviv. Coming back to Tel Aviv, straight from Argentina, fans are looking forward to seeing the Latin star once again.
// 							</p>

// 							<p>
// 							Having performed in numerous daily series, including telenovelas and movies, and after producing 3 CDs, she will bring some of her biggest hits to the show, such as Cambio dolor, Corazon Valiente, Me Muero de Amor and Rio de la Plata y más, as she opens her new World Tour.
// 							</p>

// 							<p>
// 							Tel Aviv, which attracts celebrity singers, actors and performers from around the world, is the perfect location for the Grammy-nominated singer from Uruguay. The pumping city offers entertainment beyond the walls of the Menora Mivtachim Arena, with its trendy restaurants, upscale bars, and clubs.
// 							</p>

// 							<p>
// 							 Natalia, who has performed in Israel many times in the last 20 years, already has a following here. The show is sure to attract a large audience. Join the excitement before the performance by satisfying your taste buds in one of the many highly-acclaimed restaurants in the area or continue the celebration after the curtains have closed with a drink at a pub. Whatever your tastes, Tel Aviv is a great complement to Natalia Oreiro.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:45,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "André Rieu",
//         smltitle: "Tel Aviv to Be Treated to Rieu in 2018",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											04-05.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.andrerieu.com/">
// 											 www.andrerieu.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/45/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Tel Aviv to Be Treated to Rieu in 2018
// 							</p>
// 							<p>
// 								World-class Dutch composer and violinist, André Rieu, is coming to Tel Aviv with his Johann Strauss Orchestra for a performance that promises to be unforgettable. The two events, which are Rieu’s first in Israel, will be held at the Menora Mivtachim Arena in Tel Aviv.
// 							</p>

// 							<p>
// 							Rieu will be conducting his 60-piece orchestra while playing his famous Stradivarius violin, treating the audience to their repertoire of renowned ballads and waltzes. The event will be particularly captivating as Rieu will be presenting his new album, “Amore,” which includes a unique interpretation of Naomi Shemer’s “Jerusalem of Gold.”
// 							</p>

// 							<p>
// 							Tel Aviv, with its many facets, is just the right location for the range of musical pieces that Rieu and the Johann Strauss Orchestra will be performing. From the beach to the theater, classy restaurants to lively pubs, Tel Aviv has it all. Sit down to a posh dinner, visit a charming cafe, or enjoy a drink at a chic bar, before you end off your evening with a concert that promises no shortage of exquisite music.
// 							</p>

// 							<p>
// 							  André Rieu has become one of the most popular live acts around the world and Tel Aviv is about to find out why! Make sure you don’t miss out on the experience!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:46,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Foreigner",
//         smltitle: "Foreigner Returning to Israel in May!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											05.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.foreigneronline.com/">
// 											 www.foreigneronline.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/46/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Foreigner Returning to Israel in May!
// 							</p>
// 							<p>
// 								Popular British hard rock band, Foreigner, is returning to Tel Aviv in May 2018. After recently playing 2 concerts in Caesarea, the band will now be performing in the entertainment capital of the country, Tel Aviv.
// 							</p>

// 							<p>
// 							Since being founded in 1976 by Mick Jones, Foreigner has sold nearly 80 million albums across the globe. It reached the height of its popularity in the 1980s, with some of its most well-known hits including “I Want to Know What Love Is,” “I Don’t Want to Live Without You,” “That Was Yesterday” and “Waiting for a Girl Like You.”
// 							</p>

// 							<p>
// 							With the band performing at the Menora Mivtachim Arena in Tel Aviv, fans and visitors will be able to make the most of the concert and enjoy the vibe and energy of the city. Soak up the rays on the beach as the summer sun starts to make an appearance or spend the day in one of the many museums or exhibitions of the city.
// 							</p>

// 							<p>
// 							 You will be transported back to the 80’s with this popular band, while enjoying the best that Tel Aviv has to offer. Don’t miss out on the great nightlife of the clubs and pubs after the show, as you complete your evening with style!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:47,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Don Mclean",
//         smltitle: "Enjoy a Piece of “American Pie” in June!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											16.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://don-mclean.com/">
// 											 www.don-mclean.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/47/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Enjoy a Piece of “American Pie” in June!
// 							</p>
// 							<p>
// 								Famous American songwriter, Don McLean, will perform in the outskirts of Tel Aviv in June, 2018. After almost 60 years of career, McLean remains most famous for his hit song, American Pie, which came out in 1972 and is still covered by big names in the industry, such as Madonna.
// 							</p>

// 							<p>
// 							   McLean has released 40 gold and platinum records, but it is his attachment to Israel that makes him so popular here. This is particularly clear with his song, Jerusalem, which he wrote in support of the country. This time, he will be performing closer to the entertainment capital of Israel, Tel Aviv.
// 							</p>

// 							<p>
// 							    With the show taking place only 10 minutes from the hustle and bustle of the lively city, there are plenty of options for fans to make a full day of the concert. Visit one of a number of world-class museums or take in one of the many temporary exhibitions that come to the city. If you’re looking for food, there is certainly no shortage in Tel Aviv with a range of styles and tastes to suit all visitors. Soak up the sun as summer begins to arrive or enjoy the sounds and scenes of the nightlife that Tel Aviv is famous for.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:48,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Enrique Iglesias",
//         smltitle: "Tel Aviv to Host Spanish Pop Legend!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											28.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://enriqueiglesias.com/">
// 											 www.enriqueiglesias.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/48/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Tel Aviv to Host Spanish Pop Legend!
// 							</p>
// 							<p>
// 								Spanish pop legend, Enrique Iglesias, will be returning to Israel for his fourth visit, this time to perform at the Yarkon Park in Tel Aviv. While this won’t be his first time in the entertainment capital of the country, it is expected to be his largest performance to date.
// 							</p>

// 							<p>
// 							  This visit comes close on the heels of the Hebrew remix of his popular piece, “Subleme La Radio,” together with Israeli singer, Rotem Cohen. Concert-goers can look forward to hearing some of Iglesias’ hit songs which may include “Bailamos,” “Hero,” “Be With You” and “I Like It.” He is expected to perform together with his long-time guitarist, Israeli Sean Hurwitz.
// 							</p>

// 							<p>
// 							   Iglesias is predicted to be one of the most popular concerts of the year judging by the fact that it will be held in the Yarkon Park venue which can accommodate up to 100,000 people. Those looking to make a whole evening of the event will find plenty to keep them entertained in Tel Aviv before the concert starts.
// 							</p>

// 							<p>
// 							    With a wide range of eateries and pubs, there is something to suit all tastes. Enjoy the limitless choices when it comes to restaurants and pick up the vibe of the city before heading off to the main event.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:49,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Blood Sweat and Tears",
//         smltitle: "Blood, Sweat & Tears Headed to Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											22.10.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//bloodsweatandtears.com/">
// 											 www.bloodsweatandtears.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/49/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Blood, Sweat & Tears Headed to Tel Aviv!
// 							</p>
// 							<p>
// 								Legendary rock band, Blood, Sweat & Tears, is heading to Israel for one concert to be held in Hangar 11 in Tel Aviv. The band was last in Israel 10 years ago when they played in Tel Aviv and Caesarea.
// 							</p>

// 							<p>
// 							  Established in 1967 in New York City, their best-known hits include “I Love You More than You’ll Ever Know,” “I Cannot Quit Her,” “When I Die” and “You’ve Made Me So Very Happy.” There are no original members of the band left, but seven current members will take to the stage when they perform in March. These include lead vocalist and popular runner-up to American Idol in 2005, Bo Bice.
// 							</p>

// 							<p>
// 							   Tel Aviv promises a full day of excitement for concert-goers with the opportunity to enjoy the beautiful beaches, parklands and entertainment options that the city offers before the concert even begins. Make sure to eat in one of the many restaurants scattered around the city and immerse yourself in the character of Tel Aviv by visiting one of the popular pubs or clubs that make up its charming nightlife.
// 							</p>
//                             <p>
//                                 Create the perfect night out as you combine the atmosphere of Tel Aviv with jazz and rock in a unique concert from Blood, Sweat & Tears.
//                             </p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:50,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Jamiroquai",
//         smltitle: "Jamiroquai Heads to Israel in May!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											02.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.jamiroquai.com/">
// 											 www.jamiroquai.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/50/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Jamiroquai Heads to Israel in May!
// 							</p>
// 							<p>
// 								British band, Jamiroquai, is heading to Israel in May 2018, where they will perform in the outskirts of the bustling city of Tel Aviv. With only one performance in Israel, the popular band from the 90s is expected to attract a large crowd.
// 							</p>

// 							<p>
// 							  The band has published 8 studio albums, with “Automaton” being their latest from 2017. The hip city of Tel Aviv is the ideal location for a concert that promises an exciting performance by the group that introduced “future funk” and took the world by storm. Founded in 1992 by Jay Kay, Jamiroquai holds the Guinness Book of World Records listing for “Best Selling Funk Album” of all time.
// 							</p>

// 							<p>
// 							   Anyone looking for a lively night out will do well to head to this concert. Being held a short drive from the center of Tel Aviv, concert-goers will be able to begin the party early at one of the city’s top-notch restaurants, clubs or pubs. Start your evening with a quality dinner at any one of dozens of stylish restaurants and then move onto one of Tel Aviv’s famous clubs before making your way to the concert for an unforgettable night out.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:51,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Backstreet Boys",
//         smltitle: "The Backstreet Boys are Back and Larger Than Life",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											22.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.backstreetboys.com/">
// 												www.backstreetboys.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/51/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    The Backstreet Boys are Back and Larger Than Life
// 							</p>
// 							<p>
// 									The Backstreet Boys will be back in Israel this year for a concert. To be held in the outskirts of Tel Aviv in April, concert-goers will be able to enjoy the incredible vibe of the city together with some of the greatest hits in history.
// 							</p>

// 							<p>
// 									Tel Aviv is one of the most sought-after locations for big names in the entertainment industry, with its energy, vitality and spirit. There is no shortage of eateries, pubs and coffee shops for those looking for a culinary experience. Or, if you prefer to make a full day of it, you can visit some of the world-class museums, theaters or galleries around the city.
// 							</p>

// 							<p>
// 									Formed almost 20 years ago, the Backstreet Boys have produced 7 multi-platinum albums and sold more than 130 million records worldwide, with some of their most popular hits such as “I Want It That Way,” “As Long as You Love Me” and “Larger Than Life”.
// 							</p>
// 							<p>
// 									Visitors heading to the concert will be able to enjoy Tel Aviv at its best with beautiful Spring weather enticing locals and guests to the beach, before making their way to hear the best-selling boy band of all times!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:52,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Alice in Chains",
//         smltitle: "Alice in Chains Announces Debut Show in Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											17.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.aliceinchains.com/">
// 												www.aliceinchains.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/52/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Alice in Chains Announces Debut Show in Tel Aviv
// 							</p>
// 							<p>
// 									Making their debut appearance in Israel, rock band and grunge pioneer, Alice in Chains, will perform in July, north of Tel Aviv, in what promises to be an electrifying concert.
// 							</p>

// 							<p>
// 									Having come together in the late 80’s, Alice in Chains is one of four major groups that led the grunge revolution, and they became one of the most influential bands of all time. With music that combines rock, alternative rock and metal, the band was nominated for 9 Grammy awards and sold more than 20 million albums.
// 							</p>

// 							<p>
// 									Taking place in the middle of summer, Tel Aviv is the perfect location to start the day’s activities. If you’re looking for some indoor entertainment, visit one of the city’s world-class museums or galleries, or head over to one of the many restaurants around the city. For something a bit different, soak up the rays walking along the promenade of a beautiful beach or pop into a club or pub in the area before heading north for the concert.
// 							</p>
// 							<p>
// 									This show is part of the first European tour the band has been on in four years, and being its first appearance ever in Israel, it promises to be a night full of excitement.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:53,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Hardwell",
//         smltitle: "Hardwell Headed to Israel in April",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											06.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.djhardwell.com/">
// 												www.djhardwell.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/53/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Hardwell Headed to Israel in April
// 							</p>
// 							<p>
// 									Number 1 ranking DJ, Hardwell, is coming to Israel in April where he will thrill crowds just outside Tel Aviv. This will be his third concert in the country, after performing to sell-out audiences in 2013 and 2017.
// 							</p>

// 							<p>
// 									Robbert van de Corput, better known as DJ Hardwell, first made a name for himself at the young age of 14, but it was at age 25 when he truly became famous, named World’s #1 DJ by the 2013 DJ Mag. Hardwell has become an International name, hosting his own radio show which is broadcast around the world, and producing a consistently top 10 iTunes podcast. He is also well known for his remix of The Wanted’s “Chasing the Sun”.
// 							</p>

// 							<p>
// 									Tel Aviv is the ideal location for a concert of this type with the natural vibe and energy of the city adding to the excitement that will be in the air. Tel Aviv in Spring is full of blue skies and warm weather, attracting crowds to the beach and the outdoor cafes and restaurants that can be found throughout the city. Enjoy a full day out or join the gathering of people at one of the city’s world-class restaurants before heading to the concert.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//         id:54,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Jethro Tull",
//         smltitle: "Jethro Tull’s 50th Anniversary Tour Heads to Israel",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv and Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											27-28.10.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.jethrotull.com/">
// 												jethrotull.com/
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/54/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Jethro Tull’s 50th Anniversary Tour Heads to Israel
// 							</p>
// 							<p>
// 									Ian Anderson, vocalist, flutist, and guitarist of the popular British rock band, Jethro Tull, is coming to Israel for the band’s 50th anniversary tour. Performances will take place at Heichal Hatarbut in Tel Aviv on October 27, followed by the International Convention Center in Jerusalem on October 28.
// 							</p>

// 							<p>
// 									Formed in 1967, the band initially played blues rock, but later evolved and developed elements of hard rock. Their greatest success came in the 1970s with hit songs such as “Bungle In The Jungle,” “Living In The Past,” and “The Witch’s Promise.” The band has performed in Israel numerous times in the past, and Anderson who is the only remaining member of the band who is coming on tour, is expected to receive a warm welcome.
// 							</p>

// 							<p>
// 									Performing in both Tel Aviv and Jerusalem will appeal to a wide audience. Join the energy and vibe of the lively city of Tel Aviv with its nightlife, culinary experiences and beautiful beaches, or enjoy the concert in the cultural and historic center of the country, which is Jerusalem. No matter which flavor of the region you prefer, there are plenty of restaurants, cafes, museums or galleries to visit in each of the cities before the venues open their doors.
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//       id:55,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Israel Calling",
//         smltitle: "Good Evening Europe, This is Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											08-10.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 						<!--	<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>-->

// 							<h2>
// 							   Good Evening Europe,<br class="show-on-mobile"> This is Tel Aviv!
// 							</h2>
// 							<p>
// 								Eurovision fever is sweeping over Tel Aviv as it confirms hosting the star and glitter studded event - “Israel Calling”, for the 3rd consecutive year!
// 							</p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/55/1.jpg"} class="img-responsive" />
// 							</div>

// 							<p>
// 								About 30 delegates from Eurovision participating countries worldwide will be gathering at the beginning of April in the nonstop city of Tel Aviv, for the largest Eurovision promo-event to ever take place in front of a crowd of thousands from Israel and around Europe.
// 							</p>

// 							<p>
// 								This unique and exciting event, held only in Tel Aviv, will give Eurovision fans from far and wide an amazing and completely free of charge opportunity to take part in the glamour of the Eurovision right here in the beautiful city of Tel Aviv.

// 						</p>

// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/55/2.jpg"} class="img-responsive" />
// 						</div>

// 						<p>
// 						The event will be held for three days starting on the 8th of April. The main stage will be set in Rabin Square, Tel Aviv’s main square and one of the city’s favorite outdoor venues, located at the heart of the buzzing city.
// 						</p>

// 						<p>
// 						The main event will take place on Tuesday and will include a mini Eurovision show in front of a live audience, featuring performances by the various Eurovision contenders performing the songs they will be competing with on the main event in May.

// 						</p>

// 						<p>
// 						This much anticipated pre-Eurovision event is set to take place just a few minutes’ walk from the stunning Tel Aviv beach. Fans and music lovers coming to see the show will get to take in all the city has to offer, including the excellent bars, restaurants and the awesome nightlife in this world-famous ultimate vacation destination called Tel Aviv.
// 						</p>

// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/55/3.jpg"} class="img-responsive" />
// 						</div>

// 						`
// 			}
// 		}

//     },

//     {

//       id:56,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Clean Bandit",
//         smltitle: "Clean Bandit Announces First Visit to Israel",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											26.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//cleanbandit.co.uk/">
// 												cleanbandit.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/56/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Clean Bandit Announces First Visit to Israel
// 							</p>
// 							<p>
// 									British electro-pop group, Clean Bandit, which has become one of the leading dance acts around the world, has announced their debut performance in Israel. Visiting as part of their European tour, the band will play on the outskirts of Tel Aviv on June 26.
// 							</p>

// 							<p>
// 									Formed in 2008, they became well-known for merging classical instruments and pop with a unique and masterful outcome and they became a sensation with their smash hits “Rather Be,” “Real Love,” “Rockabye,” and “Symphony.” Since its release in 2016, “Rockabye” has been viewed almost 2 billion times on YouTube, while they won a Grammy for “Rather Be” in 2015.
// 							</p>

// 							<p>
// 									The band has been together for ten years and has seen incredible success in the that time. Join the throngs of people heading to Tel Aviv for the group’s first visit.
// 						    </p>

// 						    <p>
// 									Tel Aviv is just the venue for the unforgettable night that this concert offers. With cafes, bars, clubs, and pubs throughout the city, there is no shortage of activities in Tel Aviv. Known as “the city that doesn’t stop”, you can take advantage of the buzz of the nightlife and enjoy the vibe of the bustling beachfront at any hour before or after the concert.
// 						    </p>

// 						`
// 			}
// 		}

//     },

//     {

//        id:57,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Alanis Morissette",
//         smltitle: "Alanis Morissette to Turn Up The Heat with Summer Performance in Israel",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											30.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//alanis.com/">
// 												alanis.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/57/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Alanis Morissette to Turn Up The Heat with Summer Performance in Israel
// 							</p>
// 							<p>
// 									Canadian singer and songwriter, Alanis Morissette, will return to Israel in the summer for one show which will take place on the outskirts of the lively city of Tel Aviv. Morissette has performed in Israel a number of times, including in 2000 and 2012, since she released her first album, “Jagged Little Pill” in 1995.
// 							</p>

// 							<p>
// 									The popular alternative rock singer is expected to rock Tel Aviv with some of her top hits, including “All I Really Want,” “Hand in My Pocket,” “Head Over Feet,” “Ironic,” “You Learn,” and “You Ought to Know.” Having taken home seven Grammy Awards and with eight albums having sold more than 60 million copies across the globe, her upcoming visit is already causing much excitement.
// 							</p>

// 							<p>
// 									The Tel Aviv area is the perfect location for a concert of this calibre, with visitors to the city given an exceptional choice of wining, dining and entertainment options. Begin your night at one of the many world-class restaurants or head out to one of the quaint coffee shops or bustling bars to end off your evening. The music scene will be hotter than ever with Alanis Morissette this July!
// 							</p>

// 						`
// 			}
// 		}

//     },

//     {

//        id:58,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Marc Almond",
//         smltitle: "Marc Almond’s Amazing Summer Concert",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											14.08.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.marcalmond.co.uk/news/index.html">
// 												marcalmond.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/58/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Marc Almond’s Amazing Summer Concert
// 							</p>
// 							<p>
// 									English musician, Marc Almond, will be heading to Israel in the summer for a much-awaited concert. The singer, who is most famous for his part in the new wave duo Soft Cell, will be playing north of Just north of the nonstop city of Tel Aviv in August.
// 							</p>

// 							<p>
// 									Soft Cell became famous for its 80’s hits “Tainted Love,” “Torch,” “Say Hello, Wave Goodbye,” and others, while Almond’s solo career took off when the duo split in the mid-80’s with hits including “Jacky” and “Something’s Gotten Hold of My Heart.” In another tribute to the decade, the Israeli rock group, Tattoo, which broke up in 1989, will open the concert in a historic reunion.
// 							</p>

// 							<p>
// 									Fans have been waiting for this performance since 2011, when his planned concert was canceled due to technical reasons. The 2018 concert promises to be an experience to remember.
// 							</p>

// 						    <p>
// 									From music to art, culture to fun, Tel Aviv has something for everyone. Spend the day wandering the vibrant streets of the city or pop into one of the many museums, theatres or galleries downtown. Make sure to stop off for a bite to eat at any of the city’s many world-class restaurants so you’ll be energized for what is sure to be an awesome concert.
// 							</p>

// 						`
// 			}
// 		}

//     },
//     {

//         id:59,
//         bgImage:"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title : "Shakira",
//         smlTitle : "Shakira to heat up the summer in sizzling Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											09.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.shakira.com/">
// 												shakira.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/59/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Shakira to heat up the summer in sizzling Tel Aviv
// 							</p>
// 							<p>
// 									The worldwide sensation Shakira is set to perform for the first time on the big stage in Tel Aviv this coming July and the city’s a buzz. The 41-year-old Colombian superstar who has sold close to 200 million albums and has won over 250 awards including three Grammys is just the perfect fit for a summertime concert in Tel Aviv.
// 							</p>

// 							<p>
// 									With a long and illustrious list of hit songs, including “Waka-Waka”, “Chantage” and “Whenever, whenever” Shakira is one of the most celebrated artists in the world today and nearly every song she records tops the international charts and receives hundreds of millions of Youtube views.
// 							</p>

// 							<p>
// 									Shakira’s concert is due to be held on July 9th in Yarkon Park, Tel Aviv’s massive park also dubbed the city’s “Green Lung”, which boasts, in addition to beautiful greenery, a stunning lake and excellent bike trails, a huge outdoor live music venue.
// 							</p>
// 							<p>
// 							        The party atmosphere of the nonstop city in July, the beautiful beaches and amazing nightlife and cool street vibe, all set the scene for perfectly Shakira’s show-stopping style and what is guaranteed to be an explosive musical celebration in the heart of cool city of Tel Aviv.
// 							</p>

// 	                    `
// 			}
// 		}
//       },
//   //     {

//   //     id: 60,
//   //     bgImage:"/posts/bank/16/1.jpg",
//   //     mobBgImage:"/posts/bank/16/M.jpg",
//   //     title: "White Night TLV",
//   //     smlTitle: "A “White Night” Rager In the Non-Stop City!",
//   //     html: function(){
// 		// 	return {
// 		// 		__html: `

// 		// 					<h2 class="align-center">
// 		// 					   16.05.2019
// 		// 					</h2>
// 		// 					<h1 class="align-center">
// 		// 					   A “White Night” Rager In the<br class="show-on-mobile"/> Non-Stop City!
// 		// 					</h1>
// 		// 					<div class="responisve-iframe">
// 		// 						<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 		// 					</div>
// 		// 					<p>
// 		// 						When a city renowned across the world as the “City that never sleeps” holds an event like “White Night” – you know you’re in for a treat. “White Night”, one of Tel Aviv’s biggest events of the year, is a traditional annual citywide celebration which keeps the city up all night – everything is open and everything is happening across the city at the same time…
// 		// 					</p>

// 		// 					<p>
// 		// 						From the early evening and until dawn, the city becomes packed with tourists and locals, high on life and enjoying everything on offer, from shops and eateries to cinemas and culture venues – free of charge or at reduced rates, all night long!
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo By: Adam Primer
// 		// 					</small>
// 		// 					<p>
// 		// 						The origin of this now world-famous event dates back to 2003 when UNESCO declared the "White City", Tel Aviv’s largest architectural collection of Bauhaus style buildings a world cultural heritage site, giving it a unique status in the architectural heritage of the modern era.
// 		// 					</p>
// 		// 					<p>
// 		// 						This historic declaration has been celebrated yearly ever since by Tel Aviv-Jaffa in a series of white night events, named after the "White City" and Tel Aviv’s other well-known characteristic: being “The City That Doesn’t Stop”.
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo By: Kfir Sivan
// 		// 					</small>
// 		// 					<p>
// 		// 						The White Night is a celebration of numerous events held throughout the city, which seems to expand with every passing year. In recent years, the celebrations  included (to name just a few): a unique midnight public picnic, an epic headphones party in the city’s main square, countless live music concerts, amazing indoor as well as street theatre performances, fascinating nighttime tours, night sports classes , Yoga at sunrise, and of course countless epic parties, all taking place all night across the city at the same time.
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo by Moshik Lindenbaum
// 		// 					</small>
// 		// 					<p>
// 		// 						So you better get your rest on- you’re gonna need all your energy to keep up with “White Night” in the awesome city of Tel Aviv!
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo by: Guy Yechiely‎.
// 		// 					</small>

// 		// 			               `
// 		// 	}
// 		// }
//   //   },
//       {
//       id: 60,
//       bgImage:"/posts/bank/16/1.jpg",
//       mobBgImage:"/posts/bank/16/M.jpg",
//       title: "White Night TLV",
//       smlTitle: "All Night Citywide party in Tel Aviv on Eurovision Semifinal!",
//       html: function(){
// 			return {
// 				__html: `

// 							<h2 class="align-center">
// 							   16.05.2019
// 							</h2>
// 							<h1 class="align-center">
// 							   All Night Citywide party in Tel Aviv on Eurovision Semifinal!
// 							</h1>
// 							<div class="responisve-iframe">
// 								<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 							</div>
// 							<p>
// 								When a city renowned across the world as the “City that never sleeps” holds an event like “White Night” – you know you’re in for a treat, and this year the treat is going to be especially epic!
// 							</p>

// 							<p>
// 								As part of the warm and exciting welcome awaiting visitors during Eurovision week, the powers that be have decided to combine Tel Aviv’s annual “White Night” extravaganza with the Eurovision Semifinal set to be held on 16.05.2019.
// 							</p>
// 							<p>
// 								“White Night”, one of Tel Aviv’s biggest events of the year, is a traditional annual citywide celebration which keeps the city up all night – everything is open, and everything is happening throughout the city simultaneously.
// 							</p>
// 							<p>
// 								The origin of this now world-famous event dates back to 2003 when UNESCO declared the "White City as a world cultural heritage site, setting off annual citywide celebration in a series of white night events in the city that (truly) doesn’t sleeps.
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo By: Adam Primer
// 							</small>
// 							<p>
// 								From the early evening and until dawn, the city becomes packed with tourists and locals, high on life and enjoying everything on offer, from shops and eateries to cinemas and culture venues – free of charge or at reduced rates, all night long!
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo By: Kfir Sivan
// 							</small>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo by Moshik Lindenbaum
// 							</small>
// 							<p>
// 								So you better get some rest - you’re gonna need all your energy to keep up with “White Night” in the awesome city of Tel Aviv!
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo by: Guy Yechiely‎.
// 							</small>

// 					               `
// 			}
// 		}
//     },
//     {

//         id:61,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Brian Wilson",
// 	    smlTitle: "The legendary Brian Wilson returning to rock Tel Aviv!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											07.08.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.brianwilson.com/">
// 												brianwilson.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/61/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 The legendary Brian Wilson returning to rock Tel Aviv!
// 							</p>
// 							<p>
// 									He returns to the white city with Al Jardine and Blondie Chaplin as a part of his world tour that celebrates his biggest hits from the last 54 years. The Beach Boys is one of the world’s most successful bands, the band has won many Grammy awards, got their own star in Hollywood and entered the Rock N’ Roll hall of fame.
// 							</p>

// 							<p>
// 									The band sold over 100 million records over the years and produced more hits than any other American band. They’re known especially for their hits “God Only Knows”, “Get Around”, “California Girls” and “Good Vibrations”. Wilson’s solo career is also successful, he recorded 11 albums and won 2 Grammy awards.
// 							</p>

// 							<p>
// 									Wilson’s concert will take place in Tel Aviv on August’s 7th. The summertime provides long daylight hours that give visitors the perfect opportunity to see what Tel Aviv has to offer; from an incredible art scene to fantastic theatres, to phenomenal live music shows and world-class restaurants – there are so many options in the spectacular city of Tel Aviv for  everyone will to find their brand of fun and excitement in the nonstop city.

//                             </p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 62,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Jason Derulo and Rita Ora",
// 	    smlTitle: "Jason Derulo and Rita Ora to raise it up in Tel Aviv!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											The outskirts of Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											01.08.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.jasonderulo.com/">
// 												jasonderulo.com
// 											</a><br>
// 											<a target="_blank" href="//ritaora.com/">
// 												ritaora.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/62/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						         	Jason Derulo and Rita Ora to raise it up in Tel Aviv!
// 							</p>
// 							<p>
// 									The two mega pop stars will perform at the “Lollipop” festival that will take place at the outskirts of Tel Aviv on the first of August. Derulo, that made his big breakthrough in 2009 with the hit “Whatcha Say”, became over the last decade one of the biggest stars in the international music industry with his huge hits such as “Wiggle”, “Want to Want Me”, “Swalla”, “Tip Toe” and “Talk Dirty”. The popular British Pop star, Rita Ora, is known especially for her famous hits “I Will Never Let You Down”, “Anywhere”, “R.I.P” and “Hot Right Now”.
// 							</p>

// 							<p>
// 									The festival provides a great opportunity to explore the city that never sleeps and enjoy its famous nightlife scene – from world-class bars, to secret underground clubs, to live music shows and various culinary options and even alternative art galleries, Tel Aviv for sure has something for everyone to enjoy. Whether you’re following a map or letting yourself get lost in the streets, you’re sure to fall in love with Tel Aviv!
// 							</p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 63,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Julio Iglesias",
// 	    smlTitle: "The Latin legend returning to wow Tel Aviv!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											06.10.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.julioiglesias.com/">
// 												julioiglesias.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/63/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						             The Latin legend returning to wow Tel Aviv!
// 							</p>
// 							<p>
// 									Tel Aviv can’t wait for the return of the beloved Spanish star! With a great cultural scene, incredible culinary options, amazing beaches, phenomenal museums and galleries and plenty of unique spots to explore – those who come to enjoy Iglesias’s concert have plenty of different ways to spend their time in the cultural capital.
// 							</p>

// 							<p>
// 									The hot climate and long daylight hours just reminiscent of the phenomenal singer’s origin country, Tel Aviv offers a variety of options that suit all ages and therefore attracts a big amount of visitors all around the year.
// 							</p>
// 							<p>
// 							        Iglesias has an ongoing love affair with the nonstop city and his past shows were sold out. He’s one of the most successful singers in the history and during his career became a phenomenal success story all around the world. He has 77 different albums that sold over 300 million copies!
// 							</p>

// 							<p>
// 							         Many of the Spanish phenomenon’s hits have reached the top of the charts and he won numerous awards, such as the Grammy. His fans are incredibly excited about his return and tickets are selling like hot falafels. This is guaranteed to be a show to remember!
// 							</p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 64,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Maluma",
// 	    smlTitle: "The Reggaeton sensation returns to the white city!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											28.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//fame.malumaofficial.com/">
// 												fame.malumaofficial.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/64/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						           The Reggaeton sensation returns to the white city!
// 							</p>
// 							<p>
// 									After winning over the crowd’s hearts during his last visit, the Colombian reggaetón singer and songwriter Juan Luis Londoño Arias, better known by his stage name Maluma returns to the city that never stops for one show only!
// 							</p>

// 							<p>
// 									Maluma has several singles that have charted within the top 10 on Billboard Hot Latin Songs, including "Felices los 4", "Borro Cassette", "El Perdedor" and "Corazón". During his career he won several awards, among which there is MTV Europe’s award for best world tour. The phenomenal performer is known among his fans as “the Latin lover” despite being only 24 years old.
// 							</p>
// 							<p>
// 							       His show will be held on June’s 28th in HaYarkon Park, located in the heart of Tel Aviv. Fans from all over the world who come to the show can enjoy the lovely beaches the city has to offer, the variety of restaurants and cafes, the remarkable art scene, the world-class bars and clubs, the various shopping venues spread all across the city – Tel Aviv has something for everyone.
// 						    </p>

// 							<p>
// 							         The Latin superstar is known to be quite a charmer and win everyone over in his shows – don’t miss this fantastic mix of Maluma and Tel Aviv -  come see the legend live in the hot hot city!
// 						    </p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 65,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Martin Garrix",
// 	    smlTitle: "The 1# DJ comes to the nonstop city!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											10.09.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.martingarrix.com/">
// 												martingarrix.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/65/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						           The 1# DJ comes to the nonstop city!
// 							</p>
// 							<p>
// 									Martin Garrix , hailed as “the world’s best DJ” by DJMag is coming to get the party going in the nightlife capital of the middle east! With tons of world known clubs, bars, pubs and a one of a kind atmosphere, Tel Aviv is known for its vibrant vibe and incredible night scene.
// 							</p>

// 							<p>
// 									At 20 years old, the Dutch wonderkid is coming at the height of his career for one unforgettable show in Tel Aviv! The international hits machine became famous when he was only 17 and since then has released many loved tracks and climbed the charts all over the world.
// 							</p>
// 							<p>
// 							       Garrix is considered by many is the undeniable king of the industry. With remarkable hits such as “Animals”, “Tremor”, “In the Name of Love” and “Scared to Be Lonely”, the phenomenal DJ is one of the most popular performers in the world and is a must-have headliner for every well-known festival.
// 							</p>

// 							<p>
// 							        The show will be held in HaYarkon Park, in the heart of the awesome city, on September 10th. The international vibe, gorgeous location and great nightlife scene attract an extraordinary crowd that comes from different corners of the world and is guaranteed to make this show a once in a lifetime experience!
// 						    </p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 66,
// 	    bgImage:"/posts/bank/59/1.jpg",
// 	    mobBgImage:"/posts/bank/59/M.jpg",
// 	    title: "Eurovision Tel Aviv",
// 	    smlTitle: "Epic song contest in the Non-Stop City",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											14-18.05.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<!--<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>-->

// 							<h3>A once in a lifetime opportunity to visit Tel Aviv as it hosts the Eurovision song contest.</h3>
// 							<p>
// 						     Epic song contest in the Non-Stop City
// 							</p>
// 							<p>Semi-final 1: 14 May 2019</p>
//                             <p>Semi-final 2: 16 May 2019</p>
//                             <p>Grand Final: 18 May 2019</p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/67/1.svg"} class="img-responsive" />

// 							</div>
//                             <p>It’s getting hot hot hot in Fabulous Tel Aviv! The nonstop city is teaming with excitement as it is getting ready to host the 2019 Eurovision Song Contest in what promises to be one of the most epic events ever held in the famous party city. </p>
//                             <p>Tel Aviv, known for its amazing energy, stunning beaches, great year round weather and gorgeous people, is the perfect destination for an unforgettable citybreak.  Tel Aviv is known world over for its open mindedness and liberal spirit, making it the ideal host for the Eurovision song contest, offering visitors from far and wide the perfect opportunity to enjoy this vibrant and energetic city at its finest. </p>
//                             <div class="img-wrapper">

// 							    <img src=${getImgUrl() + "/Concerts/67/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>Major productions centered around the Eurovision contest month are already well on their way. Some of the exciting events planned include an amazing opening ceremony, a prestigious red-carpet event, and even a mega “Euro Village” which will be situated merely a minutes’ walk from the awesome Tel Aviv baordwalk and beach. The Euro Village will be open for 10 days and will include live performances from past and present mega stars as well as live screenings of the Eurovision contest’s semifinal and final. The contest itself will take place in the Expo Tel Aviv. </p>

//                             <p>The Eurovision Song contest in Tel Aviv is guaranteed to be an event of a lifetime, so make sure to book your trip now to the most amazing Eurovision contest yet, in the most amazing city of all! </p>

// 					               `
// 			}
// 		}
//     },

//    {

//         id: 68,
// 	    bgImage:"/posts/bank/68/1.jpg",
// 	    mobBgImage:"/posts/bank/68/M.jpg",
// 	    title: "",
// 	    smlTitle: "36 Years of Cinema Magic!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											25.07-04.08.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.jff.org.il/en">

// 												www.jff.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<h2>Jerusalem Film Festival (JFF)</h2>
// 							<p>Time to start preparing your Summer 2019 checklist: Buy suntan lotion, pick wildflowers, host a barbeque, make plans to attend the 36th Annual Jerusalem Film Festival! It’s 11 days, over 200 films, prizes awarded to the very best, and you’ll be a part of it all! From star-studded international features to independent productions and the best of Israeli cinema, this unique film fest showcases excellence from various genres. </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/68/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>Take advantage of the opportunity to meet festival guests, including world-renown stars, writers, directors, cinematographers and other movie-making professionals. Film enthusiasts will enjoy Jerusalem’s many cinema spaces and be delighted by JFF on the Go, which presents films under the stars throughout the festival, and Cinema Park, which includes a 300 square meter pool with rubber boats, a giant LED screen, and a concert stage featuring live musical performances nightly. </p>
//                             <p>As you travel across the city to attend screenings, workshops, master classes, parties, musical shows and other festival events, you’ll experience how ancient cultures give modern spice to the contemporary vibe and personality of this global city. Fill your spare time strolling through neighborhood streets, exploring local shops, and taking your pick of Jerusalem’s wide variety of restaurants and cafes. You may have attended other film fests, but you won’t find one quite like this and, certainly, none other can boast the grandeur of the eternal City of Peace! </p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 69,
// 	    bgImage:"/posts/bank/69/1.jpg",
// 	    mobBgImage:"/posts/bank/69/M.jpg",
// 	    title: "",
// 	    smlTitle: "Jerusalem Wine Festival (JWF)",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											01-31.08.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.imj.org.il/en/events/wine-festival-1">
// 												www.imj.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Jerusalem Wine Festival (JWF)</h2>
// 							<p>
// 								Relaxing summer evenings were made for an exquisite glass of fine wine! And for four days in August, you can enjoy world class selections and award-winning food at the 16th Annual JWF. Hosted in the beauty of the Japanese Art Garden of the Israel Museum, this is considered by many to be Jerusalem’s premiere social event. It’s a wine festival unlike any other, whose ambiance and stunning views of this historic city combine to make the JWF a not-to-be-missed experience.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/69/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Hundreds of wines will be served by dozens of well-known and boutique wineries. There’ll be free wine tasting opportunities, along with a culinary oasis of stalls offering cheeses, chocolates, olive oils, exceptional sauces, and tasty jams. And speaking of tasty jams, the festival will get your party started every night with two different live music concerts.
// 							</p>
//                            <p>
// 								Every year, the JWF welcomes a diverse and refined crowd of over 20,000 wine and culture lovers to Jerusalem. Many attend over multiple evenings simply to soak in the atmosphere. You could even build your stay in the city around the festival! Certainly, your days will be filled with sightseeing, shopping, and loads of walking about. The perfect way to unwind after your busy days might well be several fun-filled nights at the Jerusalem Wine Festival!
// 							</p>
// 					               `
// 			}
// 		}
//     },

//     {

//         id: 70,
// 	    bgImage:"/posts/bank/70/1.jpg",
// 	    mobBgImage:"/posts/bank/70/M.jpg",
// 	    title: "OPEN RESTAURANTS TLV",
// 	    smlTitle: "Feed Your Curiosity!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											2019 y.
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
// 												open-restaurants.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Feed Your Curiosity!</h2>
// 							<p>
// 								Ever wanted to get more than a taste of what gets created in a truly fine restaurant? Have you ever fantasized about what it would be like to be a top chef? Well, now’s your chance!
// 							</p>
// 							<p>
// 								OpenRestaurants is more than a culinary event, it’s a cultural happening that showcases Tel Aviv’s wide array of restaurants, chefs, and local culinary personalities. Guests get to meet with chefs from around the city, wander through open markets, and try their hands at cooking up flagship dishes under the supervision of first-class professionals. It’s your opportunity to experience a day in the life of the sophisticated chefs, line cooks, restaurateurs, food vendors, and others who make gastronomy in Tel Aviv as palate pleasing as it is.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/70/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Beyond peeking behind many kitchen curtains, OpenRestaurants hosts a range of events that include curated dinners, history presentations, and exhibitions of culinary-themed art, design, music, and technology!
// 							</p>
//                            <p>
// 								Many events are available at no charge, including the Culinary Innovation Summit, the Food & Hospitality Hackathon, and various food talks. There are also family-oriented events that focus on cooking activities for children and several market tours.
// 							</p>
//                            <p>
// 								Everyone’s gotta eat and there’s no one who doesn’t enjoy good food that’s well prepared. So, whether you like to understand the process behind the preparation, you like to do the preparing, or you just have a hearty appetite, there’ll be plenty to delight your senses at OpenRestaurants: Tel Aviv!
// 							</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 71,
// 	    bgImage:"/posts/bank/71/1.jpg",
// 	    mobBgImage:"/posts/bank/71/M.jpg",
// 	    title: "CULINARY FESTIVAL",
// 	    smlTitle: "Round Tables Culinary Festival",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											09-23.11.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
// 												open-restaurants.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Round Tables Culinary Festival</h2>
// 							<p>
// 								The 4th edition of this celebrated culinary experience that brings renowned chefs from around the globe and invites them to take over the kitchens of several of Tel Aviv’s most notable restaurants.
// 							</p>
// 							<p>
// 								This year offers a new twist: The eight visiting chefs are all women – hailing from Mexico, South Korea, Italy, Switzerland, Colombia, Slovenia, Spain, and the United States. They’ll work with their local counterparts in the creation of culture crossover chowdowns featuring signature dishes from the guest chefs alongside flavors offered by the local chefs from the host restaurants.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/71/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Everyone involved agrees that creative cooking is always intensely steeped cultural context and a deeply felt sense of place. All of them are passionate about using local ingredients. Of course, each of these chefs has received accolades and awards from international critics and guides.
// 							</p>
//                            <p>
// 								There’s no better way to showcase Tel Aviv’s growing prominence on the global stage of gastronomy than the annual Round Table event. Seats get reserved quickly and must be made in advance. So, don’t miss your chance for a place at these prestigious tables – your taste buds will never forgive you!
// 							</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 72,
// 	    bgImage:"/posts/bank/72/1.jpg",
// 	    mobBgImage:"/posts/bank/72/M.jpg",
// 	    title: "TEL AVIV FASHION WEEK",
// 	    smlTitle: "Tel Aviv Fashion Week (TAFW)",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//fashionweektelaviv.com/">
// 												fashionweektelaviv.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Tel Aviv Fashion Week (TAFW)</h2>
// 							<p>
// 								Fashion events are always occasions for the celebration of elegance, imagination, creativity, and style. But the TAFW has been making its mark in the international fashion industry with its recent attention to changing ideals of beauty, featuring models, both male and female, of different ages, sizes, heights, colors, and religions. The 4-day event showcases uncommon displays from around the world and those close to home in and around Tel Aviv’s vibrant design scene.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/72/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								TAFW also embraces leading edge fashion concepts by exhibiting innovative uses of technology and textiles. And it’s especially proud of the support it provides to young designers. As in past editions, this 7th annual event will feature an Upcoming Designers show in which new talent will have an opportunity to share their wares with you!
// 							</p>
//                            <p>
// 								In 2019, Tel Aviv Fashion Week will once again take place in the historic Tachana complex. Formerly the final stop of the old Jaffa-to-Jerusalem railway, the station has been transformed into one of Tel Aviv’s coolest and most lively public spaces. Located in a trendy neighborhood of pastel-colored homes, unique boutiques, and numerous cafes, you’ll want to explore the entire area while you’re getting your vogue on at the TAFW!
// 							</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 73,
// 	    bgImage:"/posts/bank/73/1.jpg",
// 	    mobBgImage:"/posts/bank/73/M.jpg",
// 	    title: "DGTL FESTIVAL",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://tlv.dgtl.nl/en/dgtl-tel-aviv-returns-to-israel/">

// 												tlv.dgtl.nl/en
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
//                             <p>After its stellar debut in Tel Aviv, DGTL Festival is back, bringing yet another excellent musical program to Yarkon Park, accompanied by the latest sustainable and technological innovations and fresh art projects.</p>

//                             <p>The DGTL festival is a global event at the forefront of the music and festivals scene, showcasing in an exclusive list of cities around the world: Amsterdam, Sao Paulo, Barcelona, Santiago and now Tel Aviv and bringing together the worlds of music, technology and art, as well as the latest discoveries in production and sound. </p>

// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/73/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>The DGTL festival will be held in an expanded edition with a huge lineup and will include three stages which will operate simultaneously at any given moment.</p>
//                             <p>In addition to being an innovative music festival, DGTL champions environmental protection and sustainability and has won prizes for being the greenest festival in Europe. The festival has a revolutionary program for saving electricity, vegetarian food only, a recycling plan and more. </p>
//                             <p>The Festival will be held in the fabulous Yarkon Park in the heart of the buzzing city of Tel Aviv, a hub of innovation, trendiness and exciting nightlife scene, making it the host for DGTL. </p>
//                             <p>Come and get your groove on in the most cutting-edge festival on the planet, held in heart of the most exciting city in the world! </p>

// 					               `
// 			}
// 		}
//     },
//     {

//         id: 74,
// 	    bgImage:"/posts/bank/74/1.jpg",
// 	    mobBgImage:"/posts/bank/74/M.jpg",
// 	    title: "Tel Aviv Marathon",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											22.02.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>

// 											<a target="_blank" href="https://www.tlvmarathon.co.il/MenuDefault.aspx?id=5418">
// 												www.tlvmarathon.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <h2  class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Run and fun in the city that doesn’t stop</h2><br/>
//                             <p>Tel Aviv Marathon is the country’s biggest international sports event and a unique and exciting celebration for runners worldwide. The Marathon is held in the heart of the fabulous city of Tel Aviv, giving participants the opportunity to take in its awesome sites and views and feel their heart beat become one with the pulse of this adrenaline charged metropolis. </p>
//                             <p>The Tel Aviv Marathon is city wide celebration stretching along the stunning beachfront, the amazing sites of the white city - a UNESCO World Heritage Site, and the city’s many buzzing stylish streets, packed with over 150,000 people taking part in the many side events, cheering the runners along the race’s flat and friendly course.   </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/74/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>Around 40,000 runners come from far and wide to take part in this multi-course annual even. Allowing runners in all levels and styles, from professional long-distance runners to beginners, to take part.</p>
//                             <p>Much more than just a run, the marathon is in fact a huge festival featuring a host of dedicated lively events before and after the race, full of live music, dancing and many other attractions to the delight of runners and supporters alike.  </p>
//                             <p>Dubbed ‘The Mediterranean Capital of Cool’ By the New York Times and among Lonely Planet’s ‘Top 10 Action-Packed Cities’. Tel Aviv offers a host of fascinating attractions from all walks of life including dazzling stretches of golden beaches, colorful markets, cutting edge culture and entertainment, outstanding nightlife & an exciting culinary scene. </p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 75,
// 	    bgImage:"/posts/bank/75/1.jpg",
// 	    mobBgImage:"/posts/bank/75/M.jpg",
// 	    title: "Jerusalem Marathon",
// 	    smlTitle: "The Ultimate Race against time in this spectacular Marathon held in the 3,000-Year-old magnificent city of Jerusalem",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											15.03.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://jerusalem-marathon.com/Register.aspx">

// 												jerusalem-marathon.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <h2>The Ultimate Race against time in this spectacular Marathon held in the 3,000-Year-old magnificent city of Jerusalem</h2>
//                             <p>The International Jerusalem Winner Marathon is one of Israel's largest marathons, with 30,000 participants including hundreds of elite runners from Israel and around the world.</p>
//                             <p>The marathon offers a variety of tracks, from professional to family friendly, which pass by fascinating historical sites that illuminate 3,000 years of the history of Jerusalem, Israel's capital guaranteeing a challenging, thrilling and unforgettable experience for all runners. </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/75/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>With a series of cultural happenings planned around the central event, the Jerusalem International Marathon provides international runners with the perfect opportunity to visit the ancient city while participating in a truly modern and excitement-filled competitive sporting event. </p>
//                             <p>The Jerusalem marathon allows runners the chance to compete in a setting of unparalleled natural and cultural beauty unlike any other international marathon course. The topography of the city lends itself to a challenging route that will test even the most experienced of runners.</p>
//                             <p>The course takes the runner on a unique path through Jerusalem’s 3,000-year historical narrative, on the cobblestones of the ancient and holy walled city of Jerusalem and through the modern city center of Israel’s capital. The course includes the city’s best known sites including, among others, the Knesset, the Old City, Sultan's Pool, Mount Zion, the German Colony, the Jerusalem Promenade and the Mount of Olives.</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 76,
// 	    bgImage:"/posts/bank/76/1.jpg",
// 	    mobBgImage:"/posts/bank/76/M.jpg",
// 	    title: "Bon Jovi",
// 	    smlTitle: "Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											HaYarkon Park, TLV
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											25.07.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.bonjovi.com/">

// 												bonjovi.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <h2>Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!</h2>

//                             <p>Bon Jovi, all-time favorites in Tel Aviv, are making their way back to the city, famed for its lively music scene once more to appear in the famous Yarkon Park, the beautiful green lung of the city.
//                             <p>Currently touring America to sold out venues, Bon Jovi will arrive here as part of a new European tour in the summer of 2019, entitled "This House is not for Sale". The tour is set will begin on May 31, 2019 in Moscow and will probably end on July 25, 2019 with their show in Tel Aviv.
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/76/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>The band, considered e one of the most successful American bands of all times has sold more than 100 million copies, performed in over 2700 concerts in 50 different countries to more than 34 million viewers worldwide.
//                             <p>This is not Bon Jovi's first stint in the city. The band gave a truly memorable performance about three years ago at the Hayarkon Park in Tel Aviv to 50,000 adoring fans, singing along to every lyric .
//                             <p>Those coming to see the band play in Tel Aviv are in for a special treat as they will get to experience Tel Aviv in July, the city’s summer finest,  sunbathe on the fabulous beaches, enjoy the awesome culinary options, take in  the epic hot night life and best of all see Bon Jovi raise it live on stage in the city that doesn’t stop!

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 77,
// 	    bgImage:"/posts/bank/77/1.jpg",
// 	    mobBgImage:"/posts/bank/77/M.jpg",
// 	    title: "TAG 2019",
// 	    smlTitle: "Tel Aviv Games are Back!",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											TAG 2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											27-30.3.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.bonjovi.com/">
// 												www.telavivgames.org
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                            <h2>
//                             	Tel Aviv Games are Back!
//                           	 </h2>

//                             <p>
// 								Tel Aviv, declared one of the best gay travel destinations in the world, is joining a list of renowned capitals such as Paris, New York, Berlin and Rome, organizing its own LGBT multinational sports event – Tel Aviv Games – TAG2019. TAG 2019 offering the LGBT+ traveler a unique and exciting sports experience.
//                             </p>
//                             <p>
// 								With over 250 athletes from all over the world already signed up, and an estimated 500 more expected, Tel Aviv Games 2019 is anticipated to become the biggest LGBT+ Sports event in the middle east and one of the biggest in Europe.
//                             </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/77/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>
// 								LGBT+ athletes from more than 17 countries (including France, Germany, UK, US, Australia, Canada, Belgium, Czech Rep., Greece, Netherlands, Norway, Spain, Russia, Surnami and more) will come together for a 3-day multi-national celebration of participation, inclusion and personal best.
//                             </p>
//                             <p>
// 								The tournament will include individual and team events in 7 sporting categories: Swimming, Tennis, Basketball, Soccer, Volleyball, Same Sex Dance, and 5K and 10K Competitive Running.
//                             </p>
//                             <p>
// 								This year Tel Aviv Games will also introduce the city’s first ever “Pride Run - Running for the youth”, supporting Healthy LGBT+ Youth lifestyle in a 5K race along Tel Aviv’s beautiful shore.
// 							 </p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: 78,
// 	    bgImage:"/posts/bank/100/1.jpg",
// 	    mobBgImage:"/posts/bank/100/M.jpg",
// 	    title: "Purim 2019",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv and Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											20-22.03.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.tel-aviv.gov.il/en/Pages/MainItemPage.aspx?WebID=9336473c-1537-4ab6-8a69-d299b5db8bcc&ListID=0ac6b290-896c-4fcb-bb36-0c5252101eff&ItemId=123">
// 												Tel Aviv Purim 2019
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                            <p>Every year in March, the people of Tel Aviv & Jerusalem dress up in costumes, the cities are a party and it’s all because of Purim – the most colorful and fun holiday of them all!
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/78/1.jpg"} class="img-responsive" />
// 							</div>

//                             <p>As expected, the party capital doesn’t disappoint, as there are tons of events to choose from – the annual street party is Tel Aviv’s biggest event. Thousands of dressed up people will gather together in “Kikar Hamedina” (State’s Square)  to enjoy performances from top musicians and dance together! The best part? It’s free of charge! If you won’t be too exhausted, you can also participate in Tel Aviv’s Zombie Walk. The name is self-explanatory, as the walk features hundreds of zombies walking through the streets of the city that never sleeps. Other events include Tel Aviv Street Party in Rothschild boulevard and many more.
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/78/2.jpg"} class="img-responsive" />
// 							</div>
//                             <p>If your prefer to spend the holiday in the city of gold, have no fear as there are plenty of events taking place across Jerusalem – from carnivals to parties there is something for everyone: The official Jerusalem Purim events is at Safra Square, featuring activities and performances for kids. Another option is the event at the Israel Museum that’s meant for the whole family. There’s also a Purim Rave Party at The Tower of David, the traditional parade at Nachlaot street, a party at Downtown Jerusalem building, a Purim party at the Shuka and more events to be confirmed!
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/78/3.jpg"} class="img-responsive" />
// 							</div>
//                             <p>So choose your costume and come celebrate with us!
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/78/4.jpg"} class="img-responsive" />
// 							</div>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: "J_Lo",
// 	    bgImage:"/posts/bank/J_Lo/1.jpg",
// 	    mobBgImage:"/posts/bank/J_Lo/M.jpg",
// 	    title: "J.LO",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Hayarkon Park
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											01.08.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<h3>
// 								J.LO HEADING TO TEL AVIV TO SET THE SUMMER ON FIRE!
// 							</h3>
// 							<p>
// 								Yes, it's true! after weeks of rumors flying around it is officially confirmed the J.Lo, AKA Jeniffer Lopes, AKA Jenny from the block, the hottest name worldwide as queen of pop for the past 2 decades, is coming to light up your summer in Tel Aviv!
// 							</p>
//                          <p>
// 								Performing for the first time in this country, J.Lo will be getting loud on the floor on August 1st at the Yarkon Park. The show, part of the maga star’s “It’s My Party” worldwide tour is expected to be one of the summer’s biggest concerts, along with Bon Jovi’s highly anticipated performance on the very same Tel Aviv stage on the 25th July.
// 							</p>
// 							<p>
// 								Hayarkon park is Tel Aviv’s green lung. This is the perfect place to get some respite after spending a wild night in Tel Aviv. Here you can spend the day cycling, walking or relaxing in the beautiful outdoor scenery and even enjoy flying high on a hot air balloon before heading to take your place in the stunning amphitheater. Whatever you choose, make sure to come packed with energy for J.Lo’s once in a lifetime performance in sunny awesome Tel Aviv!
// 							</p>
// 					               `
// 			}
// 		}
//     },

//     {

//         id: "Pride_Parade_2019",
// 	    bgImage:"/posts/bank/Pride_Parade_2019/1.jpg",
// 	    mobBgImage:"/posts/bank/Pride_Parade_2019/M.jpg",
// 	    title: "Pride Parade 2019",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											14.6.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<h3>
// 								The  most fabulous event of the Year
// 							</h3>
// 							<p>
// 								<strong>
// 									Tel Aviv 2019 Pride Celebrations – guaranteed to blow your mind!
// 								</strong>
// 							</p>
// 							<p>
// 								Tel Aviv, one of the most celebrated gay capitals in the world, is famous for its round the clock energy and extravagant nonstop parties. One of the biggest and hottest events, by far in the city is the ‘Gay Pride Week’ parties ending with the awesome Friday Pride Parade.
// 							</p>
//                          <p>
// 								The parade, a tradition which began as early as 1998, draws a huge crowd of the coolest people and thousands of participants from around the world. All them come together to celebrate and support freedom and embrace all lifestyles and genres in an open minded, off the charts, celebration.
// 							</p>
// 							<p>
// 								The parade is the highlight of a week of gay pride events which take place around the city of Tel Aviv and include pride-themed parties, exhibitions, movie festivals, music concerts and so much more.
// 							</p>
// 							<p>
// 								The parade itself takes place along the buzzing main streets of marvelous Tel Aviv, and features, in the tradition of pride parades from across the world, fantastic extravagant floats, live music, dance performances and revelers dressed in a colorful festival dress.
// 							</p>
// 							<p>
// 								The parade stops and rests at the stunning Tel Aviv promenade by the shores of the beautiful coastline, where it turns into an epic adrenaline-charged beach party featuring leading DJs and live performances, lasting well into the small hours of the night.
// 							</p>
// 							<p>
// 								The 2019 parade will take place on June 14th 2019 and participation, as always, will be completely free of charge.
// 							</p>
// 					               `
// 			}
// 		}
//     },

//     {

//         id: "Open_Restaurants_Jerusalem",
// 	    bgImage:"/posts/bank/Open_Restaurants_Jerusalem/1.jpg",
// 	    mobBgImage:"/posts/bank/Open_Restaurants_Jerusalem/M.jpg",
// 	    title: "Open Restaurants Jerusalem",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											19-23.11.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
// 												www.open-restaurants.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>

// 							<h3>
// 								Open Restaurants Jerusalem
// 							</h3>
// 							<p>
// 								Taking place in the iconic city of Jerusalem at varying hours, \‘Open Restaurants\’ is a unique culinary festival giving visitors a glimpse into the fascinating cultural and culinary diversity of Jerusalem.
// 							</p>
// 							<p>
// 								The festival includes about 100 different events held all over the city of Jerusalem, even in places which are less culinary oriented, as well as in culinary adequate venues and combine food with art, culture, innovation and technology.
// 							</p>
//                          <p>
// 								Festival-goers will also have a chance to participate in a series of meetings, workshops and lectures by prominent local personalities, and visits to the city\'s famous restaurant kitchens.
// 							</p>
// 							<p>
// 								As part of the festival program, day and night tours will be held at various culinary centers throughout Jerusalem including flavors tours in the Old City,Ein Kerem and more. You are encouraged to take at least one of them!
// 							</p>
// 							<p>
// 								In addition, FoodTalks meetings will be held with leading culinary experts (we can’t reveal who they are, so keep guessing…), photographers and chefs. The top hotels in Jerusalem will also collaborate with their private chefs at special prices.
// 							</p>
// 							<p>
// 								Whether you’re a foodie or just a curious visitor, you are sure to enjoy this unique taste of magical Jerusalem’s culinary side happening between the 19th -23rd , November,2019.
// 							</p>
// 					               `
// 			}
// 		}
//     },

//     {

//                   id: "Jerusalem_Beer_Festival",
// 	              bgImage:"/posts/bank/jerusalem-beer-festival/1.jpg",
// 	              mobBgImage:"/posts/bank/jerusalem-beer-festival/M.jpg",
// 	              title: "Jerusalem Beer Festival",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Time</h2>
// 											<div class="text">
// 												<p>
// 													18:00 – 00:00
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													28 - 29.08.2019
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 	                                <p>The city of Jerusalem is proud to host, for the 15th(!) year in a row – the fabulous and hugely popular ‘Beer Festival’.</p>
// 	                                <p>The Jerusalem Beer Festival is an internationally recognized celebration of good music, good food and of course, you guessed it, great beer. </p>

// 	                                <p>Held in the magical 3000-year-old city of Jerusalem, the festival boasts an incomparable atmosphere, guaranteeing an unforgettable experience. </p>

// 	                                <p>The iconic festival has become over the years, a symbol of Jerusalem's entertainment culture and creates a unique opportunity for visitors from around the globe, to enjoy a delicious variety of cold beers, food and people in open air of Jerusalem.</p>

// 	                                <p>During the festival you will have the opportunity to taste any (or all) of the variety special flavors of beers from around the country and the world (and we have over 120 of them), served in pop up bars, built specifically for the festival. </p>
// 	                                <p>The Jerusalem Beer Festival is the only festival of its kind in Israel, hosting a huge variety of large and international beer brands every year alongside a distinguished presence of local breweries. </p>

// 	                                <p>So make your way and join more than 15,000 visitors coming to enjoy the unique atmosphere, the fantastic live shows, the great food and the awesome people, and to celebrate the global love of Beer.</p>
//                                     <a href="https://www.jerusalembeer.com/en" target="_blank" class="jerusalem-link">www.jerusalembeer.com</a>
// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "DGTL_Festival",
// 	              bgImage:"/posts/bank/dgtl-festival2019/1.jpg",
// 	              mobBgImage:"/posts/bank/dgtl-festival2019/M.jpg",
// 	              title: "DGTL FESTIVAL",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											 <h2>lieu</h2>
// 											<div class="text">
// 												<p>
// 													Hayarkon Park Tel Aviv
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													14.10.19
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Plus D'infos sur:</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://tlv.dgtl.nl/en/dgtl-tel-aviv-returns-to-israel/">

// 														www.tlv.dgtl.nl
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 							        <p>After its stellar debut in Tel Aviv, DGTL Festival is back, bringing yet another excellent musical program to the Yarkon Park, accompanied by the latest sustainable and technological innovations and fresh art projects.</p>

//                                    <p>The DGTL festival is a global event at the forefront of the music and festivals scene, showcasing in an exclusive list of cities around the world: Amsterdam, Sao Paulo, Barcelona, Santiago and now, Tel Aviv. DGTL brings together the worlds of music, technology and art, as well as the latest discoveries in production and sound.</p>
//                                    <p>The DGTL festival will be held in an expanded edition with a huge lineup and will include four stages which, will operate simultaneously at any given moment.</p>
//                                    <p>In addition to being an innovative music festival, DGTL champions environmental protection and sustainability and has won prizes for being the greenest festival in Europe. The festival has a revolutionary program for reducing electricity consumption, vegetarian food only, a recycling plan and more. </p>
//                                    <p>The Festival will be held in the fabulous Yarkon Park,  situated in the heart of the buzzing city of Tel Aviv. As a hub of innovation, trendiness and exciting nightlife scene, it is the perfect host for DGTL festival. </p>
//                                    <p>Come and get your groove on in the most cutting-edge festival on the planet, held in heart of the most exciting city in the world! </p>

// 	                            `
// 			}
// 		}
//     },

//     {
// 	              id: "The_International_Arts",
// 	              bgImage:"/posts/bank/international-arts/1.jpg",
// 	              mobBgImage:"/posts/bank/international-arts/M.jpg",
// 	              title: "The International Arts",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											 <h2>lieu</h2>
// 											<div class="text">
// 												<p>
// 													Jérusalem
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													12 - 24.08.2019
// 												</p>
// 											</div>
// 										</div>
// 									</div>

//                                     <h2>The International Arts and Crafts Festival 2019<br>
//                                     <small>Hutzot Hayotzer Jerusalem<small></h2>
//                                     <p>Jerusalem is packed with fantastic events throughout the summer. One of the most celebrated events is the colorful “Hutzot Hayotzer -International Art and Crafts Festival”. </p>
//                                     <p>This large-scale annual festival takes place in the Hutzot Hayotzer lane and the Sultan’s Pool, opposite the Tower of David and at the foot of the walls of the Old City. </p>
//                                     <p>The iconic Hutzot Hayotzer festival has been held for over 35 consecutive years. It has long since became a hugely popular tourist and artistic attraction for visitors from around the world. Visitors will enjoy more than 150 local artists who showcase their art including paintings, prints, ceramics, jewelry and more, as well as an international exhibition, showcasing the work of overseas artists.  They will be able to engage in fascinating art conversations and enjoy unique workshops, live performances, an Irish pub, huge sculptures, live Jazz music, all wrapped up in an authentic European carnival atmosphere. </p>
//                                     <p>The festival is open every evening (except Fridays) between 18:00 and 23:00 and on Saturday night from 21:00 until midnight, at the Hutzot Hayotzer, Mitchell Park and the Merrill Haasenfeld Amphitheater at the Sultan’s Pool.</p>
//                                     <p>Last but definitely not least, don’t miss the “Food around the world” - an Israeli and international food fair, which will include food stalls of various tastes from different world kitchens: Thai, Israeli, Chinese, Korean, and more.</p>
//                                     <a href="https://artfair-jer.com/english/" target="_blank" class="artfair-link">www.artfair-jer.com</a>
// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Jerusalem_Marathon",
// 	              bgImage:"/posts/bank/jer-marathon2019/1.jpg",
// 	              mobBgImage:"/posts/bank/jer-marathon2019/M.jpg",
// 	              title: "Jerusalem Marathon",
// 	              smlTitle: "",
// 	              html: function(){
// 			                 return {
// 				                 __html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											 <h2>lieu</h2>
// 											<div class="text">
// 												<p>
// 													Jérusalem
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													20.03.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Plus D'infos sur:</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://jerusalem-marathon.com/default.aspx">

// 														jerusalem-marathon.com
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
// 									<div class="responisve-iframe">
// 									<iframe width="560" height="315" src="https://www.youtube.com/embed/7wMT5mKOwYk?autoplay=1&amp;controls=0&amp;loop=1&amp;rel=0&amp;playlist=7wMT5mKOwYk&amp;modestbranding=1&amp;autohide=1&amp;showinfo=0" frameborder="0" allowfullscreen=""></iframe>
// 									</div>
// 									<br/>
//                                     <h2  class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">A Spectacular run through the 3,000-Year-old city</h2>
//                                     <p>With 30,000 participants including hundreds of elite runners from around the world, The International Jerusalem marathon, is a fantastic celebration of body and mind in the heart of one of the most enchanted cities in the world. </p>
//                                     <p>The Jerusalem International Marathon provides the runners with the perfect opportunity to visit the ancient city while participating in a truly modern and excitement-filled competitive sporting event, with a series of cultural happenings planned around the central event.</p>
//                                     <p>The marathon offers a variety of tracks, from professional to family friendly.</p>
//                                     <p>The course takes you by the fascinating historical sites that reveal the 3,000 years of Jerusalem’s history, the cobblestones of the ancient and holy walled city of Jerusalem and through the modern city center of the capital. </p>
//                                     <p>The course includes the city’s best-known sites, among others the Knesset, the Old City, Sultan's Pool, Mount Zion, the German Colony, the Jerusalem Promenade and the Mount of Olives.</p>

//                                     <p>Runners are provided with the opportunity to compete in a setting of unparalleled natural and cultural beauty unlike any other international marathon course. The topography of the city lends itself to a challenging route that will test even the most experienced of runners. Ultimately guaranteeing an illuminating, challenging, thrilling and unforgettable experience for all runners. </p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Open_Houses_Festival",
// 	              bgImage:"/posts/bank/openhf/1.jpg",
// 	              mobBgImage:"/posts/bank/openhf/M.jpg",
// 	              title: "Open Houses Festival",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											 <h2>lieu</h2>
// 											<div class="text">
// 												<p>
// 													Tel Aviv, City -Wide
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													19 - 21.09.2019
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Plus D'infos sur:</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="//www.batim-il.org/DefaultEng.aspx?batim=">

// 														www.batim-il.org
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div><div class="clear"></div>
//                                     <h2>An amazing experience for design lovers everywhere</h2>
//                                     <p>This September, the nonstop city of Tel Aviv will be hosting for the 14th year, the fantastic ‘Open Houses’ Architecture and Design Festival. </p>

//                                     <p>The ‘Open Houses’ opens a one-time door to allow a glimpse into the forms of design, style of living, history, culture, technology, ecology and houses of added value that makes them intriguing and attractive</p>
//                                     <p>The event will include an exciting program of fascinating visits and tours to some of the most intriguing buildings in the city including private homes, apartments, historical as well as urban buildings. The Festival will also include special guided tours and attractions in unusual places -  from tours of residential apartments to tours of  new buildings. </p>
//                                     <p>Among the many buildings and structures open to the public, some of which have never been opened before are:  Tel-Aviv Velodrome, opened for the first time, a ship from within, a synagogue from 1840 in Old Jaffa and some fan favorites including the helipad on the Azrieli roof and a glimpse of the atomic shelter at Dizengoff Center. </p>
//                                      <p>"Open Houses” is part of the Open House World Wide's international organization, operating in New York, London, Chicago, Rome, Barcelona, Melbourne, Dublin, Helsinki, and more. </p>
//                                     <p>Be sure to check out what is guaranteed to be a unique and unforgettable urban celebration in the awesome city of Tel Aviv!</p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "TelAviv_Marathon",
// 	              bgImage:"/posts/bank/tlv-marathon2020/1.jpg",
// 	              mobBgImage:"/posts/bank/tlv-marathon2020/M.jpg",
// 	              title: "Le Marathon de Tel-Aviv",
// 	              smlTitle: "",
// 	              html: function(){
// 			              return {
// 				              __html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											 <h2>lieu</h2>
// 											<div class="text">
// 												<p>
// 													Tel Aviv
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													28.02.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Plus D'infos sur:</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://www.tlvmarathon.co.il/MenuDefault.aspx?id=6607">

// 														www.tlvmarathon.co.il
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
// 									<div class="responisve-iframe">
// 									<iframe width="560" height="315" src="https://www.youtube.com/embed/7wMT5mKOwYk?autoplay=1&amp;controls=0&amp;loop=1&amp;rel=0&amp;playlist=7wMT5mKOwYk&amp;modestbranding=1&amp;autohide=1&amp;showinfo=0" frameborder="0" allowfullscreen=""></iframe>
// 									</div>
// 									<br/>
//                                     <h2  class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Courez et amusez-vous dans la ville qui ne s’arrête jamais</h2>
//                                    <p>Le Marathon de Tel-Aviv est le plus grand événement sportif international du pays. Une célébration unique et palpitante pour les coureurs du monde entier. La rencontre se déroule au cœur de la fabuleuse Tel-Aviv. L’opportunité, pour les participants, de profiter des sites et vues remarquables, et de sentir le pouls de cette métropole chargée d’adrénaline.</p>
//                                    <p>Ils seront quelque 40 000 coureurs venus des quatre coins du monde, pour participer aux différentes courses de cet événement annuel, qui permet aux sportifs ou amateurs de tous niveaux et de tous styles, professionnels sur longue distance ou débutants, de prendre le départ.</p>
//                                    <p>Le Marathon de Tel Aviv s'étend le long du magnifique front de mer, traversant les étonnants sites de la Ville blanche – classée au patrimoine mondial de l'UNESCO - et ses diverses artères élégantes et animées, rassemblant sur son passage plus de 150 000 personnes venues prendre part aux nombreux événements parallèles ou encourager les coureurs le long du circuit plat et convivial.</p>
//                                    <p>La rencontre sportive est en fait un festival géant, dotée de tout un éventail d’événements animés, avant et après la course. Au programme : danse et musique live à gogo et de nombreuses autres attractions, pour le plus grand plaisir des coureurs et des supporters.</p>
//                                    <p>Surnommé « la capitale méditerranéenne la plus cool » par le New York Times et l’une des « 10 villes les plus actives » selon Lonely Planet, Tel-Aviv offre une multitude d'attractions fascinantes tous domaines confondus : des plages dorées éblouissantes, des marchés colorés, une richesse culturelle et des divertissements d'avant-garde, une vie nocturne exceptionnelle, ainsi qu’une étonnante scène culinaire.</p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Night_Run_TelAviv",
// 	              bgImage:"/posts/bank/tlv-nightrun2019/1.jpg",
// 	              mobBgImage:"/posts/bank/tlv-nightrun2019/M.jpg",
// 	              title: "Night Run Tel Aviv",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											30.10.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.tlvnightrun.co.il/MenuDefault.aspx?id=6571">

// 												www.tlvnightrun.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <h2>The most exhilarating 10km you will ever experience</h2>
//                                     <p>A lot has been said about the world-renowned city of Tel Aviv. Named among Lonely Planet’s 'Top 10 Action-Packed Cities’, this city is a truly trendy buzzing metropolis that doesn’t rest. While its official slogan is the Non Stop City, it truly gives NYC a run for its money for the title the City that doesn’t sleep. </p>
//                                     <p>This is especially the case when it comes to the amazing Night Run Tel Aviv annual race. </p>
//                                     <p>With around 25,000 runners and tens of thousands of cheering spectators, this upbeat adrenaline-charged race is more of a full-blown night time party for the scores of participants and spectators who come from all around the world to take part.</p>
//                                     <p>Taking place during the autumn, the 10KM night run begins well after sundown and follows a fantastic urban route along the streets of Tel Aviv, starting at  Rabin Square in the center of town, and south along Rothschild Boulevard, before continuing along Dizengoff Street, Nordau Boulevard, and into Park Hayarkon, reaching the finish line alongside the river. </p>
//                                     <p>You will be passing all the trendy,, fascinating attractions and renowned Bauhaus architecture the "White City" of Tel Aviv has been declared a UNESCO World Heritage Site for. </p>
//                                     <p>Best of all, The TLV Night Run ends with a celebratory finish line festival at Hayarkon park in the heart of the city where thousands more come to join the runners and spectators in an all-night rager of music, dancing and nonstop fun.</p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Celine_Dion",
// 	              bgImage:"/posts/bank/Celine_Dion/1.jpg",
// 	              mobBgImage:"/posts/bank/Celine_Dion/M.jpg",
// 	              title: "Celine Dion",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											HaYarkon Park, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											04.08.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.celinedion.com">

// 												www.celinedion.com

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Our Heart Goes On – for Celine Dion in Tel Aviv!</h2>
// 										<p>The Diva is coming! Now it’s official: Celine Dion will perform in Tel Aviv on August 4th of next summer and it’s going to be a hot one! This will be Dion’s first ever concert here, and boy are we excited.</p>

//                                         <p>The 6 Grammy award-winner will visit Tel Aviv, the city that never sleeps, to keep the party going all Night. Dion’s countless hits, “Because you Loved Me”, “Just Walk Away” and of course her all-time greatest hit – “My Heart Will Go On” – will hopefully make their debut live in Tel Aviv.</p>

//                                         <p>Tel Aviv has also hosted some of the largest art exhibitions, live shows and festivals, making it one of the liveliest cities in the world. With a combination of sun, rich nightlife scene, spectacular sights in every corner and the Dion’s first appearance – Tel Aviv is the place to be next summer.</p>

//                                         <p>Ticket sales have yet to open, but it’s never too early to start planning your next visit to Tel Aviv!

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Nickcave_Badseeds",
// 	              bgImage:"/Concerts/bank/nickcave_badseeds/1.jpg",
// 	              mobBgImage:"/Concerts/bank/nickcave_badseeds/M.jpg",
// 	              title: "NICK CAVE & BAD SEEDS",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Bloomfield Stadium, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											17.06.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">

// 												Update Soon

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">NICK CAVE AND THE BAD SEEDS LIVE IN TEL AVIV!</h2>
//                                     <p>Nick Cave is coming to Tel Aviv to blow the roof off! Returning to the city that never sleeps in June 2020, the Australian pop-punk musician is coming to rock you.</p>

//                                     <p>Having recorded no less than 17 studio albums with his band, the talented musician is excited about his visit – which will be hotter than ever.</p>

//                                     <p>Coming back just a little more than two years after his previous performance here, this time, lighting up the newly renovated Bloomfield Stadium (which has hosted a long line of international artists). Judging by the last performance, this one should be truly sensational.</p>

//                                     <p>Tel Aviv has been known to attract and feature some of the biggest names in the world, making it one of the hottest cities when it comes to live concerts and the nightlife scene. This performance shouldn’t be any different and is a great opportunity to catch Nick Cave live, as part of his summer tour.</p>

//                                     <p>Warm summer nights, soft sand beaches and the mesmerizing music of a world-renowned artist – what more could you ask for? Tel Aviv has it all!</p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Louis_CK",
// 	              bgImage:"/posts/bank/Louis_CK/1.jpg",
// 	              mobBgImage:"/posts/bank/Louis_CK/M.jpg",
// 	              title: "He’s coming back! Louis CK in Tel Aviv",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Hangar 11, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											23.11.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.facebook.com/events/%D7%A4%D7%99%D7%A1-%D7%90%D7%A8%D7%A0%D7%94-%D7%9E%D7%9C%D7%97%D7%94-%D7%99%D7%A8%D7%95%D7%A9%D7%9C%D7%99%D7%9D/%D7%9C%D7%95%D7%90%D7%99%D7%A1-%D7%A1%D7%99-%D7%A7%D7%99%D7%99-%D7%91%D7%94%D7%95%D7%A4%D7%A2%D7%94-%D7%91%D7%99%D7%A9%D7%A8%D7%90%D7%9C-louis-ck-live-in-israel/554683431359536/">

// 												Louis CK

// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <p>Back for the second time, Louis CK will preform at the Hangar 11 in Tel Aviv, this upcoming November.</p>

//                                     <p>After his tremendous success in Jerusalem in 2016, Louis CK is about to return for another exclusive show; this time, right here in Tel Aviv, one of the hottest cities for live shows.</p>

//                                     <p>The talented, hilarious comedian is back in action after a two-year break making this show, bigger, better and funnier than ever. Having a wide following audience in Tel Aviv alone, the sharp comedian is sure to light up the stage.</p>

//                                     <p>Tel Aviv has hosted dozens of comedians from all over the world, including Jerry Seinfeld and Chris Rock, Jim Jefferies and many others, is the ultimate city for having a good time. The city is known for its art and culture as well as its exciting club scene and trendy bars and restaurants.</p>

//                                     <p>So book your trip now and get ready for an unforgettable time in the city that doesn’t stop!</p>
// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Cycle_Tel_Aviv",
// 	              bgImage:"/Concerts/bank/cycle-tlv-2019/1.jpg",
// 	              mobBgImage:"/Concerts/bank/cycle-tlv-2019/M.jpg",
// 	              title: "Cycle Tel Aviv",
// 				  vidId: "5nqL-oIC0GA",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-50">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											All Around Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											18.10.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <p>The mild to warm October weather, combined with the energetic vibe of Tel Aviv, provide the perfect setting for the biggest cycling event in the country.</p>

//                                     <p>Thousands of cycling enthusiasts flock to Tel Aviv to ride through the vibrant city, on a scenic course showing you everything Tel Aviv has to offer:</p>

//                                     <p>From the beautiful Yarkon Park, along the coast, past the city’s many dazzling beaches and back up to the park through the city center, you’ll get a glimpse of every characteristic place, the “Mediterranean capital” has to offer.</p>

//                                     <p>Everyone can experience the thrill and excitement of the event, from the 60 km course for professional riders to the 8 km course for families and beginners, there is even a rollerblades course for those who prefer to make their way through the city on foot.</p>

//                                     <p>With the locals coming out in droves to cheer on the event, you’ll see a colorful and diverse crowd, adding to the fun and excitement in the air.</p>

//                                     <p>Whether you’re looking for a personal challenge to compete against some of the top riders in the country, or you’re hoping to enjoy a family day out with the crowds, you’re sure to experience the beauty and energy that makes up the unique atmosphere of Tel Aviv.</p>
// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "DGTL_Festival_2020",
// 	              bgImage:"/posts/bank/dgtl-festival2019/1.jpg",
// 	              mobBgImage:"/posts/bank/dgtl-festival2019/M.jpg",
// 	              title: "DGTL FESTIVAL",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											 <h2>lieu</h2>
// 											<div class="text">
// 												<p>
// 													Parc Hayarkon Tel-Aviv
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													08.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Plus D'infos sur:</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://tlv.dgtl.nl/en/dgtl-tel-aviv-returns-to-israel/">

// 														www.tlv.dgtl.nl
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
// 							        <p>Le Festival DGTL est de retour au parc Hayarkon ! Avec, cette année encore, un excellent programme musical soutenu par les dernières innovations technologiques et durables, et des projets artistiques originaux.</p>
// 									<p>Le Festival DGTL est un événement mondial à la pointe de la scène musicale et festivalière, qui se produit dans un cercle sélect de villes internationales : Amsterdam, Sao Paulo, Barcelone, Santiago et désormais, Tel-Aviv. DGTL combine les mondes de la musique, de la technologie et de l'art, ainsi que les dernières découvertes en matière de production et de son.</p>
// 									<p>Le festival voit grand avec une programmation édifiante et quatre scènes qui officieront simultanément pendant tout le festival.</p>
// 									<p>DGTL est non seulement un festival de musique innovant, mais aussi un champion de la protection de l'environnement et du développement durable, ce qui lui a valu de remporter des prix en tant que festival le plus vert d'Europe. A son actif : un programme révolutionnaire pour réduire la consommation d'électricité, de la nourriture végétarienne uniquement, un plan de recyclage, et plus encore.</p>
// 									<p>Le festival se tiendra dans le fabuleux parc Hayarkon, situé au cœur de la vibrante Tel-Aviv. Cette ville animée, plaque tournante de l'innovation, des tendances et de la vie nocturne palpitante, est l'hôte idéal pour accueillir le DGTL.</p>
// 									<p>Venez vibrer au rythme du festival le plus avant-gardiste de la planète, au cœur de la ville la plus envoûtante au monde !</p>

// 	                            `
// 			}
// 		}
//     },

//     {

//         id: "Pride_Week_2020",
// 	    bgImage:"/posts/bank/Pride_Parade_2019/1.jpg",
// 	    mobBgImage:"/posts/bank/Pride_Parade_2019/M.jpg",
// 	    title: "Semaine de la fierté 2020",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											12.6.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<div class="responisve-iframe">
// 					             <iframe width="560" height="315" src="https://www.youtube.com/embed/U8KwXVP3Xng" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 				             </div>
// 				             <div class="ac-cradit" style="margin-top: -15px;margin-bottom: 40px;">
// 							<span class="ac-cradit-text">Credits:</span>

// 								<span class="ac-cradit-text-1"><a href="https://www.youtube.com/channel/UCWN-mUP4IzdHLH7gaXHEKVw" target="_blank">Basti Hansen</a><br/>
// 							</div>
// 							<p></p>
// 							</div>

//                             <h2  class="ac-align-center">L'événement absolument fabuleux de l’année</h2>
//                             <p class="ac-align-center ac-margin-bottom-20"><strong>Célébrations de la fierté 2020 à Tel-Aviv – Vous allez être bluffé !</strong></p>
//                             <p>Tel-Aviv, l'une des capitales gays les plus célèbres au monde, est bien connue pour son énergie 24h/24 et ses soirées extravagantes sans interruption. Parmi ses événements les plus importants et les plus intenses, figure en bonne place la semaine de la Gay Pride, avec, en point d’orgue, l’impressionnante parade de la fierté du vendredi.</p>
//                             <p>Ce défilé, tradition qui remonte à 1998, attire une foule particulièrement dense et décontractée, venue du monde entier pour célébrer et soutenir avec une ouverture d’esprit, la liberté et l'acceptation de tous les genres et modes de vie.</p>
//                             <p>Il constitue le point culminant d'une semaine d'événements dans la ville, avec au programme : fêtes non-stop sur le thème de la fierté, expositions, festivals de cinéma, concerts de musique et bien plus encore.</p>
//                             <p>Cette tourbillonnante parade se déroule tout au long des principales artères animées de l'incroyable Tel-Aviv et présente, dans la tradition des défilés de fierté du monde entier, des chars fantastiques, de la musique live, des spectacles de danse et des fêtards vêtus de festifs costumes colorés.</p>
//                             <p>Elle s’achève sur la promenade de Tel-Aviv qui longe la magnifique côte méditerranéenne, pour se transformer sur la plage en fête épique, chargée d'adrénaline, avec des DJ de pointe et des spectacles live, jusqu'aux petites heures de la nuit.</p>
//                             <p>Cette année, le défilé aura lieu le 12 juin 2020. Et, comme d’habitude, la participation est entièrement gratuite.</p>

// 					               `
// 			}
// 		}
//     },

//     {
// 	              id: "Hutzot_Hayotzer_Jerusalem_2020",
// 	              bgImage:"/posts/bank/international-arts/1.jpg",
// 	              mobBgImage:"/posts/bank/international-arts/M.jpg",
// 	              title: "Houtsot Hayotser Jérusalem",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											 <h2>lieu</h2>
// 											<div class="text">
// 												<p>
// 													Piscine du sultan, Jérusalem
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													08.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 							        <div class="clear"></div>
//                                    <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Le Festival international des arts et de l'artisanat</h2>
//                                     <p>Tout l’été, Jérusalem regorge d’événements extraordinaires. Parmi les plus célèbres, le très coloré « Houtsot Hayotser – Le Festival international des arts et de l'artisanat ».</p>
// 									<p>Ce festival annuel de grande envergure s’installe chaque année dans les ruelles de Houtsot Hayotser et la piscine du Sultan, face à la tour de David et au pied des murailles de la Vieille ville.</p>
// 									<p>Fort de ses 35 ans d’existence, ce festival emblématique constitue une attraction touristique et artistique incontournable pour les visiteurs du monde entier. A son actif, plus de 150 artistes locaux qui viennent présenter leurs créations : peintures, estampes, céramiques, bijoux, et plus encore. Il comprend également une exposition internationale mettant en valeur le travail de créateurs étrangers. </p>
// 									<p>Les visiteurs pourront ainsi s’engager dans un fascinant dialogue avec l’art, ou profiter d'ateliers uniques, de spectacles live, d'un pub irlandais, d’imposantes sculptures, de concerts de jazz, le tout dans une authentique atmosphère de carnaval européen.</p>
// 									<p>Le festival est ouvert tous les soirs (sauf le vendredi) de 18h00 à 23h00 et le samedi soir de 21h00 à minuit, à Houtsot Hayotser, au Parc Mitchell et à l’amphithéâtre Merrill Haasenfeld de la piscine du Sultan.</p>
// 									<p>Dernier point, mais non des moindres, ne manquez pas « Nourriture du monde » - une foire alimentaire israélienne et internationale, avec ses stands de plats originaux et ses différentes saveurs de cuisines du monde : thaïlandaise, israélienne, chinoise, coréenne, etc.</p>

// 	                            `
// 			}
// 		}
//     },

//     {

//                   id: "Jerusalem_Beer_Festival_2020",
// 	              bgImage:"/posts/bank/jerusalem-beer-festival/1.jpg",
// 	              mobBgImage:"/posts/bank/jerusalem-beer-festival/M.jpg",
// 	              title: "Le Festival de la bière de Jérusalem",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Time</h2>
// 											<div class="text">
// 												<p>
// 													18:00 – 00:00
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													08.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
// 							         <p>La ville de Jérusalem est fière d’accueillir, pour la 16e année (!) consécutive, son fabuleux "Festival de la bière", un rendez-vous incontournable.</p>
// 									<p>Le Festival de la bière à Jérusalem est une célébration de renommée internationale sur fond de bonne musique, de bons plats et bien sûr, vous l'aurez deviné, d’excellentes bières.</p>
// 									<p>Organisé dans la magique cité hiérosolomytaine de 3000 ans, l’évènement se caractérise par une atmosphère incomparable, qui promet une expérience inoubliable.</p>
// 									<p>Ce rendez-vous emblématique est devenu au fil des ans un symbole de la culture de divertissement de Jérusalem et offre aux visiteurs du monde entier une occasion unique de déguster une excellente palette de bières fraîches, de plats et de nouvelles rencontres, en plein air.</p>
// 									<p>Le temps du festival, vous pourrez savourer un ou plusieurs parfums des 120 bières typiques ou insolites, locales ou internationales, servies dans des bars éphémères, construits spécialement pour l’occasion.</p>
// 									<p>Le Festival de la bière de Jérusalem est un évènement unique en son genre en Israël, qui accueille chaque année une grande variété de bières internationales aux côtés d’une présence notable de brasseries locales.</p>
// 									<p>Alors, n’hésitez pas à rejoindre ces plus de 15 000 visiteurs venus profiter de cette atmosphère unique, de cette délicieuse cuisine, de ces fantastiques spectacles live, et de ce public formidable, pour célébrer vous aussi l'amour de la bière.</p>

// 	                            `
// 			}
// 		}
//     },

//     {

//         id: "Jerusalem_Wine_Festival_2020",
// 	    bgImage:"/Concerts/bank/jer-wine-festival-2020/1.jpg",
// 	    mobBgImage:"/Concerts/bank/jer-wine-festival-2020/M.jpg",
// 	    title: "Le Festival du vin de Jérusalem",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Jérusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											08.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.imj.org.il/en/events/wine-festival-1">
// 												www.imj.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2  class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">   Vins fins et collations de rêve dans<br/> la Ville sainte !</h2>
// 				            <p>Qui dit soirées d'été relaxantes, dit verre de bon vin ! Quatre jours durant, en août, vous pourrez profiter de sélections de crus de classe mondiale et de plats primés, à l’occasion de la 16e édition annuelle du Festival du vin de Jérusalem. Hébergé dans les superbes jardins d'art japonais du musée d'Israël, il est considéré par beaucoup comme le premier événement social de la cité hiérosolomytaine. Et de fait, ce n'est pas un festival comme les autres : l'ambiance et la vue imprenable sur la ville historique se combinent pour en faire une expérience à ne pas manquer.</p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/69/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>Des centaines de vins seront proposés par des dizaines de vignobles boutique bien connus. Aux dégustations gratuites de vin, s’ajoutent également une oasis culinaire d’étals de fromages, chocolats, huiles d'olive, sauces exceptionnelles et autres confitures savoureuses. Le tout sur un fond sonore des plus agréables puisque le festival proposera tous les soirs deux concerts de musique live.</p>
//                             <p>Chaque année, l’événement accueille à Jérusalem une foule diversifiée et raffinée de plus de 20 000 amateurs de vin et de culture. Beaucoup ne se contentent pas d’une seule soirée, ne serait-ce que pour s’enivrer de cette atmosphère si particulière. Et pourquoi ne pas construire votre séjour dans la capitale autour du festival ! Certes, vos journées seront déjà remplies de visites, shopping et autres découvertes de la ville. Mais le moyen idéal pour finir la soirée en beauté pourrait bien être de profiter chaque soir du Festival du vin de Jérusalem !</p>

// 					     `
// 			}
// 		}
//     },

//     {

// 	              id: "Open_Houses_Festival_2020",
// 	              bgImage:"/posts/bank/openhf/1.jpg",
// 	              mobBgImage:"/posts/bank/openhf/M.jpg",
// 	              title: "Le Festival Maisons Ouvertes",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											 <h2>lieu</h2>
// 											<div class="text">
// 												<p>
// 														Tel-Aviv, dans toute la ville
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													09.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Plus D'infos sur:</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="//www.batim-il.org/DefaultEng.aspx?batim=">

// 														www.batim-il.org
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div><div class="clear"></div>
//                                     <h2  class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">  Une expérience enthousiasmante pour les amateurs de design du monde entier	</h2>

// 									<p>Ce mois de septembre, Tel-Aviv, la ville qui ne s’arrête jamais, accueillera pour la 14e année consécutive son emblématique festival d’architecture et de design "Maisons Ouvertes".</p>
// 									<p>Un événement hors-du-commun au programme alléchant : visites et découvertes fascinantes de certains des édifices les plus énigmatiques de la ville - maisons particulières, appartements, bâtiments historiques et immeubles urbains. Le festival proposera également des visites guidées originales et diverses attractions dans des lieux insolites.</p>
// 									<p>Le temps d’un week-end, ces "Maisons Ouvertes" ouvrent une fenêtre sur un monde méconnu et donnent un avant-goût des différentes facettes du design, de la vie, l’histoire, la culture, la technologie, l’écologie, qui rendent si fascinantes et attrayantes ces maisons à valeur ajoutée.</p>
// 									<p>Parmi les nombreux bâtiments et édifices ouverts au public, certains d'entre eux s’exposent pour la première fois : le vélodrome de Tel-Aviv, l’intérieur d’un navire, une synagogue de 1840 du vieux Jaffa et quelques lieux cultes, comme l’héliport du toit Azrieli ou un aperçu de l’abri antiatomique du centre Dizengoff.</p>
// 									<p>"Maisons Ouvertes" fait partie de l'organisation internationale Open House World Wide (Maisons Ouvertes dans le monde entier), qui s’illustre, entre autres, à New York, Londres, Chicago, Rome, Barcelone, Melbourne, Dublin, Helsinki, ou ailleurs…</p>
// 									<p>On vous promet une célébration urbaine unique et inoubliable dans l’impressionante ville de Tel-Aviv ! Prenez note !</p>

// 	                            `
// 			}
// 		}
//     },

//     {

// 	              id: "Purim_2020",
// 	              bgImage:"/Concerts/bank/purim2020/1.jpg",
// 	              mobBgImage:"/Concerts/bank/purim2020/M.jpg",
// 	              title: "Pourim 2020",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											 <h2>lieu</h2>
// 											<div class="text">
// 												<p>
// 													Tel-Aviv et Jérusalem
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													09-10.03.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>

// 									</div><div class="clear"></div>
//                                     <p>Chaque année en mars, Tel-Aviv et Jérusalem sont en liesse ; partout dans les rues, leurs habitants sont déguisés. La raison ? Pourim – la fête la plus gaie et la plus colorée du calendrier !</p>
// 									<div class="img-wrapper">
// 										<img src=${getImgUrl() + "/Concerts/purim2020/1.jpg"} class="img-responsive" />
// 									</div>
// 									<p>Comme à son habitude, la capitale du loisir ne déçoit pas. Tel-Aviv offrira un vaste panel d’événements à célébrer – avec, en point d’orgue, sa parade annuelle. Des milliers de personnes déguisées se réuniront à Kikar Hamedina pour profiter des prestations des meilleurs musiciens et danser ensemble ! Et vous savez quoi ? C'est gratuit ! Si vous n’êtes pas trop épuisé, vous pourrez aussi participer à la Zombie Walk de Tel-Aviv. Son nom est explicite : il s’agit d’une marche où des centaines de participants grimés en morts-vivants déambulent dans les rues de la ville qui ne dort jamais. Parmi les événements majeurs, on peut également citer la fête de rue du boulevard Rothschild et bien d'autres encore…</p>
// 									 <div class="img-wrapper">
// 										<img src=${getImgUrl() + "/Concerts/purim2020/2.jpg"} class="img-responsive" />
// 									</div>
// 									<p>Si vous optez pour la ville d'or, vous ne serez pas déçus, de nombreuses attractions sont également prévues à Jérusalem - carnavals ou festivités, il y en aura pour tous les goûts. Les événements officiels de Pourim se dérouleront sur l’esplanade de la municipalité, place Safra. Au programme : activités et spectacles pour enfants. Autre option, le Musée d'Israël qui organise des événements pour toute la famille. A noter également : une Rave Party de Pourim à la Tour de David, le défilé traditionnel de la rue Nahlaot, une fête au centre-ville de Jérusalem, des animations de Pourim au Shouk et tant d'autres rendez-vous à confirmer !</p>
// 									<div class="img-wrapper">
// 										<img src=${getImgUrl() + "/Concerts/purim2020/4.jpg"} class="img-responsive" />
// 									</div>
// 									<p>Il ne vous reste qu’à choisir votre costume et rejoignez-nous pour faire la fête !</p>

// 	                            `
// 			}
// 		}
//     },

//     {

//         id: "TelAviv_Fashion_Week_2020",
// 	    bgImage:"/Concerts/bank/fashion-week-2020/1.jpg",
// 	    mobBgImage:"/Concerts/bank/fashion-week-2020/M.jpg",
// 	    title: "La Fashion Week de Tel-Aviv",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											03.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//fashionweektelaviv.com/">
// 												fashionweektelaviv.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">C'est chic, magnifique!</h2>

// 							<p>Chaque défilé de mode est une célébration de l'élégance, de l'imagination, de la créativité et du style. La Fashion Week de Tel-Aviv n’échappe pas à la règle : elle a su mettre sa griffe sur l’industrie de la mode internationale, avec ses idéaux de beauté en pleine évolution et ses modèles hommes et femmes, de tous âges, tailles, hauteurs, couleurs et religions. L'événement de 4 jours présente des collections inhabituelles de la scène internationale et locale, avec des créateurs issus du dynamique monde du design de la ville et de ses environs.</p>

//                              <!--<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/72/1.jpg"} class="img-responsive" />
// 							</div>-->
// 							<p>La Fashion Week de Tel-Aviv est également à la pointe de la mode pour présenter des concepts d’utilisation innovants de la technologie et des textiles. Quant au soutien qu’elle apporte aux jeunes designers, elle n’en est pas peu fière. Comme lors des éditions précédentes, ce 7e événement annuel proposera un défilé des designers de demain, l’opportunité pour les nouveaux talents de partager leurs créations avec les participants.</p>
//                             <p>En 2020, la Fashion Week de Tel-Aviv aura lieu, une fois encore, dans le complexe historique de la Tahana. Dernière station de la liaison ferroviaire qui reliait autrefois Jaffa à Jérusalem, cette ancienne gare a été reconvertie en centre commercial à ciel ouvert, un des lieux publics les plus vivants et les plus animés de Tel-Aviv, situé dans un quartier branché ponctué de maisons pastel, de boutiques stylées et de cafés tendance. La Fashion Week sera pour vous l’occasion d’approcher l’univers de la mode et d'explorer toute la région !</p>

// 					               `
// 			}
// 		}
//     },

//     {

//         id: "The_Jerusalem_March_2020",
// 	    bgImage:"/Concerts/bank/jerusalem-march/1.jpg",
// 	    mobBgImage:"/Concerts/bank/jerusalem-march/M.jpg",
// 	    title: "La Marche de Jérusalem",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Jérusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											30.09.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="clear"></div>
// 							<p>La Marche de Jérusalem est l'un des événements les plus colorés et les plus excitants du pays. Organisée au mois d’octobre, elle rassemble des dizaines de milliers de marcheurs du monde entier.
//                             <p> Elle comprend trois événements - un parcours matinal sur des chemins de randonnée, un happening dans le parc Sacher et un défilé festif dans les rues du centre-ville de Jérusalem.
//                             <p>Pour permettre au plus grand nombre de prendre part à l’aventure, plusieurs itinéraires de longueurs variables et de différents niveaux de difficulté sont proposés.
//                             <p><strong>Pistes du matin</strong><br/>
//                                 Piste A - Pour les bons marcheurs, environ 12 km (7h00 à 9h00)</p>
//                             <p><strong>De la Colline des munitions au parc Sacher.</strong><br/>
//                                 Piste B - Niveau de difficulté moyen, environ 9 km (7h30 à 9h30)</p>
//                             <p><strong>Da Mount Scopus a Sacher Park.</strong><br/>
//                                 Piste C - Niveau de difficulté facile / familial, environ 4 km (8h00 à 10h00)</p>
//                             <p>De la place Safra au parc Sacher.<br/>
//                                 Festival au parc Sacher</p>
//                             <p>Entre 10h00 et 16h00, un événement festif aura lieu au parc Sacher, avec des représentations, de la musique live et des spectacles pour enfants, ainsi qu'un espace dédié aux plus jeunes.</p>
//                             <p>Le défilé festif prendra le départ à 15h00 pour longer les rues de Bezalel, Hillel et King David, avant de se terminer à proximité du parc de la Cloche. La parade se composera de véhicules de collection, délégations d'Israël et du monde entier, orchestres, groupes de danse, soldats de Tsahal, artistes de rue, équipes sportives et plus encore.</p>
//                             <p>Ne manquez pas votre chance de participer à cette célébration de Jérusalem, parmi les plus belles et les plus animées !</p>

// 				`
// 			}
// 		}
//     },

//     {

//         id:"The_Pixies_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Les Pixies",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											14.07.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.pixiesmusic.com">
// 											www.pixiesmusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>

//                             <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">The Pixies sont de retour pour du rock en live à Tel-Aviv !</h2>

// 										<p>L'été israélien est toujours chaud, mais le retour des Pixies à Tel-Aviv après 3 ans d’absence, va faire encore monter la température d’un cran !</p>
//                                         <p>Le célèbre groupe américain, bien connu pour son style de punk rock et de pop agressif, est à l’origine de certaines des chansons les plus emblématiques de l’histoire de la musique. En particulier avec son tube intemporel ‘Where is my mind’. Les pixies reviennent à Tel-Aviv pour la troisième fois, dans le cadre de la tournée promotionnelle de leur nouvel album, ‘Beneath the Eyrie’.</p>
//                                         <p>Ils donneront une représentation unique dans la ville qui ne s’arrête jamais, de quoi faire vibrer vos vacances de sable, soleil et loisirs. Le concert est prévu en juillet, moment idéal pour profiter du célèbre été telavivien, de ses fêtes, sa cuisine gourmande et ses plages enivrantes.</p>
//                                         <p>Les billets se vendent rapidement. Alors n’hésitez pas et réservez votre voyage dès aujourd'hui !</p>

// 						`
// 			}
// 		}
// 	},

// 	{

//         id:"White_Night_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Nuit Blanche",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											06.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							                <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">
// 											   "Nuit Blanche" détonante dans la ville non-stop !
// 											</h2>
// 				        					<div class="responisve-iframe">
// 												<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 											</div>
//                                             <p>Lorsqu'une cité connue aux quatre coins de la planète comme la "ville qui ne dort jamais" organise une "Nuit Blanche" - aucun doute que vous voudrez, vous aussi, être de la partie. "Nuit Blanche" est l'un des plus grands événements de Tel-Aviv. Une célébration annuelle traditionnelle qui tient la ville éveillée toute la nuit : tout y est ouvert et tout s’y passe en même temps…</p>
//                                             <p>Du début de soirée jusqu'à l'aube, la cité regorge de touristes et de locaux, débordant d’énergie et prêts à profiter de tout ce qui s’offre à eux – magasins, restaurants, cinémas et autres lieux de culture – le tout, gratuitement ou à tarifs réduits, toute la nuit !</p>

// 											<div class="img-wrapper">
// 								                <img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
// 							                </div>
// 											<small>
// 												Photo : Adam Primer
// 											</small>

// 											<p>L'origine de cet événement désormais mondialement connu remonte à 2003, lorsque l'Unesco inscrit au patrimoine mondial la "ville Blanche", pour sa plus grande collection architecturale de bâtiments de style Bauhaus. Une reconnaissance qui lui confère alors un statut unique dans le patrimoine architectural de l'ère moderne.</p>
//                                             <p>Depuis, la municipalité de Tel-Aviv-Jaffa célèbre chaque année cette déclaration historique par une série d'événements qui s’inscrivent dans une fantastique "Nuit Blanche", faisant écho aux deux surnoms de Tel-Aviv-Jaffa, la "ville Blanche" et "la ville qui ne s'arrête jamais".</p>

// 											<div class="img-wrapper">
// 								                <img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
// 							                </div>
// 											<small>
// 												Photo : Kfir Sivan
// 											</small>
//                                             <p>La Nuit Blanche consiste en un festival de festivités, chaque année de plus en plus nombreuses, organisées dans toute la ville. Au programme de ces dernières éditions, pour n'en citer que quelques-uns : pique-nique de minuit hors-du-commun, épique Silent Party (soirée à casque) sur la place principale de la ville, innombrables concerts de musique live, superbes représentations théâtrale ou spectacles de rue, fascinantes visites de nuit, cours de sport nocturnes, yoga au lever du soleil, et tant d’autres moments fantastiques, qui se déroulent simultanément, le temps d’une nuit, à travers toute la ville</p>
//                                             <div class="img-wrapper">
// 								                <img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
// 							                </div>
// 											<small>
// 												Photo : Moshik Lindenbaum
// 											</small>
// 											<p>Ti consigliamo di riposarti a dovere, perché avrai bisogno di tutta la tua energia per stare al passo con la “Notte Bianca” nella meravigliosa città di Tel Aviv! </p>
// 											<div class="img-wrapper">
// 								                <img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
// 							                </div>
// 											<p>En résumé, commencez par vous reposer, vous aurez besoin de toute votre énergie pour suivre le rythme endiablé de la "Nuit Blanche" de Tel-Aviv !</p>
// 											<small>
// 												Photo : Guy Yechiely
// 											</small>

// 						`
// 			}
// 		}
// 	},

// 	{

//         id:"Piano_Competition_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Rubinstein International Piano Competition 2020",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											05-21.05.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://arims.org.il/">
// 											www.arims.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<p>There is no shortage of fantastic arts and culture events in Tel Aviv, but the Rubinstein International Competition is the pride of the city. </p>

// 							<p>39 extremely talented pianists have been nominated to participate in the 16th Arthur Rubinstein International Piano Master Competition. 15 competitors are coming from Asia, 10 from Eastern Europe, 7 from Europe, 3 local talents, 2 from Georgia, and 2 from the USA. Tel Aviv, the cultural hub, is happy to welcome all of them. </p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/piano-competition-2020/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>The first two stages of this prestigious competition will be held at the Tel Aviv Museum of Art, one of the country’s leading artistic and cultural institutions. The lively Sarona Market is only a 10-minute stroll from there. </p>
// 							<p>The final stages will be hosted at the Charles Bronfman Auditorium, also known as the Culture Palace (Heichal HaTarbut), located in Habima Square, next to the national theater. Some of the best cafés and restaurants of Tel Aviv are located nearby, as well as the beautiful Rothschild Boulevard. </p>
// 							<p>Early tickets sale for friends of the society and newcomers has already started. The regular sale will commence on 16 February 2020. </p>

// 						`
// 			}
// 		}
// 	},

// 	{

//         id:"Red_Hot_Chili_Peppers_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Red Hot Chili Peppers",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											HaYarkon Park, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											10.06.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>

// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://redhotchilipeppers.com/">
// 											www.redhotchilipeppers.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2  class="ac-align-center ac-margin-top-20">Red Hot Chili Peppers are coming to Funkyard Tel Aviv!</h2>
// 							<p  class="ac-align-center ac-margin-bottom-20 "><b>They’re hot, they’re sexy, they’re Red Hot Chili Peppers,<br class="hide-on-mobile"> and they’re coming back to Tel Aviv for the first time since 2012!</b></p>
// 							<p>With 11 albums, 16 Grammy nominations and six awards, this mega-successful band will make your heart, body, and soul dance at the new Funkyard Festival to be held at the green heart of Tel Aviv - Hayarkon Park. </p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/red-hot-chili-peppers-2020/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>last December, the band announced the return of the legendary guitarist John Frusciante to the band for the second time, and we’re sure the LA funk-rock icons will rock the park once again.</p>
// 							<p>Red Hot Chili Peppers will give a single concert in the city that doesn’t stop, where you can start the day tanning at the beach with ice-cold beers and end up at one of the lively bars open till morning. The Peppers’ will perform at the beginning of summer when the temperatures are not too hot, but the parties across the city are sizzling. </p>
// 							<p>Tickets are on sale now and the concert is expected to be sold out, so book your trip before it’s gone!</p>

// 						`
// 			}
// 		}
// 	},

// ];

// End live shows
export const ShowsPostsData = [];

export const newPostdata = [
  {
    id: "eurovision",
    bgImage: "/posts/bank/eurovision/1.jpg",
    mobBgImage: "/posts/bank/eurovision/M/1.jpg",
    title: "EUROVISION TEL AVIV",
    ctg: "eurovision",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `

                   	<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/thingsToDo/posts/eurovision/logo.png"} class="img-responsive" />
					</div>
					<h3>
						A ONCE IN A LIFETIME OPPORTUNITY TO VISIT TEL AVIV AS IT HOSTS THE EUROVISION SONG CONTEST
					</h3>
					<p>					
						Epic song contest in the Non-Stop City
					</p>
					<p>
						Semi-final 1: 14 May 2019
					</p>
					<p>
						Semi-final 2: 16 May 2019
					</p>
					<p>
						Grand Final: 18 May 2019
					</p>
					<p>
						It’s getting hot hot hot in Fabulous Tel Aviv! The nonstop city is teaming with excitement as it is getting ready to host the 2019 Eurovision Song Contest in what promises to be one of the most epic events ever held in the famous party city.
					</p>					
					<p>
						Tel Aviv, known for its amazing energy, stunning beaches, great year round weather and gorgeous people, is the perfect destination for an unforgettable citybreak. Tel Aviv is known world over for its open mindedness and liberal spirit, making it the ideal host for the Eurovision song contest, offering visitors from far and wide the perfect opportunity to enjoy this vibrant and energetic city at its finest.
					</p>            
                   	<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/thingsToDo/posts/eurovision/1.jpg"} class="img-responsive" />
					</div>
					<p>
						Major productions centered around the Eurovision contest month are already well on their way. Some of the exciting events planned include an amazing opening ceremony, a prestigious red-carpet event, and even a mega “Euro Village” which will be situated merely a minutes’ walk from the awesome Tel Aviv baordwalk and beach. The Euro Village will be open for 10 days and will include live performances from past and present mega stars as well as live screenings of the Eurovision contest’s semifinal and final. The contest itself will take place in the Expo Tel Aviv.
					</p>
					<p>
						The Eurovision Song contest in Tel Aviv is guaranteed to be an event of a lifetime, so make sure to book your trip now to the most amazing Eurovision contest yet, in the most amazing city of all!
					</p>

            	`,
      };
    },
  },

  {
    id: "Get_ready_to_party",
    bgImage: "/posts/bank/Get_ready_to_party/1.jpg",
    mobBgImage: "/posts/bank/Get_ready_to_party/M/1.jpg",
    title: "The best Eurovision parties to be at",
    ctg: "eurovision",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `

               <h3>
               	Your Total Guide to Tel Aviv Eurovision parties
               </h3>
               <p>
					From the Eurovision Village to the EXPO Centre, these are all the key places you need to know about for Eurovision 2019 in Tel Aviv…
				</p>
				<h3>
					CHARLES CLORE PARTY VENUE
				</h3>
				<h3>
					Charles Clore Park: home to the largest Eurovision Village to have ever been made.
				</h3>
				<p>
					Charles Clore Park is located on the sea-front in the south-west of Tel Aviv. It’s a beautiful green space overlooking Old Jaffa, one of the most ancient places in Tel Aviv. 
					During Eurovision week it will be home to the Eurovision Village, where free concerts from the biggest Eurovision stars will take place. Highlights include Dana International and Conchita Wurst, plus parties and screenings of the live Eurovision TV shows will take place outside, right in-front of the beautiful Mediterranean sea! 
				</p>
				<p>
					Also, some of Israel’s best chefs will be opening food stalls for the public to get first-hand experience of-mouth-watering Israeli and Middle-Eastern cuisine.
				</p>
				<p>
					Charles Clore is easy to get to: It’s a five minute walk from the Carmelit bus terminal, so any bus terminating there is a good choice. Then you can just walk towards the sea and you’ll see the village. If coming by foot, walk along the beach promenade. Or you can cycle or scoot along the sea front to get there. 
					It’s a big park and will be having a Eurovision makeover, so you won’t be able to miss it! In fact, this is the largest village to ever have been made for the Eurovision!
				</p>
				<h3>
					TEL AVIV PORT VENUE (“The Namal”)
				</h3>
				<h3>
					Home to 2019’s official Eurovision Euro Club
				</h3>
				<p>
					With its huge venues, gorgeous decking and sea-side views, Tel Aviv Port is the perfect place to party the night away on Eurovision week!
				</p>
				<p>
					With its huge venues, gorgeous decking and sea-side views, Tel Aviv Port is the perfect place to party the night away on Eurovision week!
				</p>
				<p>
					The club will feature theme parties, live performances, screenings of the Eurovision live shows and many more surprises to be revealed. Former Eurovision acts and winners, both Israeli and international, are set to perform there during the Eurovision week, so the venue will offer much more than just a traditional night-club. Entry to the Euroclub is free for accredited fans, journalists, delegations and artists. Members of the general public can get in to the Euroclub by purchasing a special weekly bracelet, here:
					<a href="https://www.eventer.co.il/euroclub?fbclid=IwAR37-d_19OE7bsq0rQ_gPHAW-sRfn1QAMi-cxp_ID2pFtDODBYzbf5NB6S0" target="_blank">https://www.eventer.co.il</a>
				</p>
				<h3>
					EUROVISION VENUE
				</h3>
				<h3>
					Expo Tel Aviv: home to the Eurovision Song Contest itself
				</h3>
				<p>
					The 2019 Eurovision Song Contest will be held at the Tel Aviv Expo center on the14th, 16th and 18th May. If you’ve got tickets, this is the place you’ll need to get to.
					It’s located on Rokach Boulevard in the north of the city, past HaYarkon Park and near to Tel Aviv University. To get there, use a journey planning app to find a bus route that will drop you right outside. Or, if travelling by train, get off at Tel Aviv University Train Station which is just a few minutes’ away from the convention centre.
				</p>
				<p>
					Don’t forget about the White Night, all the details are in the next article.
				</p>

         	`,
      };
    },
  },

  {
    id: "Dead_Sea2",
    bgImage: "/posts/bank/deadsea2/1.jpg",
    mobBgImage: "/posts/bank/deadsea2/M.jpg",
    title: "LA MER MORTE",
    smltitle: "",
    isVid: true,
    vidId: "c93EwT_1EU8",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `
                     
                     <br/>
					 <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">
                             Le plaisir de la vie à son plus haut niveau au point le plus bas sur Terre
                      </h2>
              		<p>
			Une merveille géologique dans un cadre particulièrement serein, la mer Morte est une attraction touristique extrêmement populaire. Expérimentez le calme et la tranquillité de l’eau avec ses propriétés médicinales apparentes tout en profitant de la beauté inégalée du paysage environnant. <strong>La mer Morte, également connue comme étant le plus vieux spa naturel du monde, jouit d’une concentration extrêmement forte en sel, soit 31,5%, permettant aux touristes venus de toutes parts de vivre l’expérience extraordinaire de flotter sans efforts dans les eaux de l’endroit le plus bas sur terre. </strong> Sur place, vous pouvez vous baigner dans la boue noire et saine de la région ou explorer les paysages fascinants et riches en histoire des alentours.
              		</p>

              		<p>
			            Les hôtels de luxe, la cuisine variée des restaurants gourmets à la restauration rapide, les grands magasins de souvenirs, l’histoire extraordinaire de Masada, à proximité, et les nombreuses activités culturelles pendant toute l’année, font de la mer Morte une destination populaire aussi bien pour les touristes locaux que les visiteurs du monde entier.
			       </p>
              		
				
				<!--<div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/next-level/1.jpg"} class="img-responsive" />
				</div>
				
				<div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/next-level/2.jpg"} class="img-responsive" />
				</div>-->
				      


           `,
      };
    },
  },

  {
    id: "Tourist_info",
    bgImage: "/posts/bank/Tourist_info/1.jpg",
    mobBgImage: "/posts/bank/Tourist_info/M/1.jpg",
    title: "Tourist info",
    ctg: "telaviv",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `

					<h3>
					How to get to Tel Aviv from the airport:
					</h3>
					<p>
					The cheapest way to get into central Tel Aviv from Ben Gurion airport is by train. Follow the signs to the train station that’s attached to the airport (it’s clearly sign-posted) and look for a train that’s going to Tel Aviv-HaHagana (for south Tel Aviv), Tel Aviv-HaShalom (for Central Tel Aviv), Tel Aviv-Savidor Center (for the Old North area of Tel Aviv), or Tel Aviv-University (for the Eurovision Song Contest venue itself). Please note that Tel Aviv HaShalom is closed on Fridays until September 2019. 
					A one-way single ride ticket will cost 13 shekels 50, and the journey takes around 25 minutes. When you get off the train, you might want to take a taxi to your accommodation. Whenever you get in a taxi, ask the driver to use the meter (“monet”) and have cash ready to pay. Or see below for details of taxi apps. For more information and to plan your journey, visit <a href="https://www.rail.co.il/en" target="_blank">https://www.rail.co.il/en</a>: - it’s in English!
					</p>
					<p>
					If you’d prefer to take a taxi all the way to Tel Aviv from the airport, then join the registered taxi queue outside the arrivals hall. A member of staff will ask you where you’re going and how many passengers and cases you have, then will give you a ticket to hand to your driver. You can either use a meter or accept a fixed price. Journeys usually cost around 150-170 shekels for one person. 
					</p>
					<h3>
					How to get from Tel Aviv to Jerusalem:
					</h3>
					<h3>
					By Bus
					</h3>
					<p>
					Head to the Tel Aviv Savidor train central station take bus no.480. The journey time is around 45 minutes. The bus route finishes at the Jerusalem Central Bus Station on Jaffa Road. From there you can take the tram or any other means of  available to you, to get to your final destination. 
					</p>
					<h3>
					By Train
					</h3>            
					<p>
					You can also take the brand new train! If you want to go to Jerusalem directly from Ben Gurion Airport, take the train to Navon Station in Jerusalem. The journey from the airport takes around 25 minutes. If you’re connecting from other Tel Aviv stations, just take a train to Ben Gurion Airport station and change there for a connection to Navon.  
					</p>            
					<h3>
					How to get around Tel Aviv
					</h3>
					<p>
					The municipality of Tel Aviv will offer free public transport throughout the city over the weekend of the Eurovision Song Contest. 
					Free buses will run on Friday and Saturday May 17-18.
					However Usually on Saturday there is no public transport in Tel Aviv (aside from taxies).
					</p>
					<p>
					For the other days of Eurovision week, you’ll need a Rav Kav card: Similar to the “Oyster Card” in London, a Rav Kav is a smart card that can be loaded with credit to allow you to ride on buses without needing to worry about cash. In fact, bus drivers no longer let you pay in cash, so it’s super important to get a Rav Kav as soon as you arrive in Tel Aviv.
					To get a card, just jump on a bus at any bus stop, and ask the driver for a Rav-Kav card - it costs 5 shekels (You will need exact change). Then, when you get off the bus, take the card anywhere with you. Some local 7/11s (Kiosk) provide top up serives, ask to add some credit. 50 shekels is probably enough for a one-week visit, as it will cover the cost of around 10 local journeys (each journey is 5 shekels 90). 
					You can also buy a Rav Kav at the official Rav Kav office at 35 Iban Gabirol Street, which is open Sunday to Thursday 8:00 - 20:00 and Friday and holiday eves 8:00 - 13:00 ,or in the Tel Aviv Savidor train station and Carmelit central. You can also add credit at any train station. 
					</p>
					<h3>
					Cycling
					</h3>
					<p>
					Tel Aviv is a cycling hot-spot and there are bike lanes all around the city, including one that runs all the way along the beach promenade from Jaffa in the south  the north of Tel Aviv and beyond, which are gorgeous locations to take a bike ride while soaking up the atmosphere and architecture of Tel Aviv. If you have a bicycle helmet, bring it with you. 
					</p>
					<h3>
					Electric Scooters
					</h3>
					<p>
					Scooters have become super popular in Tel Aviv! They offer a convenient and fun way to get round the city. There are a few brands around – all you have to do is download the relevant app, follow instructions and off you go. Swap your handbag for a rucksack as this will help with balance and remember to keep an eye on the traffic and not to listen to music while scooting. If you have a helmet, it’s a good idea to wear it while you scoot
					</p>
					<h3>
					Walking
					</h3>
					<p>
					Walking is also a great option too - your step-count will soar after a few days in the non-stop city! Equip yourself with a map, a sun-hat and a bottle fo water, and hit the pavements!
					</p>
					<h3>
					 Apps 
					</h3>
					<p>
					There are various  apps you can download before arrival to help you plan your way around. Search for one from each category: there are taxi apps, bicycle rental apps, scooter rental apps and journey planning apps. You can also ask your hotel concierge or apartment host for advice on how to get around Tel Aviv - they will be happy to help! 
					</p>
					<h3>
					WIFI
					</h3>
					<p>
					Tel Aviv has a free Wifi network throughout the city. Look for the ‘Free TLV’ network in your smartphone - it works in 80 locations around the city. Most cafes and bars have free public Wifi networks you can use too; just ask for the password when you make your order. Hotels also have free Wifi so just ask for the password information when you check-in.
					</p>

         	`,
      };
    },
  },

  {
    id: "White_night",
    bgImage: "/posts/bank/White_night/1.jpg",
    mobBgImage: "/posts/bank/White_night/M/1.jpg",
    title: "White night",
    ctg: "eurovision",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `

							<h1 class="align-center">
							  White Night Lights Up Tel Aviv on 16th May 
							</h1>
        					<div class="responisve-iframe">
								<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
							</div>

							<p>What do you get when you cross a Eurovision Semi-Final with an all-night party in a city that is famous for its 24/7 party energy? The answer is White Night, which will hit Tel Aviv this year on Thursday 16th May, just two days before the 2019 Eurovision Song Contest grand final.</p>
                            <p>Featuring pop-up art installations, live music, dance parties, cultural events, food and drink, all fused together with Tel Aviv’s eclectic atmosphere, White Night is one of the biggest cultural events of the year. </p>
                            <p>And for 2019, it’s taking place a month earlier than usual, so that visitors coming for the Eurovision Song Contest can also experience this magical experience in the White City of Tel Aviv.</p>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/posts/White_night/1.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo By: Adam Primer
							</small>

							<p>From sunset until sunrise, the city will be wide-awake with cultural activities. Locals and visitors alike are invited to explore the city and soak up all the activities on offer. Many bars, restaurants and shops will be offering experiences free of charge or at reduced rates, so it’s definitely worth stocking up on sleep so you’re ready to party all night long!</p>
                            <p>And at the Eurovision Village in Charles Clore Park, there’ll be an extra sparkle of Eurovision magic, as several icons of the competition take to the stage to entertain visitors during the night. </p>
                            <p>Last year’s runner-up, Eleni Foureira, who narrowly missed out to Tel Aviv’s own Neta Barzilai with her smash-hit song “Fuego”, will be performing, as will 2014 winner, Conchita Wurst from Austria, who will most likely perform his iconic winning song, “Rise Like a Phoenix” while showcasing his new-look for 2019!</p>
                            <p>They’ll be joined by three more Queens of Eurovision, in the form of 1970s pop icon Anne-Marie David, who won for Luxembourg in 1973, Swedish pop star Carola Häggkvist, who won the contest in 1991, and Loreen, who also won for Sweden in 2012 with her song Euphoria. The performances will take place on the coast, overlooking the Mediterranean; the live semi-final will also be shown on big-screens in the Eurovision Village, off-set by jaw-dropping light compositions, created by the competition’s official lighting partner OSRAM.</p>
                            <p>All in all, White Night is a night not to be missed. So make the 15th May your duvet day and get-set to party all night long on Thursday 16th May 2019. Tel Aviv is ready and waiting to celebrate with you!</p>

							<div class="img-wrapper">
								<img src=${getImgUrl() + "/posts/White_night/2.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo By: Kfir Sivan
							</small>
							
							<div class="img-wrapper">
								<img src=${getImgUrl() + "/posts/White_night/3.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo by Moshik Lindenbaum
							</small>
							
							<div class="img-wrapper">
								<img src=${getImgUrl() + "/posts/White_night/4.jpg"} class="img-responsive" />
							</div>
							<small>
								Photo by: Guy Yechiely‎.
							</small>

         	`,
      };
    },
  },

  {
    id: "Tel_Aviv_Street_Food",
    bgImage: "/posts/bank/street-food/1.jpg",
    mobBgImage: "/posts/bank/street-food/M/1.jpg",
    title: "PARADIS POUR LES GOURMETS",
    ctg: "telaviv",
    isVid: true,
    vidId: "JQD9JpMaw9g",
    smlTitle: "",
    html: function() {
      return {
        __html: `

				<p>Explorez l’impressionnante scène culinaire de Tel Aviv. Si vous êtes gourmands (et soyons honnêtes, la plupart d’entre nous le sommes), alors vous devriez venir goûter à Tel Aviv. Ses chefs israéliens sont devenus célèbres à travers le monde pour leurs plats innovants, et la scène culinaire de Tel Aviv est en train de complètement exploser.</p>

				<p>Dotée d’environ 4 500 lieux de restauration, Tel Aviv est une véritable Mecque de la gastronomie. Beaucoup de restaurants appartiennent à de brillants chefs de renommée internationale, qui ont été formés et ont travaillé dans certains des meilleurs établissements du monde, avant de revenir en Israël pour marquer la scène culinaire locale de leurs empreintes uniques.</p>
				
				<p>À Tel Aviv, la cuisine possède de quoi faire le bonheur de chaque palais. Désignée ‘Top destination vegan’ par le site web culinaire américain The Daily Meal, Tel Aviv répertorie quelques 400 restaurants adaptés aux végétaliens et végétaliennes. Vous aurez envie d’essayer les excellentes spécialités de rue comme le Falafel et le Houmous, ainsi que la gamme variée des délices en vente sur les marchés locaux. Pour vivre une fantastique expérience culinaire, ne manquez pas les restaurants à la mode du port de Tel Aviv, de l’avenue Rothschild, du quartier Neve Tzedek et ceux situés dans le complexe superbement rénové de ‘Tachana’.</p>
				
				<p>Une partie de la cuisine la plus avant-gardiste de la ville se trouve essentiellement au marché de Sarona, qui fut à l’origine une colonie allemande de Templiers ; ce marché d’une superficie de 8 700 m2 a été méticuleusement restauré et abrite désormais 91 boutiques de tous types, des stands et des restaurants, où vous pouvez tester de nouveaux plats qui mettent non seulement l’eau à la bouche, mais sont aussi particulièrement originaux.</p>

         	`,
      };
    },
  },

  {
    id: "Dead_Sea_Video",
    bgImage: "/posts/bank/natures-glory/1.jpg",
    mobBgImage: "/posts/bank/natures-glory/M.jpg",
    title: "LA MER MORTE",
    ctg: "deadsea",
    isVid: true,
    vidId: "ixFocykfYHo",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                      <p>Le plaisir de la vie à son plus haut niveau au point le plus bas sur Terre</p>
                   
         	`,
      };
    },
  },

  {
    id: "Jerusalem_Old_City",
    bgImage: "/posts/bank/jerusalem1/1.jpg",
    mobBgImage: "/posts/bank/jerusalem1/M.jpg",
    title: "La vieille ville",
    ctg: "jerusalem",
    isVid: true,
    vidId: "6eXJu1Yy4kg",
    smlTitle: "",
    html: function() {
      return {
        __html: `
		 
					<p>Jérusalem est une véritable invitation au voyage. Gravissez les montagnes, pénétrez dans la ville et ressentez ce mélange de passé et de présent, d'ordinaire et d'extraordinaire. L'une des cités les plus anciennes au monde et considérée comme sacrée par les juifs, les chrétiens et les musulmans, Jérusalem offre une expérience sensorielle et spirituelle sans équivalent.</p>

					<p>Pénétrez dans la ville. Pour le judaïsme, le cœur de la ville sainte est la vieille ville. Empruntez l'entrée historique, La Porte de Jaffa, ou la Porte de Sion qui conduit directement au Quartier juif, l'un des quatre quartiers de la ville fortifiée où habitent des juifs presque sans interruption depuis le 8ème siècle avant J.C. Flânez dans les ruelles, observez les habitants, visitez le Cardo, l'ancienne voie principale de Jérusalem et imprégnez-vous de son atmosphère. Vous marchez dans les traces des rois et prophètes, c'est extraordinaire.</p>
					
					<h3>Regardez l'histoire prendre vie et ressentez la profonde énergie spirituelle que contiennent ces murs</h3>
					
					<p>Ce qui est devant vous. Le Mur occidental, dernière portion encore présente des murailles antiques qui entouraient le Second temple, symbolise l'aspiration des juifs à retrouver leur patrie ancestrale et spirituelle. Chaque juif hors de Jérusalem prie face au lieu où vous vous trouvez maintenant, celui où, selon le judaïsme, réside Dieu. Quelle que soit notre confession, ce lieu force l'humilité. Honorez l'esprit du site et placez un message contenant une prière ou un souhait entre les pierres du mur.</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/jerusalem-old-city/1.jpg"} class="img-responsive" />
					</div>

					<p>Ce qui est sous vous. Jérusalem est littéralement constituée de plusieurs niveaux d'histoire, et toucher du doigt cette histoire prend ici une toute nouvelle signification.</p>
					
					<p>Visitez les mystérieux tunnels du Mur occidental et découvrez ses recoins secrets. L'histoire prendra vie devant vous lorsque vous parcourrez les passages souterrains, découvrirez la vie à l'époque du Second temple, vous familiariserez avec l'art, l'architecture et les pratiques de construction.</p>
					
					<p>Visitez le site archéologique de la Ville de David, situé à proximité, et apprenez à connaître l'histoire de la ville, désignée il y a 3000 ans comme la capitale unifiée des 12 tribus d'Israël par le Roi David. Au détour des murs et forteresses anciennes, découvrez les sources cachées où des rois ont été couronnés, puis suivez les pas des habitants de Jérusalem lorsqu'ils ont fui la ville conquise par les Romains.</p>
					
					<h3>Émerveillez-vous devant l'extraordinaire panorama et sentez-vous sur le toit du monde</h3>
					
					<p>Ce qui est au-dessus. À l'origine, les murs qui entourent Jérusalem avaient été bâtis pour protéger la ville de l'envahisseur. Aujourd'hui, les Murs de Jérusalem offrent l'opportunité d'explorer la ville sous une perspective inédite. Écoutez les histoires, admirez la ville qui s'étale à vos pieds et embrassez sa beauté.</p>
					
					<p>Vous n'êtes pas au bout de vos surprises.</p>

					<h2>LES PORTES DE JÉRUSALEM<br/>
						Franchissez les portes et découvrez un nouvel aspect de la vieille ville de Jérusalem
			        </h2>

			        <p>Les remparts de la vieille ville de Jérusalem, construits au 16<sup>ème</sup> siècle par le sultan turc Soliman le Magnifique, comportent huit portes. Toutes ces portes, à l'exception de la Porte de la miséricorde, permettent toujours aux Hiérosolymitains et aux visiteurs de se rendre sur ses marchés et sur ses sites historiques et sacrés.</p>
					<p>Vous trouverez ci-après un aperçu de ces portes, dans le sens contraire des aiguilles d'une montre, du sud à l'ouest:</p>
					<p><strong>La Porte de Sion:</strong></p>
					<p>Elle porte le nom biblique le plus ancien de Jérusalem, que ce soit en hébreu ou en français. Son nom arabe est "Porte du Prophète David", car la tombe du roi David, sur le mont Sion adjacent, ne se trouve qu'à quelques pas. La Porte de Sion débouche directement sur les quartiers arméniens et juifs.</p>
					<p><strong>La Porte des immondices</strong>: cette porte doit son nom peu courant aux décharges malodorantes qui se trouvaient à cet endroit durant l'antiquité, et dont les odeurs étaient portées par les vents dominants. Néhémie 2:13 mentionne une porte des immondices qui se trouvait probablement à proximité de celle-ci. Cette porte débouche directement sur le Mur occidental et le Parc archéologique du Mur méridional.</p>
					<p><strong>La Porte de la miséricorde</strong>: cette porte, qui se trouve dans le mur oriental du Mont du Temple, est peut-être la plus connue. Également appelée Porte dorée ou Porte orientale, elle est murée depuis des siècles. Il est dit qu'elle attend une ouverture miraculeuse lorsque le Messie viendra sur terre et que les morts ressusciteront.</p>
					<p><strong>La Porte des Lions:</strong></p>
					<p>Cette porte doit son nom aux deux couples de félins en bas-relief qui l'encadrent. Il s'agit en réalité de léopards, symbole héraldique du sultan Beybars au 13<sup>ème</sup> siècle. Elle est également appelée Porte Saint-Étienne, du nom du premier martyr chrétien, dont la tradition fixe la lapidation à cet endroit. La Porte des Lions, qui débouche sur la piscine de Bethesda, la Via Dolorosa et les marchés, est devenue célèbre durant la Guerre des Six Jours.</p>
					<p><strong>La Porte d'Hérode:</strong></p>
					<p>Malgré son nom, le célèbre roi de Judée n'a aucun rapport avec cette porte. En arabe et en hébreu, cette porte qui fait face au nord et débouche sur les marchés de la vieille ville est appelée Porte des Fleurs. Certains prétendent que son nom provient de la rosette sculptée qui la surplombe. Cependant, un mot similaire en arabe signifie «&nbsp;réveillé&nbsp;», ce qui peut faire référence à un cimetière proche et à l'espoir d'une résurrection.</p>
					<p><strong>La Porte de Damas:</strong></p>
					<p>Il s'agit de la porte la plus imposante de Jérusalem. Faisant également face au nord, son nom provient de la grande ville dont vinrent autrefois les souverains de Jérusalem. Ce passage est toujours très actif, grâce aux marchés animés qui s'y tiennent. Sous la porte du 16<sup>ème</sup> siècle, les archéologues ont découvert une partie de l'entrée bâtie par l'empereur Hadrien au deuxième siècle de notre ère.</p>
					<p><strong>La Nouvelle Porte:</strong></p>
					<p>C'est le seul point d'accès à la vieille ville qui ne faisait pas partie de la structure originale des remparts du 16<sup>ème</sup> siècle. Elle fut percée dans les derniers jours de l'Empire ottoman, afin de permettre aux pèlerins chrétiens d'accéder plus rapidement à leurs lieux saints à l'intérieur des remparts.</p>
					<p><strong>La Porte de Jaffa:</strong> elle était la destination des pèlerins juifs et chrétiens débarquant dans le port de Jaffa, d'où son nom. Elle conduisait (et conduit toujours) directement aux quartiers juif et chrétien, ainsi qu'aux parties les plus populaires du marché et au Musée de la Tour de David, qui fut autrefois la citadelle de Jérusalem et présente aujourd'hui son histoire.</p>


         	`,
      };
    },
  },

  {
    id: 13,
    bgImage: "/posts/bank/25/1.jpg",
    mobBgImage: "/posts/bank/25/M.jpg",
    vidId: "k4OwoEk5wMw",
    ctg: "jerusalem",
    isVid: true,
    title: "Jerusalem’s Calling",
    smltitle: "",
    html: function() {
      return {
        __html: `

				<h2>The most magical and radiant city on Earth </h2>

					<p>
						What else can you say about the world’s most unique city? Simply put: Welcome to Jerusalem – where a glorious history is intertwined with modern and dynamic life.
					</p>

					<p>
						Jerusalem is home to innumerable fascinating historic sites, magical walkways, breathtaking views at sunset, a wide variety of entertainment options, restaurants that offer culinary excitement, spirited nightlife and a tremendous offering of centers for the arts and culture.
					</p>

					<h3>
					   The Old City
					</h3>
					<p>
						No other place offers as many attractions and emotionally inspiring sites in a single square kilometer. The Old City of Jerusalem brims with opportunities for you to connect with the city’s resplendent past, history, culture and spirituality. In the Old City, you’ll find archaeological treasures that are thousands of years old, contemporary art and bustling markets where you can purchase delectable delights.
					</p>

					<h3>
					  The Western Wall:
					</h3>
					<p>
						Believed to be the only remaining segment of the Second Temple, the Western Wall has become truly synonymous with Jerusalem. Thousands of years old, it is the most important Jewish prayer site in the world, where thirteen-year-old boys come to celebrate their bar mitzvahs, and where millions of visitors and tourists from around the world place notes with requests and prayers into its cracks.
					</p>
					<h3>
					  Western Wall Tunnels:
					</h3>
					<p>
						Visiting the tunnels is like entering a time machine. Located beneath the Western Wall and the Muslim Quarter, provides visitors with a glimpse of the various periods in the history of Jerusalem.
					</p>
					<h3>
					   City of David:
					</h3>
					<p>
						Located next to the Dung Gate, this site presents the story of Jerusalem during the reigns of King David, King Solomon and King Hezekiah. Many archeological treasures were unearthed in the excavation, including a two-thousand year-old gold earring.
					</p>
					<p>
					   A visit to the site will enable you to take a flashlight and wade through the flowing water of the Siloam Tunnel, which was built during the reign of King Hezekiah.
					</p>

					<h3>
					 Via Dolorosa
					</h3>
					<p>
						Christian faithful follow in the footsteps of Jesus down the Via Dolorosa and the 14 Stations of the Cross, reenacting the fateful path that had an unprecedented impact on the course of history.
					</p>

					<h3>
					  Church of the Holy Sepulchre:
					</h3>
					<p>
						According to Christian tradition, the Church is the site where Jesus was crucified, buried and where he resurrected from the dead. It has long been and continues to be a major pilgrimage center for Christians world over.
					</p>

					<h3>
					 The market in the Old City:
					</h3>
					<p>
						This must-see attraction is made up of a series of alleyways, with numerous stalls offering a staggering variety of souvenirs, clothing, foods (baked goods, spices, sweets, tehini and more); stands hawking juices of all kinds, Armenian ceramics, drums and other musical instruments, earthenware jugs and much more. The colorful market delivers an authentic and extremely enjoyable experience that simply cannot be missed.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/4/2.jpg"} class="img-responsive" />
					</div>

					<h3>
						Attractions
					</h3>

					<h3>
						Segway tours:
					</h3>
					<p>
						This adrenaline-packed method of seeing the city will allow you to take in the beauty of Jerusalem from an entirely different perspective. The Segway tours leave from various central spots, including the Armon HaNatziv Promenade (East Talpiot), Yemin Moshe, and the Old City, as well as near the Knesset and the museum area.
					</p>

					<h3>
                        First Station (Hatachana):
					</h3>

					<p>
					   If you like amusement park rides, you love having your senses scintillated by the Time Elevator. It’s an interactive experience that takes visitors on fabulous voyages to fascinating places, with motion-based seating in a unique hall that is filled with special effects.
					</p>

					<h3>
                        Time Elevator:
					</h3>

					<p>
					   The First Station is right in the heart of Jerusalem, between the Old City and the city center, and between the historical neighborhoods of the German Colony and Yemin Moshe. It is the site of the first train station in Jerusalem, which was built in 1892. After undergoing renovation and preservation, the First Station was reopened as a lively entertainment spot.
					</p>

					<h3>
					   Machane Yehuda Market:
					</h3>

					<p>
					   To experience the city as authentically as possible, your itinerary must include a stop at Machane Yehuda Market. It represents Jerusalem of the present and the future. Machane Yehuda uniquely brings together old and new, with its fruit and vegetable market, along with an excellent food and a vibrant entertainment area.
					</p>

					<h3>
					   Museums
					</h3>

					<p>
					   In a city filled with a large number of museums, you have every opportunity to experience and learn about the events of the past and to visit modern and contemporary exhibits.
					</p>

					<h3>
					   Israel Museum
					</h3>

					<p>
					   The Israel Museum is the largest cultural institution in the country. It has many wings and very large collections of art, archeology and Judaica. One of the highlights of any visit to the museum is the Shrine of the Book, with its unique design that has come to be closely associated with the city itself.
					</p>

					<h3>
					   Tower of David Museum:
					</h3>

					<p>
					  Thousands of years ago, Jerusalem was a small city, where kings and prophets walked or rode their horses down the alleys. Since that time, one of the best-known symbols of the city is David’s Tower, with its turret standing proudly above the ancient fortress that has also become one of the city’s important museums.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/4/3.jpg"} class="img-responsive" />
					</div>

					<h3>
					   Restaurants
					</h3>

					<p>
					  Jerusalem boasts many restaurants, where you can dine on a wide array of delicacies –local and international, standard and exotic. And if you are looking for the gourmet experience, you can reserve a spot at exclusive chef restaurants. The following are five of Jerusalem’s finest and most popular spots, which attract crowds all day long:
					</p>

					<h3>
					   Café Kadosh
					</h3>

					<p>
					 Highly popular, the café serves kosher dairy cuisine – all made in house, and all delicious!
					</p>

					<h3>
					   Tmol Shilshom
					</h3>

					<p>
					  A dairy bookstore café in the city center, favored for its warmth, delicious food and friendly service. Don’t miss the shakshuka or salmon fillet in fig sauce!
					</p>

					<h3>
					   The Eucalyptus
					</h3>

					<p>
					  The kosher restaurant, located in the Artist’s Quarter, serves Chef Moshe Basson’s interpretation of biblical cuisine. Every dish has its origins in biblical scenes and all the spices and herbs used grow, as in ancient times, in the surrounding hills of Jerusalem and Judea. An unforgettable experience.					</p>

					<h3>
					   Darna
					</h3>

					<p>
					  An authentic, glatt kosher, Moroccan restaurant, located in the heart of the city. Experience the warm welcome and the true meaning of Moroccan hospitality, while enjoying the culinary excellence of the Maghreb.
					</p>

					<h3>
					   Ima Restaurant
					</h3>

					<p>
					  Right down the street from Machane Yehuda market, Ima offers excellent kosher Middle Eastern food, served in a relaxed family atmosphere
					</p>

					<h3>
					   And no visit to Jerusalem is complete without scooping up some hummus with a pita right out of the oven. The following are a few centrally located hummus spots:
					</h3>

					<div class="cradit">
							<p>
							<strong>Azura,</strong><small> in the Iraqi section of the Mahane Yehuda Market </small><br>
							<strong>Lina,</strong><small> in the Christian Quarter of the Old City</small><br>
							<strong>Hummus Acramawi,</strong><small>  in the Muslim Quarter of the Old City </small><br>
							<strong>Hummus</strong><small> Ben Sira, in the city center next to the Mamilla Hotel</small><br>
							<strong>Abu Shukri,</strong><small> in the Muslim Quarter in the Old City of Jerusalem </small><br>
							</p>
				    </div>

				    <h3>
				        Nightlife
				    </h3>

				    <p>
				         Jerusalem is filled with scores of restaurants and entertainment spots that are also open on Friday nights (the Jewish Sabbath). All of Jerusalem’s entertainment areas have excellent options for weekend fun on Friday nights as well as Saturdays, and you can most definitely enjoy a delightful evening over a cold beer or dance to great music.
                         Below is a small selection of bars and clubs that are hopping on Friday nights and will leave you wanting more…
				    </p>

				    <h3>
				       Mantra
				    </h3>

				    <p>
				       An intimate restaurant and wine bar, where a friendly atmosphere meets superb cuisine.
				    </p>

				    <h3>
				       Gatsby Cocktail Room
				    </h3>

				    <p>
				       The cocktail lounge and bar evokes the magic of the Roaring 20’s and the days of cabarets.
				    </p>

				    <h3>
				        HaTaklit
				    </h3>

				    <p>
				       With a name means “the record” in Hebrew, the trendy bar is decorated with record sleeves. Enjoy full bar, live music, DJs and even independent performers.
				    </p>

				    <h3>
				       Toy Bar (HaTza’atzua)
				    </h3>

				    <p>
				      Centrally located, Toy Bar offers great drinks, great music by some of the best local DJs and great dance bar experience.
				    </p>

				    <h3>
                        Sira
				    </h3>

				    <p>
                       One of the city’s most eclectic underground clubs, with an arcade room and dance floor. The pub also hosts events and performances.
				    </p>

				    <h3>
                        Even / Juke
				    </h3>

				    <p>
				       A music club that showcases the most creative bands in Israel, with an emphasis on jazz, blues and funk.
				    </p>

				    <h3>
                       Video Pub
				    </h3>

				    <p>
				       Jerusalem’s only “official” gay bar is home to some of the wildest parties in the city.
				    </p>

				    <p>
				       Jerusalem is the ultimate vacation destination! With so much to see and do, so much to stimulate your senses and pique your curiosity, your trip to Jerusalem promises us an unforgettable experience. Book your vacation now!
				    </p>

				    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/4/4.jpg"} class="img-responsive" />
					</div>

					<h3>Box:</h3>
					<h3>
					   Annual events
					</h3>

					<p>
					   Jerusalem plays host to a variety of unique annual events. Check the Internet for dates and further information.
					</p>

					<h3>
					   Festival of Light
					</h3>

					<p>
					   Held in the Old City – May 25, 2016 to June 2, 2016. Come and be part of the enchanting games of light and color, with dozens of displays by Israeli and international artists. Follow the paths set up throughout the Old City, guiding visitors from one mesmerizing work to another.
					</p>

					<h3>
					   International Arts and Crafts Fair (Khutsot Hayotser):
					</h3>

					<p>
					  August 15, 2016 – August 29, 2016. Held against the backdrop of the Old City walls, visitors enjoy a very special nighttime atmosphere and happening with musical performances. Walk through the gardens and stop at the various stands, where artists from Israel and the world exhibit paintings, prints, ceramics, metalwork and jewelry, weaving and textiles, Judaica, toys, crafts in various techniques, woodwork and more.
					</p>

					<h3>
					   The Israel Festival
					</h3>

					<p>
					   May 24, 2016 – June 11, 2016. The festival is Israel’s premiere multi-disciplinary international festival. It takes place annually in the spring, presenting outstanding theater performances, contemporary dance, classical music and performances from around the world, along with ground breaking Israeli works. Numerous festival events are held at unique Jerusalem locations that have historic significance of hundreds, if not thousands, of years. There are also many street performances that are open to the public.
					</p>

					<h3>
					  Jerusalem Film Festival
					</h3>

					<p>
					   July 7, 2016 – July 17, 2016. The festival sprinkles star dust across the city, with quality cinema, actors and writers that are guests. Many famous stars have come to the festival of the years. Over 200 Israeli and foreign films will be screened during the festival, highlighting various genres and competing for prizes. The festival offers opportunities for meetings with artists, workshops, parties and musical events.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/4/5.jpg"} class="img-responsive" />
					</div>


         `,
      };
    },
  },

  {
    id: "Outdoor_Adventures",
    bgImage: "/posts/bank/40/1.jpg",
    mobBgImage: "/posts/bank/40/M.jpg",
    title: "Aventures en plein air",
    ctg: "telaviv",
    vidId: "88OV6xU0vPI",
    isVid: true,
    smltitle: "",
    html: function() {
      return {
        __html: `
				<br/>
                <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Une ville pleine d’action idéale pour les personnes actives</h2>
			     <p>
						Les gens à Tel Aviv profitent pleinement de la vie ; et ils le font à l’extérieur. Cette ville regorge d’activités de plein air, et vous pouvez choisir vos préférées en toute liberté. C’est une ville riche en action, ce qui la rend idéale pour les personnes actives.
					</p>
					<h3>
						Le parc Hayarkon
					</h3>
					<p>
						Surnommé le « Central Park » de Tel Aviv, le parc Hayarkon est visité par approximativement seize millions de personnes chaque année. Les attractions vont des pique-niques sur les immenses pelouses et du pédalo sur le magnifique lac artificiel aux pistes cyclables et visites de nombreux jardins étonnants, dépeignant la nature au coeur de la ville.
					<h3>
						La scène cycliste
					</h3>
					<p>
						L'une des meilleures façons de découvrir Tel Aviv est de parcourir ses 100 km de pistes cyclables. Vous pouvez profiter du système de location de vélos publics Tel-O-Fun qui permet aux résidents et aux visiteurs de prendre ou de déposer des vélos verts dans 150 stations à travers la ville. Et si vous aimez passer du temps sur des roulettes, vous devriez aussi vous rendre aux nombreux planchodromes pour y admirer les casse-cou locaux faire leurs numéros ou alors vous procurer un skateboard ou des rollers, et prendre part à l’action.
					</p>

         `,
      };
    },
  },

  {
    id: "Port_Pleasures",
    bgImage: "/posts/bank/23/1.jpg",
    mobBgImage: "/posts/bank/23/M.jpg",
    vidId_post: "a6QMndU0wx0",
    ctg: "telaviv",
    isVid: true,
    //  vidId : "LLOUxE-K_9Y",
    vidId: "tgF0zMUYY2g",
    title: "PLAISIRS PORTUAIRES",
    smltitle: "",
    html: function() {
      return {
        __html: `


				<br/>
				<h3>Une histoire colorée et un irrésistible charme du levant</h3>

				<p>Les odeurs de la mer se mêlant aux parfums de café noir et d'épices qui émanent des marchés, le mariage des cultures du levant et européennes, de l'ancien et du moderne – vous êtes à Jaffa. Jaffa est l'une des plus anciennes villes portuaires au monde et son histoire remonte à l'époque du Déluge. C'est aujourd'hui une ville dynamique qui ne cesse jamais de surprendre et d'innover. Des ruelles pittoresques, des galeries d'art, des boutiques uniques, des bâtiments anciens, des monuments magnifiques et une pléthore d'authentiques restaurants moyens-orientaux – visiter la vieille ville de Jaffa, c'est vivre une expérience multisensorielle que toute personne visitant Israël ne doit manquer sous aucun prétexte. Vous tomberez amoureux de cette ville.</p>

				<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/3/2.jpg"} class="img-responsive" />
					<div class="cradit">
							<small>Dana Friedlander</small>
					</div>
				</div>

				
				<h3>Découvrez la magie d'une ville portuaire pleine de vie </h3>
				
				<p>Située dans la partie sud de Tel Aviv, sur une colline dominant la mer Méditerranée, Jaffa est depuis des millénaires le centre d'événements historiques. Toujours actif, le Port de Jaffa est un endroit extraordinaire à explorer. Découvrez ses galeries d'art, ses boutiques et ses marchés gastronomiques. Flânez le long des anciens quais, assistez aux spectacles musicaux, buvez, mangez, imprégnez-vous de son atmosphère si particulière.</p>
				
				<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/3/1.jpg"} class="img-responsive" />
				</div>

				<p>Pour avoir une meilleure vue de la ville, montez sur la colline jusqu'au Jardin de la Crête (Ha'Pisga) surplombant la baie et contemplez la magnifique cité qui s'étend à vos pieds. En redescendant, faites un souhait sur le pont des Vœux. Qui sait, peut-être se réalisera-t-il.</p>
				
				<h3>Plongez-vous dans une aventure urbaine et romantique</h3>
				
				<p>Les rues de Jaffa sont pleines de surprises. Flânez dans les étroites rues pavées du vieux Jaffa, dénichez ses cours intérieures cachées et prêtez attention aux petits détails – carreaux de céramique peints, petites sculptures et terrasses en hauteur ouvertes. Faites la connaissance des habitants, visitez les galeries d'art, les studios d'artiste et les boutiques originales.</p>
				
				<p>Poursuivez votre exploration. Depuis la place de la tour de l'horloge au cœur de la ville, poursuivez votre chemin vers le fameux marché aux puces de Jaffa et faufilez-vous parmi les objets du quotidien et les trésors cachés. C'est le moment de tester vos aptitudes à marchander. Profitez des petits cafés pittoresques, des authentiques restaurants moyen-orientaux, des bars et goûtez leurs houmous, parmi les meilleurs que vous n'aurez jamais goûtés. Garanti !</p> 

				<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/3/3.jpg"} class="img-responsive" />
					<div class="cradit">
							<small>Dana Friedlander</small>
					</div>
				</div>

         `,
      };
    },
  },

  {
    id: 14,
    bgImage: "/posts/videos/deadsea/1/1.jpg",
    mobBgImage: "/posts/videos/deadsea/1/M.jpg",
    title: "The Dead Sea",
    vidId: "ixFocykfYHo",
    ctg: "deadsea",
    isVid: true,
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h2>Time to bask in nature’s glory</h2>
			<p>
					A geological wonder in a uniquely serene setting, the Dead Sea is an extremely popular tourist attraction. Experience the calm tranquility of the water with its distinct healing properties while enjoying the unparalleled beauty of the surrounding landscape. <strong>The Dead Sea, also known as the oldest natural spa in the world, is blessed with an extremely high salt concentration of 31.5%, allowing tourists from far and wide the amazing experience of effortlessly floating on the waters of the lowest place on Earth. While here, you can bathe</strong> in the healthy black mud of the area or explore the fascinating and historically rich nearby landscapes.
			</p>
           <p>
					Luxury hotels, varied cuisine from gourmet restaurants to fast food eateries, great souvenir shops, the extraordinary history of the nearby Masada, and many cultural activities throughout the year, make the Dead Sea a popular destination for local tourists as well as International visitors.
           </p>
			`,
      };
    },
  },

  {
    id: 3,
    bgImage: "/posts/bank/23/1.jpg",
    mobBgImage: "/posts/bank/23/M.jpg",
    vidId: "LLOUxE-K_9Y",
    player_id_post: "3",
    title: "Port Pleasures",
    isVid: true,
    ctg: "telaviv",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<h2>The different charms of Tel Aviv and Jaffa Ports</h2>
					<p>
						Jaffa Port offers an ancient history, stone buildings and cobbled lanes while Tel Aviv Port is a contemporary cultural, recreational and commercial hub.
					</p>

					<h3>
					    Jaffa Port
					</h3>
					<p>
						The modern city of Tel Aviv had its humble beginnings in the port of Jaffa where immigrants, armies and traders docked their ships. The port is famed as one of the oldest in the world and today it is still used by local fishermen while the historic surrounding area has become a popular tourist destination.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/2.jpg"} class="img-responsive" />
						<div class="cradit">
								<small>Dana Friedlander</small>
					    </div>
					</div>

					<p>
						The waterside hangers have been converted into galleries and cultural spaces like the Nalaga’at Center operated by the deaf and blind community and the Dvir Gallery. From the waterfront the ancient cobbled alleyways wend their way up through stone buildings reminiscent of old Jerusalem. In among the historic buildings are galleries, specialty stores and excellent restaurants. As you reach the upper levels of the Old Port area you can see St. Peter’s Church, the Wishing Bridge, the Old Jaffa Museum and the Ilana Goor Museum.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/1.jpg"} class="img-responsive" />
					</div>

					<h3>
						Tel Aviv Port
					</h3>
					<p>
						In contrast to Jaffa Port Tel Aviv has a more commercial and contemporary feel. The port operated from 1938 to 1965 and has undergone renewal and restoration to convert it into a shopping and entertainment district. The port area consists of converted hangers and a long wide waterfront promenade. It is popular with families visiting the Dyada Center for children’s activities and others visiting the yoga center, center for women, conference venue and the Cavim Institute of Design and Architecture. The promenade is always alive with street performers, musical events and outdoor markets. The port is a contemporary and dynamic area for creative and cultural expression. When the sun goes down the Tel Aviv Port becomes a popular nightlife destination with bars and clubs.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/3/3.jpg"} class="img-responsive" />
						<div class="cradit">
								<small>Dana Friedlander</small>
					    </div>
					</div>


         `,
      };
    },
  },

  {
    id: "TelAviv_By_The_Sea",
    bgImage: "posts/bank/17/1.jpg",
    mobBgImage: "posts/bank/17/M.jpg",
    title: "TEL AVIV, EN BORD DE MER",
    vidId: "jsTzRtTCvWg",
    isVid: true,
    ctg: "telaviv",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<br/>
			<h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">
							Pour le magazine National Geographic : « Une des 10 meilleures villes balnéaires du monde »
						</h2>
						<p>
							Avec leurs eaux cristallines et leurs caractères animés, les 16 plages de Tel Aviv possèdent toutes leurs propres styles et attirent des profils différents allant des hippies décontractés aux personnes chics de la Riviera. De jour comme de nuit, l’un des meilleurs moyens de passer son temps à Tel Aviv est de flâner sur la plage.
						</p>

			`,
      };
    },
  },

  {
    id: "Sarona_TelAviv",
    bgImage: "posts/bank/36/1.jpg",
    mobBgImage: "posts/bank/36/M.jpg",
    title: "Sarona Tel Aviv",
    isVid: true,
    ctg: "telaviv",
    // vidId: "hdquOPEilDo",
    vidId: "MJ-gsGs1tqA",
    smlTitle: "",
    html: function() {
      return {
        __html: `

			            <p>Un immense choix de lieux à découvrir dans une superbe colonie des Templiers rénovée</p>
						
						<h3>Sur le marché de Sarona à Tel Aviv, le choix culinaire est illimité</h3>

						<p>Bâti au cœur de Tel Aviv, à l'emplacement de structures templières vieilles de 150 ans, le marché de Sarona est le véritable melting pot gastronomique d'Israël. Reflétant l'atmosphère culinaire exemplaire de Tel Aviv et apportant une touche contemporaine aux marchés plus traditionnels de la ville, Sarona est le lieu à visiter pour satisfaire votre gourmandise - et avoir un aperçu des diverses inspirations ethniques qui animent cette trépidante cité maritime.</p>
						
						<h3>Visitez le plus grand marché gastronomique couvert d'Israël</h3>
						
						<p>Créations gastronomiques sophistiquées ou spécialités locales traditionnelles : le marché de Sarona a tout pour satisfaire les palais les plus exigeants. Plus de 90 restaurants, stands d'alimentation, pubs et boutiques gastronomiques y sont ouverts sept jours sur sept. Sur place, vous n'aurez que l'embarras du choix entre un bol de succulents rāmen, un plat d'empanadas épicées, un succulent sandwich ou une pâtisserie... Vous n'arrivez pas à vous décider ? Les établissements de restauration étant tous proches les uns des autres, vous pourrez facilement déguster une entrée de fruits de mer suivie d'un pad thaï épicé ou d'un savoureux hamburger.</p>
						
						<p>Besoin de faire une pause entre les plats ? Le marché de Sarona accueille également des boutiques d'accessoires, des musées, un centre dédié aux visiteurs et d'autres attractions à ne pas manquer.</p> 
						
						<h3>Mettez-vous au vert</h3>
						
						<p>Le vendredi, c'est la fête ! Au marché de Sarona, le vendredi est un jour à part. C'est le jour où des produits sont livrés directement de la ferme, ce qui rendra votre expérience gastronomique encore plus interactive et attrayante. Une fois que vous aurez sélectionné votre produit, vous poursuivrez votre exploration de ce marché urbain, et ajouterez à votre cabas de savoureux fromages importés, un vinaigre balsamique italien de première qualité, des bières artisanales et des friandises sucrées. Tous ces ingrédients goûteux vous permettront de concocter un repas inoubliable au cours du week-end.</p>
						
						<p>Sur le marché de Sarona, découvrez toute la force de la cuisine israélienne moderne. Avec ses innombrables options culinaires, qui reflètent l'atmosphère gastronomique unique de Tel Aviv, le marché de Sarona donnera satisfaction aux gourmets les plus exigeants. Un endroit à ne manquer sous aucun prétexte.</p> 

		
		           `,
      };
    },
  },

  {
    id: "Neve_Tzedek",
    bgImage: "posts/bank/4/1.jpg",
    mobBgImage: "posts/bank/4/M.jpg",
    title: "Névé Tzedek",
    // vidId: "SUJncZH91Bo",
    vidId: "5jl13Z-38eE",
    smlTitle: "",
    isVid: true,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `

                      	<br/>
                      	<h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20"> Déborde de cafés pittoresques, boutiques, galeries d'art, élégance et atmosphère rafraîchissante</h2>
						
						<h3>Découvrez l'ambiance magique des cours ombragées des restaurants et cafés de Névé Tzedek</h3>

						<p>Niché dans l'un des plus anciens quartiers de Tel Aviv, se trouve un joyau architectural à l'esprit jeune et dynamique. Créé en 1887, Névé Tzedek, le premier quartier juif en dehors de la vieille cité portuaire de Jaffa, est récemment devenu le terrain de prédilection d'artistes de toutes tendances, qui s'intègrent parfaitement à l'architecture orientale pittoresque du quartier restauré.</p>
						
						
						<h3>Une véritable oasis dans l'agitation de Tel Aviv</h3>
						
						<p>Vous cherchez un plat en céramique artisanal, un article vestimentaire original ou un bijou réalisé avec les techniques de joaillerie traditionnelles ? Les innombrables boutiques, galeries, ateliers de design et  magasins de mode qu'abritent les immeubles de style oriental bordant les passages étroits jusqu'à la rue Shabazi vous laisseront le souvenir d'une séance de shopping à nulle autre pareille. Pendant que vous flânerez dans le quartier, la brise de mer vous rafraîchira et vous vous sentirez plein de vie et joyeux, en harmonie avec l'esprit fantasque des lieux.</p>
						
						<p>Appréciez l'ambiance magique des cours ombragées des restaurants et cafés de Névé Tzedek en vous attablant devant un repas léger mais satisfaisant. Les nombreux restaurants, installés dans les bâtiments historiques pittoresques jalonnant les ruelles étroites du quartier, servent de véritables spécialités culinaires. Se mariant à l'ambiance sereine des rues du quartier, ces plats délicieux vous transporteront dans une atmosphère bohème sans équivalent.</p>
						
						<h3>Ici, la créativité n'a pas de limites...</h3>
						
						<p>La visite de Névé Tzedek ne serait pas complète sans une visite au musée Nachum Gutman, qui rend hommage à ce grand artiste de Tel Aviv. Des expositions permanentes et des activités interactives renforcent le sentiment artistique véhiculé par ce quartier tranquille, et vous invitent à visiter les autres galeries et ateliers de céramique qui s'y trouvent.</p>
						
						<p>Visitez le Centre Suzanne Dellal dédié à la danse et au théâtre, où assistez à l'un des nombreux spectacles et festivals organisés par ce centre culturel, dont les spectacles de musique et de danse ethniques, établit un véritable lien entre les arts israéliens de la scène et la scène internationale.</p>
						
						<p>En remontant la rue Shabazi, vous constaterez que l'esprit créatif du quartier reste sensible, jusqu'à imprégner Hatachana, l'ancienne gare ferroviaire de Jaffa. Récemment transformé en centre commercial à la mode, cet ensemble historique surprenant abrite des boutiques et des cafés.</p>

						<p>
							Offrez-vous une pause avec le rythme trépidant de Tel Aviv ; cette perle, dissimulée dans un quartier, possède un magnifique style architectural oriental et de charmantes rues étroites qui font de Neve Tzedek, qui signifie litéralement une Oasis de Justice, une veritable oasis au coeur de la ville effervescente.
						</p><p><a href="https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1" rel="nofollow" target="_blank">View attractions in Tel Aviv &amp; Center at Tourist Information site</a><br><a href="https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19" rel="nofollow" target="_blank">View accommodations in </a><a href="https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1" rel="nofollow" target="_blank">Tel Aviv &amp; Center</a><a href="https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19" rel="nofollow" target="_blank"> at Tourist Information site</a></p>

              
			`,
      };
    },
  },

  {
    id: 9,
    bgImage: "posts/bank/5/1.jpg",
    mobBgImage: "posts/bank/5/M.jpg",
    title: "Jerusalem Old and new ",
    isVid: true,
    ctg: "jerusalem",
    vidId: "MXtcTm_JXus",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h2>Ancient treasures and modern luxuries.</h2>

			<p>
				Downtown Jerusalem is the heart of the modern metropolis, bursting with nightlife, dining and cultural options to rival any major city in the world.
			</p>
			<p>
				The area is made up of several neighborhoods and appealing locations such as charming Nachlat Shiva, the bustling Yafo Street and Ben Yehuda Street, with its own unique personality and atmosphere not to be missed.
			</p>
			<p>
				The center of Jerusalem includes some of the city’s most charming neighborhoods and fascinating attractions. For an unbeatable cultural experience, check out Jerusalem’s variety of fascinating museums, including the world class Israel Museum, the Bible Lands Museum and Jerusalem’s Science Museum.
			</p>
			<h3>
				Machane Yehuda Market
			</h3>
			<p>
				Discover this market's unrivaled atmosphere and variety which draw thousands of tourists every day. Once the shopping is done and the food vendors close up, join the young trendy crowds, foreign and locals alike, who descend on the market to drink and party until the small hours, in the bars, restaurants and alleyways.
			</p>
			<h3>
				Nahalat Shiv’a
			</h3>
			<p>
				This charming cobblestone neighborhood at the heart of the city offers an excellent selection of shops, restaurants, bars and outdoor cafés. Nahalat Shiva is home to Kikar Hamusica (Music Square) – a lively and trendy outdoor space that offers live music every day throughout the week.
			</p>
			<h3>
				Yemin Moshe
			</h3>
			<p>
				This lovely neighborhood facing the Old City walls was originally built to escape overcrowding in the 19th Century. Home to artists, writers and academics, Yemin Moshe is known for its beautiful windmill and oriental style houses, green parks, lively music center and stunning views.
			</p>
			<h3>
				Ein Kerem
			</h3>
			<p>
				Nestled in a peaceful valley between the mountains and the terraced hills southwest of Jerusalem, Ein Kerem is one of Jerusalem’s most picturesque neighborhoods. With its winding paved lanes, their charming stone houses adorned with arches, churches whose bells chime in the clear air, Ein Kerem radiates charm and beauty like an island in a sea of green forest
			</p>  

			`,
      };
    },
  },

  {
    id: "Market_Madness",
    bgImage: "posts/bank/10/1.jpg",
    mobBgImage: "posts/bank/10/M.jpg",
    title: "MAH’ANÉ YÉHOUDA",
    vidId: "fJ7bLOOstgA",
    isVid: true,
    ctg: "culinary",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                    <br/>
                    <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Goûtez à la culture israélienne</h2>
					<p><strong>Le marché extérieur de Jérusalem - un régal pour les yeux et pour les papilles</strong></p>
					<p>Considéré comme le marché en plein air<b>&nbsp;</b>le plus à la mode et le plus animé d'Israël, Mah’ané Yéhouda est une source de divertissement unique, avec ses innombrables produits frais, ses agréables commerces et ses restaurants pittoresques.</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "posts/7/1.jpg"} class="img-responsive" />
					</div>
					<p>Ce marché ne cesse de se réinventer : les traditions ancestrales s'y mêlent et s'y opposent aux derniers phénomènes de mode, et les parfums et fumets qui émanent des mets proposés sont absolument irrésistibles.</p>

					<p><strong>La Culture et la cuisine à leur summum </strong></p>
					<p>Flânez dans les longues allées étroites du marché et explorez les restaurants, cafés, pubs, établissements végétaliens et boutiques qui se dissimulent là où vous ne les attendez pas. En franchissant leur seuil, vous apprécierez le calme relatif qu'ils offrent après l'agitation des marchands locaux vantant aux consommateurs avides les mérites de leurs pains frais, fruits et légumes tout juste cueillis, salades, desserts, épices fraîchement moulus et viandes. Les odeurs suffisent à faire gargouiller votre estomac tandis qu'elles vous transportent aux quatre coins du monde. Chaque coupe de fruits, fallafel ou halva parfumée est un régal pour les sens.</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "posts/7/2.jpg"} class="img-responsive" />
					</div>
					<p><strong>Une visite pour satisfaire votre curiosité et votre appétit</strong></p>
					<p>Participez à un des nombreux ateliers ou itinéraire de visite et dégustation pour découvrir le marché Mah’ané Yéhouda de manière interactive, en goûtant aux plats frais préparés par certains exposants. Écoutez les anecdotes qui font l'histoire du marché et apprenez à connaître les boutiques et stands qui ont contribué faire de ce marché en plein air&nbsp;le plus connu d'Israël. Lorsque la nuit tombe, le marché se transforme en un lieu branché et extrêmement animé, prisé des jeunes de la ville et des touristes.</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "posts/7/3.jpg"} class="img-responsive" />
					</div>
					

              
			`,
      };
    },
  },

  {
    id: 13,
    bgImage: "posts/bank/24/1.jpg",
    mobBgImage: "posts/bank/24/M.jpg",
    title: "The old city ",
    vidId: "k4OwoEk5wMw",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h2>Feel the story come alive</h2>
			<p>
			   Become inspired by the world renowned treasures of the ancient city of Jerusalem.
			</p>
              
			`,
      };
    },
  },

  {
    id: 14,
    bgImage: "posts/bank/32/1.jpg",
    mobBgImage: "posts/bank/32/M.jpg",
    title: "The Dead Sea ",
    vidId: "DzEJxjnC_UQ",
    isVid: true,
    ctg: "deadsea",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			<h2>Time to bask in nature’s glory</h2>
			<p>
			   Get high on life in the lowest place on earth.
			</p>
              
			`,
      };
    },
  },

  {
    id: 3,
    bgImage: "posts/bank/58/1.jpg",
    mobBgImage: "posts/bank/58/M.jpg",
    title: "The Dead Sea ",
    vidId: "DzEJxjnC_UQ",
    isVid: true,
    ctg: "deadsea",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			  <h2>Time to bask in nature’s glory</h2>
              <p>
						The Dead Sea is one of the most unique natural phenomena on the planet. A crevice in the earth’s crust that is part of the Great Rift Valley allows the waters of the River Jordan to flow south into a lozenge-shaped lake at the lowest point on our planet. With no outlet, the rays of the blazing sun evaporates the Jordan water to a point where its mineral content is highly concentrated; and it is this density of minerals and salt that makes it impossible to sink in the sea: bathers float effortlessly on the water’s surface. Because the sun has to travel an additional 1,200 feet to reach the shore, ultra-violet rays are filtered out and oxygen is enriched to a point where even the fairest skins tan but do not burn.
              </p>
              <p>
              		This is why a visit to the Dead Sea enables sufferers of rheumatic diseases to breathe better, and why victims of psoriasis and other serious skin ailments receive temporary cures by bathing in the Dead Sea, slathering themselves with Dead Sea mud and baking in the non-burning sun.
              </p>
              <p>
              		The Dead Sea is lined with spas, bathing beaches and spa hotels.
              </p>
			`,
      };
    },
  },

  {
    id: "Go_To_Guide",
    bgImage: "/posts/bank/gotoguide/1.jpg",
    mobBgImage: "/posts/bank/gotoguide/M/1.jpg",
    title: "Go To Guide",
    ctg: "telaviv",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `
                    <h2>
                    Travel from Tel Aviv and Jerusalem
                    </h2>
					<p>
						One of the best things in visiting Tel Aviv and Jerusalem is how incredibly different yet amazingly close are these two fabulous destinations. In fact, the two cities are less than one hour’s drive(!) from one another, which means that should you wish, you could spend the day exploring the awesome and world-famous sites of Jerusalem and be back in time to watch the sunset from one of Tel Aviv stunning beaches before heading on to an all-night rager in one of the city’s hottest clubs. Talk about a full day’s fun…
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/gotoguide/1.jpg"} class="img-responsive" />
					</div>
					<p>
						Getting to and from Tel Aviv and Jerusalem is easy and there are several ways depending on your preference and budget:
					</p>
					<p>
						<strong>By Car:</strong> 
						Should you choose to hire a car you will find route 1 connects the two cities directly, and road signs to be pretty clear and come in three languages. However, you may want to use one of the local navigation apps to show you the way and help you avoid heavy traffic. 
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/gotoguide/2.jpg"} class="img-responsive" />
					</div>
					<p>
						<strong>By Bus:</strong> 
						there are several public buses which travel to and from Tel Aviv and Jerusalem. This is by far one of the most convenient and budget-friendly means of travel. 
					</p>
					<p>
						<strong>By Train:</strong> 
						A convenient train service operates in several main stations to and from Tel Aviv and Jerusalem. Works are currently underway and soon a fast new direct route will begin operating between the two cities. 
			            	</p>
					<p>
						<strong>By Taxi:</strong> 
						Taxis for interurban travel can be flagged on the street or booked via phone or designated apps such as Gett (GetTaxi).
			            	</p>
					<p>
						<strong>Sherut Taxis:</strong> 
						“Sherut” (service) taxis are 10 - 12 seater vans which generally follow major bus routes, in and between major cities. Pricewise, sherut taxi fares have a fixed price, similar to public bus fares. Sherut taxis also offer a replacement to service to buses on Fridays.  
			            	</p>
			            	<p>
			            		For information regarding train stations, routes and schedules, visit <a href="https://www.rail.co.il" target="_blank">www.rail.co.il</a>
			            	</p>
			            	<p>
			            		For information regarding bus routes and schedules visit  <a href="https://www.bus.co.il" target="_blank">www.bus.co.il</a>
			            	</p>
			            	<p>
			            		Public transport helpline   <a href="tel:*8787">*8787</a>
			            	</p>
			            	<p>
			            		Local public transport app - ‘Moovit’
			            	</p>
			            	<p>
						So come check out Epic Tel Aviv and unforgettable Jerusalem, less than one hour away from each other!
			            	</p>

            	`,
      };
    },
  },

  {
    id: "Day_IsTrippin",
    bgImage: "/posts/bank/48/1.jpg",
    mobBgImage: "/posts/bank/48/M/1.jpg",
    title: "UNE JOURNÉE À TEL AVIV",
    isVid: false,
    ctg: "telaviv",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<p>
				Démarrez votre journée au Midron parc de Jaffa (parc en pente), avec un magnifique panorama sur presque la totalité du littoral israélien et sur le point de départ historique de la métropole, il y a 4,000 ans. Dégustez une tasse de café sur l'ancien port rénové et continuez vers le nord pour une belle balade le long de la promenade, un agréable petit plaisir balnéaire.
				</p>
				<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/37/2.jpg"} class="img-responsive" />
				</div>
				<p>
				Traversez la rue pour vous diriger vers la "Tachana compound" (le complexe de la gare), un fabuleux centre commercial en plein air entièrement rénové situé dans une ancienne gare ferroviaire historique construite dans les années 1890 pour servir de gare centrale de Tel Aviv et de Jaffa.
				</p>
				<p>
				Avancez jusqu'au pittoresque quartier de Neve Tsedek et découvrez ses magnifiques ruelles. Faites-vous plaisir dans les petites boutiques jusqu'à ce que vous atteigniez l'agitation bariolée du marché Ha carmel. Faites une pause le temps d'avaler une excellente spécialité de rue et si c'est un mardi ou un vendredi – considérez-vous chanceux et faites un peu de shopping à la foire traditionnelle de Nahalat Benyamin où les artisans locaux présentent leurs ouvrages.
				</p>
				<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/37/1.jpg"} class="img-responsive" />
				</div>
				<p>
				Remontez le splendide boulevard Rothschild, le cœur de l'architecture Bauhaus et un site du patrimoine international de l'UNESCO. C'est le moment de louer une bicyclette et de se joindre à la foule locale jusqu'à la place Habima, foyer du théâtre national et de l'orchestre philarmonique israélien. Dirigez-vous vers la rue Dizengoff, très tendance et animée, ou avalez un morceau dans l'un des coffee shops encerclant la place puis poursuivez votre marche ou roulez sur le boulevard Hen jusqu'à la place Rabin.
				</p>
				<p>
				Découvrez la rue Ibn Gabirol, une plaque tournante de cette ville incroyable, foyer d'un large éventail de restaurants primés et d'excellents pubs et bars où vous pouvez avaler un repas ou siroter un verre et vous mêler à la population locale.
				</p>
				<p>
				Grimpez dans un bus de la ligne 5, véritable icône urbaine et descendez au port de Tel Aviv. Profitez du coucher du soleil et posez votre regard vers le sud sur l'horizon de Jaffa où votre journée a démarré. Passez la soirée dans le coin et observez sa transformation en l'une des scènes les plus chaudes de la vie nocturne de la ville, débordante de bars formidables et de discothèques sur mesure pour des soirées épiques.
				</p>

            	`,
      };
    },
  },

  // has ho translation' hadar said to hide untill she'll send the translation
  // {
  // 	id:"Non_Stop_Culture",
  //               bgImage: "/posts/bank/non-stop-culture/1.jpg",
  //               mobBgImage: "/posts/bank/non-stop-culture/M/1.jpg",
  //               title :"Non Stop Culture",
  // 				isVid:true,
  // 				vidId:"MXtcTm_JXus",
  // 				ctg:"telaviv",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `
  //                     <h2>Tel Aviv’s fascinating cultural scene</h2>
  // 				    <p>Tel Aviv is famous around the world for its culture and entertainment scene. Home to fantastic museums and art galleries, theaters, concert halls, and dance centers, your cultural desires are sure to be met.
  //                     <h3>Theatres</h3>
  //                     <p>The Tel Aviv theatre scene is flourishing and visitors to the city will enjoy the many world class plays of the city’s main theatres – Habima, Hakameri and Gesher, located is beautiful surroundings and often hosting shows in English or offer subtitles for non-Hebrew speakers.
  //                     <h3>Tel Aviv Museum of Art</h3>
  //                     <p> The city’s beautifully designed, leading museum for Israeli and international art containing one of the world’s largest contemporary art collections featuring permanent displays alongside rotating exhibitions.

  //                     <div class="img-wrapper">
  // 					    <img src=${getImgUrl() + "/posts/non-stop-culture/1.jpg"} class="img-responsive" />
  // 				    </div>

  //                     <h3>Beit Ha’ir (The old Town Hall)</h3>
  //                     <p>The recently renovated Beit Ha’ir, was the old city hall in Tel Aviv-Yafo on Bialik Street, and is now a living display of the city’s history, featuring a new exhibition, which sums up the extensive collection of photos and stories featuring events, sites, and experiences of residents throughout the years.

  //                     <h3>Eretz Israel Museum</h3>
  //                     <p>A multi-disciplinary institution. It presents the history of the land and its culture through an extensive permanent exhibit, in addition to a variety of temporary exhibits on subjects such as archaeology, ethnography, folklore, Judaica, cultural history, local identity, traditional crafts and functional arts.

  //                     <h3>Private Galleries</h3>
  //                     <p>All around Tel Aviv, but mainly in Neve Tzedek, Ben Yehuda and Gordon streets you can freely wonder into any of the privately-owned beautiful art galleries featuring original works of local contemporary artists.

  //             	`   }
  //   }
  // },
  // end has ho translation' hadar said to hide untill she'll send the translation

  {
    id: "A_Taste_Of_Jerusalem",
    bgImage: "/posts/bank/taste-of-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/taste-of-jerusalem/M/1.jpg",
    title: "JERUSALEM",
    ctg: "culinaryjerusalem",
    isVid: true,
    vidId: "2CSCe2WC7Ns",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                <h2>A manger à Jérusalem</h2>
				<p>
				Jérusalem est une ville fascinante et magique. De nombreuses personnes qui visitent Jérusalem sont emballées par l'atmosphère extraordinaire, les sites inoubliables, les vues à couper le souffle et plus encore. Cependant, pour vraiment comprendre ce que représente Jérusalem, il y a certaines choses que vous devez découvrir grâce à vos papilles. Voici un petit aperçu de ce qu’il vous faut vraiment tester en visitant Jérusalem.
				</p>
	                    	<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/39/1.jpg"} class="img-responsive" />
				</div>
				<p>
				<strong>Malabi:</strong> une combinaison unique entre une boisson et un dessert, préparée avec un mélange d'eau de rose, de lait, de fécule de maïs et de sucre. Le Malabi est un met très populaire à Jérusalem, proposé dans beaucoup de restaurants orientaux et de kiosques à travers la ville. Ce qui est certain c'est que cela ne ressemble à rien de tout ce que vous avez déjà pu goûter.
				</p>
				<p>
				<strong>Knafe:</strong> un plat très intéressant et surprenant lorsqu'il est servi et mangé frais. Le Knafe est plutôt un dessert arabe préparé avec du fromage de chèvre fondu et recouvert de cheveux d'anges de couleur orange fortement imbibés d'un sirop à l'eau de rose sucré. Trouver le parfait Knafe est une véritable mission, mais une fois que vous l'avez trouvé, le déguster devient une addiction.
				</p>
				<p>
				<strong>Pretzel de Jérusalem:</strong> le must absolu, lorsque vous visitez les sites fascinants de la vieille ville, est de s'arrêter à l'un de ces petits chariots verts et d'acheter un authentique pretzel de Jérusalem. Pour l'accompagner, vous recevrez une herbe aromatique locale de couleur verte appelé Zaatar et qui se marie très bien avec ce délicieux pain chaud.
				</p>
				<p>
				<strong>Meorav Yerushalmi:</strong> Traduit mot à mot par "Mélange de Jérusalem", ce délicieux assortiment de différentes sortes de viandes marinées dans un mélange d'herbes locales est un paradis absolu pour le palais des carnivores.
				</p>
				<p>
				<strong>"Ashtanur":</strong> une abrévation en hébreu pour "le feu au four", Ashtanur est un pain pita local authentique que vous pouvez trouver en ville ou au marché à l'heure du déjeuner. Si vous avez très faim, testez-le farci d'une portion de shawarma ou de falafel.
				</p>
				<p>
				<strong>Sabich:</strong> une véritable originalité, le sabich est vraiment un plat local unique composé d'un pain pita farci d'aubergines frites, d'œufs durs et de cornichons, généralement recouvert d'une sauce Amba à base d'un savoureux condiment local. Dès que vous l'aurez goûté, vous en serez accro !
				</p>

            	`,
      };
    },
  },

  {
    id: "Sectrets_Of_Jewish_Jerusalem",
    bgImage: "/posts/bank/sectrets-of-jewish-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/sectrets-of-jewish-jerusalem/M/1.jpg",
    title: "A taste of Jerusalem",
    ctg: "jerusalem",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
                                <p>Jerusalem is an open invitation for a journey. Climb the mountains, enter the city and feel the unique mix between past and present, ordinary and extraordinary. One of the most ancient cities in the world, sacred for Jews, Christians and Muslims, Jerusalem offers an unparalleled sensory and spiritual experience.</p>

                                <p>Enter. The heart of the holiest city in Judaism is the Old City. Enter through the historic entrance, The Jaffa Gate, or use The Zion Gate that leads straight to the Jewish Quarter, one of the four quarters of the walled city and home to Jews almost consecutively since 8 BCE. Wonder through the alleyways, see the people, visit the Cardo, Jerusalem's ancient main street and absorb the unique atmosphere. You're walking in the footsteps of kings and prophets – It's no ordinary thing.</p>
                                <div class="img-wrapper">
					                <img src=${getImgUrl() +
                            "/posts/sectrets-of-jewish-jerusalem/1.jpg"} class="img-responsive" />
				                </div>
							    <small style="color:#000; display:block;">
                      		        Credit: Noam Chen
                      	        </small>
								<p>Witness History Comes alive and Feel the Deep Spiritual Energy within the Walls </h3>

                                <p>What Lays Ahead.  The last remaining segment from the ancient walls that surrounded The Second Temple, The Western Wall, is a symbol of Jewish yearnings for their ancestral and spiritual homeland. Every Jew outside Jerusalem pray facing the place you stand in now, the place where according to Judaism, God resides. No matter what your beliefs are, it's a humbling experience. Honor the spirit of the site and place a note in the wall with a prayer or a wish.</p>

                                <p>What Lays Beneath. Jerusalem is literally covered with layers of history and touching history gets a whole new meaning here.</p>

                                <p>Take the fascinating tour at the Western Wall Tunnels and reveal the hidden sections of the Western Wall. History will come to life as you move through underground passages, discover life in Jerusalem during The Second Temple era and learn about the art, architecture and building practices.</p>

                                <p>Visit the nearby archeological site City of David and learn more about the history of the city King David declared as the unified capital of Israel's 12 tribes 3000 years ago. Go on a journey between ancient walls and fortresses, hidden springs where kings were coroneted and follow the path of fleeing Jerusalem residents after the city was conquered by the Romans.</p>

                                <h3>Marvel at the Breathtaking Extraordinary Vista and Feel on Top of the World</h3>

                                <p>What Lays Above. Originally built to protect the city against intruders, Jerusalem is surrounded by walls.  Today The Walls of Jerusalem offer an opportunity to explore the city from a different angle. Hear the stories, see the city below you and take in all this beauty.</p>

                                <p>You are just beginning to stretch the surface.</p>

            	`,
      };
    },
  },

  {
    id: "Jamie_Oliver",
    bgImage: "/posts/bank/jamie_oliver/1.jpg",
    mobBgImage: "/posts/bank/jamie_oliver/M/1.jpg",
    title: "Jamie Oliver découvre les saveurs des petits-déjeuners de Tel Aviv",
    ctg: "culinarytelaviv",
    isVid: true,
    vidId: "gGe4W8WaIiQ",
    smlTitle: "",
    html: function() {
      return {
        __html: `

						<small style="color:#000; display:block;position: relative;top: 5px;">
						Credit:  Israeli food channel
						</small>


            	`,
      };
    },
  },

  {
    id: 37,
    bgImage: "/posts/bank/enjoy-and-indulge/1.jpg",
    mobBgImage: "/posts/bank/enjoy-and-indulge/M/1.jpg",
    title: "TEL AVIV",
    isVid: false,
    ctg: "telaviv",
    smltitle: "",
    html: function() {
      return {
        __html: `
                    <h2>L'ultime destination de luxe</h2>
					<p>
					Oubliez les Caraïbes, Cannes ou les Maldives, si vous recherchez des vacances de luxe – Tel Aviv est l'endroit où il faut être !
					</p>

					<p> 
					Tout d'abord, la ville, surnommée "la capitale du cool" par le New York Time, n'est qu'à quelques heures, ce qui signifie que vous ne perdrez même pas une minute de vos vacances à vous remettre du décalage horaire.
					</p>
					<p>
					Une fois sur place, votre premier délice est le temps ensoleillé tout au long de l'année – du sur mesure pour le plaisir.
					</p>
					<p> 
					Ensuite, allez vous installer et vous relaxer dans l'un des nombreux hébergements luxueux proposés – des hôtels 5 étoiles de rang mondial surplombant la plage aux différents hôtels boutiques surprenants situés dans des endroits à couper le souffle à travers la ville.
					</p>
                   	<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/38/1.jpg"} class="img-responsive" />
					</div>
					<p>
					Pour compléter cette aventure, attrapez une serviette et dirigez-vous vers l'une des admirables plages, aménagées avec toutes les installations nécessaires pour passer une journée fabuleuse, sans oublier les splendides eaux fraîches.
					</p>
					<p> 
					Une petite faim ? Profitez d'un large choix de repas gastronomiques, du local à la fusion, Tel Aviv est mondialement réputée pour la qualité de sa cuisine proposée dans des restaurants de chefs primés au décor exquis.
					</p>
		 			<p>
					 Il est temps de faire un peu de shopping – prenez votre portefeuille et venez découvrir les articles dans les boutiques de créateurs locaux, les magasins chics des grandes marques et les luxueux centre commerciaux où vous pouvez tout trouver, des articles de Haute Couture comme les dernières tendances internationales.
					 </p>
					<p>
					Pour terminer votre journée, avalez une bière artisanale ou un cocktail glamour dans l'une des discothèques sensationnelles ou l'un des bars chics de la ville et dansez toute la nuit avant de retourner à votre hôtel pour un sommeil 5 étoiles bien mérité.
					</p>
					<p>
					Du luxe ? Du style ? Du glamour ? Nous avons tout ! Alors dépêchez-vous et réservez votre séjour à Tel Aviv dès Aujourd’hui !
					</p>

            	`,
      };
    },
  },

  {
    id: "Cool_Jerusalem",
    bgImage: "/posts/bank/cool-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/cool-jerusalem/M/1.jpg",
    title: "",
    ctg: "jerusalem",
    isVid: true,
    vidId: "nLKWDp5uA-U",
    smltitle: "LES SURPRISES DE JÉRUSALEM",
    html: function() {
      return {
        __html: `
				<br/>
                    <h2  class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Une ville au-delà de toutes attentes</h2>
					<p>
					Jérusalem est une ville mondialement célèbre et l'une des destinations de vacances les plus populaires au monde. Beaucoup de gens visitent Jérusalem chaque année en raison de sa signification historique, ses lieux saints, son architecture magnifique et unique et son atmosphère hors du commun. Cependant, Jérusalem est une ville de surprises et il y a de nombreuses choses à proposer dans cette cité extraordinaire que la plupart des gens ne pourraient pas imaginer au premier abord. Voici juste un aperçu des choses que vous ne vous attendrez pas nécessairement à trouver à Jérusalem.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/40/1.jpg"} class="img-responsive" />
					</div>

					<h3>LES FÊTES DE L'ÉTÉ</h3>
					<p>
					Tous les ans pendant la saison d'été, le centre de Jérusalem est inondé des fêtes du vendredi midi, emplies de musique, de danses, de personnes formidables du monde entier et d'une ambiance enivrante pour démarrer les choses en beauté et vous mettre en forme pour le reste du week-end.
					</p>

					<h3>LA FOLIE DU MARCHÉ</h3>
					<p>
					Une aventure incroyable qui opère le jeudi soir, lorsque le marché très animé de Mahané Yehuda se transforme en une scène de fin de soirée bourdonnante et bouillonnante de bars et de pubs délirants et de la musique en live toute la soirée.
					</p>

					<h3>LES FESTIVALS</h3>
					<p>
					Jérusalem est une ville débordante de festivals – du célèbre festival du film au festival du vin, en passant par un festival international de marionnettes et même une fête de la bière, quoique vous appréciez, vous pouvez être certain de trouver un festival qui vous correspond et qui, à un moment donné, se tiendra dans la ville.
					</p>
					<h3>LE MARATHON DE JÉRUSALEM</h3>
					<p>
					Un marathon génial et extrêmement populaire qui propose une variété de parcours, pour les professionnels ou les familles d'amateurs, traversant des sites historiques fascinants qui illuminent 3,000 ans de l'histoire de Jérusalem, garants d'une expérience stimulante, passionnante et inoubliable pour l'ensemble des coureurs et des spectateurs.
					</p>

					<h3>LES MUSÉES ET LES EXPOSITIONS</h3>
					<p>
					La diversité de la ville de Jérusalem se prolonge dans ses musées et ses évènements culturels présentés dans toute la ville. Du mondialement célèbre musée d'Israël à Yad Vashem, au mémorable spectacle ‘’sons et lumières’’ de la vieille ville et la promenade sur les remparts, et beaucoup plus encore ; la ville est tout simplement baignée d'expériences culturelles admirables.
					</p>

					<h3>LE MARCHÉ CHAMPÊTRE</h3>
					<p>Tous les vendredis, dans le quartier de la colonie allemande au cœur de la ville, vous trouverez le marché champêtre local. Proposant une multitude de bons produits et une large variété de délicatesses locales et d'excellentes affaires.</p>

					<h3>UN AQUARIUM DE CLASSE MONDIALE</h3>
					<p>
					L'un des plus grands aquariums du Moyen-Orient, cette fabuleuse attraction pour les enfants comme pour les adultes a ouvert, pour la première fois cette année, ses portes au public. Cet aquarium s'étend sur 7,000 m2 et renferme 40 espèces marines dans 33 réservoirs d'eau, dont le plus grand contient 1.6 millions de litres d'eau.
					</p>


            	`,
      };
    },
  },

  {
    id: 39,
    bgImage: "/posts/bank/cycle-in-telaviv/1.jpg",
    mobBgImage: "/posts/bank/cycle-in-telaviv/M/1.jpg",
    vidId: "88OV6xU0vPI",
    isVid: true,
    ctg: "telaviv",
    title: "TEL-AVIV SUR ROUES",
    smltitle: "",
    html: function() {
      return {
        __html: `

					
					
					<p>Le meilleur moyen d'apprendre à connaître une nouvelle ville est d'explorer ses recoins - et quel meilleur moyen de le faire qu'à vélo&nbsp;? Ces dernières années, Tel Aviv a adopté la mode du deux roues, encouragée par son nouveau réseau de pistes cyclables et ses zones de stationnement. C'est une bonne nouvelle pour les touristes - le moment n'a jamais été meilleur pour se déplacer en ville à bicyclette.</p>
					<h3>Circuler en deux roues à Tel Aviv</h3>
					<p>Quasiment sans dénivelé, la ville est idéale pour les vélos, et la circulation en voiture y est légendaire. La bicyclette constitue un excellent moyen de transport pour les habitants et les touristes qui souhaitent se déplacer en ville à leur rythme. Sept minutes suffisent pour passer de la verdure du parc Hayarkon à celle du square Rabin situé en centre-ville, soit quasiment le temps nécessaire pour parcourir le même trajet en voiture&nbsp;!</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/41/1.jpg"} class="img-responsive" />
					</div>
					<p>La partie centrale bordée d'arbres du Boulevard Rothschild est équipée d'une piste cyclable qui vous permet d'admirer les bâtiments de style Bauhaus en roulant. La promenade rénovée du port de la ville et celle qui longe le front de mer à Tel Aviv et Jaffa sont elles aussi très agréables à parcourir à vélo. Emprunter les pistes qui longent les eaux de la Méditerranée est une des activités touristiques les plus romantiques de la ville, en particulier lorsque le soleil se couche et que souffle une légère brise.</p>
					<h3>Visiter Tel Aviv sur deux roues</h3>
					<p>À Tel Aviv, l'année 2011 a été marquée par le lancement du programme de location de vélos Tel-O-Fun. Son fonctionnement est le même que celui de systèmes équivalents proposés à New York, Londres et Paris. Touristes et visiteurs peuvent acheter des cartes d'accès quotidiennes ou hebdomadaires, en ligne ou dans l’une des 206 bornes de vente disponibles dans toute la ville. Passez votre carte dans l'appareil pour obtenir un vélo et la ville est à vous&nbsp;!</p>
					<p>Le Segway est un autre moyen amusant de découvrir la ville sur deux roues. Des visites guidées en Segway de la zone portuaire, des sentiers du parc Hayarkon, du vieux Jaffa et des charmants quartiers de style Bauhaus sont proposées aux touristes qui souhaitent s'aventurer dans les rues auxquelles les bus touristiques ne peuvent accéder.</p>

            	`,
      };
    },
  },

  {
    id: "TelAviv_Adventures",
    bgImage: "/posts/bank/telaviv-adventures/1.jpg",
    mobBgImage: "/posts/bank/telaviv-adventures/M/1.jpg",
    title: "",
    smltitle: "Bons plans sur Tel Aviv",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
					<p>
					Tel Aviv est mondialement reconnue comme la ville qui ne dort jamais, réputée pour son incroyable vie nocturne, ses plages fabuleuses, son art et sa culture fantastiques et plus encore. Mais voici quelques endroits moins connus dont vous pouvez profiter durant l'été à Tel Aviv.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/42/1.jpg"} class="img-responsive" />
					</div>

					<h3>ESSAYEZ LES BARS BRACELET</h3>
					<p>
					Les bars Bracelet sont un excellent moyen de profiter d'une sortie nocturne en dégustant des verres sans ruiner son budget. Frayez-vous simplement un chemin dans l'un des nombreux bars de Tel Aviv qui vous proposent de payer un prix fixe à l'avance et de boire autant que vous le souhaitez ou autant que vous le pouvez…
					</p>
					<h3>LES CERCLES DE PERCUSSIONS DES VENDREDIS APRÈS-MIDI<h3>
					<p>
					Dirigez-vous vers la fameuse plage Banana beach les vendredis après-midi et faites-vous doublement plaisir – profitez d'un impressionnant morceau de percussions sur la plage et admirez le splendide coucher du soleil – le tout entièrement gratuit!
					<p>
					<h3>LE PLAISIR SUR LES TOITS<h3>
					<p>
					C'est peut-être le climat; c'est peut-être la vue – une chose est sûre, les Tel Aviviens adorent être dehors, surtout un verre à la main. En été, la plupart des bars et des pubs atteignent le sommet (littéralement!) et se transforment en lieux extérieurs, car beaucoup de bars s'installent sur les toits des immeubles commerciaux et de bureaux. Pour trouver ces formidables endroits, vous n'avez qu'à suivre les sons de la musique et de la fête.
					</p>
					<h3>LA GYM EN PLEIN AIR<h3>
					<p>
					Rien n'est plus important que votre santé et l'une des meilleures chose que vous pouvez offrir à votre corps c'est un peu d'exercice. Tel Aviv vous permet de le faire de différentes manières – en nageant dans la mer, en courant le long de la promenade, en vélo à travers les magnifiques rues de la ville et même en faisant de la gymnastique dans l'une des stations de sport en plein air (gratuites) situées un peu partout en ville.
					</p>
					<h3>LES FABULEUX ÉVÉNEMENTS DE L'ÉTÉ<h3>
					<p>
					Des artistes internationaux de renommée mondiale à la technologie surprenante, des festivals d'art et de la bière, des inaugurations de galeries, des expositions, des musiques de rue, aux cinémas en plein air et aux fêtes sur la plage qui durent toute la nuit, Tel Aviv l'été est une source intarrissable d'amusement et de divertissement qu'il ne faut pas manquer!
					</p>

            	`,
      };
    },
  },

  {
    id: "ANIMATED_NIGHTS_TEL_AVIV",
    bgImage: "/posts/bank/ANIMATED_NIGHTS_TEL_AVIV/1.jpg",
    mobBgImage: "/posts/bank/ANIMATED_NIGHTS_TEL_AVIV/M/1.jpg",
    title: "LES NUITS ANIMÉES DE TEL AVIV NUITS BLANCHES DANS LA VILLE BLANCHE",
    smltitle: "",
    isVid: false,
    ctg: "telaviv",
    html: function() {
      return {
        __html: `

				<p>Tel Aviv est à juste titre connue comme une des villes au monde où l'on peut s'amuser jusqu'au bout de la nuit, son chaud climat méditerranéen en fait le lieu idéal pour faire la fête en extérieur  presque toute l'année. Au coucher du soleil, la ville s'anime pour offrir de multiples expériences aux noctambules.</p>

				<h3>Tel Aviv de nuit</h3>
				<p>Peu importe l'heure, il se passe toujours quelque chose à Tel Aviv. Regardez le soleil se coucher depuis un bar en bord de mer, les pieds dans le sable chaud, une boisson fraîche à la main, avant de poursuivre votre soirée dans un pub en vogue pour déguster une bière artisanale, siroter un cocktail exotique dans un bar tranquille ou prendre un délicieux en-cas avant d'aller fouler la piste d'une discothèque de Tel Aviv jusqu’à l'aube.</p>
				<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/animated-nights-tlv/1.jpg"} class="img-responsive" />
					</div>
				<p>Les gourmands apprécieront les fantastiques cocktails réalisés par les habiles barmen de Tel Aviv, les bières et plats de fabrication artisanale servis dans les pubs, ainsi que les lieux de restauration très variés allant des établissements raffinés aux marchands de rue proposant tous les styles et types de cuisine. Mangez tout ce qui vous fait envie !</p>
				
				<h3>Profiter à fond de la vie nocturne à Tel Aviv</h3>
				<p>Vous pouvez passer une soirée tranquille dans un élégant bar à vin d'un quartier branché tel que Névé Tzedek, où vous aurez la possibilité de goûter quelques-uns des vins renommés d'Israël. Allez-vous détendre dans un des nombreux bars où se produisent des orchestres en live ou cultivez-vous en dégustant un cocktail dans une des nouvelles galeries-bars de la ville exposant les œuvres d'artistes prometteurs.</p>
				
				<p>Si vous voulez faire la fête en ville toute la nuit, Tel Aviv est l'endroit qu'il vous faut. Ses discothèques sont connues dans le monde entier et reçoivent même des DJ internationaux. En été, certaines plages se transforment en boîte de nuit pour proposer jusqu'au petit matin des rave-parties où vous retrouverez les rythmes lancinants, lasers et musiques entêtantes qui les caractérisent. Dans la plupart des discothèques de la ville qui reçoivent des DJ renommés, la fête ne bat totalement son plein que vers 2 heures du matin. Vous trouverez tous les types de clubs possibles, que vous recherchiez une atmosphère intime ou une méga discothèque, et même si vous aimez les danses rétro ou les musiques électriques indés les plus récentes.</p>
				
				<p>À Tel Aviv, le milieu LGBTQ n'est pas en reste, puisque certains des meilleurs concerts et fêtes sont donnés dans des clubs et bars gay. Quoi que recherchiez, une atmosphère paisible, une fête endiablée, une soirée culturelle ou un lieu intime pour passer un moment à deux, un nombre impressionnant de lieux n'attendent que vous, quelle que soit l'heure du jour ou de la nuit.</p>

            	`,
      };
    },
  },

  {
    id: "2_AWESOME_CITIES",
    bgImage: "/posts/bank/27/1.jpg",
    mobBgImage: "/posts/bank/27/M.jpg",
    title: "2 VILLES GRANDIOSES",
    smltitle: "",
    isVid: true,
    vidId: "b0QexDxEklA",
    ctg: "telavivAndJerusalem",
    html: function() {
      return {
        __html: `

					
					<h2>Une escapade magique et inoubliable au soleil</h2>
					<p>
					Tel Aviv, cette métropole ultra moderne vous offre ses plages de sable fin, son atmosphère trépidante et les infinies possibilités de se faire plaisir façon méditerranéenne, sans parler de l’excellence de sa cuisine et de son café. A moins de 40 minutes de là, le rythme est tout à fait différent. Jérusalem, cette ville d’une beauté sans pareil. Pas étonnant qu’elle ait inspiré autant de gens depuis des millénaires.
					</p>

					<p>
					Bien que Tel Aviv et Jérusalem soient toutes deux des cités industrieuses, vitales et intrigantes qui offrent une multitude d’attractions à voir absolument, elles sont aussi différentes que possible. Malgré leur proximité géographique, elles ont des paysages, odeurs et saveurs complètement différents. A quel autre endroit pouvez-vous combiner plages de rêve et lieux les plus anciens et sacrés de l’histoire ? Alors voilà un échantillon de ce que vous pourriez faire pendant vos vacances dans ces deux villes.
					</p>

					<h3>TEL AVIV- LA VILLE QUI NE DORT JAMAIS</h3>
					<p>
					Vous voilà donc à Tel-Aviv. Faites l’expérience de l’excitation que la première ville hébraïque moderne vous réserve. Découvrez l’azur de la Méditerranée, les endroits typiques de la ville blanche, ses marchés, restaurants, saveurs spéciales et sa vie nocturne trépidante. Attrapez quelques vagues vous comprendrez pourquoi donc Tel Aviv est connue comme la ville qui ne dort hamais, qui respire et exhale la vitalité 24 heures sur 24. Allons-y.
					</p>
					<h3>
					NEVÉ TZÉDEK :
					</h3>
					<p>
					Découvrez la magie de ce quartier spectaculaire, joliment rénové de l’extrême sud de la promenade de Tel Aviv, à côté de Jaffa. Commencez la matinée par une expérience culinaire en prenant un petit-déjeuner israélien typique, de délicieuses viennoiseries, des œufs, fromages et autres laitages, salade verte ou mixte, jus d’oranges bien sûr et bien entendu un excellent café. La visite de Nevé Tzédek que nous vous recommandons vous conduira dans des lieux historiques
					</p>

					<h3>
					HATA’HANA :
					</h3>
					<p>
					Après vous être sustentés, allez visiter HaTa’hana, tout à côté. Là vous pouvez admirer des bâtiments rénovés datant de l’époque des templiers, ainsi que l‘ancienne gare ferroviaire de Jaffa, refaite à neuf. Le site raconte l’histoire de la gare et sa ligne Jaffa-Jérusalem, opérationnelle entre 1892 et 1948.
					</p>
					<h3>
						Jaffa
					</h3>
					<p>
					De là marchez le long du magnifique littoral jusqu’à Jaffa. Nous recommandons de visiter le port de Jaffa, considéré comme l’un des plus anciens au monde. Installez-vous dans l’un des cafés du front de mer et observez les pêcheurs au travail. Puis continuez vers le marché aux puces haut en couleurs où vous pourrez vous offrir un objet de collection, céramique arménienne, main de Fatma ou tout autre objet parmi une multitude de souvenirs. La nuit ce quartier devient un lieu de divertissement avec ses bars et restaurants.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/1/7.jpg"} class="img-responsive" />
					</div>
					<h3>
					PÉDALEZ LE LONG DE LA PLAGE :
					</h3>
					<p>
					Tel Aviv est connue pour être la capitale israélienne du vélo. Par une belle journée, les plus sportifs d’entre vous pourront en louer un à l’une des stations Tel-o-Fun ou à tout autre endroit de la ville. Pédaler de Névé Tzédek à la plage de Tel Baruch au nord de la ville est un vrai plaisir.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/1/2.jpg"} class="img-responsive" />
					</div>
					<h3>
					MUSÉE D’ERETZ ISRAËL :
					</h3>
					<p>
					Si vous vous trouvez dans la partie nord de la ville, nous vous suggérons de visiter le Musée d’Eretz Israël, musée multidisciplinaire qui se concentre sur l’histoire et la culture d’Israël grâce à des expositions permanentes et temporaires consacrées à l’archéologie, à l’ethnographie, la poste et la philatélie, au folklore, à l’art juif, aux arts traditionnels, à l’art populaire, à l’histoire culturelle et à l’identité locale ;
					</p>
					<h3>
					BOULEVARD ROTHSCHILD :
					</h3>
					<p>
					Vous cherchez un endroit où faire un excellent repas ? Essayez l’un des restaurants du Boulevard Rothschild ou de ses alentours, au cœur de la ville. C’est l’une des trois zones qui composent la ville blanche, reconnue par l’UNESCO comme appartenant au patrimoine mondial de l’Humanité. Cette artère, qui définit parfaitement l’essence de Tel Aviv, vous offre une occasion sans pareille d’observer le genre humain. Vous pouvez aussi vous promener et admirer la magnifique architecture Bauhaus, le vieux kiosque et les musées qui relatent la fascinante histoire de Tel Aviv et de son premier quartier, A’huzat Bayit.
					</p>
					<h3>
					VIE NOCTURNE :
					</h3>
					<p>
					Si vous comptez rester quelques jours, vous pouvez choisir de louer une chambre dans l’un des grands hôtels de la plage, près de la promenade, ou dans l’un des hôtels-pensions. Et si vous avez encore de l’énergie et désirez marcher, c’est le moment de vous rendre dans un bar ou un night-club, à l’Opéra, ou d’aller assister à un spectacle de dance ou à n’importe quel autre festival ou évènement à Tel Aviv. Vous avez fini de goûter aux plaisirs de Tel Aviv ? Maintenant profitez du meilleur des deux mondes en allant à Jérusalem. Ce n’est qu’à 40 minutes ! La cité sacrée vous attend !
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/1/3.jpg"} class="img-responsive" />
					</div>
					<h3>
					JÉRUSALEM - LA PLUS BELLE VILLE AU MONDE
					</h3>
					<p>
					Découvrez la ville sacrée pour trois religions – judaïsme, chrétienté et islam. Visitez ses sites historiques, respirez ses odeurs enivrantes, goûtez à ses plats spéciaux, inhalez l'air pur de la montagne et amusez-vous dans les nombreux lieux de divertissement de la ville.
					</p>
					<h3>
					EIN KAREM :
					</h3>
					<p>
					Avant même d'arriver, vous pourrez visiter le quartier pittoresque d'Ein Karem. A 20 minutes du centre-ville, il est connu pour son caractère idyllique: niché dans la verdure, Ein Karem vous offre ses vues imprenables, ses charmantes maisons en pierre, ses allées enchanteresses, galeries et boutiques spéciales, ses cafés et restaurants, ainsi que ses hôtels exquis, anciens ou nouveaux.
					</p>
					<h3>
					LE MUSÉE BLOOMFIELD DES SCIENCES :
					</h3>
					<p>
					Le musée des sciences de Jérusalem est un royaume magique tant pour les enfants que pour les adultes, regorgeant d'objets mouvants, d’illusions d’optique, d’expériences électriques et de tout ce qui fait de ce monde un lieu convivial.
					</p>
					<h3>
					LA VIEILLE VILLE :
					</h3>
					<p>
					Véritable must de toute visite de Jérusalem ! La vieille ville de Jérusalem est, pour dire les choses simplement, un véritable trésor combinant découverte et plaisir. La véritable essence de Jérusalem se cache dans les allées étroites et serpentées de la Vieille Ville: ambiance unique, histoire fascinante et secrets garantis au détour de ses vieilles pierres. Visitez le Mur occidental, laissez l’émotion vous gagnez devant la sainteté des vestiges du Temple et glissez votre message entre les pierres avec une requête adressée au Très Haut.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/1/4.jpg"} class="img-responsive" />
					</div>
					<p>
					Suivez les traces de Jésus le long de la Via Dolorosa, vers l'Eglise du Saint Sépulcre l’un des sites les plus saints de la Chrétienté : l’endroit où Jésus a été crucifié et où se trouve le tombeau vide duquel il est dit avoir ressuscité. Continuez vers le Mont Sion où vous pourrez visiter le Cénacle traditionnellement considéré comme la salle de la Dernière Cène. Puis, comme le faisait Jésus, rendez-vous au Mont des Oliviers pour un moment de méditation au Gethsémani, où Jésus a prié et où ses disciples se sont reposés la nuit précédant sa crucifixion. Puis, montez sur le toit de l'Hospice autrichien de la Sainte Famille pour une vue véritablement magnifique de Jérusalem et de la Vieille Ville. Pour vous plonger encore davantage dans les racines de la Jérusalem antique, visitez les tunnels du Mur occidental, le Dôme du Rocher, le lieu saint où Mahomet est supposé être monté au Ciel, ainsi que l'Eglise luthérienne du Rédempteur, qui abrite l'un des plus beaux orgues d'Israël.
					</p>
					<h3>
					LE MARCHÉ DE MA'HANÉ YÉHUDA :
					</h3>
					<p>
					Vous avez eu une journée bien remplie. Vous commencez à avoir faim ? C’est le moment où jamais de visiter le Marché de Ma'hané Yéhuda, ce marché hiérosolymitain à ciel ouvert, vibrant et dynamique. Aux côtés de ses étals, des cafés et restaurants ont « fleuri » ces dernières années.
					</p>
					<h3>
					SHOPPING À JÉRUSALEM :
					</h3>
					<p>
					Prêt pour un peu de shopping et des souvenirs ? Achetez de la céramique arménienne ou des pièces d'art juif dans les belles boutiques de la Vieille Ville. Vous trouverez également une pléthore de souvenirs d'Israël au centre ville. De nombreuses boutiques de confection sont à votre disposition sur la rue piétonne Ben Yehuda. Et n'oubliez pas les boutiques de fripes si vous souhaitez acheter quelque chose de plus authentique. De plus, ne ratez le centre commercial de Mamila, considéré comme l'un des centres commerciaux les plus actifs de la ville.
					</p>
					<p>
					Si divers, si différents et pourtant si proches, Jérusalem et Tel Aviv font la paire comme destination parfaite. Ensemble, elles vous apportent histoire et modernité, des artéfacts anciens et de l'art moderne, des moments au soleil tout et le voyage le plus spirituel de votre vie. Il n'y a pas mieux ! Alors qu'attendez-vous ? Réservez vos vacances dès à présent !
					</p>


           `,
      };
    },
  },

  {
    id: "Jerusalem",
    bgImage: "/posts/bank/jerusalem-p/1.jpg",
    mobBgImage: "/posts/bank/jerusalem-p/M.jpg",
    title: "Jerusalem",
    smltitle: "",
    isVid: true,
    vidId: "FvAWuLQEOJw",
    ctg: "jerusalem",
    html: function() {
      return {
        __html: `

					<h2>A CITY OF MAGIC AND RADIANCE BEYOND YOUR WILDEST DREAMS</h2>
					<p><strong>Jerusalem is The Capital of Israel and By Far One of The Most Famous and Fascinating Cities in the World, Where Thousands of Years of Glorious History Seamlessly Intertwine with Modern Day Life.</strong></p>
                              
                                <p>Discover the overwhelming power of this 3,000 year old city - its innumerable historic sites and archeological wonders, its magical walkways and magnificent views which are guaranteed to leave a lasting impression. At the same time, the city’s strikingly modern attractions promise around the clock excitement and pleasure for all lovers of culture, arts, music, and culinary delights.</p>

                                <h2>Walk through 3000 years of history</h2>

                                <p>The Old City of Jerusalem is a favourite for all visitors from first timers, seasoned visitors as well as the locals. Surrounded by an ancient wall that has been rebuilt throughout history, there are 7 gates allowing access to historical and holy sites here. Make your way down the stone cobbled streets and find yourself walking through four thousand years of history, leaving you humbled and yet excited as you connect the modern day present with the simple beginnings of the past.</p>
                              
                                <h2>Meet the modern vibrant Jerusalem</h2>

                                <p>Step outside of the Old City and find everything that a typical modern city offers including hotels, promenades, restaurants and shopping malls. Visit museums, like the Israel Museum which is the largest cultural institution in Israel and ranked among the world’s leading art and archaeology museums housing the infamous Dead Sea Scrolls (oldest biblical manuscripts) among other treasures. Local farms, wineries and breweries are set up around Jerusalem offering a variety of options to foodies ranging from the traditional Israeli cuisine to the contemporary and fusion fare paired with delicious award-winning wines and beers attracting enthusiast from all over the world.</p>
                                <div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/Jerusalem-p/1.jpg"} class="img-responsive" />
							    </div>
                                <p>Visit Mahane Yehuda, a colourful and vibrant outdoor market with an attractive vibe filled with culture and delicious aromas of the delicacies sold here. Wait till sundown and see this ‘shuk’ transform into a trendy hangout with live music to suit every mood accompanied with energetic people, a growing ‘street-art’ gallery exceptional food and delightful drinks. Mahane Yehuda offers a special experience so walk down the streets, stop by a food joint, dance a little while enjoying a drink and make your way to the next spot.</p>

                                <p>Drenched in art, history, culture and diversity the capital city of Israel loves to have a good time while allowing one to experience the contrast between old world historical charm and modern city living. As you drive in to Jerusalem you can’t help but connect with the culture, archaeology and history of the many nations who have walked through here, where old meets new beyond the walls of the Old City in this unique world capital.</p>
                                
				


           `,
      };
    },
  },

  {
    id: "Magical_Deadsea",
    bgImage: "/posts/bank/deadsea1/1.jpg",
    mobBgImage: "/posts/bank/deadsea1/M.jpg",
    title: "LA MER MORTE",
    smltitle: "",
    isVid: true,
    vidId: "8p4qfkneH1c",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `

					
					            <br/><h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Point Le Plus Bas Du Globe, Mais Source D'élévation Pour Le Corps Et L'esprit</h2>
							    <p><strong>Détendez-vous et vivez des vacances inoubliables grâce aux vertus revitalisantes du sel de la mer Morte </strong></p>
	                            <p>Une beauté naturelle à couper le souffle, des spas apaisants riches en minéraux, des vertus reconnues pour la santé et de nombreuses expériences inoubliables&nbsp;: rien d'étonnant à ce que la mer Morte soit devenue l'une des destinations les plus prisées des touristes du monde entier. Ce mystérieux lac salé est tout ce dont vous avez besoin pour mettre votre corps et votre esprit en vacances.</p>
	                            <div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/Magical-Deadsea/1.jpg"} class="img-responsive" />
							    </div>
	                            <p><strong>Détendez-vous</strong>. Sel, boue, soleil, et ce n'est pas tout. Baignez-vous dans les eaux (chaudes) sulfureuses naturelles et profitez des soins de thalassothérapie. L'expression "plaisir coupable", vous connaissez&nbsp;? Oubliez-la. Oubliez tout sentiment de culpabilité et profitez simplement de vacances saines, relaxantes et revitalisantes.</p>
	                            <p><strong>Lâchez-prise et profitez d'un des plus somptueux cadeaux de la nature </strong></p>
	                            <p><strong>Flottez. </strong>Grâce à la salinité exceptionnellement élevée de l'eau, vous pourrez faire un petit "miracle", non pas en marchant sur l'eau, mais en flottant naturellement. Allez dans l'eau, allongez-vous et laissez-faire la nature. Il vous faudra peut-être une minute pour vous y habituer, mais vous pouvez nous croire, c'est magique.</p>
	                            <p><strong>Guérissez. </strong>Aller dans la région de la mer Morte, c'est comme pénétrer dans un autre monde. Tout y est différent&nbsp;: le paysage, l'espace, l'air, et même le soleil.</p>
	                            <p>Du fait des caractéristiques géologiques particulières de la région, l'air et le soleil n'y ont pas les mêmes propriétés et sont à l'origine de ses pouvoirs curatifs.</p>
	                            <p>L'atmosphère est spéciale à cause du sel de la mer qui se dissout en riches particules minérales saines que vous absorbez en respirant.&nbsp; Le soleil est lui aussi différent du fait de la situation de la région, si basse par rapport au niveau de la mer. Les rayons du soleil sont plus faibles et ses rayons UV sont filtrés et moins nocifs. Sortez de l'eau et profitez des bienfaits de la nature.</p>
	                            <p><strong>Découvrez l'enfant qui sommeille en vous et laissez la nature vous guérir </strong></p>
	                            <p><strong>Roulez-vous dans la boue </strong>– Les propriétés bienfaisantes de la boue de la mer Morte ne sont plus à démontrer. Cette boue assainit, revitalise et apaise la peau. Vous pouvez en acheter et l'utiliser chez vous, mais pourquoi rater l'occasion de réveiller l'enfant qui est en vous? Couvrez-vous de boue noire de la tête aux pieds et amusez-vous, tout simplement. Nous vous défions de prendre un selfie.</p>
									
           `,
      };
    },
  },
  {
    id: "Next_Level_DS",
    bgImage: "/posts/bank/1.jpg",
    mobBgImage: "/posts/bank/M.jpg",
    title: "TAKE RELAXATION TO THE NEXT LEVEL",
    smltitle: "",
    isVid: true,
    vidId: "8p4qfkneH1c",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `

					
					
                     <p>
					The Dead Sea, officially The Lowest Place On Earth (428m Below Sea Level) And A Shortlist Candidate For The World’s 7 Natural Wonders, Is An Enthralling And Evocative Combination Of Natural Splendor, Compelling Ancient History And Modern Luxuries.
				</p>
				<p>
					From the healing powers of the Dead Sea’s cobalt blue waters, through the awesome beauty of the surrounding landscape to the myriad of fascinating sights this area has to offer, the Dead Sea is a place of tranquility, health and inspiration for body and soul alike.
				</p>
				<p>
					Float on the waters, take a mud bath or go exploring - with 330 sunny days a year, the Dead Sea area is filled with superb attractions including natural healing spas, magnificent hiking trails, gourmet and fast food restaurants and adrenaline-charged attractions. Along the main part of the 75 kilometer stretch dotted with beautiful beaches, you will also find world class hotels and spa facilities to guarantee a truly indulgent experience.
				</p>
				
				<div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/next-level/1.jpg"} class="img-responsive" />
				</div>
				<p>
					The Magical Beaches of the Dead Sea
				</p>
				<p>
					The beaches of the Dead Sea are like nothing else the world has to offer. There are many kilometers of beautifully developed and well-maintained spots where you can soak up the sun while on your dream vacation. Choose your spot on the rocky sand and take in the breathtaking scenery with the incredible mountain ranges surrounding the sea. The warm waters of the Dead Sea are always calm and offer superior relaxation from the minute you get in.
				</p>
				<p>
					On the southern shores at the lowest point on earth, you will find an array of hotels where you can enjoy a magical sunrise over the lake, leaving an array of colors on the small ponds with the salt formations scattered throughout. To complete the experience of being at the Dead Sea, take some of the silky dark mud and lather it on allowing your skin to absorb the helpful minerals. Dead Sea mud has been proven beneficial to the skin and body. You will feel refreshed with skin that looks and feels younger. Give yourself the pampering that you deserve and get dirty with the Dead Sea mud – it’s healthy!
				</p>
				<p>
					Discover the desert area around the Dead Sea
				</p>
				<p>
					There is more to do than just relaxing in the spas and floating in the Dead Sea. If you are travelling south from Jerusalem, complement your desert experience by stopping at kibbutz Ein Gedi, a natural oasis on the slopes of the Judean desert, and take a hike through a nature reserve where you will see wildlife like the ibex (a kind of mountain goat) and enjoy the waterfalls and pools cascading on the rock formation. Ein Gedi also offers hotel accommodations and spas which houses hot sulphur pools and have different types of healing and therapeutic massages too. Continue south from here to Masada, a national landmark with a strong historical connection, located at the top of a massive mountain that the adventure seeker can hike, or it can be reached comfortably by cable car.
				</p>
				<h3>
					MOUNT KARKOM
				</h3>
				<p>
					In the heart of the western Negev lies a site considered one of the most significant landmarks in Christian history- the mysterious and beautiful Mount Karkom.
				</p>
				<p>
					Featuring a wildly unspoiled landscape - an 847-meter-high limestone plateau scored by dramatic ravines, mount Karkom is believed by some scholars to be the site of the biblical Mount Sinai – mentioned often in the book of Exodus as the place where Moses received the Ten Commandments.
				</p>
				<p>
					Walking down the eight-kilometer-long loop-trail, on the banks of the Karkom dry riverbed are two rows of standing stones and a rounded wall, reminiscent of nomadic shrine of the type built by the Israelites of the time. Looking closely, one can even spot 12 standing stones, believed by some to represent the 12 tribes of Israel.
				</p>
				<div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/next-level/2.jpg"} class="img-responsive" />
				</div>
				<p>
					Adding to the mystery and appeal, Mount Karkom features many famous rock drawings, depicting worshipping figures, animals and enigmatic symbols.
				</p>
				<p>
					To visit the area Hikers must coordinate tour to the site in advance and use a Society for the Protection of Nature (SPNI) trail map (available in Hebrew only) to explore Mount Karkom.
				</p>          


           `,
      };
    },
  },
  {
    id: "Natures_Glory",
    bgImage: "/posts/bank/natures-glory/1.jpg",
    mobBgImage: "/posts/bank/natures-glory/M.jpg",
    title: "NATURE'S GLORY",
    smltitle: "",
    isVid: true,
    vidId: "M627s8TdaB8",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `

					
					
			    <p>
					Get high on life in the lowest place on earth
				</p>
				<p>
					The Dead Sea, officially the lowest place on earth (428m below sea level) and one the world’s natural wonders, is an enthralling and evocative combination of natural splendor, compelling ancient history, and modern luxuries.
				</p>
				<p>
					Float on the waters, take a mud bath or go exploring - with 330 sunny days a year, the Dead Sea area is filled with superb attractions including natural healing spas, magnificent hiking trails, gourmet and fast food restaurants and adrenaline-charged attractions.
				</p>
				<h3>
					NEW BOARDWALK AT THE DEAD SEA
				</h3>
				<p>
					Just in time for the Passover and Easter holidays, a new, stone 4k boardwalk and free, accessible public beaches with full facilities have opened in the hotels area of the Dead Sea. The promenade will eventually extend another ten kilometers, to include a total of 16 public beaches, connecting Ein Bokek and Hamei Zohar, along the southern part of the Dead Sea. This is part of a major new leisure and hotel complex that is planned for the region.
				</p>
				<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/natures-glory/1.jpg"} class="img-responsive" />
				</div>
				<p>
					Visitors to the Dead Sea - the lowest place on earth and the world’s largest natural spa known for its unique wellness properties since Biblical times – can now enjoy full access to wide, sandy beaches, walking, jogging, cycling or even taking a Segway along the entire length of the new boardwalk. The new beaches are all free to the public, with facilities that include beach chairs, showers, canopies, sports equipment, children’s playgrounds and more.
				</p>
				<p>
					The beaches are accessible for the disabled, with special wheelchairs and trails that can take visitors right into the waters of the Dead Sea. Special illumination allows tourists and visitors to walk the boardwalk at night, while at the same time enjoying the very special atmosphere at the Dead Sea.
				</p>
                               


           `,
      };
    },
  },
  {
    id: "Natural_Spa",
    bgImage: "/posts/bank/deadsea1/1.jpg",
    mobBgImage: "/posts/bank/deadsea1/M.jpg",
    title: "MER MORTE",
    smltitle: "",
    isVid: true,
    vidId: "8p4qfkneH1c",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `

					
					<h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Avoir la sensation d'être sur le toit du monde, au point le plus bas de la surface du globe</h2>
				    <p><strong>La relaxation à son summum</strong></p>
					<p><strong>La mer Morte, qui est officiellement le point le plus bas sur Terre (428 mètres sous le niveau de la mer), a figuré dans la sélection finale des 7 merveilles naturelles du monde. Elle offre une combinaison passionnante et fascinante de splendeur naturelle, d'histoire ancienne et de luxe moderne.</strong></p>
					<p>Des pouvoirs curatifs des eaux bleues cobalt de la mer Morte à la beauté spectaculaire des paysages environnants, en passant par les innombrables sites intéressants que recèle cette région, la mer Morte est un havre de tranquillité, de santé et d'inspiration pour le corps et l'esprit.</p>
					<p>Flottez sur l'eau, prenez un bain de boue ou partez en balade. Avec 330 jours d'ensoleillement par an, ce ne sont pas les divertissements qui manquent dans la région de la mer Morte, avec ses eaux thermales naturelles, ses magnifiques chemins de randonnée, ses établissements gastronomiques ou de restauration rapide, et ses attractions qui font monter l'adrénaline. Si vous voulez vous faire plaisir, vous trouverez aussi des hôtels et centres de thalassothérapie haut de gamme sur les 75 kilomètres de côtes bordées de splendides plages.</p>
					<div class="img-wrapper">
										    <img src=${getImgUrl() +
                          "/posts/natural-spa/1.jpg"} class="img-responsive" />
										</div>
					<p><strong>Les plages magiques de la mer Morte</strong></p>
					<p>Les plages de la mer Morte sont uniques au monde. Sur des kilomètres, vous trouverez des plages somptueuses et parfaitement entretenues où vous pourrez prendre le soleil et passer des vacances de rêve. Installez-vous sur le sable et embrassez du regard le splendide panorama des montagnes entourant la mer. Les eaux chaudes de la Mer morte sont toujours calmes et vous permettent de vous relaxer dès la première minute où vous y pénétrez.</p>
					<p>Sur les rives sud du point le plus bas de la Terre, plusieurs hôtels permettent de voir le soleil se lever et couvrir de couleurs irisées les petites étendues d'eau parsemées de concrétions de sel.&nbsp; Pour ne rien oublier, enduisez-vous de boue noire et soyeuse et laissez votre peau absorber les minéraux bienfaisants qu'elle contient. La boue de la mer Noire est connue pour ses vertus bienfaisantes pour la peau et le corps. Vous vous sentirez mieux grâce à une peau plus jeune, tant à l'aspect qu'au toucher. Laissez-vous bichonner et lâchez-vous en vous couvrant de boue de la mer Morte, c'est bon pour la santé&nbsp;!</p>

					<p><strong>Découvrez le désert qui entoure la mer Morte</strong></p>
					<p>Se détendre au spa et flotter sur la mer Morte ne sont pas les seules activités offertes par la mer Morte.&nbsp; Si vous allez vers le sud en partant de Jérusalem, arrêtez-vous dans le désert au kibboutz d'Ein Gedi, une oasis naturelle située sur les flancs du désert de Judée. Faites une randonnée dans la réserve naturelle et partez à la rencontre d'espèces sauvages, notamment des bouquetins (chèvres des montagnes), et profitez des bassins et des cascades qui surgissent entre les formations rocheuses.&nbsp; À Ein Gedi, vous trouverez également des hôtels et centres de thalassothérapie proposant des sources chaudes sulfureuses aux diverses propriétés guérissantes, ainsi que des massages thérapeutiques.&nbsp; Partez encore plus au sud, à Massada, un site historique national situé en haut d'une haute montagne que les amateurs de sensations fortes pourront escalader, tandis que les autres profiteront du confort d'un téléphérique.</p>

                               


           `,
      };
    },
  },
  {
    id: "Natural_Phenomena",
    bgImage: "/posts/bank/1.jpg",
    mobBgImage: "/posts/bank/M.jpg",
    title: "NATURAL PHENOMENA",
    smltitle: "",
    isVid: true,
    vidId: "8p4qfkneH1c",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `

					
					
                        <p>
							The Dead Sea is one of the most unique natural phenomena on the planet. A crevice in the earth’s crust that is part of the Great Rift Valley allows the waters of the River Jordan to flow south into a lozenge-shaped lake at the lowest point on our planet. With no outlet, the rays of the blazing sun evaporates the Jordan water to a point where its mineral content is highly concentrated; and it is this density of minerals and salt that makes it impossible to sink in the sea: bathers float effortlessly on the water’s surface. Because the sun has to travel an additional 1,200 feet to reach the shore, ultra-violet rays are filtered out and oxygen is enriched to a point where even the fairest skins tan but do not burn.
						</p>
						<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/natural-phenomena/1.jpg"} class="img-responsive" />
					    </div>
						<p>
							This is why a visit to the Dead Sea enables sufferers of rheumatic diseases to breathe better, and why victims of psoriasis and other serious skin ailments receive temporary cures by bathing in the Dead Sea, slathering themselves with Dead Sea mud and baking in the non-burning sun.
						</p>
						<p>
							The Dead Sea is lined with spas, bathing beaches and spa hotels.
						</p>          


           `,
      };
    },
  },
  {
    id: "Masada",
    bgImage: "/posts/bank/1.jpg",
    mobBgImage: "/posts/bank/M.jpg",
    title: "MASADA",
    smltitle: "",
    isVid: true,
    vidId: "XxWa_MNm5x8",
    ctg: "deadsea",
    html: function() {
      return {
        __html: `

					
					
                    <p>        	
				Next to the Dead Sea is a site that, unlike the rest of the landscape, appears to be part of the Rift Valley cliff but is in fact an oval-shaped flat-topped mesa – a mountain completely surrounded by a virtually sheer drop. In the days before helicopters and drones, this was about as secure a site as could be found for King Herod to build himself a palace fortress to which he could retire in the case of emergency. (And, as it was adjacent to the Dead Sea it was convenient for a monarch who historians tell us had a “chronic skin ailment” - possibly psoriasis.) The splendor of Masada was epic. It was also a marvel of engineering that used artificial water courses to channel the desert’s rare rainfall into giant cisterns where, despite the 120°-Fahrenheit heat, they could make and store ice.
			</p>			
			<div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/masada/1.jpg"} class="img-responsive" />
							    </div>
			<p>
				After Herod’s death the site was all-but abandoned…until the year 73. After the Romans destroyed Jerusalem in 70 and expelled Jews from their holy city, a group of Jewish refugees made their way to the summit of Masada and converted the once grand palace into their home. Having no interest in the palace’s grandeur and considering themselves zealots, the refugees built a synagogue, created a mikveh, planted crops and tended goats. The Romans, however, could not tolerate their defiance and went on to besiege the mountain for three years, condemning thousands of legionnaires to camp in the extreme heat in a quest to starve the mountaintop inhabitants into surrender. (The outlines of the Roman encampments are clearly visible to this day.) Thousands of Jewish slaves were forced to build a giant ramp to the summit and after the months it took to complete the  construction, the mountaintop zealots -- realizing that the next day would bring Roman soldiers into their hideout -- determined to commit mass suicide rather than have their their wives, children and themselves murdered or enslaved. When the Romans finally battered their way onto the mountaintop they met no resistance and discovered 960 corpses. Two women who had hidden themselves from the mass suicide shared details of the events with the “conquerors” and Jewish Roman historian, Josephus, told the story of Masada in his book “The Jewish Wars.” The pledge by the zealots’ leader, Elazar Ben Yair on the last night of freedom has entered immortality: “Since we long ago resolved never to be servants to the Romans, nor to any other than to God Himself, Who alone is the true and just Lord of mankind, the time is now come that obliges us to make that resolution true in practice...We were the very first that revolted, and we are the last to fight against them; and I cannot but esteem it as a favor that God has granted us, that it is still in our power to die bravely, and in a state of freedom.” The Byzantines built a church atop Masada in the 4th-century, but it and the mountain went on to be abandoned for centuries.
			</p>
			<div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/masada/2.jpg"} class="img-responsive" />
							    </div>
			<p>
				In 1964. Israel’s Professor Yigal Yadin lead a two-year international excavation to discover Masada’s secrets. Their hundreds of discoveries support Josephus’ history, with the archeologists even finding the clay tokens on which the zealots had carved names and used as lots to decide who would “euthanize” their families and themselves first…and last.
			</p>
			<p>
				The story of what occurred two millennia ago atop Masada has become a symbol of Israelis’ commitment never to allow “Masada to fall again” and, fifty years after the excavation, Masada is, after Jerusalem, the most visited site in Israel. Access to the summit on foot is possible up the traditional snake path used by Herod, and up the Roman ramp.  But the majority of the millions of tourists who visit Masada are whisked from the Masada Museum and Visitors Center to the summit in giant cable cars that operate daily with the exception of Yom Kippur. Every June, the base of Masada becomes the site of giant Opera Festival and spectacle that uses the floodlit mountain as a backdrop.
			</p>          


           `,
      };
    },
  },

  {
    id: "Tel_Aviv",
    bgImage: "/posts/bank/telaviv-p/1.jpg",
    mobBgImage: "/posts/bank/telaviv-p/M.jpg",
    title: "TEL-AVIV",
    smltitle: "",
    isVid: true,
    vidId: "I9a4BFWO_6w",
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
			                  <br/>
			                  <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">“L'UNE DES 10 PREMIÈRES STATIONS BALNÉAIRES AU MONDE”</h2>

			                   

							    <p>Saluée par le New York Times comme «&nbsp;La capitale la plus cool de la Méditerranée&nbsp;»&nbsp; et comme l'une des «&nbsp;dix villes les plus dynamiques au monde&nbsp;» par Lonely Planet, Tel Aviv est sans aucun doute l'endroit à ne pas manquer en Méditerranée.</p>
								<p>Désignée «&nbsp;Capitale la plus cool de la Méditerranée&nbsp;» par le New York Times, <strong>Tel Aviv</strong> est une ville cosmopolite moderne et dynamique. Sa scène artistique animée, son architecture Bauhaus distinguée par l'UNESCO, sa cuisine primée, sa vie nocturne de classe mondiale, son atmosphère décontractée et ses magnifiques plages font de la ville l'une des plus belles destinations au monde.&nbsp;</p>
								<p>Mais, même dans cette ville qui a tout pour elle, votre visite doit forcément commencer par <strong>la plage.</strong></p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/telaviv-p/1.jpg"} class="img-responsive" />
							    </div>
								<p><strong>Découvrez le cœur d'une ville bouillonnante </strong></p>
								<p><strong>Quoi. </strong>Le cœur de cette ville désignée par <em>National Geographic</em> comme la "Miami beach de la Méditerranée" et intégrée à sa liste des 10 premières villes balnéaires au monde, c'est son littoral.</p>
								<p><strong>Pourquoi.</strong> Des plages de sable fin, des eaux chaudes, de nombreuses possibilités de pratiquer les sports aquatiques et un temps magnifique, faut-il en dire plus ? Le littoral de Tel Aviv comprend 13 plages uniques dont chacune apporte une expérience et un panorama différent. Plage animée et tendance ou plage retirée et reposante, elles forment une mosaïque riche et colorée dans une ville passionnante et diverse.</p>
								<p><strong>Où.</strong> Les plages de Tel Aviv s'étendent à l'ouest de la ville et ne sont jamais très loin.&nbsp; Inutile de résister à la tentation. Traversez la rue, enlevez vos chaussures et prenez du bon temps.&nbsp;</p>
								<p><strong>Choisissez vos activités de plage </strong></p>
								<p><strong>Bougez. </strong>La plage et les sports aquatiques sont très populaires à Tel Aviv. Le surf, la voile, l'aviron, la nage, le paddle, la plongée, le volley-ball – la liste des possibilités n'en finit pas.</p>
								<p>Choisissez votre activité préférée et amusez-vous. Ensuite, lorsque vous entendrez sur la plage le son du <em>Matkot</em>, joignez-vous à la foule pratiquant ce jeu de raquettes immensément populaire en Israël. Il n'y a ni gagnant ni perdant, mais ce n'en est pas moins amusant... et très addictif.</p>
								<p><strong>Engagez-vous</strong> pour la régate SAIL TLV qui se déroule au printemps et à laquelle participent des bateaux à voile et à moteur et des yachts venus du monde entier. Profitez des activités sportives et d'une communauté particulièrement accueillante.</p>
								<p>Vous en voulez encore plus ? Joignez-vous aux habitants et faites du vélo, de la marche ou du jogging sur la promenade.</p>
								<p><strong>Faites des rencontres. </strong>Construisez des châteaux de sable avec votre famille, partez vous promener avec votre chien et mêlez-vous à la foule amicale et hétéroclite.</p>
								<p><strong>Relaxez-vous. </strong>&nbsp;Vous voulez prendre votre temps et vous relaxer ? Pas de problème ! Dénichez-vous un coin tranquille sur l'une des plages les moins fréquentées, regardez (ou rejoignez) les groupes de percussions et installez-vous dans l'un des restaurants qui bordent la côte. L'après-midi, rapprochez-vous de l'eau, prenez une chaise, asseyez-vous et admirez le magnifique coucher de soleil de Tel Aviv. Il n'y a rien de plus beau.</p>
																


           `,
      };
    },
  },

  {
    id: "Simply_Delicious",
    bgImage: "/posts/bank/simply-delicious/1.jpg",
    mobBgImage: "/posts/bank/simply-delicious/M.jpg",
    ctg: "culinarytelaviv",
    isVid: true,
    // vidId: "n4kCnPXEX7g",
    vidId: "JQD9JpMaw9g",
    title: "Tel Aviv – Tout simplement délicieux",
    smltitle: "",
    html: function() {
      return {
        __html: `

				<h2>Il n'est pas étonnant que Tel-Aviv figure parmi les « destinations culinaires exceptionnelles » recommandées par « Saveur Magazine »</h2>

				<p>Tel Aviv, connue pour ses plages de sable fin, sa vie trépidante et ses nuits endiablées regorge aussi de restaurants et bars uniques qui font de cette station balnéaire une destination incontournable pour les gourmets. À Tel Aviv, la culture gastronomique constitue véritablement le cœur et l'âme de la ville, et même si l’on y trouve de nombreux restaurants haut de gamme, c’est la cuisine de rue à base de produits frais locaux qui a véritablement pris d'assaut la ville.</p>
				
				<h3>Quand la cuisine traditionnelle sur le pouce prend une nouvelle dimension</h3>
				
				<p>Oubliez l'époque où la cuisine sur le pouce de Tel Aviv se limitait essentiellement à des fallafels frits et croustillants, fourrés dans un pain pita fraîchement cuit au four. Aujourd'hui, la cuisine de rue de Tel Aviv est un vrai spectacle, des spécialités et plats raffinés étant servis aux promeneurs à tous les coins de rue. Flânez le long des rues Ibn Gvirol, Ben Yehuda ou Carmel et faites votre choix parmi les innombrables mets haut de gamme constitués de viande, poisson, légumes préparés et sauces, tous artistiquement présentés dans des pitas, entre des tranches de pain ou sous diverses autres formes. Grignotez les succulentes spécialités inspirées des quatre coins du monde, un sabich agrémenté de tahini servi dans un pain laffa, de succulents sandwichs de hareng, et bien plus encore. Vous poursuivrez votre balade en ville en initiant votre palais à la culture israélienne avec un agréable sentiment de satiété.</p>
				
				<h3>La même qualité qu'au restaurant mais sur le pouce</h3>
				
				<p>Que demander de plus dans une ville animée où se pressent hommes d'affaires et touristes que de pouvoir déguster facilement en chemin des plats savoureux et à la dernière mode ? Les points de restauration rapide originaux, qui se multiplient aux coins des rues de la ville, servent des plats comme du pain ciabatta garni d'une entrecôte et des arepas de maïs. Il n'est donc pas étonnant que Tel-Aviv figure parmi les « destinations culinaires exceptionnelles » recommandées par Saveur Magazine.</p>
				
				<p>Le paradis des gourmets: avec le spectacle offert par sa cuisine sur le pouce, qui propose un choix illimité de mets délicieux à chaque coin de rue, Tel Aviv est la destination culinaire par excellence et un arrêt incontournable lors de votre prochain voyage en Israël.</p>


                 <h3>À tel aviv, prenez le temps de goûter à la cuisine le goût et la ville de tel aviv.</h3>

                 <p><strong>Tel Aviv</strong>, la ville qui ne dort jamais, située sur les rives de la Méditerranée, est une des destinations touristiques les plus prisées au monde. Animée, dynamique et festive, la seconde ville d'Israël a tout pour elle, y compris une scène culinaire créative, tendance, originale et plusieurs fois primée, qui satisfait tous les goûts et tous les budgets. Depuis les restaurants gastronomiques modernes et sophistiqués jusqu'aux établissements locaux simples et traditionnels, en passant par toutes les déclinaisons situées entre les deux. La ville a même été nommée parmi les principales destinations véganes. Gourmands des quatre coins du monde, Tel Aviv est l'endroit qu'il vous faut.</p>
					<p><strong>En balade</strong>. Les Telaviviens adorent être dehors. Il se passe toujours quelque chose de nouveau et de passionnant en ville, y compris en matière de cuisine. Vous voulez explorer la scène culinaire de Tel Aviv&nbsp;? Commencez tout simplement par sortir dans la rue. Allez dans une des principales rues animées de la ville, comme <strong>Dizengoff</strong> et <strong>Ibn Gabirol</strong> et allez de découverte en découverte. Les meilleurs cafés, restaurants, bars, traiteurs et vendeur de rue n'attendent que vous.</p>
					<p><strong>Goûter les délices des marchés.</strong> Visitez le <strong>marché Carmel</strong>, le plus grand et le plus central des marchés alimentaires de la ville, immensément populaire. Ensuite, direction le <strong>marché Levinsky</strong>, au sud de la ville, le paradis des gourmets et des épices. Un conseil&nbsp;: prenez votre temps. Ces rues cachent certains des plus grands trésors culinaires de la ville.</p>

					<p><strong>Une cuisine locale et internationale.</strong> Avec ses immigrants venus de plus de 120 pays, il n'est pas étonnant que Tel Aviv soit un véritable creuset (littéralement). Si pour vous nourriture ethnique signifie alimentation d'origine japonaise, thaï ou indienne, ici le terme a une signification bien plus vaste. Cuisine turque, marocaine, perse, yéménite, éthiopienne, géorgienne, et la liste ne fait que commencer...</p>
					<p>Tel Aviv est également extrêmement fière de sa cuisine locale, qui s'inspire de ces nombreuses spécialités internationales qui apportent une touche originale aux mets traditionnels. Le résultat est délicieux et extrêmement original. Visitez le <strong>marché paysan du port de Tel Aviv</strong> ainsi que le <strong>marché international Sarona</strong>, pour goûter à certains des meilleurs produits que la ville vous propose.</p>
					<p><strong>Une cuisine sophistiquée, raffinée et innovante. </strong>Ce n'est un secret pour personne, un grand nombre des meilleurs restaurants israéliens se trouvent à Tel Aviv. Des chefs créatifs et ayant le goût du risque, qui n'hésitent pas à se lancer dans des expériences à partir de mets du Moyen-Orient, d'Asie de l'Est et d'Europe, ont transformé Tel Aviv en un pôle gastronomique connu dans tout le pays et dans le monde entier. Intelligente et esthétique, cette cuisine est élaborée à partir des produits locaux les plus frais - une expérience culinaire que vous n'êtes pas près d'oublier.</p>
					<p><strong>Une cuisine végétarienne et végane. </strong>Contrairement à de nombreuses villes du monde, à Tel Aviv on peut très facilement passer une semaine (ou plus) sans manger de viande ou de laitage. Vous trouverez facilement de la nourriture de qualité, ethnique, raffinée et préparée rapidement. Nombreux sont les boulangeries, traiteurs, restaurants totalement végétariens ou établissements classiques à proposer de nombreux plats végans et végétariens. Vous pourrez déguster une cuisine savoureuse et originale, élaborée à l'aide produits frais.</p>
					<p>Ce qui est apparu il y a quelques années comme une mode parmi tant d'autres s'est imposé comme l’une des principales caractéristiques de la scène culinaire de Tel Aviv. Celle-ci fait bon usage de ses diverses influences gastronomiques, de l'impressionnante variété des légumes proposés sur les marchés et de l'intérêt de la population pour la protection de l'environnement.</p>
									
         `,
      };
    },
  },

  {
    id: "Nonstop_Excitement",
    bgImage: "/posts/bank/35/1.jpg",
    mobBgImage: "/posts/bank/35/M.jpg",
    title: "EFFERVESCENCE NON-STOP",
    vidId: "88OV6xU0vPI",
    isVid: true,
    smltitle: "",
    ctg: "telaviv",
    html: function() {
      return {
        __html: `
                    <h2>Belle, pittoresque et palpitante – Incroyable Tel Aviv</h2>
					<p>
					Bienvenue à la ville qui irradie la vitalité 24 heures sur 24. Une cité vibrante, joyeuse, qui vous accueille à bras ouverts. Qu'est-ce qui séduit autant les visiteurs dans cette ville et les fait revenir encore et encore ? Tel-Aviv est connue comme la ville israélienne qui ne dort jamais, et cela la décrit parfaitement. Les cafés sont bondés 24 heures sur 24. Sa vie nocturne sans égale commence au coucher du soleil et finit à l'aube.
					</p>

					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/3.jpg"} class="img-responsive" />
					</div>

					<p>
					De surcroît son climat, merveilleux tout au long de l'année, vous permet de profiter de la plage à n'importe quelle saison, de prendre un vélo et pédaler à travers le Parc HaYarkon, visiter les deux ports de la ville ou tout simplement flâner dans les rues de la première ville israélienne qui combine les bâtiments historiques à des projets neufs et modernes. Et - cerise sur le gâteau - la ville offre une vaste variété d'évènements culturels et de divertissements pour tous les âges.
					</p>

					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/2.jpg"} class="img-responsive" />
					</div>
					<p>
					Découvrez pourquoi le National Geographic a qualifié Tel-Aviv de l'une des dix meilleures stations balnéaires monde. Pourquoi elle a été baptisée Destination Culinaire hors pair par le magazine Sauveur et classée comme exceptionnelle dans la catégorie Meilleurs marchés et Boutiques. De surcroît la Brasserie Pastel a été déclaré Plus beau restaurant de 2014 par l’International Space Design Awards. Etes-vous un amateur de café ? Le Huffington Post classe cette ville de bord de mer parmi les meilleures destinations pour les amateurs de café. Impressionnant, n'est-il pas ? Mais ce n'est pas fini...
					</p>

					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/4.jpg"} class="img-responsive" />
					</div>

					<p>
					Tel-Aviv a eu le dessus sur 250 autres villes et obtenu le World Smart Cities Award pour 2004, grâce à l'usage qu'elle fait des nouvelles technologies au bénéfice de ses habitants. Selon le Lonely Planet, Tel-Aviv arrive en bonne place sur la liste des villes pour ses fêtes.. And Tel-Aviv est également fière d'être considérée la meilleure ville pour gays par Gay Cities et la compagnie aérienne American Airlines.
					</p>
					<p>
					Vous projetez venir vous amuser à Tel-Aviv? Voici quelques recommandations qui vous aideront à réussir vos vacances.
					</p>
					<br>

					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/5.jpg"} class="img-responsive" />
					</div>
					<h3>
					LES PLAGES
					</h3>
					<p>
					La vie est une plage. Le littoral de Tel-Aviv, au bord de la Méditerranée, compte 13 plages s'étalant sur 14 km. Celles-ci, parfaites pour se baigner, faire la fête ou flâner, attirent des milliers de visiteurs et vacanciers locaux et étrangers. La saison des plages dure de mai à octobre mais même en hiver vous pouvez profiter du soleil à Tel-Aviv. Les restaurants, clubs et nombreux lieux de divertissement de la promenade sont adaptés tous les visiteurs. Vous pouvez aussi participer à de nombreux sports nautiques.
					</P>

					<h3>LES PORTS</h3>
					<p>Tel-Aviv abrite deux vieux ports. Quand vous les visiterez vous serez étonnés de constater à quel point ils associent passé et présent, en faisant la fête dans l'un des nombreux clubs, restaurants et cafés qui surplombent l'azur de la Méditerranée.</p>

					<h3>LE PORT DE TEL-AVIV :</h3>
					<p>construit en 1938, ce port est devenu un lieu de divertissement ouvert à tout public. Ce site de 14 000 m² avec ses planches caractéristiques en teck, accueille des bars, night clubs, des boutiques, restaurants et cafés. C'est un must pour tous ceux qui souhaitent faire l'expérience d'une cuisine variée et délicieuse, tout en faisant du shopping et en se divertissant. Et si cela ne suffisait pas, le coucher du soleil y est absolument incroyable. Alors venez et profitez de la brise rafraîchissante de la mer. Au coucher du soleil le port se transforme en l'un des lieux de divertissement les plus prisés de la ville et regorge de fêtards.</p>

					<h3>LE PORT DE JAFFA:</h3>
					<p>Considéré comme l'un des plus anciens au monde, le port de Jaffa a desservi pêcheurs, marins, croisés, marchands, conquérants et immigrants pendant des milliers d'années. De nos jours, le port continue à servir comme port de pêche mais a aussi été rénové et offre aujourd'hui des activités ludiques et culturelles, des possibilités de shopping et des attractions touristiques, tout en préservant son caractère culturel et historique unique.</p>
					

					<br>


					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/6.jpg"} class="img-responsive" />
					</div>


					<h3>VIE NOCTURNE</h3>
					<p>Les noctambules pourront faire la fête dans les cafés et night clubs de la ville et expérimenter la vie nocturne non-stop que la ville a à offrir. Une nuit typique à Tel-Aviv commence à 11h du soir et dans certains cas se prolonge jusqu'à l'aube. Voici quelques endroits à la mode où vous pouvez danser toute la nuit</p>
					
					<h3>HAOMAN 17</h3>
					<p>Haoman 17 - C'est le méga-club le plus connu et le plus grand. Il accueille quelques uns des meilleurs DJs de la planète. Adresse: 88 rue Abrabanel. Tél: 03-6813636</p>
					
					<h3>DIZINGOFF CLUB</h3>
					<p>Trois bars, une piste de dance, salons, des salles VIP, etc. Ce club attire un public branché. On peut danser au son de la musique rock, disco, funk ou de tout ce que l'on joue d'autre. Adresse : 9 rue Dizengoff Tél. : 052-3285103</p>
					
					<h3>DREAM EXHIBITION</h3>
					<p>l'un des endroits les plus populaires de Tel-Aviv. Son chic contemporain et son système son sans égal à 360° vous fait rêver. Adresse : 30 Bd Ibn Gvirol Tél.: 054-9500001</p>
					
					<h3>KULEI ALMA</h3>
					<p>L'un des lieux alternatifs les plus chauds de la ville. Les murs sont couverts d'art de rue et art vidéo. On y expose les œuvres d'artistes locaux, et il dispose d'une cour agréable, où on peut boire, grignoter et faire connaissance. Adresse : 30 rue Miqvé Israël Tél.: 03-6565155</p>
					
					<h3>THE CAT AND DOG</h3>
					<p>Club underground situé dans la zone de Carlebach, On y écoute de la musique éclectique, les boissons coulent à flot gratuitement et la piste de dance ne désemplit pas. C'est sans doute l'un des plus chauds lieux de la vie nocturne de Tel-Aviv. Adresse : 23 rue Carlebach Tél. : 072-32819233</p>
					
					<h3>THE BLOCK</h3>
					<p>Il a gagné de nombreuses récompenses, y compris celle du meilleur night-club de l'année, où sont organisées les meilleures fêtes de l'année, et la meilleure fête locale de l'année, noté par la BBC comme ayant l'un de cinq meilleurs systèmes son du monde. Vaut vraiment le détour. Adresse : 157 rue Salamé Tél. : 03-5378002</p>
					
					<h3>KTOVET</h3>
					<p>Son nom signifie « adresse » en hébreu, et il est considéré par beaucoup comme L'ENDROIT où il faut être vu. Alors mettez vos chaussures et en piste. Des DJs internationaux vous y attendent. Adresse : 1 rue Miqvé Israël Tél.: 052-6779503</p>
					
					<h3>BIGGY Z BAR</h3>
					<p>Entrez dans ce bar. Vous vous retrouverez dans la Big Easy - New Orleans. Avec sa formule unique de boissons à volonté, faites la fête! Alors buvez votre mint Julep et soyez heureux... Adresse : 18 rue Bograshov Tél. : 03-5365982</p>
					
					<p>Et si vous cherchez un bar gay :</p>
					
					<h3>APOLO SEXY BAR</h3>
					<p>Seul bar gay de Tel-Aviv exclusivement réservé aux hommes, l'Apollo s'inspire des meilleurs clubs d'Europe. Adresse : 46 rue Allenby Tél.: 03-7741106</p>
					
					<h3>AMAZONA</h3>
					<p>Le top des bars gay de Tel-Aviv, excellente ambiance. Adresse : 23 rue Lilienblum Tél.: 050-4810488</p>
					
					<h3>BARVAZ</h3>
					<p>Bar gay populaire avec de grands DJs chaque nuit. Adresse : 10 rue Hamehoga</p>
					
					<h3>MARCHÉS :</h3>
					<h3>MARCHÉ DU CARMEL :</h3>
					<p>Le plus célèbre des marchés de la ville qui, en plus de son paysage humain haut en couleur, offre un nombre infini de mets fins, épices, aliments et autres options tentantes et enchanteresses. Ce marché est bondé en toute saison et en plus de ses clients fidèles, il est fréquenté par les touristes qui profitent au maximum de cette expérience de shopping moyen-oriental unique.</p>
					
					<h3>MARCHÉ LÉVINSKY :</h3>
					<p>Un mélange de boulangeries, boutiques de spécialités, restaurants et échoppes, qui proposent des épices, noix, fruit secs et aliments exotiques. Vous pouvez vous inscrire à une visite gastronomique du marché et écouter les histoires, légendes et secrets de l'ancien et du nouveau marché. Le caractère unique de Lévinsky en fait une attraction pour les touristes autant que pour les locaux.</p>
					
					<h3>MARCHÉ AUX PUCES :</h3>
					<p>Situé à Jaffa, le célèbre marché aux puces propose de la vaisselle, des fripes, et des chaussures ainsi que des objets de brocante, de décoration pour la maison et des meubles de collection. On y trouve aussi des cafés à la mode, des restaurants qui servent du houmous et des fèves (authentiques) et des plats du passé.</p>
					
					<h3>FOIRES ALIMENTAIRES :</h3>
					<p>Au cours de ces dernières années, 3 foires aux aliments ont vu le jour à Tel-Aviv : Shuk Hanamal au port de Tel-Aviv, Sarona et le Shuk Tzafon à Ramat Hahayal et tous offrent aux visiteurs une expérience gastronomique qui les fait saliver. Ces marchés offrent des produits frais et des matières premières hors pair aux palais délicats.</p>
					
					<h3>LE MARCHÉ ARTISANAL DU CENTRE COMMERCIAL PIÉTONNIER DE LA RUE NAHALAT BINYAMIN :</h3>
					<p>Ce marché haut en couleur, ouvert les mardis et vendredis donne un cachet spécial à cette rue. N'hésitez pas à vous y promener, il constitue une source inépuisable d'idées créatives et originales de cadeaux qui ne se trouvent pas en magasin : des bijoux colorés, du papier mâché, des peintures à l'huile, des jouets en bois, des horloges murales décoratives, des figurines de verre en miniature, des mains de Fatma, des poupées, de la vaisselle, etc.</p>
					<br>

					<h3>RESTAURANTS</h3>
					<p>Tel-Aviv est une véritable Mecque de la gastronomie. Au-delà des fallafels et des shawarmas, elle regorge de bistros pour gourmets tenus par les meilleurs chefs du pays et de cafés enchanteurs où vous pourrez prendre une légère collation et déguster un excellent café. Parallèlement à ses restaurants où l'on peut virtuellement commander tout ce que l'on peut imaginer, Tel-Aviv dispose également de brasseries et de cafés et de restaurants végétariens hors pair Voici quelques options pour vous régaler…</p>
					
					<h3>MIZLALA :</h3>
					<p>Ce restaurant offre des plats issus de la créativité et de la passion de son chef Meir Adoni. Située à Nahalat Binyamin, lieu à la mode s'il en fut, dans un bâtiment Bauhaus magnifiquement restauré, la Mizlala déborde d'énergie et offre une expérience gastronomique inoubliable. Adresse : 57 rue Nahalat Binyamin Tél. : 03-5665505</p>
					
					<h3>TOPOLPOMPO</h3>
					<p>Le restaurant du dragon de feu du chef Avi Conforti et son architecture hors norme vous font découvrir des goûts, senteurs et sensations nés d'un travail avec le feu et les épices. Une soirée dans cet établissement, ainsi que le décrit son chef, ne peut être que chaude, sexy et pleine d'émotions – à ne pas rater. Adresse : 14 Hasolelim Tél. : 03-6910691</p>
					
					<h3>TSFON ABRAXAS</h3>
					<p>
						Le célèbre chef local Eyal Shani, y sert des plats novateurs, intelligents et délicieux. Lieu à la mode par excellence où la cuisine est ouverte, le restaurant Abraxas vous permet de savourer l'ambiance autant que la nourriture en observant les cuisiniers et leur énergie contagieuse. Adresse : 40 rue Lilienblum Tél.: 03-5166660
						Et si vous préférez les plats végétariens…
					</p>
					
					<h3>HASHAWARMA HATIVONIT</h3>
					<p>Considéré comme l'un des meilleurs restaurants végétariens de rue de Tel-Aviv, ce restaurant sert des hamburgers et des hot dogs végétariens et bien entendu une shawarma végétarienne. Adresse : 81 rue King George Tél. : 03-5248821</p>
					
					<h3>NANUCHKA</h3>
					<p>On y sert un excellent menu géorgien végétarien dans un décor hors normes avec un plancher antique et des œuvres d'art des meilleurs artistes israéliens. Le menu est tellement original et savoureux que même les carnivores les plus endurcis se passeront de viande avec plaisir. Adresse : 30 rue Lilienblum Tél. : 03-5162254</p>
					
					<h3>BUDDHA BURGERS</h3>
					<p>Fast food populaire végétarien, où l'ambiance est agréable, les prix abordables et les plats variés: burgers, hot dog, shawarmas et burritos. Adresse : 86 rue Ibn Gabirol Tél. : 03-5101222</p>
					
					<h3>ZAKAIM</h3>
					<p>Se définissent comme une boutique végétarienne pratiquant les prix d'un marché fermier, tous les plats sont à base d'ingrédients locaux et de saison. Adresse : 20 Simtat Beit Hasho'eva (Alenby 98) Tél. : 03-6135060</p>
					
					<h3>TENAT</h3>
					<p>Qualifié de l'un des meilleurs restaurants végétariens de Tel-Aviv par le guide Secret Tel-Aviv, Tenat sert un menu éthiopien végétarien et sans gluten. Adresse : 27 rue Chelnov Tél. : 054-7499538</p>

					<h3>CULTURE</h3>
					<p>Si vous êtes amateur d'art, visitez les nombreux musées et galeries d'art de la ville.</p>
					
					<h3>LE MUSÉE D'ART DE TEL-AVIV :</h3>
					<p>Ce musée d'art israélien et international de premier plan accueille des collections permanentes ainsi que des expositions itinérantes et affiche les meilleurs tableaux, sculptures, œuvres de design et d'architecture, vidéographie, dessins et autres.</p>
					
					<h3>BEIT HATFUTZOT, LE MUSÉE DE LA DIASPORA :</h3>
					<p>Il s'agit de l'une des principales institutions au monde impliquées dans la recherche sur le judaïsme et il est également considéré comme le premier musée à afficher l'histoire et les réalisations du peuple juif. Sa visite est une expérience émouvante pour les Juifs et permet d'avoir un aperçu des expositions passionnantes retraçant les récits et les évènements de la Diaspora juive tout au long de l'histoire.</p>
					
					<p>Tel-Aviv vous apporte tout ce qu'une grande ville de villégiature a à offrir – la mer, le soleil, la possibilité de se relaxer ainsi qu'un monde culturel vibrant et une cuisine haut de gamme, des boutiques et une vitalité inégalable. Grâce aux vols directs à partir des plus grandes villes des Etats-Unis et d'Europe, vous pourrez vous rendre compte par vous-même de ce qui fait le charme unique de cette ville.</p>

					<h3>EVÈNEMENTS ANNUELS</h3>
					<p>Tel-Aviv ne s'arrête pas en si bon chemin, elle accueille de nombreux évènements sportifs, culturels et divertissements. Nous vous recommandons de chercher les dates de ces évènements sur Internet. En voici un échantillon :</p>
					
					<h3>LA NUIT BLANCHE DE TEL-AVIV :</h3>
					<p>Personne ne dort ne 30 juin 2016! Cette nuit spéciale organisée une fois par an, vous propose ses concerts, fêtes, spectacles de rue, pièces de théâtre etc. jusqu'au petit matin. Les sites artistiques et culturels de la ville restent ouverts ainsi que les magasins et certains clubs. La plupart des évènements de la Nuit Blanche sont ouverts au public, gratuitement ou pour un prix symbolique.</p>
					
					<h3>LE FESTIVAL DES MAISONS OUVERTES :</h3>
					<p>Du 26 au 28 mai 2016. Ce festival prévoit des visites rares des maisons et bâtiments les plus fascinants de la ville, dont la plupart n'ont jamais été ouverts au public.</p>
					
					<h3>COURSE NOCTURNE DE TEL-AVIV :</h3>
					<p>Cette course de 10 km aura lieu le 16 novembre 2016. Cet évènement attire des milliers de coureurs ainsi que des dizaines de milliers de spectateurs venus les encourager et assister à cette incroyable célébration unique. A la fin de la course, une grande fête de rythme et de musique est organisée à Ganei Yehoshua.</p>
					
					<h3>LA GAY PRIDE :</h3>
					<p>évènement annuel qui a lieu chaque année en juin à Tel-Aviv, destination de plus en plus prisée par la communauté gay internationale. La parade commence par un happening au Parc Meir avec des discours, des spectacles de drag queens et autres. Après cela, la parade se fraie un chemin au travers des rues principales, sur fond de bonne musique, en présence de groupes qui la suivent. Nombreux participants et de dizaines de milliers de spectateurs. Le point culminant de la parade est la méga fête organisée à la plage Charles Chlore. Mais ce n'est pas tout… les évènements se poursuivent dans des soirées organisées dans toute la ville.</p>
					
					<h3>LE FESTIVAL DE L'INNOVATION DLD :</h3>
					<p>La conférence numérique DLD de Tel-Aviv est le plus grand rassemblement international d'innovateurs et d'entrepreneurs, elle accueille des centaines de startups, VC, investisseurs et multinationales leaders. Grâce à ses compétences technologiques de pointe, à son taux d'investissement dans les entreprises à risque le plus élevé par capita et aux succursales de multinationales leaders de l'industrie telles que Intel, Google, Microsoft, Kimberly Clark, Amazon, GM, Amdocs, Facebook et autres qui y sont implantées, Tel-Aviv est l'endroit idéal pour mieux connaître le monde de la haute technologie. Le festival comprend de nombreuses conférences, évènements, rencontres et rassemblements axés sur différents aspects de l'innovation numérique, technologique, sociale et urbaine. Cette année le festival aura lieu du 24 au 29 septembre 2016.</p>

					<div class="img-wrapper">
					<img src=${getImgUrl() + "/posts/2/7.jpg"} class="img-responsive" />
					</div>

         `,
      };
    },
  },

  {
    id: "Vegan_Friendly_TelAviv",
    bgImage: "posts/bank/8/1.jpg",
    mobBgImage: "posts/bank/8/M.jpg",
    title: "SCENE VEGAN DE TEL AVIV",
    ctg: "culinarytelaviv",
    isVid: true,
    vidId: "S2NGYP3QQT8",
    vidId: "9l04RfZ95J0",
    smlTitle: "",
    html: function() {
      return {
        __html: `
                     
					 <br/>
					 

					 <h2>La visite de Tel Aviv n'a jamais été aussi agréable ou savoureuse pour les végétaliens</h2>

					 <p>La visite de villes étrangères peut s'avérer difficile pour les végétaliens, qui ne consomment que des aliments n'ayant aucune origine animale. Tel n'est pas le cas de Tel Aviv, qui accueille une école de cuisine intégralement végétalienne et de nombreux restaurants qui ouvrent leurs portes aux végétaliens. Déjà un haut lieu du tourisme gastronomique et couronnée « Première ville gastronomique au monde » par Saveur Magazine, Tel Aviv a adopté le végétalisme, ce qui a conduit la revue culinaire The Daily Meal à déclarer la ville « Meilleure destination végétalienne au monde, » devant huit autre « villes ouvertes aux végétaliens ».</p>
					 <div class="img-wrapper">
						 <img src=${getImgUrl() + "posts/6/2.jpg"} class="img-responsive" />
					 </div>
					 
					 
					 <h3>Tout ce que désirent les végétaliens</h3>
					 
					 <p>Si vous parcourez Tel Aviv, vous tomberez sur une quantité de restaurants, brasseries et établissements de restauration rapide végétaliens ou ouverts aux végétaliens. Appréciez les aromes doux et savoureux flottant dans l'air de la ville en sachant que vous trouverez près de vous un mets délicieux que vous pourrez consommer. Suivant les goûts et les demandes des habitants de Tel Aviv et des touristes, la plupart des établissements de restauration de la ville, ou du moins ceux qui ont une once d'amour-propre, intègrent à leurs menus des plats végétaliens. D'autres ont choisi d'embrasser complètement la philosophie végane, et proposent des déclinaisons des délices locaux comme le fallafel sans œuf, le shawarma au seitan et la pizza au fromage sans produits laitiers.</p>
					 
					 <h3>Goûtez les saveurs de la Méditerranée</h3>
					 
					 <p>Respirer l'air frais de la Méditerranée vous a ouvert l'appétit et vous voulez goûter les délices locaux ? Si vous êtes un végan en visite à Tel Aviv, votre estomac saura vous guider vers les succulents plats à base de produits locaux frais, qui reflètant les différentes cultures, tendances et orientations gastronomiques de la ville.</p>
					 
					 <p>Israël offre un grand nombre d'options culinaires aux végans, mais, avec ses nombreux restaurants, Tel Aviv est vraiment le joyau gastronomique végétalien. Que vos aspiriez à un repas sur le pouce, à un menu gastronomique ou à un dessert, Tel Aviv a l'option végétalienne qui vous convient, ce qui fait de la station balnéaire israélienne une destination à ne pas manquer à l'occasion de votre prochain voyage en Israël.</p>

					 <div class="img-wrapper">
						 <img src=${getImgUrl() + "posts/6/3.jpg"} class="img-responsive" />
					 </div>

			`,
      };
    },
  },

  {
    id: "Jerusalem_Cuisine",
    bgImage: "/posts/bank/28/1.jpg",
    mobBgImage: "/posts/bank/28/M.jpg",
    title: "La cuisine de Jérusalem",
    ctg: "culinaryjerusalem",
    isVid: true,
    vidId: "2CSCe2WC7Ns",
    smltitle: "",
    html: function() {
      return {
        __html: `

				<h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Exaltante et diversifiée, et oops si délicieuse</h2>

					<p>
							Jérusalem regorge de restaurants animés et branchés et de lieux où passer du bon temps. La ville est remplie d’endroits offrant d’excellentes possibilités de divertissements, de jour comme de nuit. Vous pouvez ainsi profiter d’une agréable soirée autour d’un bon repas accompagné d’une bière fraiche ou aller danser sur de la musique entrainante.
			    </p>

					<p>
							Il est coutume de dire que l’on se rend à Jérusalem pour son houmous, et que l’on y reste pour sa gastronomie incroyablement variée. De la cuisine traditionnelle du Moyen-Orient et d’Afrique du nord à la cuisine fusion d’Amérique du sud et d’Asie et aux mets d’Europe continentale, des fastfood aux restaurants gastronomiques : Jérusalem est sur tous les fronts culinaires. Un vaste choix d’options de restauration est réellement présent partout à Jérusalem : spécialités locales dans les échoppes, restaurants authentiques sur les marchés, et si vous êtes en quête d’une véritable expérience gastronomique, vous pouvez réserver une table dans l’une des nombreuses adresses prestigieuses de chefs.
					</p>

         `,
      };
    },
  },

  {
    id: "Coffee_In_TelAviv",
    bgImage: "posts/bank/42/1.jpg",
    mobBgImage: "posts/bank/42/M.jpg",
    title: "PAUSE-CAFÉ À TEL AVIV",
    ctg: "culinarytelaviv",
    isVid: true,
    vidId: "Q162n8iMTg8",
    smlTitle: "",
    html: function() {
      return {
        __html: `

			<p>Tel Aviv est une ville dynamique connue pour ses attractions touristiques, son effervescence et ses multiples activités. Or, c'est dans les cafés que bat réellement son cœur. Les cafés constituent un aspect fondamental de la culture de Tel Aviv. Alors faites une pause et imprégnez-vous de l'atmosphère de la ville devant un café.</p>

			<h3>La culture du café</h3>
			<p>Si vous voulez connaître la « véritable Tel Aviv », il n'est pas de meilleur moyen que de vous soumettre à la tradition locale du café. Vous pouvez en déguster un dans l’un des nombreux coffee shops à la mode fréquentés par les touristes, mais pourquoi ne pas sortir des sentiers battus et vous rendre dans un petit établissement authentique pour prendre le pouls de cette ville en regardant son quotidien se dérouler sous vos yeux ? Assistez au rush matinal ou faites comme les vrais Tel-aviviens qui, en fin de journée, s'installent en terrasse pour profiter du frais, discuter, et bien sûr, prendre un café. Vous aurez l'irrésistible envie de vous attarder à votre table, alors profitez-en pour goûter aux délicieux plats servis par ces établissements. Certains vous raviront avec leurs riches pâtisseries européennes tandis que d'autres vous serviront des repas complets s'inspirant de différentes tendances culinaires et cultures.</p>
			
			<p>Tel Aviv regorge d'établissements de qualité pour boire le café, chacun offrant une atmosphère qui lui est propre. Sirotez un café glacé en bronzant sur la plage, mêlez-vous aux autochtones dans un magnifique coffee shop situé dans les fameux bâtiments de style Bauhaus du quartier à la mode Névé Tzedek, ou détendez-vous en buvant un latte au port. Regardez passer les joggers, cyclistes et rollers pendant que vous savourez la vie - et un bon café.</p>
			<div class="img-wrapper">
				<img src=${getImgUrl() + "posts/coffe-in-tlv/1.jpg"} class="img-responsive" />
			</div>
			
			<h3>L'heure du café</h3>
			<p>À Tel Aviv, vous ne boirez pas seulement différents types de cafés, vous goûterez à plusieurs mondes et traditions. Le matin, vous pourrez essayer un « café hafuch », moderne et tendance, la version israélienne du cappuccino, constituée d'un trait d'expresso versé dans du lait chaud, que boivent les jeunes Telaviviens branchés. En milieu de matinée, laissez une tasse de café turc traditionnel, chaud, noir et fort, vous emporter dans un autre monde, à seulement quelques minutes de là, dans le vieux Jaffa. L'arôme et l'atmosphère vous transporteront dans le passé, parmi les odeurs et les parfums du Moyen-Orient ancien. Pour terminer, adoptez la tradition méditerranéenne du café du soir, pris en terrasse, sur le boulevard Rothschild, avec les figues de barbarie.</p>
			
			<p>À Tel Aviv, il n'y a pas de mauvais moment pour boire un café.</p>
              
			`,
      };
    },
  },

  {
    id: "Non_Stop_Markets",
    bgImage: "posts/bank/non-stop-markets/1.jpg",
    mobBgImage: "posts/bank/non-stop-markets/M.jpg",
    title: "Non Stop Markets",
    ctg: "telaviv",
    isVid: false,
    smlTitle: "",
    html: function() {
      return {
        __html: `
			                 <p>A tour of the markets in Tel Aviv, with their unparalleled human tapestry and never-ending variety of delicacies is probably one of the best ways to get to know the true local spirit of Tel Aviv.<br>
                             Here are some of the markets that are definitely a must, when visiting the sunny city:</p>

                             <h3>Carmel Market:</h3>
                             <p>The city’s most famous market, renowned for its colorful spirit and food stalls, featuring fresh local delicacies and excellent restaurants serving fresh food straight from the market. You can also find hidden food placed behind the stalls and around the area. They are really worth finding. <br>
                             <h3>The Flea Market:</h3>
                             <p>Located in Jaffa, packed with fantastic authentic antiques from Tel Aviv and Jerusalem, a joy to bargain hunters. This market is also home to many fashionable and excellent cafés and restaurants of all varieties of cuisines: from Greek, to Italian, to Arabic.<br>
                             <div class="img-wrapper">
						         <img src=${getImgUrl() +
                       "posts/non-stop-markets/1.jpg"} class="img-responsive" />
					         </div>
                             <h3>Nahalat Binyamin Arts & Crafts Market: </h3>
                             <p>Open on Tuesdays and Fridays, this is a ‘fair-like’ artists’ market, rich with creative and original ideas for gifts. It is just the place to pick up that perfect souvenir you won’t find in any store.<br> 
                             <h3>Sarona Market</h3>
                             <p>Offering a unique and fabulous culinary adventure, Sarona Market is located in the Trendy Sarona Complex, and is home to a modern and vibrant “food court” which offers a huge assortment of culinary options. Sarona is also extremely family friendly, filled with outdoor activities and fantastic playgrounds. <br>
                             <h3>Tel Aviv Port Market</h3>
                             <p>With more of a Farmers Market feel, this seaside Market is packed with tasty treats and specialty produce which you can enjoy, on the spot of take home as culinary souvenirs.<br>

              
			`,
      };
    },
  },

  {
    id: "Joys_Of_Jaffa",
    bgImage: "posts/bank/joys-of-jaffa/1.jpg",
    mobBgImage: "posts/bank/joys-of-jaffa/M.jpg",
    title: "JAFFA, VILLE MAGIQUE",
    ctg: "telaviv",
    isVid: true,
    // vidId:"a6QMndU0wx0",
    vidId: "tgF0zMUYY2g",
    smlTitle: "",
    html: function() {
      return {
        __html: `
			            
			            <br/>
			            <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Explorez tous les trésors de la splendide ville antique de Jaffa</h2>
			            <p>Recently named among CNN Travel’s must visit places for 2019, Jaffa is Tel Aviv’s smaller sister, and even though it dates back thousands of years, a visit to Old Jaffa always feels like an exciting discovery. A tour of Jaffa reveals charming winding alleyways interspersed with art galleries, historic buildings, newly renovated hotels in extraordinary landmark areas and a multitude of quaint authentic restaurants.</p>

                        <h3>Jaffa Flea Market</h3>
                        <p>Located in Jaffa, the famous flea market is a pure delight for the bargain hunters among you, packed with great authentic antiques. The flea market has been experiencing a recent bloom, and is considered a nightlife hub, featuring trendy bars and cool outdoor eateries, packed with young party people until the (very) late.</p> 

                        <h3>Jaffa Port </h3>
                        <p>Considered one of the world’s most ancient ports, the Port of Jaffa served fishermen, sailors, merchants, crusaders, conquerors and immigrants for thousands of years. Today, the port continues to serve as a fishing port, and is also being renovated as an urban attraction that offers cultural and leisure activities, shopping and tourism, while preserving its unique historical and fascinating character.</p>

                        <h3>Around Jaffa </h3>
                        <p>A stone’s throw away from Jaffa you can find the HaTachana complex, Tel Aviv’s renovated Old Railway is now a now vibrant tourist hub and an attractive site in itself and also lovely Neve Tzaedek  neighborhood, perfect for a leisurely stroll. Jaffa also boasts stunning beaches and fantastic restaurants serving a variety of fantastic local cuisine at affordable prices.  </p>
                        
                        <h3>Colorful History and Irresistible Levantine Charm</h3>
                        <p>The smells of the sea flavored with black coffee and spices from the markets, Levantine culture combined with European, ancient mixed with new – this is Jaffa. One of the oldest port cities in the world whose history dates back to the great flood, today's Jaffa is a vibrant city that never ceases to surprise and innovates. Picturesque alleys, art galleries, unique boutiques, ancient building, wonderful landmarks and an abundant of authentic middle-eastern restaurants – a trip to old Jaffa is a must-have multi-sensory stimulating experience for anyone visiting Israel. Prepare to fall in love.<br>&nbsp;</p>
                        <h3>Discover the magic of a vibrant Port City</h3>
                        <p>Situated on a hill overlooking the Mediterranean Sea, in the southern part of Tel-Aviv, Jaffa has been the center of historical events for thousands of years. Still an active port today the Jaffa Port is a great place to explore. Wander through the art galleries, shopping boutiques and gourmet food markets. Stroll by the old docks, listen to live music, drink, eat and absorb the special atmosphere.<br><br>To get a better view of the city, climb up the hill to Peak (Ha'Pisga) Park overlooking the bay and gaze at the beautiful city below. On your way down, make a wish at the Wishing Bridge. Who know, it may come true.</p>
                        <h3>Go on A Romantic urban adventure</h3>
                        <p>Jaffa streets are full of surprises. Stroll in the narrow stone-paved streets of old Jaffa, discover hidden courtyards and notice the small details – painted ceramic tiles, small sculptures and upper open terrace. See the people, enter the art galleries, artists' studios and unique boutique.<br><br>Keep exploring. From the Clock tower square at the heart of the city continue to the well-known Jaffa Flea Market and weave your way through daily basics and hidden treasures. It's time to test those bargaining skills. Enjoy the small quaint cafés, middle-eastern authentic restaurants, great bar and some of best hummus you ever tasted. Guaranteed.</p>
					
                        <p><a href="https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1" rel="nofollow" target="_blank">View attractions in Tel Aviv &amp; Center at Tourist Information site</a><br><a href="https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19" rel="nofollow" target="_blank">View accommodations in </a><a href="https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1" rel="nofollow" target="_blank">Tel Aviv &amp; Center</a><a href="https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19" rel="nofollow" target="_blank"> at Tourist Information site</a></p>
					
              
			`,
      };
    },
  },

  {
    id: "Gourmet_TelAviv",
    bgImage: "posts/bank/33/1.jpg",
    mobBgImage: "posts/bank/33/M.jpg",
    title: "SCÈNE GOURMANDE SUR TEL-AVIV",
    ctg: "culinarytelaviv",
    isVid: true,
    vidId: "jfyHxk8ZRrI",
    smlTitle: "",
    html: function() {
      return {
        __html: `

			<h2>SCÈNE GOURMANDE SUR TEL-AVIV</h2>
			
			<p>
			L’immense variété de restaurants fantastiques sur Tel-Aviv – L’endroit parfait pour vous faire plaisir
			</p>

			<p>Tel Aviv, la ville qui ne dort jamais, située sur les rives de la Méditerranée, est une des destinations touristiques les plus prisées au monde. Animée, dynamique et festive, la seconde ville d'Israël a tout pour elle, y compris une scène culinaire créative, tendance, originale et plusieurs fois primée, qui satisfait tous les goûts et tous les budgets. Depuis les restaurants gastronomiques modernes et sophistiqués jusqu'aux établissements locaux simples et traditionnels, en passant par toutes les déclinaisons situées entre les deux. La ville a même été nommée parmi les principales destinations véganes. Gourmands des quatre coins du monde, Tel Aviv est l'endroit qu'il vous faut.</p>

			<p>En balade. Les Telaviviens adorent être dehors. Il se passe toujours quelque chose de nouveau et de passionnant en ville, y compris en matière de cuisine. Vous voulez explorer la scène culinaire de Tel Aviv ? Commencez tout simplement par sortir dans la rue. Allez dans une des principales rues animées de la ville, comme Dizengoff et Ibn Gabirol et allez de découverte en découverte. Les meilleurs cafés, restaurants, bars, traiteurs et vendeur de rue n'attendent que vous.</p>
			
			<p>Goûter les délices des marchés. Visitez le marché Carmel, le plus grand et le plus central des marchés alimentaires de la ville, immensément populaire. Ensuite, direction le marché Levinsky, au sud de la ville, le paradis des gourmets et des épices. Un conseil : prenez votre temps. Ces rues cachent certains des plus grands trésors culinaires de la ville.</p>
			
			<p>Une cuisine locale et internationale. Avec ses immigrants venus de plus de 120 pays, il n'est pas étonnant que Tel Aviv soit un véritable creuset (littéralement). Si pour vous nourriture ethnique signifie alimentation d'origine japonaise, thaï ou indienne, ici le terme a une signification bien plus vaste. Cuisine turque, marocaine, perse, yéménite, éthiopienne, géorgienne, et la liste ne fait que commencer...</p>
			
			<p>Tel Aviv est également extrêmement fière de sa cuisine locale, qui s'inspire de ces nombreuses spécialités internationales qui apportent une touche originale aux mets traditionnels. Le résultat est délicieux et extrêmement original. Visitez le marché paysan du port de Tel Aviv ainsi que le marché international Sarona, pour goûter à certains des meilleurs produits que la ville vous propose.</p>
			
			<p>Une cuisine sophistiquée, raffinée et innovante. Ce n'est un secret pour personne, un grand nombre des meilleurs restaurants israéliens se trouvent à Tel Aviv. Des chefs créatifs et ayant le goût du risque, qui n'hésitent pas à se lancer dans des expériences à partir de mets du Moyen-Orient, d'Asie de l'Est et d'Europe, ont transformé Tel Aviv en un pôle gastronomique connu dans tout le pays et dans le monde entier. Intelligente et esthétique, cette cuisine est élaborée à partir des produits locaux les plus frais - une expérience culinaire que vous n'êtes pas près d'oublier.</p>
			
			<p>Une cuisine végétarienne et végane. Contrairement à de nombreuses villes du monde, à Tel Aviv on peut très facilement passer une semaine (ou plus) sans manger de viande ou de laitage. Vous trouverez facilement de la nourriture de qualité, ethnique, raffinée et préparée rapidement. Nombreux sont les boulangeries, traiteurs, restaurants totalement végétariens ou établissements classiques à proposer de nombreux plats végans et végétariens. Vous pourrez déguster une cuisine savoureuse et originale, élaborée à l'aide produits frais.</p>
			
			<p>Ce qui est apparu il y a quelques années comme une mode parmi tant d'autres s'est imposé comme l’une des principales caractéristiques de la scène culinaire de Tel Aviv. Celle-ci fait bon usage de ses diverses influences gastronomiques, de l'impressionnante variété des légumes proposés sur les marchés et de l'intérêt de la population pour la protection de l'environnement.</p>
			
			<p>Cela vous a-t-il ouvert l'appétit ?</p>
              
			`,
      };
    },
  },

  {
    id: 34,
    bgImage: "/posts/34/1.jpg",
    mobBgImage: "/posts/34/M/1.jpg",
    title: "the DEAD SEA",
    ctg: "deadsea",
    isVid: false,
    player_id_post: "",
    smltitle: "",
    html: function() {
      return {
        __html: `
            
				<p>
               		A geological wonder in a uniquely serene setting, the Dead Sea is an extremely popular tourist attraction.

                </p>

                <p>
               		Experience the calm tranquility of the water with its distinct healing properties while enjoying the unparalleled beauty of the surrounding landscape. The Dead Sea, also known as the oldest natural spa in the world, is blessed with an extremely high salt concentration of 31.5%, allowing tourists from far and wide the amazing experience of effortlessly floating on the waters of the lowest place on Earth. While here, you can bathe in the healthy black mud of the area or explore the fascinating and historically rich nearby landscapes.
					
                </p>

                <p>

					Luxury hotels, varied cuisine from gourmet restaurants to fast food eateries, great souvenir shops, the extraordinary history of the nearby Masada, and many cultural activities throughout the year, make the Dead Sea a popular destination for local tourists as well as International visitors.

                </p>
				
            	 `,
      };
    },
  },

  {
    id: "Shakshuka",
    bgImage: "/posts/bank/43/1.jpg",
    mobBgImage: "/posts/bank/43/M.jpg",
    title: "L’HEURE DE LA SHAKSHUKA",
    ctg: "culinary",
    isVid: true,
    vidId: "n4kCnPXEX7g",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<p>Quand vous demandez aux gens qui visitent Tel Aviv et Jérusalem quel est leur plat préféré parmi ceux qu’ils ont goûtés durant leur séjour en Israël, ils vous répondront la plupart du temps que c’est la Shakshuka. Ce mets méditerranéen, qui est une spécialité régionale incontournable, consiste essentiellement en un plat d’oeufs pochés dans une sauce à base de tomates, de piments et d’oignons, riche en saveurs et souvent servi avec du pain du tahini. Il existe évidemment plusieurs variantes de ce plat, en fonction des styles et des goûts locaux ; il est habituellement servi au petit-déjeuner ou pour un brunch, bien qu’il puisse aussi faire un excellent dîner.</p>

				<p>Le meilleur endroit pour savourer la Shakshuka est certainement à Tel Aviv ou à Jérusalem, villes ensoleillées toute l’année, ce qui permet de profiter d’une escapade urbaine surprenante, pleine de saveurs et d’expériences inoubliables.</p>

				<p>Mais au cas où vous souhaiteriez mettre la main à la pâte et recréer le goût de la sensationnelle Shakshuka dans votre propre cuisine, voici comment procéder :</p>

				<h3>INGRÉDIENTS</h3>
				<ul>
					<li>2 cuillerées à soupe d’huile d’olive</li>
					<li>1 oignon, haché</li>
					<li>1 poivron rouge, épépiné et coupé en dés</li>
					<li>4 gousses d’ail, émincées</li>
					<li>2 boîtes de tomates en dés</li>
					<li>6 oeufs</li>
					<li>2 cuillerées à soupe de coriandre frais, haché</li>
					<li>¾ cuillère à café de sel</li>
					<li>1 cuillère à café de paprika</li>
					<li>¼ cuillère à café de poivre noir</li>
					<li>1 jalapeno (facultatif)</li>
				</ul>
				<h3>PRÉPARATION</h3>
				<ul>
					<li>Commencez par préchauffer le four à 375 degrés.</li>
					<li>Faites chauffer à feu moyen l’huile d’olive dans une grande poêle qui peut aller au four. Ajoutez-y l’oignon, le poivron rouge et le jalapeno, et faites frire l’oignon jusqu’à ce qu’il soit translucide.</li>
					<li>Ajoutez-y l’ail et le paprika. Puis ajoutez les tomates, le sel et le poivre noir.</li>
					<li>Portez à ébullition puis réduisez le feu. Laissez mijoter 10 à 15 minutes.</li>
					<li>Créez 6 petits trous dans la sauce et cassez soigneusement les oeufs dans chacun des 6 espaces libres.</li>
					<li>Mettez la poêle dans le four préchauffé et faites revenir jusqu’à ce que les blancs d’oeuf soient cuits – 10 minutes environ.</li>
					<li>Garnissez de coriandre avant de servir.</li>
					<li>Servez avec du pain et du tahini, et… Dégustez !</li>
				</ul>

         `,
      };
    },
  },

  {
    id: "The_Gates_Of_Jerusalem",
    ctg: "jerusalem",
    isVid: true,
    // vidId:"MXtcTm_JXus",
    vidId: "V0Acsw3Hf_M",
    bgImage: "/posts/bank/gates-of-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/gates-of-jerusalem/M.jpg",
    title: "THE GATES OF JERUSALEM",
    smltitle: "",
    html: function() {
      return {
        __html: `
				  
				                <p>Jerusalem’s Old City walls, built in the early 16th century by the Turkish Sultan Suleiman the Magnificent, have eight gates. All but one (the Gate of Mercy) still serve Jerusalemites and visitors streaming to its markets, and sacred and historic sites.</p>

                                <p>Following  is a thumbnail description of the gates, counter-clockwise from south to west:</p>

                                <h3>The Zion Gate:</h3>

                                <p>Bearing Jerusalem’s earliest biblical name in Hebrew and English, this gate’s  Arabic name is the Gate of the Prophet David, as the Tomb of King David, on adjacent Mount Zion, is only a few steps away. Zion Gate leads directly to the Armenian and Jewish quarters.</p>

                                <p><strong>The Dung Gate:</strong> This gate’s unusual name derives from the refuse dumped here in antiquity, where the prevailing winds would carry odors away. Nehemiah 2:13 mentions a Dung Gate that was probably near this one. This gate leads directly to the Western Wall and the Southern Wall Archaeological Park.</p>

                                <p><strong>Gate of Mercy:</strong> This gate, in the eastern Temple-Mount wall, may be the best-known of them all. Also called the Golden Gate or the Eastern Gate, it has been blocked for centuries, and is said to be awaiting a miraculous opening when the Messiah comes and the dead are resurrected.</p>
                                <div class="img-wrapper">
						            <img src=${getImgUrl() +
                          "/posts/gates-of-jerusalem/1.jpg"} class="img-responsive" />
					            </div>

							    <h3>Lion’s Gate:</h3>

                                <p>This portal is named after a pair of ferocious-looking animal carvings that flank it. They are actually tigers, the heraldic symbol of the 13th-century Sultan Beybars. It is also called St. Stephen’s Gate, after the first Christian martyr, who tradition says was stoned nearby. Lion’s Gate, which leads to the Pools of Bethesda, the Via Dolorosa, and the markets, became famous during the Six Day War.</p>

                                <h3>Herod’s Gate:</h3>

                                <p>  Despite its name, the notorious Judean king had nothing to do with this gate. In Arabic and Hebrew this north-facing gate, which leads to the Old City markets, is called the Flowers Gate. Some say the name derives from a rosette carved over it. However, in Arabic a similar word means “awakened,” and may refer to a nearby cemetery and the hope of resurrection.</p>

                                <h3> Damascus Gate:</h3>

                                <p> This most imposing of Jerusalem’s gateways also faces north and is named for the grand city from which Jerusalem’s rulers once came. It is always a busy thoroughfare, thanks to the bustling markets within. Below the 16th-century gate, archaeologists have uncovered part of the entryway built by Emperor Hadrian in the second century CE.</p>

                                <h3> The New Gate:</h3>

                                <p>This is the only Old City entryway not part of the original design of the 16th-century walls. It was breached in the waning days of the Ottoman Empire to allow Christian pilgrims quicker access to their holy places within the ramparts.</p>

                                <p>The Jaffa Gate: This was the destination of Jewish and Christian pilgrims disembarking at the Jaffa port, hence its name. It led (and still leads) directly to the Jewish and Christian quarters, as well as to the most popular parts of the market, and to the Tower of David Museum, once Jerusalem’s citadel and now a showcase of its history.</p>
							    

         `,
      };
    },
  },

  {
    id: "Shopping_Delights",
    ctg: "jerusalem",
    isVid: true,
    // vidId:"MXtcTm_JXus",
    vidId: "V0Acsw3Hf_M",
    bgImage: "/posts/bank/shopping-delights/1.jpg",
    mobBgImage: "/posts/bank/shopping-delights/M.jpg",
    title: "JOIES DU SHOPPING",
    smltitle: "",
    html: function() {
      return {
        __html: `
				  
					<p>
					    Des articles de mode aux souvenirs, Jérusalem propose tout cela.<br/>
						From couture to souvenirs, Jerusalem has it all. <br/>
					
						There are several areas in Jerusalem with outdoor shopping promenades and a few indoor malls as well. Rest assured, going shopping in Jerusalem, you can find what you’re looking for budget.
					</p>

					<h3>
					   CITY CENTER: BEN YEHUDA AND SURROUNDING STREETS
					</h3>


					<p>
                          Jerusalem’s entire city center area is now one large pedestrian mall.&nbsp; The city is&nbsp;<a href="//www.itraveljerusalem.com/ben-yehuda-street" target="_blank"><strong>Ben Yehuda St.</strong></a>, a pedestrian street full of shops and restaurants<a href="//www.itraveljerusalem.com/ben-yehuda-street"><strong>,</strong></a>&nbsp; with its repaved Jerusalem stone walkway,&nbsp; classy street lamp, elevated seating areas,&nbsp; and a small fountain to boot.&nbsp; The surrounding streets also enjoyed an upgrade with a sleek, grey-tiled sidewalk resurfacing and the same classy street lamp. This renovation was in preparation for the city’s&nbsp;<a href="//www.itraveljerusalem.com/articles/jerusalem-light-rail/" target="_blank"><strong>lightrail on Jaffa St</strong></a>.
                    </p>

                    <p>
                       Given the expanded revamped area, when you go shopping in Jerusalem, it’s worth a stroll on all of the center city streets: Shatz St., King George St.,Hillel St., Ben Yehuda St., Jaffa St., Yoel Salomon St., and all of their offshoot streets. Tip: On Fridays during the day, check out the Artists Fair on Shatz and Betzalel Streets – an excellent place to purchase Jerusalem gifts by local artisans.
                    </p>

                    <p>
                       Ben Yehuda St. itself is a hill, connecting with King George St. at the top, and Jaffa St. at the bottom, where it opens up into the Zion Square plaza (Kikar Tzion). Ben Yehuda highlights include branches of two famous Israeli companies: The Dead Sea spa products, Ahava, and the quality Teva-Naot leather shoes. Ben Yehuda St. is also a good place to peruse Judaica and Christian souvenirs at overall mid-tier prices – be sure to haggle! The area also offers practical day-to-day items, from hats and umbrellas to electronics.
                    </p>

                   <!-- <p>
                          At the bottom of Ben Yehuda St., at Zion Square plaza, stands the newly-installed department store HaMashbir LaTzarchan (commonly referred to as simply “HaMashbir”), whose multiple floors offer everything you’re used to in a department store. Near Zion Square, jewellery store&nbsp;<a href="//www.itraveljerusalem.com/baltinester-jewelry-judaica-jerusalem" target="_blank"><strong>Baltinester (Jaffa St.</strong></a>) is well known in particular for its name necklaces made to order.&nbsp;From Zion Square, you’ll enter into Nachalat Shiva, centeredon Yoel Salomon St., home to several pottery and jewellery shops as well as boutique clothing stores.
                    </p> -->

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/5/2.jpg"} class="img-responsive" />
					</div>

					<h3>
					   MAMILLA MALL & THE OLD CITY’S CARDO: UPSCALE SHOPPING
					</h3>

					<p>
                          During your&nbsp;<a href="//www.itraveljerusalem.com/jerusalem-old-city" target="_blank"><strong>Old City tours</strong></a>, you’ll find an exclusive shopping experience at&nbsp;<a href="//www.itraveljerusalem.com/cardo-jerusalem" target="_blank"><strong>the Cardo</strong></a>&nbsp;in the Jewish Quarter. The Cardo’s row of luxury shops are particularly suited to purchasing Jerusalem souvenirs, all with the unique backdrop of the Cardo’s ancient Roman columns and other archaeological remains.&nbsp; Thereby, the Cardo is a one-of-a-kind experience for any Jerusalem visitor, in that you can combine treading on history with shopping high-end.
                    </p>

					<h3>
					THE JERUSALEM MALCHA MALL
					</h3>

					<p>
					    The Jerusalem Malcha Mall is a solid choice for anyone seeking the suburban indoor shopping mall experience, as well as families seeking an indoor outing.
					</p>

					<p>
					    Now over twenty years old, when the Jerusalem Malcha Mall was established it was dubbed “The Biggest Mall in the Middle East”. To date Malcha Mall certainly maintains its status as the biggest conglomerate of stores in Jerusalem, with over 250 to choose from.
					</p>

					<p>
					    The Jerusalem Malcha Mall houses both international and Israeli stores, ranging from somewhat low to mid-range budget to boutique, higher end. World-famous brand names such as H&M, Zara, Home Depot, and Toys R Us all maintain branches at this mall. Several Israeli clothing shops for all budgets have space here, as well as a branch of the department store HaMashbir LaTzarchan (the same department store as on Zion Square), and the Mega supermarket. In addition, Malcha Mall offers practical services such as a synagogue, a post office, and Bank Hapoalim. For eats, there’s a vast selection of take out restaurants at the food court, all kosher.
					</p>

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/5/3.jpg"} class="img-responsive" />
					</div>

					<p>
                          Activities include an indoor ice skating rink during winter, and entertainment and crafts workshops during holiday seasons – check our&nbsp;<a href="//www.itraveljerusalem.com/jerusalem-events" target="_blank"><strong>events schedule</strong></a>&nbsp;to plan your outing. In addition, the Shilav baby store has a gymboree area good for ages up to six. <br>
                          Malcha Mall is an easy bus ride from center city or cab ride from anywhere.
                    </p>

                    <h3>
                       THE OLD CITY’S ARAB SHUK
                    </h3>

                    <p>
                       If you’re looking for authentic, local ware, the Old City’s Arab Shuk is the place to be. Located in the Muslim and Christian quarters, enter via Jaffa Gate and go straight into the Muslim Quarter. Once you see dresses and frocks hanging high, you’ll know you’re in the right place. The Arab shuk in the Old City is a Middle Eastern market full of endemic artistry both in clothing and in foods. You can also find Christian, Jewish, and Muslim souvenirs here, often at a lower price than on Ben Yehuda St. – it’s up to you to know, and use, your bargaining chips.(Hint: Start at half the offer price.)
                    </p>

                    <p>
                      In the Arab shuk, you’ll have a taste of the way things used to be. Merchants have been operating in the Old City for a couple of millenia, in these narrow alleyways, day in, day out; the sincerity of this centuries-old, Middle Eastern marketplace is something unmatched in Western culture in general.
                    </p>

                    <h3>
                        MAHANE YEHUDA SHUK (MARKET)
                    </h3>

                    <p>
                       The Mahane Yehuda market, or shuk, is renowned mostly for its Jerusalem flare with local food – fresh produce and nuts, bakeries (such as&nbsp;Marzipan), and shawarma/falafel  joints.&nbsp; In recent years&nbsp;<a href="//www.itraveljerusalem.com/mahane-yehuda-market" target="_blank"><strong>Mahane Yehuda</strong></a>&nbsp;has seen a slew of more upscale establishments – going from “shuk&nbsp; to chic” – with specialized wine and cheese shops, health food stores, vegetarian restaurants, and even a branch of the Israeli international franchise, Café Aroma. In addition to food, you can find gifts to take home such as Judaica, jewelleryry, and pottery. &nbsp;You can also purchase electronics and low-cost clothing.
                    </p>



                    <p>
                    Even with its upscale spin of late, the Mahane Yehuda shuk’s salt of the earth, authentic Jerusalemite ambience remains entrenched, and for this reason it's a must.
                    </p>

                    <h3>
                       IN SUMMARY
                    </h3>

                    <p>
                          All in all, shopping in Jerusalem reflects the city itself, spanning the spectrum of ancient to modern, with options for those on a limited budget to those looking for upscale. You will see that shopping in Jerusalem is certainly an exciting, varied experience.
                          <br>– See more at: http://www.itraveljerusalem.com/articles/popular-shopping-places/#sthash.HdOTQ81q.dpuf
                    </p>

         `,
      };
    },
  },

  {
    id: "Top_5_Things",
    ctg: "telaviv",
    isVid: false,
    bgImage: "/posts/bank/37/1.jpg",
    mobBgImage: "/posts/bank/37/M.jpg",
    title: "LES POINTS FORTS DE TEL AVIV",
    smltitle: "",
    isVid: true,
    vidId: "LLOUxE-K_9Y",
    html: function() {
      return {
        __html: `
					
					<h2>Le top 5 des choses à voir et à faire dans la ville:</h2>
					<h3>
					LE VIEUX JAFFA
					</h3>
					<p>
					Même si elle ramène à des millions d’années en arrière, une visite du Vieux Jaffa donne toujours l’impression d’une découverte passionnante. De charmantes ruelles sinueuses parsemées de galleries d’art, de bâtiments historiques, de sites extraordinaires et d’une multitude de charmants restaurants pittoresques. Un tour du Vieux Jaffa est une expérience impressionnante, un ‘must’ indéniable pour tout touriste visitant Israël.
					</p>
					<h3>
					LE PORT DE JAFFA
					</h3>
					<p>
					Considéré comme l’un des plus ancients ports du monde, celui de Jaffa a accueilli des pêcheurs, des marins, des marchands, des croisés, des conquérants et des immigrants pendant des milliers d’années. De nos jours, le port continue d’être utilisé comme port de pêche ; il est aussi en train d’être rénové pour devenir une attraction urbaine offrant loisirs et activités culturelles, shopping et activités touristiques, tout en préservant son caractère historique unique et fascinant.
					</p>
					<h3>
					LE PORT DE TEL AVIV
					</h3>
					<p>
					Récemment restauré, le quartier branché du port a vraiment tout pour lui. En journée, vous pouvez vous retrouver en train de flâner dans de remarquables espaces au style suspendu et y faire du shopping dans des magasins de marque, vous offrir un repas dans l’un des restaurants avec vues magnifiques sur la mer, et participer à une multitude d’activités destinées à toute la famille. La nuit tombée, une foule de jeunes clubbers descend alors sur la zone qui devient l’un des quartiers nocturnes les plus appréciés concentrant quelques-uns des clubs et bars les plus cools de Tel Aviv.
					</p>
					<h3>
					LA VILLE BLANCHE
					</h3>
					<p>
					Participez à une visite fascinante de la ‘Ville Blanche’ de Tel Aviv et découvrez pourquoi elle a été déclarée site classé au patrimoine mondial de l’UNESCO. La ‘Ville Blanche’ abrite le plus vaste groupement de bâtiments de style international au monde, également connu sous le nom de Bauhaus. Construite dans les années 1920 et 1930, et minutieusement restaurée à sa gloire d’origine, le quartier de la ‘Ville Blanche’ est vraiment unique. C’est un trésor architectural mémorable.
					</p>
					<h3>
					NÉVÉ TZEDEK
					</h3>
					<p>
					Offrez-vous une pause avec le rythme trépidant de Tel Aviv ; cette perle, dissimulée dans un quartier, possède un magnifique style architectural oriental et de charmantes rues étroites qui font de Neve Tzedek, qui signifie litéralement une Oasis de Justice, une véritable oasis au coeur de la ville effervescente.
					</p>

         `,
      };
    },
  },

  // in fr.citiesbreak old this post wasn't translated
  {
    id: "Amazing_Nightlife",
    bgImage: "/posts/bank/18/1.jpg",
    mobBgImage: "/posts/bank/18/M.jpg",
    title: "A LA RECHERCHE D'UNE VIE NOCTURNE",
    ctg: "telaviv",
    isVid: true,
    vidId: "ogEN7aRT0SM",
    // vidId:"WKfjMATNH8Q", - this is an old youtube video
    smltitle: "",
    html: function() {
      return {
        __html: `

					<div class="ac-cradit">
					<span class="ac-cradit-text">Credits:</span>
						<br/>
						<span class="ac-cradit-text-1">Tel Aviv Jaffa municipality<br/></span<
						<span class="ac-cradit-text-2">UDINI prodactions<br/></span>
					</div>
					<p></p>
					</div>

                    <h2>
                    It’s a never-ending party in the nonstop city!</h2>
					<p>
					    Tel Aviv is rightly famous as one of the world’s great nightlife cities, with her warm Mediterranean climate making it ideal to party outdoors for most of the year. As the sun goes down the city transforms into a welcoming nighttime experience that’s pulsing with life.</p>
						<h3>Tel Aviv by Night</h3>
						<p>No matter what time it is, there’s always something going on in Tel Aviv. Watch the sun go down at a casual beach bar, feet in the warm sand and a cold drink in your hand, before moving on to taste craft brews in a packed, friendly pub, enjoy an exotic cocktail in a relaxed bar or eat something delicious before heading off to one of Tel Aviv’s pumping, pulsing clubs to dance the night away.</p>
						

					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/8/2.jpg"} class="img-responsive" />
					</div>

					<p>Foodies will love the amazing cocktails mixed by Tel Aviv’s expert baristas, Israel’s lively pub scene serving craft beers and snacks, and the restaurants that range from elegant to casual to street pop-ups, offering every possible style and type of food. Eat your heart out!</p>
                        <h3>Making the Most of Tel Aviv’s Nightlife</h3>
                        <p>Spend a relaxed evening in an upmarket wine bar in a trendy neighborhood like Neve Tzedek, where you’ll be introduced to some of Israel’s highly acclaimed wines. Move on to chill at one of the many bars that feature live bands, or enjoy some culture with your cocktails in one of Tel Aviv’s new and exciting gallery bars that display pieces by up and coming artists.</p>
                         

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/8/3.jpg"} class="img-responsive" />
					</div>

					<p>If you want a pumping party night on the town, Tel Aviv is the right place to find it. Tel Aviv’s nightclubs are world-famous, often hosting international DJs. During the long summer season some of the beaches transform into nightclubs for all-night raves, with throbbing beats, lasers and pulsing music. The party doesn’t reach full swing until 2am in most of Tel Aviv’s wildly popular nightclubs, manned by top DJs. You’ll find every time of club, from intimate to massive and from throwback dance to the newest electric indie beats.</p>
                         

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/8/4.jpg"} class="img-responsive" />
					</div>
                      <p>The LGBTQ scene is also hot in Tel Aviv, with some of the best parties and music nights hosted by gay-friendly clubs and bars. Whether you want chilled or full-on, cultural or flirty, you’ll find countless places to hang out at every hour of the day and night.</p>

                        <p>photo credit: Dana Friedlander</p>

         `,
      };
    },
  },

  {
    id: "Boutique_Hospitality",
    bgImage: "/posts/bank/1.jpg",
    mobBgImage: "/posts/bank/M.jpg",
    title: "Boutique Hospitality",
    ctg: "telaviv",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `

                                <p>Tel Aviv has long been known as a young and vibrant seaside city, where life is fast-paced and non-stop. And with countless bars, restaurants, beaches, museums, shops and attractions lining every free inch of prime Tel Aviv real estate, the recent revolution in the city’s boutique hotel offerings in the past two years has paved the way for luxury and leisure packed vacations, combining action with relaxation and increased visitor satisfaction.</p>

                                <h3>A unique, personalized touch</h3>

                                <p>If you are seeking a unique hospitality experience in a trendy neighborhood establishment that blends into the local infrastructure, a Tel Aviv boutique hotel stay is just what you need. Perfectly bringing together desired service and amenity features with an added increasingly personalized customer service, boutique hotels are known for their staff’s exemplary accommodating attention to their visitors’ every request and fancy.</p>

                                <p>Built in converted heritage sites, restored old buildings or other contemporarily designed structures, each Tel Aviv neighborhood boutique hotel possesses unique themes, concepts and characteristics. Defined by their souls and coupled with uniquely designed guest rooms and a high level of customized service, the boutique hotels have great views of the “City that Never Sleeps” from sprawling rooftop terraces, in-house spas, internet hubs and restaurants.</p>
								<div class="img-wrapper">
						            <img src=${getImgUrl() +
                          "/posts/boutique-hospitality/1.jpg"} class="img-responsive" />
						            Credit: Dana Friedlander
					            </div>
							   
								<h3>Live the big city</h3>

                                <p>Looking to enjoy a romantic couple’s getaway, find a quiet place to unwind during a weeklong business conference, gather your family for an intimate reunion or hang out with friends for a fun beach vacation? Don’t want to travel far from your hotel room or sit in traffic to reach big city attractions, nightlife and events? The warm and inviting yet luxurious nature of boutique hotel stays in Tel Aviv provide the ideal hospitality experience that lets you “live” Tel Aviv like a local, minus the onus of cleaning your own rooms and preparing your own meals.</p>

                                <p>Think of boutique hotels as upscale and authentic guest houses in the heart of the big city. Somewhere you can go to escape the hustle and bustle when it’s time to relax and be pampered, but still be able to pop out on a whim and casually enjoy the plethora of sites and services Tel Aviv offers the public, just like any one of  the city’s locals. And with many of the city’s boutique hotels situated in trendy areas, including in Neve Tzedek, along the coastline, in the diamond district and on Rothschild, Shenkin and Montefiore streets, a Tel Aviv boutique hotel stay is charming, authentic, pleasurable and exciting for all hospitality seekers.</p>
            

         `,
      };
    },
  },

  {
    id: 10,
    bgImage: "/posts/bank/12/1.jpg",
    mobBgImage: "/posts/bank/12/M.jpg",
    ctg: "telaviv",
    isVid: false,
    title: "Culture Time",
    smltitle: " ",
    html: function() {
      return {
        __html: `

					<h2>A variety of fascinating museums and unique galleries</h2>

				    <h3>
				        Tel-Aviv Museum of Art
				    </h3>

					<p>
						The Tel Aviv Museum of Art presents a variety of permanent and temporal exhibits at its home in the Helena Rubenstein Pavilion, located on Shaul Hamelech Boulevard, next to the Mann Auditorium. The permanent exhibits include some of the best works of Israeli art, as well as sculptures from the 20’s until today. It features European paintings – impressionism and post-impressionism – from the 16th to the 19th centuries, as well as European and American works of the 20th century. The museum’s graphic collection includes more than 20,000 prints and sketches. Among the museum’s outstanding works are a unique selection of early painted reliefs of Alexander Archipenko and works by Chagall, which he donated to the museum before its establishment. Helena Rubenstein’s well-known collection of miniature rooms is on permanent display in the pavilion, which bears her name.
					</p>

					<h3>
				        OPENING HOURS:
				    </h3>

				    <p>

                          Sun Closed <br>
                          Mon, Wed, Sat 10:00-18:00 <br>
                          Tue, Thu 10:00-22:00 <br>
                          Fri 10:00-14:00 <br>
                          Sat 10:00-16:00 (July-August closed on Sat)<br>
                    </p>

                    <p>
                       For more information, click to the&nbsp;<a href="//www.tamuseum.org.il/en/default.aspx" target="_blank">Tel-Aviv Museum of Art</a>
                    </p>

                    <h3>
                        Beit Hatfutsot: The Diaspora Museum
                    </h3>

                    <p>
                       Beit Hatefutsot-The Jewish Diaspora Museum, situated on the Tel Aviv University campus, has gained honorary distinction throughout the Jewish world as the first museum of the history of the Jewish people to showcase the Jewish contribution to human creativity and culture over a period of more than two millennia. The Museum’s permanent exhibition brings the story of the Jewish People throughout the Diaspora to life through drawings, video clips, films, reconstructed models and other means. The exhibit focuses on various subjects – including “The Jewish Family life cycle”, “the community”, “the faith”, and “the return to Zion”.
                    </p>

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/10/2.jpg"} class="img-responsive" />
					</div>

					<p>

                          For more information, click to the&nbsp;<a href="//www.bh.org.il/" target="_blank">Beit Hatfutsot: The Diaspora Museum</a>

                    </p>

                    <h3>
                         Eretz Israel Museum
                    </h3>

                    <p>

                            The Eretz Israel Museum- Tel Aviv is a multi-disciplinary institution. It presents the history of the land and its culture through an extensive permanent exhibit, in addition to a variety of temporary exhibits on subjects such as archaeology, ethnography, folklore, Judaica, cultural history, local identity, traditional crafts and functional arts. The museum’s pavilions are scattered throughout a spacious courtyard with the ancient archaeological mound of Tel Kassile, at which excavations revealed valuable findings, positioned at its center. The museum houses a variety of reconstructed ancient production devices, including wine presses, an olive oil press, and a flour mill, along with a “craftsperson’s marketplace” which showcases traditional work instruments that were used in the Land of Israel and throughout the region. There is also a sophisticated Planetarium with its “Journey to the Universe” program, and a museum shop offering a unique selection of locally produced gifts and ornaments.<br>

                            OPENING HOURS:<br>

                          Sun-Wed 10:00-16:00 <br>



                          Thu 10:00-20:00<br>



                          Fri-Sat 10:00-14:00<br>

                        </p>

                    <p>
                       For more information, click to the <strong>&nbsp;</strong><a href="//www.eretzmuseum.org.il/e/" target="_blank">Eretz Israel Museum&nbsp;</a>
                    </p>

					<h3>
					    Beit Ha’ir
					</h3>


					<p>

                          Beit Ha’ir, renovated by the city, was the old City Hall in Tel Aviv-Yafo on Bialik Street, and is now a living display of the city’s history.  Beit Ha’ir has a new exhibition, which sums up the extensive collection of photos and stories featuring events, sites, and experiences of residents throughout the years, a project that was part of the centenary celebrations of the city. The main hall has a virtual display, including hundreds of documentary films and thousands of rare photos and documents that showcase major events in the early years of city life.  At Beit Ha’ir you can also visit the Dizengoff House, the restored residence of Meir Dizengoff, first mayor of Tel Aviv-Yafo, which includes a permanent exhibition.

                          <br>
                          OPENING HOURS:
                          Sun Closed
                          Mon-Thu 9:00-17:00 <br>
                          Fri-Sat 10:00-14:00
                    </p>

                    <p>
                      For more information, click to the <a href="//www.eretzmuseum.org.il/e/" target="_blank">Beit Ha’ir</a>
                    </p>

                    <h3>
                        The Olympic Experience Museum
                    <h3>

                    <p>

                          A new museum in Tel Aviv-Yafo, The Olympic Experience Museum, presents a one-hour, five-ring trip through the greatest Olympic records, with a special focus on Israel’s finest moments. The Olympic Experience boasts state-of-the art high tech imaging and illustrations, audio-visuals presentations, holograms, interactive screens, hands-on trials and much, much more.

                          Guided tours for organized groups every 30 minutes. Advanced reservation is recommended.

                          Opening Hours: Sunday-Thursday: 10:00-18:00, Friday:  10:00-14:00

                          The Olympic Experience, 6 Shitrit Street, Hadar-Yosef. Tel: +972-3-6498385

                    </p>

                    <p>
                       For more information, click to the&nbsp;<a href="//www.olympic.one.co.il/General/Page.aspx?id=86&amp;siteid=2" target="_blank">The Olympic Experience Museum</a>
                    </p>

                    <p>

                          Ilana Goor Museum in Jaffa

                          The private home of this world renowned artist has been turned into a museum. You can see her sculptures, furniture, jewelry and get a glimpse into this unique Jaffa home <br>
                          OPENING HOURS: <br>
                          Sun-Fri 10:00-16:00 <br>
                          Sat 10:00-18:00<br>
                          <a href="//www.ilanagoormuseum.org/eng/">www.ilanagoormuseum.org</a>
                    </p>

                    <h3>
                         Palmach Museum
                    </h3>

                    <p>
                        Rated #1 Tel-Aviv museum on Trip Advisor, this museum examines the Palmach, the military wing of the Zionist Movement, which functioned until the establishment of the State of Israel.
                    </p>

                    <p>
                        For more information, click to the&nbsp;<a href="//info.palmach.org.il/show_item.asp?itemId=8096&amp;levelId=42798&amp;itemType=0" target="_blank">Palmach Museum</a>
                    </p>

                    <h3>
                        Other unique Museums
                    </h3>

                    <p>
                        Tel Aviv-Yafo is home to a variety of smaller, specialized museums, such as Beit Ben Gurion (The home of David Ben Gurion, Israel’s first prime minister), Beit Hatanach (The home of the Bible), The Haganah (defense) Museum, The I.Z.L. (the Irgun Zva’I Leumi – National Military Organization) Museum, Beit Hasofer (author’s house), Beit Reuven, The Jabotinsky Museum, and many others. Each of these smaller museums is a treasure house of artifacts. For example, Beit Bialik – the house of the national poet, displays the books, furniture and belongings of Israel’s renowned national poet. Bialik’s personal library of more than 3,000 books has been preserved, and the museum’s archives contain thousands of manuscripts, including the most extensive collection of his writings.
                    </p>

                    <h3>
                        OPENING HOURS OF TEL AVIV MUSEUMS:
                    </h3>
                    <h3>
                        Etzel Museum:
                    </h3>

                    <p>

                          King George 38: Sun-Thu 8:30-16:00 <br>

                          For more information, click to the&nbsp;<a href="//www.goisrael.com/Tourism_Eng/Tourist%20Information/attractions/Pages/Etzel%20Museum.aspx" target="_blank">Etzel Museum</a>
                    </p>

                    <h3>
                        Ben Gurion House:
                    </h3>

                    <p>
                            Sun, Tue-Thu 8:00-15:00 <br>
                            Mon 8:00-17:00<br>
                            Fri 8:00-13:00<br>
                            Sat 11:00-14:00
                    </p>

                    <p>
                       For more information, click to the&nbsp;<a href="//www.bg-house.org/?categoryId=6575" target="_blank">Ben Gurion House</a>
                    </p>

                    <h3>
                        Jabotinsky Institute in Israel:
                    </h3>

                    <p>

                        Sun-Thu 8:00-16:00 <br>
                        For more information, click to the&nbsp;<a href="//en.jabotinsky.org/" target="_blank">Jabotinsky Institute in Israel</a>

                    </p>

                    <h3>
                           The Israeli Museum:
                    </h3>

                    <p>
                            Sun, Mon, Wed 9:00-17:00 <br>
                            Tue, Thu 9:00-19:00<br>
                            Fri 9:00-14:00 <br>
                            For more information, click to the
                            <a href="//www.imj.org.il/en/">www.imj.org.il</a>
                    </p>

                    <h3>
                       Jaffa Visitors Center:
                    </h3>

                    <p>

                            Summer Sun-Thu, Sat 9:00-20:00<br>

                            Fri 9:00-17:00<br>

                            Winter Sun-Thu, Sat 9:00-18:00<br>

                            Fri 9:00-15:00<br>

                            For more information, click to the  <br>

                            <a href="//www.touristisrael.com/old-jaffa-visitors-center/3604/" target="_blank">Jaffa Visitors Center</a>

                    </p>

                    <h3>
                         Hall of Independence:
                    </h3>

                   <p>

                            Sun-Thu 9:00-17:00 <br>

                            Fri 9:00-14:00<br>

                            For more information, click to the&nbsp;<a href="//eng.ihi.org.il/" target="_blank">Hall of Independence</a>

                    </p>

                    <h3>
                        The Bible Museum:
                    </h3>

                    <p>

                            Sun-Fri 10:00-13:00 + 16:00-18:30 <br>

                            For more information, click to the&nbsp;<a href="//www.blmj.org/en/" target="_blank">The Bible Museum</a>

                    </p>

                    <h3>
                        Joseph Bau house:
                    </h3>

                    <p>

                            By appointment only (including weekends) <br>

                            For more information, click to the&nbsp;<a href="//www.josephbau.com/" target="_blank">Joseph Bau house</a>

                    </p>

                    <h3>
                        Rubin Museum:
                    </h3>

                    <p>

                            Sun Closed <br>

                            Mon, Wed, Thu 10:00-15:00 <br>

                            Tue 10:00-20:00<br>

                            Sat 11:00-14:00<br>

                            For more information, click to the &nbsp;<a href="//www.rubinmuseum.org.il/" target="_blank">Rubin Museum</a>

                    </p>

                    <h3>
                        Art Galleries
                    </h3>

                    <p>
                        Don’t miss the dozens of fine galleries, primarily located along Gordon Street and in the Old City of Jaffa, featuring the very latest in contemporary Israeli art. We won’t say another word- we’ll let the art speak for itself.
                    </p>

         `,
      };
    },
  },

  // {
  // 	    id:99,
  //         bgImage : "/posts/bank/20/1.jpg",
  //         mobBgImage : "/posts/bank/20/M.jpg",
  //         ctg:"jerusalem",
  //         isVid:true,
  //         vidId:'k4OwoEk5wMw',
  //         title : "JERUSALEM MAIN SITES ",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  // 					<!--<div class="responisve-iframe">
  // 						<iframe src="https://www.youtube.com/embed/k4OwoEk5wMw/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
  // 					</div>-->
  // 					<h3>
  // 				    	Discover the history that stretches back thousands of years
  // 				    </h3>
  // 					<p>
  // 						Like any city, the charm and essence of Jerusalem is best absorbed by walking its streets. However, depending on your interests, you don’t want to miss out on exploring at least some of these major attractions.
  // 					</p>

  // 					<p>
  //                          When visiting religious sites, it’s advised to dress modestly and wear clothing that covers your knees and elbows.
  //                     </p>

  // 					<p>
  //                        A good place to start is Jerusalem’s Old City, which has a very special and distinct atmosphere and is where many of the major attractions of Jerusalem are found.
  //                     </p>

  //                     <h3>
  //                         OLD CITY
  //                     </h3>

  //                     <h3>
  //                         JERUSALEM WESTERN WALL
  //                     </h3>

  //                     <p>
  //                       The Western Wall, also known as the Wailing Wall and Kotel, is the western retaining wall of the Second Temple. Considered Judaisms’s holiest site, the wall is divided into a men’s and women’s section where worshipers congregate throughout the day for morning, afternoon and evening services. Diverse crowds come to pray against the stones, to tuck small pieces of paper with prayers into the cracks and to simply marvel at the site.
  //                     </p>

  //                     <p>
  //                           Address: Jewish Quarter, Old City <br>
  //                           Phone: +972-2-627-3515<br>
  //                           Hours: 24/7<br>
  //                     </p>

  //                     <h3>
  //                         VIA DOLOROSA
  //                     </h3>

  //                     <p>
  //                         TCrossing the Muslim Quarter from east to west is this street that traces the last steps of Jesus Christ as he was led to his crucifixion. Popular with both pilgrims and general tourists, the route marks 14 events on Christ’s last walk and is also lined with shops and stalls. It is worth visiting on a Friday afternoon (3:00opm in winter; 4:00pm in summer) when the Franciscans lead a procession along the route.
  //                         <br>Address: Via Dolorosa, Muslim Quarter, Old City.
  //                     </p>

  //                     <h3>
  //                         JERUSALEM CHURCH OF THE HOLY SEPULCHER
  //                     </h3>

  //                     <p>
  //                         One of the holiest sites for Christians, this impressive building draws millions of pilgrims from around the world every year. The compound is believed to be the site of Golgotha (the Hill of Calvary), where, according to the New Testament, Jesus was crucified, buried and resurrected.
  //                         <br>
  //                         Address: Between Suq Khan e-Zeit and Christian Quarter Rd, Christian Quarter, Old City<br>
  //                         Phone: +972-2-627-3314 <br>
  //                         Hours: Sun – Sat: 5:00am – 8:00pm/9:00pm
  //                     </p>

  // 					<h3>
  // 					    DAVID’S CITADEL
  // 					</h3>

  // 					<p>
  // 					   David’s Citadel (also known as the Tower of David) was originally built in the second century BC to strategically strengthen a weak point in the city’s defences, and was subsequently destroyed and rebuilt many times over the ensuing centuries. Since 1989, the grounds are home to a fascinating museum, which sheds light on the history of Jerusalem. Don’t forget to take in the splendid view of Jerusalem from its ramparts.
  // 					</p>

  // 					<p>
  //                           Address: Jaffa Gate, Christian Quarter, Old City <br>
  //                           Phone: +972-2-626-5333<br>
  //                           Hours: Sun-Thu: 10:00am -4:00pm, Fri: Closed, Sat: 10:00am – 2:00pm (September-June), Sun-Thu:<br> 10:00am – 5:00pm, Fri: 10:00am – 2:00pm, Sat: 10:00am – 5:00pm (July-August)
  //                     </p>

  //                     <h3>
  //                         CITY OF DAVID
  //                     </h3>

  //                     <p>
  //                         Situated deep below ground in the Arab village of Silwan is the remains of the once-grand citadel where a dynasty of Judean kings once ruled. A massive visitors’ center offers a tour that begins with an observation point overlooking the remains of ancient Jerusalem, then continues underground with a look at recent archaeological finds and ends at the Gihon Spring, where according to tradition Solomon was anointed king. Visitors can also wade through the waters of the 2,700-year-old Hezekiah’s Tunnel.
  //                     </p>

  //                     <p>
  //                           Address: Silwan, East Jerusalem <br>
  //                           Phone: +972-2-626-2341<br>
  //                           Hours: Sun-Thu: 8:00am – 5:00pm (winter), 8:00am – 7:00pm (summer), Fri: 8:00am – 1:00pm (winter), 8:00am – 3:00pm (summer)
  //                     </p>

  //                     <div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/posts/9/3.jpg"} class="img-responsive" />
  // 					</div>

  // 					<h3>
  //                        MOUNT OF OLIVES
  //                     </h3>

  //                     <p>
  //                         The hill that rises to the east of the Old City, the Mount of Olives, is a great place to take in views of the Old City and the Dome of the Rock. Its slopes are filled with holy and burial sites and are home to several grand churches including the Church of all Nations. To take in all the sights, it’s best to start at the top, near to the Mosque of Ascension, and walk downhill to the Tomb of the Virgin. The Old City views are best in the morning. <br>
  //                         Address: Mount of Olives, East Jerusalem
  //                     </p>

  //                     <h3>
  //                         YEMIN MOSHE
  //                     </h3>

  //                     <p>
  //                         This charming neighbourhood facing the Old City walls was originally built to escape overcrowding in the 19th Century. It is known for its windmill and communal housing block, known as Mishkenot Shaananim, which is now a venue for art and culture. The area is home to artists, writers and academics and is renowned for its Oriental-style houses, green parks, a music center, the YMCA, King David Hotel, Herod’s Family Tomb. <br>
  //                         CITY CENTER
  //                     </p>

  //                     <h3>
  //                         MAMILLA ALROV AVENUE
  //                     </h3>

  //                     <p>
  //                           Situated between the city center and the Old City, Mamilla Alrov Avenue is a pedestrian mall that offers a selection of luxury shops, as well as upscale restaurants and cafes. Mamilla is known for its chic and tasteful European feel, and offers spectacular views of the Old City walls. <br>
  //                           Address: 6 Yitzhak Kariv St, Jerusalem <br>
  //                           Phone: +972-2-636-0000<br>
  //                           Hours: Sun-Thu: 10:00am – 9:30pm (winter), 10:00am – 10:30pm (summer), Fri: 9:00am – 2:00pm (winter), 9:30am – 3:30pm (summer), Sat: One hour after Shabbat – 11:00pm
  //                     </p>

  //                     <h3>
  //                         BEN YEHUDA STREET
  //                     </h3>

  //                     <p>
  //                     One of Jerusalem’s prime hangout spots for locals and tourists alike, Ben Yehuda Street is a pedestrian mall extending between King George Street and Jaffa Road in downtown Jerusalem. The street is filled with gift shops, falafel and ice-cream stores, buskers, beggars, musicians and street performers.
  //                     </p>

  // 					<h3>
  //                         NACHALAT SHIVA
  //                     </h3>

  //                     <p>
  //                           This charming cobblestone neighbourhood just south of Ben Yehuda Street in the&nbsp;<a href="//www.itraveljerusalem.com/placecategory/food-nightlife?multi_hood=11" target="_blank"><strong>city center</strong></a>&nbsp;offers a great selection of shops, restaurants, bars and outdoor cafes. This is a great place to experience in summer and at night with many bustling until late.
  //                     </p>

  //                     <h3>
  //                        MEAH SHEARIM
  //                     </h3>

  //                     <p>
  //                           Though it is just a few minutes’ walk from modern Ben Yehuda Street, the ultra-orthodox enclave of Mea Shearim is an entirely different reality. You will feel as though you have stepped into 18th Century Europe with Jewish Orthodoxy dressed in full traditional attire such as long black coats, black fur hats and stockings. When touring, it’s recommended to dress extremely modestly, covering up your wrists and ankles, and to take photos with discretion. <br>
  //                           Address: Meah Shearim Rd, Jerusalem
  //                     </p>

  //                     <h3>
  //                         Mahane Yehuda Market
  //                     </h3>

  //                     <p>
  //                           Often referred to as “the shuk”, Mahane Yehuda Market offers a huge assortment of fresh produce and food, as well as a variety of other shops like clothing stores, kitchenware shops, jewellery stores, ceramic stores and a variety of gentrified eateries. The shuk includes an open air and closed area, bounded by Jaffa Road on the one side and busy Agripas Street on the other. It’s worth taking public  to the shuk as there is not a huge abundance of parking, and a great deal of traffic. If you can handle crowds, go on a Friday to experience last minute Shabbat shopping.<br>
  //                           Address: Agripas and Jaffa Street, Jerusalem
  //                     </p>

  //                     <h3>
  //                         OTHER AREAS OF JERUSALEM
  //                     </h3>

  //                     <h3>
  //                        YAD VASHEM
  //                     </h3>

  //                     <p>
  //                           Yad Vashem, Israel’s national Holocaust memorial, commemorates the six million men, women and children murdered by the Nazis and their allies. Located at the foot of Mt. Herzl, Yad Vashem comprises several moving memorials, including the Hall of Remembrance and the haunting Children’s Memorial; the Holocaust History Museum; the Museum of Holocaust Art; sculptures and installations; a massive archive and a research institute. Dress appropriately, and make sure to reserve at least a few hours for a visit to the Museum.  Address: Har Hazikaron <br>
  //                           Phone: +972-2-644-3400
  //                     </p>

  //                     <h3>
  //                        ISRAEL MUSEUM
  //                     </h3>

  //                     <p>
  //                           You’ll want to devote at least a day to Israel’s largest cultural institution, the Israel Museum, which was re-launched in the summer of 2010 after a major overhaul. The Museum is made up of many different wings and a huge collection of art, archaeological findings and Judaica. One of the major highlights is the distinctly shaped Shrine of the Book, which houses many ancient manuscripts including the Dead Sea Scrolls. Other highlights include the Youth Wing for children, the Billy Rose Art Garden, which showcases the development of western sculpture over the centuries, the Museum’s Fine Arts Wing and its in-depth Archaeology Wing.
  //                     </p>

  //          `
  //     }
  //   }
  // },

  {
    id: "Sensational_Beaches",
    ctg: "telaviv",
    isVid: true,
    vidId: "XDei1Zy_cu4",
    bgImage: "/posts/bank/17/1.jpg",
    mobBgImage: "/posts/bank/17/M.jpg",
    title: "PLAGES SENSATIONNELLES",
    smltitle: "",
    html: function() {
      return {
        __html: `
					
					<p>
						Come chill by the sunny beaches of Tel Aviv 
					</p>
					<h3>
						Relax by the sunny beaches of Tel Aviv Pull out the sunscreen, grab your ‘matkot’ and lets go play
					</h3>

					<p>
						Tel Aviv-Yafo boasts a long promenade, running alongside the seashore that makes up its western edge. People walk, jog, ride bikes, or sit on benches and fill their lungs with fresh air, all while being surrounded by a glorious 8.7 mile stretch of open views, blue horizons, and white sails bobbing on the waves.
					</p>

					<p>
						Dozens of restaurants, cafes, and ice cream parlors are busy all day long, while pubs, discos and jazz clubs blossom after dark. Regardless of the hour, human attractions abound – clowns, caricaturists, tattoo artists, hair-braiders, magicians and of course, the ever- changing parade of people strolling by the nearby beaches beckon. Right off the promenade you’ll find clean sand, lounge chairs, ice-cream vendors, and die-hard beach-lovers that swim daily, winter and summer, no matter what. Each of Tel Aviv’s 13 beautiful beaches enjoys unique characteristics and offers a variety of services, including lifeguard stations, kiosks, restaurants, children’s playgrounds, outdoors gyms, and more.
					</p>

                    <div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/13/2.jpg"} class="img-responsive" />
					</div>

					<h3>
						A Few Tips
					</h3>

					<ul>
                      <li>On Friday afternoons at the Dolphinarium beach, you can join in on an improvised drumming festival and a Brazilian martial arts/dance/music combination called capoeira.</li>
                      <li>Gordon beach is great for beach volleyball.</li>
                      <li>The religiously observant will find gender-specific swimming at Hof Hadatiyim (Nordau Beach), just south of the Tel Aviv port. Women and girls bathe Sunday, Tuesday and Thursday while men and boys are allowed in on Monday, Wednesday and Friday. Members of both genders are allowed on Saturday.</li>
                      <li>The gay-lesbian community tends to gravitate to the stretch near the Hilton, which has earned the unofficial title as the city’s most gay-friendly beach.</li>
                      <li>The narrow strip of sand near the Marina is less crowded and more peaceful than the other beaches, at the yacht basin, you can rent windsurfers, surfboards, sailboats, motorboats and diving equipment.</li>
                      <li>Surfing is popular at Hilton Beach, where a special light system was recently installed to allow for night surfing.</li>
                      <li>Kite Surfing is popular at Aviv Beach.</li>
                      <li>To windsurf, go to Dolfinarium Beach.</li>
                      <li>Volleyball can be found at both Aviv and Gordon beaches.</li>
                      <li>The city’s beaches are well equipped with changing rooms, showers and toilets. Lifeguard services are available during seasonal timing (May-October) and tourist police officers are present to provide security, assistance and information services.</li>
                  	</ul>

                  	<h3>
						Fun Facts
					</h3>

					<ul>
                      <li>8,500,000 bathers enjoy the beaches yearly.</li>
                      <li>The official bathing season is May-October.</li>
                      <li>There are 13 beaches along Tel Aviv-Yafo’s coastline.</li>
                      <li>Four beaches are accessible to people with disabilities: Tzuk, Northern Tzuk, Metzizim and Hilton (all in the northern part of the city).</li>
                      <li>The Tel Aviv-Yafo beaches rank highly in tests run by the Israeli Ministry of the Environment and are considered to be very clean.</li>
                      <li>An Israeli version of racquetball, called&nbsp;<a href="//www.gomatkot.com/the-game/">Matkot</a>, is a favorite sport played along the shorelines (watch your head!).</li>
                      <li>Watermelon with feta cheese is a very popular beach snack. Artikim, or popsicles, are also well liked, with the banana-chocolate flavor ranking at the top of most people’s list.</li>
                 	</ul>

                  	<h3>
						Beach Guidelines
					</h3>

					<ul>
                      <li>Bathers must comply with the lifeguard and rescue guards.</li>
                      <li>Bathing is prohibited when there is no lifeguard on duty.</li>
                      <li>Sea bathing is prohibited when the black flag is raised.</li>
                      <li>NO motor sports (jet skis, boats) are allowed.</li>
                      <li>Motorized vehicles are forbidden on beaches and boardwalk.</li>
                      <li>Building a fire is prohibited on beaches.</li>
                    </ul>

                    <h3>
                    	Bathing Season
                    </h3>


					<h3>
						The 2016 Tel Aviv bathing season opens on May 9 2016 and will end on October 31 2016.
					</h3>

					<p>
						During the duration of the season, rescue services, supervision and first aid will be given to the following beaches: North Beach Cliff, South Beach Cliff, Tel Baruch Beach, Hilton Beach, Gordon Beach, Frishman Beach, Borgashov Beach (opening delayed due to renovations), Jerusalem Beach, Charles Clore Beach, Givat Aliyah Beach.
					</p>
					<p>
						<strong>
							Hours of activity:
						</strong>
					</p>

					<p>
						May 9-31: 7am-5pm <br />
						June: 7am-6pm<br />
						July-August: 7am-7pm<br />
						September-October: 7am-5pm<br />
						Inspection and clearing will be provided in all beaches mentioned above, from 7am until the evening hours.
					</p>

					<p>
						<strong>
							The price list of the beaches is:
						</strong>
					</p>
					<p>
						Pita or bread with humus or salad – 12 NIS <br />
						Small bottle of mineral water – 7 NIS<br />
						Popsicle – 5 NIS<br />
						Reclining Beach chair for the day – 12 NIS<br />
						Beach chair for the day – 6 NIS<br />
						Umbrella for the day – 6 NIS<br />
					</p>-->
					<h3>
						National Geographic Magazine's “One of the 10 best beach cities in the world”
					</h3>
					<p>
					   With clear waters and action-packed beaches, each one of Tel Aviv’s 16 beaches has its own style and attracts certain personalities - from hippie casual to Riviera chic. Day or night, hanging out on the beach is one of the best ways to spend time in Tel Aviv.
					</p>
					<h3>
					    Beach activities
					</h3>
					<p>
					    Tel Aviv’s shoreline offers a huge variety of fun beach and water activities, where you join in a game of paddle ball (a national favorite), join a friendly game of beach-volleyball or enjoy the many water sports on offer such as surfing, kayaking, boating and diving.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/posts/13/2.jpg"} class="img-responsive" />
					</div>
					<h3>
					    The 'Tayelet' (Promenade)
					</h3>
					<p>
					    A stunning newly renovated promenade, where you can walk, bike, rollerblade or even Segway and enjoy the lively atmosphere and colorful stream of people as you become taken by its infectious energy and the beautiful beachside views.
					</p>
					<h3>
						Fun Facts
					</h3>

					<ul>
                      <li>8,500,000 bathers enjoy the beaches yearly.</li>
                      <li>The official bathing season is May-October.</li>
                      <li>There are 16 beaches along Tel Aviv-Yafo’s coastline.</li>
                      <li>Four beaches are accessible to people with disabilities: Tzuk, Northern Tzuk, Metzizim and Hilton (all in the northern part of the city).</li>
                      <li>The Tel Aviv-Yaffo beaches rank highly in tests run by the Israeli Ministry of the Environment and are considered to be very clean.</li>
                      <li>Watermelon with feta cheese is a very popular beach snack. Artikim, or popsicles, are also well liked, with the banana-chocolate flavor ranking at the top of most people’s list.</li>

                 	</ul>

         `,
      };
    },
  },

  {
    id: "Modern_And_Vibrant_Video",
    bgImage: "/posts/bank/modern-and-vibrant-video/1.jpg",
    mobBgImage: "/posts/bank/modern-and-vibrant-video/M.jpg",
    ctg: "jerusalem",
    isVid: true,
    // vidId: "cUBBkziv_4c",
    vidId: "V0Acsw3Hf_M",
    title: "MODERNE ET VIBRANTE",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<br/>
				<h2 class="ac-align-center ac-margin-top-20">Tant à voir dans le centre-ville animé de Jérusalem</h2>
				<p class="ac-align-center ac-margin-bottom-20"><b>Le nouveau & l’ancien Jérusalem</b></p>
				<p>
					Bienvenue à Jérusalem – où son passé glorieux est étroitement lié à sa vie moderne et dynamique.<br/>
					Jérusalem abrite d’innombrables sites historiques fascinants, des promenades magiques, des vues à couper le souffle au coucher du soleil, une grande variété de choix de divertissements, des restaurants qui procurent des émotions culinaires, une vie nocturne animée ainsi qu’une offre considérable de centres artistiques et culturels.
				</p>

				<p>Trouver l'inspiration à Jérusalem</p>

				<p>Cela ne fait aucun doute, Jérusalem est une des villes les plus fascinantes au monde. Depuis des siècles, elle offre un savant mélange de religions, traditions, histoire antique et modernité urbaine qui intrigue les visiteurs. C'est également cet aspect qui attire les artistes dans cette ville. La Jérusalem d'aujourd'hui propose une multitude de musées, galeries, marchés et festivals culturels qui, combinés, constituent une scène artistique et culturelle vivante et unique. Préparez-vous à y trouver l'inspiration.</p>
				
				<p>Découvrez. Sur une colline, à côté de la Knesset et de la Cour suprême d'Israël, se trouve la plus grande institution culturelle d'Israël et un des plus importants musées mondiaux d'art et d'archéologie, le Musée d'Israël. Commencez par l'aile archéologique. Organisées chronologiquement, les pièces que vous y verrez constituent la collection la plus complète au monde d'artefacts archéologiques bibliques et de Terre sainte. Poursuivez votre visite en explorant la splendide aile consacrée à l'art et à l'ethnologie juive, l'impressionnante collection de beaux-arts et les expositions provisoires d'art contemporain. Ne manquez pas les œuvres clés du musée : le sanctuaire du Livre, qui contient les manuscrits de la mer Morte, et le magnifique jardin de sculptures, qui fait face aux montagnes de Jérusalem. Un conseil : prenez votre temps ; ce musée est à la fois fascinant et accessible, et il donne tant à voir.</p>
				
				<p>À quelques pas du Musée d'Israël, vous trouverez le fascinant Musée des Pays de la Bible. Qualifié de « capsule temporelle interactive », il est le seul musée de son genre dans le monde. Déambulez dans les galeries et découvrez les merveilles du quotidien des cultures anciennes du Proche-Orient, ainsi que leurs interactions depuis l'aube de la civilisation jusqu'au début de l'ère chrétienne.</p>
				
				<p>Multipliez les expériences. Allez dans la Colonie des artistes de Jérusalem (Hutzot Hayotzer) et éveillez-vous à la créativité. Ce complexe dédié à l'art et à l'artisanat accueille l'atelier d'artistes et créateurs de différents corps de métier. Flânez dans cette rue pittoresque où se côtoient ateliers et galeries sous la muraille nord de la Vieille ville, et regardez les artistes à l'œuvre. Écoutez leurs histoires, familiarisez-vous avec les techniques artistiques traditionnelles et contemporaines et achetez leurs œuvres.</p>
				
				<p>Admirez le Spectacle son et lumière de la Tour de David, également appelé ‘’Jerusalem Night Spectacular’’. Ce splendide spectacle nocturne emploie une technologie moderne pour faire découvrir l'histoire de la ville et sublimer la beauté de la Tour. Les jeux de lumière 3D et la musique donnent vie aux murailles et paysages sous les yeux des spectateurs qui ont vraiment le sentiment d'être entraînés dans un rêve.</p>
				
				<p>Participez aux festivités. Jérusalem possède une histoire très riche ; c'est également une ville moderne et animée qui adore la fête. Consultez le riche programme de festivals et événements culturels de la ville, et profitez du meilleur de ce que Jérusalem a à vous offrir tout au long de l'année.</p>
				
				<p>Assistez au Festival d'Israël, une importante manifestation multidisciplinaire internationale proposant des représentations théâtrales, de danse contemporaine, de musique classique ainsi que des spectacles du monde entier. Visitez la Foire des arts et artisanats Hutzot Hayotzer où vous rencontrerez des artistes israéliens et internationaux… Allez au Marché nocturne de Jérusalem et promenez-vous entre les étals des artistes et créateurs en tous genres exposant et vendant leurs produits ; prenez-en plein les yeux au Festival des lumières de Jérusalem qui donne une dimension spectaculaire à la veille ville ; écoutez de l'opéra au Festival d'opéra de Jérusalem. Organisées à la Piscine du Sultan, les représentations permettent de profiter de la douceur des nuits d'été de Jérusalem avec un splendide panorama pour toile de fond.</p>
				
				<p>Ne manquez pas non plus le Festival de musique sacrée de Jérusalem. Programmé dans le cadre de la Saison culturelle de Jérusalem, ce festival extraordinaire réunit des artistes d'horizons, cultures et traditions très diverses qui interprètent et explorent les musiques sacrées du monde entier.</p>                
                            

         `,
      };
    },
  },

  {
    id: "Modern_And_Vibrant_Post",
    bgImage: "/posts/bank/39/1.jpg",
    mobBgImage: "/posts/bank/39/M.jpg",
    ctg: "jerusalem",
    isVid: true,
    vidId: "1Yx2Uht4rms",
    title: "Moderne et dynamique",
    smltitle: "",
    html: function() {
      return {
        __html: `

                
                             
                             <br/>
                             <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Il y a tant à voir dans le centre-ville animé de Jérusalem</h2>
                              <p>
								Le centre-ville de Jérusalem constitue le coeur de cette métropole moderne, regorgeant de vie nocturne, de restaurants et de curiosités culturelles, rivalisant avec les plus grandes villes du monde.
						</p>
						<p>
								La zone est composée de plusieurs quartiers ainsi que de lieux attrayants comme le charmant Nahalat Shiva, la rue animée Jaffa et la rue Ben Yehuda avec son caractère si singulier et son atmosphere à ne pas manquer.
						</p>
						<p>
								Le centre de Jérusalem comprend certains quartiers les plus charmants de la ville ainsi que quelques-unes des attractions les plus fascinantes. Pour vivre une expérience culturelle incomparable, partez à la découverte des musées passionnants de Jérusalem, parmi lesquels le Musée d’Israël de renommée mondiale, le Musée des pays de la Bible et le Musée des sciences Bloomfield.
						</p>
						<h3>
								Le marché Mahane Yehuda
						</h3>
						<p>
								Découvrez l’atmosphère et la diversité incomparables de ce marché qui attire chaque jour des milliers de touristes. Une fois que la journée de shopping est terminée et que les vendeurs de denrées ferment boutique, rejoignez la jeune foule branchée, mêlant étrangers et locaux, qui se rend sur le marché pour boire un verre et faire la fête jusqu’au petit matin, dans les bars, les restaurants et les allées.
						</p>
						<h3>
								Nahalat Shiva
						</h3>
						<p>
								Ce charmant quartier pavé situé au coeur de la ville offre une excellente sélection de boutiques, de restaurants, de bars et de cafés en terrasse. Nahalat Shiva abrite Kikar Hamusica (la place de la Musique) – un espace extérieur animé et tendance qui programme de la musique live tout au long de la semaine.
						</p>
						<h3>
								Yemin Moshe
						</h3>
						<p>
								Ce joli quartier qui fait face aux remparts de la Vieille Ville fut à l’origine construit pour échapper à la surpopulation au 19e siècle. Terre d’accueil pour les artistes, les écrivains et les chercheurs, Yemin Moshe est réputé pour son magnifique moulin à vent et ses maisons au style oriental, ses parcs verdoyants, son centre de musique contemporaine ainsi que ses vues imprenables.
						</p>
						<h3>
								Ein Kerem
						</h3>
						<p>
								Niché dans une paisible vallée entre les montagnes et les collines en terrasses au sud-ouest de Jérusalem, Ein Kerem est l’un des quartiers les plus pittoresques de Jérusalem. Avec ses ruelles pavées et sineuses, ses charmantes maisons de pierres ornées d’arcades, ses églises dont les cloches sonnent dans l’air pur, Ein Kerem déborde de charme et de beauté tel une île dans un océan de forêt verdoyante.
						</p>

         `,
      };
    },
  },

  // {
  // 	    id:"Jerusalem_After_Dark_Fun",
  //         bgImage : "/posts/bank/modern-and-vibrant/1.jpg",
  //         mobBgImage : "/posts/bank/modern-and-vibrant/M.jpg",
  //         ctg :"jerusalem",
  //         isVid:true,
  //         vidId:"nLKWDp5uA-U",
  //         title : "After Dark Fun in the Holy City",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 					            <p>Planning a trip to Jerusalem usually involves its many sights of culture and historical significance. However, just as important to many, Jerusalem’s has an amazingly cool after dark scene, filled with music, hipster hangouts, dance clubs, and much more.</p>
  //                               <p>To check it out, make your way to the City Center and explore the narrow streets just off Jaffa Street. There you’ll find bars and nightclubs that range from comfortably mainstream to eccentrically funky. Rivlin Street is a popular hangout for young people, while Shoshan Street and the surrounding area offers a more laid-back grown up vibe.</p>
  //                               <div class="img-wrapper">
  // 						          <img src=${getImgUrl() +  "/posts/modern-and-vibrant/1.jpg"} class="img-responsive" />
  // 					          </div>
  //                               <p>Machane Yehuda market offers a surprisingly awesome night out as in the evening it transforms into a trendy hotspot where vendor stalls and shops become the setting for bars, DJs, live music, and dancing. </p>
  //                               <p>Betzalel Street is famous for its student artsy vibe and the many little bars are a great place to befriend the locals who come for a drink and a jam session. </p>
  //                               <p>For a daytime change of pace head to the German Colony (Moshava) and, particularly, the neighborhood of Baka. Start at Beit Lechem Street where you’ll have your choice of popular, contemporary restaurants and bars. Then stroll all the way up Emek Refaim Street or through HaMesila (Railway) Park until you reach The First Station – once a railroad depot in use for over a century, it transformed now into a trendy culinary, cultural, and retail delight.</p>

  //          `
  //     }
  //   }
  // },

  {
    id: "Jerusalem_Musts",
    bgImage: "/posts/bank/38/1.jpg",
    mobBgImage: "/posts/bank/38/M.jpg",
    ctg: "jerusalem",
    isVid: true,
    // vidId: "k4OwoEk5wMw",
    vidId: "FvAWuLQEOJw",
    title: "Jerusalem ‘Musts’",
    smltitle: "",
    html: function() {
      return {
        __html: `

				    <h2>5 top things to do and see in the stunning city</2>
					
					<h3>
						Segway Tours
					</h3>
					<p>
						This adrenaline-packed way of seeing the city will allow you to take in the
						beauty of Jerusalem from an entirely unique perspective. The Segway
						tours leave from various central spots, including the Armon HaNatziv
						Promenade (East Talpiot), Yemin Moshe and the Old City, as well as near
						the Knesset and the museum area.
					</p>
					<h3>
						The First Station (Hatachana)
					</h3>
					<p>
						The First Station is right at the heart of Jerusalem, between the Old
						City and the City Center, between the historic neighborhoods of the
						German Colony and Yemin Moshe. It is the site of the first train station
						in Jerusalem, which was built in 1892. After undergoing renovation and
						preservation, the First Station was reopened as a lively entertainment
						spot, open seven days a week.
					</p>
					<h3>
						The Time Elevator
					</h3>
					<p>
						If you are a fan of joy rides, you will love having your senses scintillated
						by the Time Elevator. It’s an interactive experience that takes visitors on
						fabulous voyages to fascinating places, with motion-based seating in a
						unique hall, filled with special effects.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/jerusalem-must/1.jpg"} class="img-responsive" />
					</div>
					<h3>
						The Biblical Zoo
					</h3>
					<p>
						Spreading over 62 acres, this beautiful two-tiered zoo centers on a vast
						man-made lake complete with waterfalls and side pools, surrounded
						by spacious lawns and shaded resting spots. To the delight of children
						and adults alike, there are over 200 species on view, most of them
						mentioned in the Bible and some almost made extinct in the interim.
						This does not mean that regular animals are not present they even have
						penguins here. Near the Zoo there is a beautiful, huge and impressive
						Aquarium, open for visitors during the day and evening, displaying marine
						habitat from the Mediterranean Sea, the Red Sea and more.
					</p>
					<h3>
						Teddy Park
					</h3>
					<p>
						Named after Teddy Kollek who was Mayor of Jerusalem between 1965-
						1995; Teddy park is fun, beautiful and historically significant.
						The park constitutes a significant meeting point between the Old and
						New Jerusalem and includes a wishing pond, an impressive sun clock
						original sculpture, restorations of historical properties and a fantastic
						water fountain attraction, featuring a spectacular light and sound
						evening show.
					</p>

         `,
      };
    },
  },

  {
    id: 16,
    bgImage: "/posts/bank/34/1.jpg",
    ctg: "eilat",
    isVid: true,
    vidId: "yXzhH92kREg",
    mobBgImage: "/posts/bank/34/M.jpg",
    title: "NEGEV MAJESTIC DESERT",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<h2>Action adventures in the desert sun. With so much to see and do, there is never a dull moment in the Negev</h2>

					<!--<div class="responisve-iframe">
						<iframe src="https://www.youtube.com/embed/yXzhH92kREg/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
					</div>-->
					<h3 class="negev-secondary-title">
								 The Negev Desert - Pure Magic Desert
							</h3>


							\n

                            <!--negev text-->

                            <p>
								The Israeli desert with its breathtaking landscape and various attractions is offering the perfect place for a holiday. The Negev invites the visitors to an exciting journey that is rich in variety of opportunities.
							</p>
							<p>
								Israel is a small country with 62% of the total area occupied by the Negev desert. The reddish gleaming desert terrain is characterized by many impressive geological rock formations. The visitors enjoy here a unique view of an untouched vastness - silent and majestic.
							</p>
							<p class="p-margin">
								There are traces of past civilizations and their agriculture as well as archaeological sites. The Negev offers an unmistakable backdrop for encountering the Bedouin tribes - people of the desert.
							</p>

							<h2>
                                The Israeli desert is special for the following reasons:
                            </h2>

							<ul class="p-margin">
							    <li>
										<b>The desert is very near:</b> just 4 hours of flying from Europe. Israel has two international airports - Ben Gurion and Ovda, which guarantee a short trip to the desert to all travellers (half an hour to an hour and a half).
										Starting from November, there will be direct flights from Europe and Russia to Ovda airport including Ryanair, Wizzair, and SAS.
							    </li>
                                <li>
                                        <b>Easy to Hike and Bike:</b> There are a lot of marked paths. Israel offers the most imposing hiking trails of the world and hundreds of safe paths lead through the Israeli desert. You can find a selection of trails on the following websites:<br>
                                        <a href="//www.negevtour.co.il" target="_blank">www.negevtour.co.il</a>
                                        <a href="//www.en.aravaway.co.il " target="_blank">www.en.aravaway.co.il</a>
							    </li>
							    <li>
                                        <b>Cordial local population:</b> The desert dwellers are friendly and hospitable and make the desert experience both pleasant and exciting for visitors.
							    </li>
							    <li>
                                        <b>Tourists Activities:</b> Along with the development of accommodation, the huge offer of tourist activities has converted the Negev in a popular, interesting, versatile and creative destination in recent years.
							    </li>
							    <li>
                                        <b>Magnificent landscapes:</b> Lots of tourists today, enjoy the charm of the Negev with its landscapes rich in variety<br>
                                        <ul>
                                        	<li>
                                        		There are spectacular sand dunes in the north.
                                        	</li>
                                        	<li>
                                        		The Ramon Crater is present in the middle with its bold cliffs and seasonal water sources.
                                        	</li>
                                        	<li>
                                        		In the east, one experiences the African desert with wide savannas and acacia trees.
                                        	</li>
                                        	<li>
                                        		To the south, one finds red and black granite, contrasted by sandstone foothills having a powerfully pleasant colour.
                                        	</li>
                                        </ul>
                                        During a desert trip of approx. 3 hours, you can get to know the entire spectrum of the desert landscape and enjoy its variety, which one experiences in other deserts often only with a long trip of several kilometers.
										Many tourists decide for to stay for 2 or 3 days in each region of the Negev.

							    </li>
							    <li>
                                        <b>The Negev is very safe to travel.</b> In case of emergency, the rescue units working in the area are some of the best trained in the world and are always close by. Should anyone require medical assistance, Israel offers high quality, first class advanced western medical services.
							    </li>
							</ul>
							<h2>
							    More information and tips for accommodation and recommendations:
							</h2>
							<p>
							   <a href="//www.negevtour.co.il/homepage/accommodation/?lang=en" target="_blank">www.negevtour.co.il</a><br>
							   <a href="https://en.aravaway.co.il/business/category/1/" target="_blank">www.en.aravaway.co.il</a>
							</p>
							<p class="p-margin">
							   <a href="//goisrael.de/taxonomy/term/85" target="_blank">Travel deals</a><br>

							</p>




                            <!--Negev - s-->

							<h3>
							    NEGEV - LOCATION AND APPROACH
							</h3>
							<p class="p-margin">
							   Landing at the airports of Ovda or Eilat with the  onward journey to Mitzpe Ramon or Sde Boker:
							</p>

							<h2>
							   Public means of :
							</h2>
							<p>
								Bus 392 from Eilat to Mitzpe Ramon and Be'erSheva, stops at the airport of Ovda on Sunday at 07:13, 08:41, 09:43, 14:12, 15:41, 17:43.
							</p>
							<p>
								Arrival at the central bus station of Mitzpe Ramon after about an hour and a half.
							</p>
							<p>
								Mondays - Thursdays at 07:13, 07:41, 09:43, 14:12, 15:41, 17:43.
							</p>
							<p class="p-margin">
							   <a href="//www.egged.co.il/HomePage.aspx" target="_blank">Bus service </a><br>
							   <a href="//www.egged.co.il/HomePage.aspx" target="_blank">Shuttle service from Ovda Airport </a>
							</p>
							<h2>
							   Car rental in Eilat, Mitzpe Ramon and Be'erSheva:
							</h2>
							<p>
								There a multiple option in renting a car in these cities.
                                There is a choice of international and Israeli companies.

							</p>
							<p class="p-margin">
								Landing at the Ben Gurion International Airport near Tel Aviv and onward journey for Negev to Mashabei Sadeh / Sde Boker / Mitzpe Ramon

							</p>
							<h2>
							   Public means of :
							</h2>
							<p>
								Bus routes 370/380 from Tel Aviv to Be'erSheva, routes 446/470 from Jerusalem to Be'erSheva.
								<a href="//www1.rail.co.il/EN/Pages/Homepage.aspx" target="_blank">Train from Ben Gurion or Tel Aviv to Be'erSheva.</a>
                            </p>
                            <p>
								From Be'erSheva bus routes 60, 64, 65, 660 Departure every morning 6 o'clock onward (approx. every 20 minutes).
                                Arrival in Mashabei Sadeh in 35 minutes / SdeBoker area in 55 minutes / Mitzpe Ramon in 1 hour 20 minutes.
                            </p>
                            <p class="p-margin">
								More information about the public means of  is given <a href="https://www.bus.co.il/otobusimmvc?Language=en" target="_blank">here</a> or <a href="//www.egged.co.il/HomePage.aspx">here</a>
                            </p>


                             <!--NEGEV DESERT-don't miss-->








                            <h3 class="margin-h">
                                 NEGEV ROAD DISTANCES
                            </h3>
							<table>
							  <tr>
							    <th></th>
							    <th>Tel Aviv</th>
							    <th>Jerusalem</th>
							    <th>Bee'r Sheva</th>
							    <th>Eilat</th>
							  </tr>
							  <tr>
							    <td class="place-table"> <strong>Old Town <br class="show-on-mobile"> Beer Sheva</strong></td>
							    <td>113 Km</td>
							    <td>122 Km</td>
							    <td></td>
							    <td>232 Km</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Tel Arad</strong></td>
							    <td>134 Km</td>
							    <td>144 Km</td>
							    <td>40 Km</td>
							    <td>229 Km</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Ben-Gurion's House <br class="show-on-mobile">in Sde Boker</strong></td>
							    <td>162 Km</td>
							    <td>171 Km</td>
							    <td>49 Km</td>
							    <td>185 Km</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Ramon Crater</strong></td>
							    <td>210 Km</td>
							    <td>192 Km</td>
							    <td>97 Km</td>
							    <td>141 Km</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Hai Bar Wildlife <br class="show-on-mobile"> reserve Yotvata</strong></td>
							    <td>323 Km</td>
							    <td>288 Km</td>
							    <td>202 Km</td>
							    <td>35 Km</td>
							  </tr>
							  <tr>
							    <td class="place-table"><strong>Timna Park</strong></td>
							    <td>330 Km</td>
							    <td>294 Km</td>
							    <td>208 Km</td>
							    <td>30 Km</td>
							  </tr>
							</table>

                            <h3>
								NEGEV DESERT - DON'T MISS
							</h3>

							 <h2>
                                Ramon Crater
                            </h2>

                            <p>
                                At the heart of Israel’s vast Negev Desert, lies the Ramon Crater, the world’s largest erosion crater,also known as Machtesh Ramon.
								Encompassing a vast diversity of rocks of fantastic colors and forms, this mesmerizing natural phenomenon measures 40km in length and between 2 and 10km in width, shaped like an longated heart, and forms Israel’s largest national park, the Ramon Nature Reserve.
								Far from the city lights and crowds, featuring multicolored sandstone, volcanic rock and fossils, the Ramon Crater is often described as Israel’s very own Grand Canyon.
								The truly stunning views from the 300m edge lookout point of Machtesh Ramon, reminiscent of a Hollywood backdrop offer a powerful experience for tourists from all over the world, all year round.

                            </p>

                            <div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/7.jpg"} class="img-responsive" />
								Credit: Daphna Tal
							</div>

							<h2>
                                Timna Park
                            </h2>

                            <p>
                               15,000 acres in a horseshoeshaped valley surrounded by steep cliffs, Timna Park is an extraordinarily stunning experience and an absolute treat for hiking enthusiasts. Here you'll witness the marvelous works of nature, as well as the amazing wildlife, plants and trees which make the desert their home, surviving in the harsh arid conditions.
                               With its multitude of attractions, colorful sands and craggy mountains, Timna Park is an incomparable visitor magnet.

                            </p>

                            <div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/9.jpg"} class="img-responsive" />
								Credit: Daphna Tal
							</div>

							<h2 class="title-to-play">
								CLICK TO PLAY: Timna Park - An Exhilarating Desert Adventure
							</h2>
							<div class="responisve-iframe">
							    <iframe src="https://www.youtube.com/embed/i_4QKtXIeto/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
							</div>

						

                            <h2>
							    Sandboarding in the desert
							</h2>
							<p>
								An iconic desert experience. The plush sweeping sand dunes of the Negev desert allow you to glide down sitting down or standing up at an exhilarating pace. This is a fantastic and very special skill, which once you master (it’s really very easy) you can call yourself a genuine sand surfer – how cool is that?
							</p>
							<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/1.jpg"} class="img-responsive" />
							</div>
							<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/2.jpg"} class="img-responsive" />
							</div>

							<!--<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/3.jpg"} class="img-responsive" />
							</div>-->

							<h2>
							    Negev at night
							</h2>
							<p>
								The sky of the Negev at night is a mesmerizing sight. Simply look up once darkness sets and you will immediately be struck by the splendor of millions of twinkling stars, lighting up the blue-black darkness in a radiance that can only be seen in the dessert.
							</p>

							<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/4.jpg"} class="img-responsive" />
							</div>

							<h2>
							    Sunrise at Masada
							</h2>
							<p>
								Available only to those brave enough to climb atop by foot - watching the Sunrise at Masada is undoubtedly one of the most unforgettable experiences to be had in Israel. The slow rise of the sun as it emerges over the Jordanian Moab Mountains and the Dead Sea, shedding its light on the surrounding desert landscapes, is a truly spectacular sight, one which you will not soon forget.
							</p>

							<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/6.jpg"} class="img-responsive" />
							</div>


							<h3>
                                NEGEV - ISRAEL’S MAJESTIC DESERT
                            </h3>
                            <h2>
                                Where Adventure and Inspiration Await
                            </h2>
                            <p>
                              An ideal destination for travelers who love adventure in the great outdoors.
							  The south of Israel is sparsely populated, but packed with fascinating sites and activities.

                            </p>
                            <p class="p-margin">
                                With amazing natural wonders and beauty, the South boasts magnificent views that are guaranteed to take your breath away, from sunrise to sunset.
								A desert but definitely not deserted, there is so much to see and do here – there are many extraordinary geological marvels, significant historical landmarks and wonderful nature reserves, where you can go hiking, cycling and camel riding, or enjoy adrenaline-charged safari rides in the desert.
								Simply put, this majestic Southern region is one of the country’s greatest assets and an absolute must on the itinerary.

                            </p>


							<h2>
                                Sde Boker
                            </h2>

                            <p class="p-margin">
                                A remarkable glance to the history of the State of Israel, Sde Boker is a Kibbutz originally established by pioneers, with the mission to settle the Negev in the early 50’s.
                                Sde Boker is renowned as the home of David Ben Gurion, Israel’s first Prime Minister whose home is now a museum open to the public.


                            </p>

                            <h2>
                                Vidor Center
                            </h2>

                            <p class="p-margin">
                                A truly unique attraction, offering a multi-sensory experience of the exceptional nature of the Arava region. Visitors to the center can discover advanced farming methods, the local flora and fauna, climate challenges, and special qualities of the soil and water of the desert.
                            </p>



                            <h2>
                                Nevatim
                            </h2>

                            <p class="p-margin">
                               A visit to Nevatim, the home to Cochin Jews, is a fascinating experience. Cochin Jews, originally from India, immigrated to Israel after the establishment of the State. Cochin Jews consider themselves as one of the most ancient Jewish communities in the world.
                               The Center for Cochin Heritage at Moshav Nevatim tells the story of this unique community.
                            </p>

                            <h2>
							   MidBurn Festival
							</h2>

							<p class="p-margin">
								Israel’s own version of the famous “Burning Man” festival; where for 6 days, a temporary city is set up in the Negev desert, creating a platform which allows a communal life style, creativity, art and radical self-expression.
							</p>

							<div class="responisve-iframe">
							    <iframe src="https://www.youtube.com/embed/QL3BGy2p77g/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
							</div>

							<br>

                            <h2>
                                The Bedouin Experience
                            </h2>

                            <p>
                               The Bedouin hospitality is a truly unrivalled experience, one which is both highly enjoyable and culturally engaging.
                               A group of nomadic tribes indigenous to the area and dating back many hundreds of years, the Bedouins of Israel continue to live in traditional ways, opening their hearts, their homes and their way of life to the public, to share in their customs and their world-renowned hospitality. From camel riding to traditional Bedouin meals and even overnight stays in traditional Bedouin tents - all these are immensely popular attractions with tourists in the region, and an opportunity to discover and connect with a longforgotten way of life.

                            </p>

                            <div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/8.jpg"} class="img-responsive" />
								Credit: Daphna Tal
							</div>

							<h2>
                                The Culinary Queens of Yeruham
                            </h2>

                            <p class="p-margin">
                              For a truly memorable local experience, make sure to visit the Culinary Queens of Yeruham – a unique project, in which the wonderful women of Yeroham host tourists from far and wide for an excellent traditional meal in their homes, creating an unforgettable experience of smells, colors and flavors.
                              Get to know the real life of locals through their fascinating stories, while tasting the ethnic delicacies and enjoying their amazing hospitality.

                            </p>
                            <h2>
                                The Old City of Be'er Sheva
                            </h2>

                            <p class="p-margin">
                               Said to have been founded by biblical Abraham, Be'er Sheva is one of the oldest cities in the country, with evidence of a settlement dating back thousands of years. As charming as it is historic, the old city of Be'er Sheva offers a fascinating mosaic of urban spaces, and exploring the Old City will reveal a rare wealth of unique architecture, extensive history and stories as old as time.
                            </p>
                            <h2>
                                Carasso Science Park
                            </h2>

                            <p>
                               New in the Old City of Be’er Sheva, the Carasso Science Park, spread over 4.25 acres, is the largest science park in Israel.
                               Engaging and entertaining for all ages, Carasso Science Park features an interactive museum and a scientific garden with games and hands-on activities. The park also offers ten interactive exhibitions in various fields of science including: Genetics, Communication, Microelectronics, Nuclear Energy and more.

                            </p>
                            <h2>
                                Arad
                            </h2>

                            <p class="p-margin">
                               Arad of the new millennium is a town with young spirit and rich experience. Arad and its surroundings have been blessed with beautiful landscapes, desert tranquility, and many walking trails nestled amongst untouched desert nooks, suitable for any age or style.
                               With lots of attractions and plenty of tourism sites in and around the city, Arad is the perfect starting point and your natural gate to the perfect desert vacation.

                            </p>


							<h2>
                               Yotvata Hai-Bar
                            </h2>

                            <p>
                               The Yotvata Hai-Bar Nature Reserve is the area’s largest animal breeding and reclamation center for animals before they are reintroduced into the wild. The reserve boasts wonderful attractions that are an absolute delight for animal lovers, including the predators’ center with its live predators and small desert animals, a Nocturnal animal’s observatory in dark room conditions and 12 square kilometers of ground where herds of herbivores roam free.

                            </p>

                            <div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/10.jpg"} class="img-responsive" />
								Credit: Daphna Tal
							</div>


							<h2>
                               Extreme Adventures
                            </h2>

                            <p>
                               The south of Israel is a total dream destination for adventure-hungry travelers.  Its unique and challenging terrain make for an ideal setting for various extreme sports and activities including abseiling down steep ravens and canyons, dirt biking and off road cycling which are extremely popular in this area as are the 4x4 adventure drives which are all the rage for locals and tourists alike.

                            </p>

                            <div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/11.jpg"} class="img-responsive" />
								Credit: Daphna Tal
							</div>

							<h2>
							    Camel rides
							</h2>
							<p>
								A definite throwback, this is still most authentic way to explore the marvelous desert surrounding. Riding on the back of a Camel is an activity found in a number of camel farms across the Negev and one guaranteed to last in your memory.
							</p>

							<div class="img-wrapper img-page3">
								<img src=${getImgUrl() + "/Negev/5.jpg"} class="img-responsive" />
							</div>


                            <!--NEGEV - וPDATED TEXT SITES-->

                            <h3>
                                EVENTS IN THE NEGEV: CALENDAR
                            </h3>
						


							<div class="row-1 mounth-row">
					             <div class="mounths active">
					            <p id="myHeader1" data-div="newboxes1" onClick="toggleMounth(event)" href="">January <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>


					         <div class="mounths month-mid">
					            <p id="myHeader2" data-div="newboxes2" onClick="toggleMounth(event)" href="">February <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>


					         <div class="mounths" >
					            <p id="myHeader3" data-div="newboxes3" onClick="toggleMounth(event)" href="">May <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>

					         <div class="mounths month-mid">
					            <p id="myHeader1" data-div="newboxes4"onClick="toggleMounth(event)"  href="">June <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>

					         <div class="mounths">
					            <p id="myHeader2" data-div="newboxes5" onClick="toggleMounth(event)" href="">July <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>
					        </div>



					        <div class="row-2 mounth-row">
					          <div class="mounths" >
					            <p id="myHeader3" data-div="newboxes6" onClick="toggleMounth(event)" href="">August <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>

					         <div class="mounths month-mid">
					            <p id="myHeader1" data-div="newboxes7"onClick="toggleMounth(event)"  href="">October <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>

					         <div class="mounths">
					            <p id="myHeader2" data-div="newboxes8" onClick="toggleMounth(event)" href="">November <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>


					         <div class="mounths month-mid" >
					            <p id="myHeader3" data-div="newboxes9" onClick="toggleMounth(event)" href="">December <img src=${getImgUrl() +
                        "/Negev/icon/a-down.png"} class="img-responsive icon-a-down" /></p>
					         </div>

					        </div>



					         <div class="newboxes" id="newboxes1" style="    display: block;"> <!--Jen-->
					                Round The Arava Race - The 63-kilometer bike race named after Yoni Friedman offers a breathtaking desert landscape, endless expanses of nature, the power of spirituality, serenity and serenity and a connection to an extraordinary sporting experience. The starting point and end of the race are in Moshav Hatzeva.<br>
					                <a href="https://www.arava-active.co.il/MenuDefault.aspx?id=4240" target="_blank">www.arava-active.co.il</a>
					        </div>
					        <div class="newboxes" id="newboxes2"><!--Feb-->
					                Darom Adom is an annual festival held during the Anemone flower's blossoming season in the northern Negev region. The festival offers agricultural tours, farmers' markets, and countryside lodging, as well as sports activities such as marches, race, bike tours through the red fields of the northern Negev and other activities such as artistic performances. The local tourism association "Shikma Besor" is responsible for the festival and its yearly activities.<br>
					                <a href="//daromadom.habsor.co.il/" target="_blank">www.daromadom.habsor.co.il</a>
					        </div>
					        <div class="newboxes" id="newboxes3"><!--May-->
					                The cherry festival takes place in the Yatir Forest, which is the largest forest in Israel where large orchards of orchards grow, and is a 5-minute drive from Be'er Sheva. The event includes a cherry harvest for the whole family, sweet and sour snacks, baking pita bread, sheep herding, cheese gibbon, local farmers' market, klezmer melodies, climbing wall, omega and many other activities for the whole family.<br>
					                <a href="//kinderland.co.il/events/%D7%A4%D7%A1%D7%98%D7%99%D7%91%D7%9C-%D7%93%D7%95%D7%91%D7%93%D7%91%D7%9F-%D7%91%D7%99%D7%A2%D7%A8-2017-%D7%A7%D7%98%D7%99%D7%A3-%D7%A2%D7%A6%D7%9E%D7%99-%D7%A9%D7%9C-%D7%93%D7%91%D7%93%D7%91%D7%A0/" target="_blank">www.kinderland.co.il</a>
					        </div>

					        <div class="newboxes" id="newboxes4"><!--June-->
					                Experience the magic of Ramadan nights in Rahat - when the night becomes a day and the streets are bustling with life. Join an unforgettable tour at the most special time of the year, giving a unique glimpse into Bedouin culture in Rahat. Meet the authentic dishes, absorb the fragrances of spices and roasted coffee, discover the secrets of Rahat from local guides and enjoy street performances, Debka music and more.<br>
					                <a href="//ramadan-nights.co.il/" target="_blank">www.ramadan-nights.co.il</a><br>
					                The Cinema South Festival, initiated by the School of Sound and Screen Arts at Sapir Academic College, started in 2002 with an emphasis on student films. Within a few years, however, became the festival an international film festival that provides a central stage for Israeli cinema, international quality and radical cinema. The festival takes place every year in June for five full days in various locations throughout the northern and western Negev. This is a festival that opens its doors to anyone, free of charge. The South Cinema Festival is produced from a unique cultural agenda relevant to the place where it was created.<br>
					                <a href="//csf.sapir.ac.il/csf2017/csf.sapir.ac.il/index.html" target="_blank">www.csf.sapir.ac.il</a>
					        </div>
					        <div class="newboxes" id="newboxes5"><!--July-->
					               The International Fringe Festival Beer Sheva is a multi-disciplinary festival that crosses audiences and ages and constitutes a quality stage for the best Israeli and international artists from the fields of theater, dance, music, street art and the plastic arts. The festival is considered one of the major fringe events in Israel and the largest and leading cultural festivals in the south of the country. The festival was recently received by the EFFE (European Festivals Association) and is gaining a reputation as a prestigious event.<br>
					               <a href="https://www.iffb7.com/" target="_blank">www.iffb7.com</a>
					        </div>
					        <div class="newboxes" id="newboxes6"> <!--Aug-->
					               Negev Of Stars - Like every summer, the Earth passes through the shrapnel left behind by the comet SWIFT-TATTLE. These fragments penetrate our atmosphere and create a spectacular view of "shooting stars". During this time in the Negev celebratethe people the amazing experience of the Perseid Meters, a number of astronomical events - a joint observation of the meteor shower, observation points with elaborate telescopes, lectures and many other activities.
					        </div>
					        <div class="newboxes" id="newboxes7"><!--Oct-->
					                The Tamar Festival is a combination of the ideal Israeli soundtrack and the spectacular vista of Masada and the Dead Sea region. The extraordinary experience takes place with concerts over 4 days at various locations and at different times over 24 hours, when the audience ventures out to the country's most extraordinary sites and landscapes.<br>
					                <a href="//www.tamarfestival.com/" target="_blank">www.tamarfestival.com</a><br>
					                Desert Magic Festival - The first Bedouin festival: A variety of experiential activities for the whole family that provide an authentic glimpse into the ancient Bedouin tradition.<br>
					                <a href="//www.kesem-hamidbar.co.il/" target="_blank">www.kesem-hamidbar.co.il</a>
					        </div>
					        <div class="newboxes" id="newboxes8"><!--Nov-->
					                The Arava Film Festival is a unique event that has been going on for several years every November in the heart of the Arush Nature Reserve, adjacent to Tzukim. The films at the festival are screened in the evening and in the night, under the stars in the open air. They are the first line of international production that has been screened at world film festivals in the last year. Among the films of the festival are films for children and teenagers, as well as short films produced and filmed during the past year in the Arava. The films are screened on a giant screen and the audience can relax on a spacious and surprisingly comfortable platform, which was built especially for this purpose in the valley between the mountain cliffs of the eastern Negev.<br>
					                <a href="https://www.aravaff.co.il/" target="_blank">www.aravaff.co.il</a>
					        </div>
					        <div class="newboxes" id="newboxes9"><!--Dec-->
					                Ben-Gurion's march has been taking place for more than 20 years, at the initiative of the Ramat Negev Regional Council, following the daily sporting march of the first Prime Minister, David Ben-Gurion, during his stay in Kibbutz Sde-Boker. The march takes place on three tracks – a short track for families (7 km), a medium pathway (15 km) and a long one (22 km).<br>
					                <a href="//www.zaadatbg.org.il/" target="_blank">www.zaadatbg.org.il</a><br>
					                 Docaviv Negev - Docaviv, the Tel Aviv International Documentary Film Festival, is the largest film festival in the city of Tel Aviv, and the only festival in Israel dedicated in its entirety to documentary films. In order to expose as wide an audience as possible to documentary work, the NPO also organizes a regional festivals: Docaviv Negev, held in Yeruham, as well as dozens of documentary film screenings at cultural centers located throughout the country. Each year, Docaviv NPO awards Israel’s largest prize for an original Israeli documentary production, and alongside it, prizes for the Best International Film Award, prizes for outstanding student filmmakers, and an additional prize within the Depth of Field framework, for innovative, inspiring documentary films from around the world.<br>
					                <a href="//www.docaviv.co.il/" target="_blank">www.docaviv.co.il</a>
					        </div>




                            <a href="//graphics-lapam.org.il/clients/tayarut/negev/files/assets/basic-html/page-1.html#" target="_blank">FOR MORE IMFORMATION CLICK HERE </a>


         `,
      };
    },
  },

  {
    ctg: "telavivAndJerusalem",
    isVid: false,
    id: 41,
    bgImage: "/posts/bank/46/1.jpg",
    mobBgImage: "/posts/bank/46/M/1.jpg",
    title: "Tel Aviv and Jerusalem",
    smltitle: "",
    html: function() {
      return {
        __html: `
				<h2>Nonstop fun for the whole family</h2>

              		<p>
			Travelling with kids to Tel Aviv and Jerusalem is a fantastic experience. Both cities, as is most of the country, are extremely family oriented, and from nature to culture, there is absolutely loads of amazing attractions and exciting activities for families to enjoy together. Wherever you turn, you’re likely to find children out and about with parents, grandparents or groups.              		
		</p>
              		<p>
			With up to 300 sunny days a year, the beautiful beaches of Tel Aviv are a favorite destination for locals and tourists alike. The beaches themselves offer a fabulous combination of sun and fun the Tel Aviv boardwalk to is a great place for kids to walk, run or ride along on a bike or a mini scooter, and there are plenty of playgrounds and cafes.
              		</p>
              		<p>
			For a fun day outdoors, take a picnic basket to the lovely Yarkon Park and enjoy bike riding, boating or running around. Tel Aviv also offers a multitude of hands-on museums and exhibitions, free performances, especially in the gorgeous Tel Aviv port area and outdoor entertainment guaranteed to keep visitors of all ages entertained.
              		</p>
              		<p>
			A visit to Jerusalem will ignite the imaginations of your little ones with its quaint alleyways, unique museums and fascinating history. with shady parks, water fountains and children-oriented exhibits and shows, there’s definitely something for every age.
              		</p>
              		<p>
			An incredible variety of food will keep all the kids, and adults, of your group happy. From outdoor food stalls to sit-down restaurants there is no shortage of places to eat and most restaurants and cafés offer children’s’ meals at considerably reduced rates. 
              		</p>
              		<p>
			Your visit to Tel Aviv or Jerusalem with the young ones is guaranteed to be fun and rewarding.
			Here are just a few of the fabulous ways you can have a great family time in Jerusalem and Tel Aviv, all you and yours need to do is choose and go go go: 
              		</p>
		<div class="img-wrapper">
			<img src=${getImgUrl() + "/thingsToDo/posts/35/1.jpg"} class="img-responsive" />
		</div>
              		<h3>
              			Tel Aviv
              		</h3>
              		<p>
			<strong>"Luna Park":</strong> A fantastic amusement park in the heart of the city offering a range of fun and exciting rides and attractions for the entire family. Right across from the beautiful Hayarkon Park, the green lung of Tel Aviv.
              		</p>
              		<p>
			<strong>HaYarkon Park:</strong> The tranquil Yarkon Park on the outskirts of the busy city offers beautiful green expanses, boating on the river, cycling along the bike paths, sports fields, and much more for the whole family. Enjoy a picnic with a view of the stunning Tel Aviv Skyline.
              		</p>
              		<p>
			<strong>Hot Air Balloon:</strong> After relaxing in gorgeous HaYarkon Park, get high with a view of gorgeous Tel Aviv like you’ve never seen it before, float above the Yarkon Park in an experience that is suitable for romantic trips or family fun.
              		</p>
              		<p>
			<strong>The Observatory:</strong> While in Azrieli, be sure to check out the amazing top floor observatory located on the top floor for an 360 view of Tel Aviv the little ones will not soon forget.  
              		</p>
              		<p>
			<strong>The Planetarium:</strong> Offering a fun introduction to astronomy, you’ll be transported into space by interactive exhibits, revolving seats and informative presentations to suit the whole family.
              		</p>
              		<p>
			<strong>Safari:</strong> With the largest collection of animals in the Middle East, you can spend a wonderful day in the wild, just 15 minutes from the heart of Tel Aviv, where you can check out the rest of the city’s stunning attractions.
              		</p>
              		<p>
			<strong>HaTachana:</strong> Tel Aviv’s Old Railway Station: A delight for the whole family, the Old Train Station complex offers something for everyone with restaurants, kids activities, art galleries, street performances, and even a train carriage ride.
              		</p>
              		<p>
			<strong>Tel Aviv Port:</strong> Breath in the sea air and vies from the gorgeous marina, get some food in any of the  and check out the awesome street performances of music, magic theatre and more geared specifically for the joy of the little ones. 
              		</p>
              		<p>
			<strong>Nachlat Binyamin Street Fair:</strong> The biggest of its kind in Israel, the fair is a bright and bustling experience of crafts, live music, street performances, and cafes that will appeal to people of all ages.
              		</p>
              		<p>
			<strong>Sarona:</strong> A trendy hub of restaurants, cafes, and bars, the covered market is a popular destination for couples, groups and families looking for one of the most happening places in the city.
              		</p>
              		<h3>
              			Tel Aviv Museums
              		</h3>
              		<p>
			<strong>Tel Aviv Museum of Art:</strong> With a large number of collections, guides, creative and interactive activities, and games, the museum is a treasure for parents and children alike.
              		</p>
              		<p>
			<strong>The Museum of Natural History:</strong> Opened in 2018, the 5-floor museum with its 3,000 items, gives children the possibility to see the country’s creatures right up close.
              		</p>
              		<p>
			<strong>The Olympic Experience Museum:</strong> Available via guided tours, offering an interactive glimpse into the history of sport in Israel through multimedia exhibits that are fun for the whole family.
			Independence Hall- the birthplace of the State of Israel and the birthplace of the first Hebrew speaking city, Tel Aviv. A fascinating journey through history for the entire family. 
              		</p>
		<div class="img-wrapper">
			<img src=${getImgUrl() + "/thingsToDo/posts/35/2.jpg"} class="img-responsive" />
		</div>
              		<h3>
              			Jerusalem 
              		</h3>
              		<p>
              			<strong>City of David:</strong> An immersive archeological experience in the heart of Ancient Jerusalem including archeological digs, guided tours and a walk through an underground water tunnel.
              		</p>
              		<p>
			<strong>Night Spectacular Sound & Light Show:</strong> A stunning first of its kind show where the walls of the Citadel become the stage for a nighttime show celebrating Jerusalem’s 4,000-year-old history through sights and sounds.
              		</p>
              		<p>
			<strong>The Aquarium:</strong> One of the hottest attractions in Jerusalem, opened at the end of 2017, it offers a captivating adventure through the four seas of Israel that will thrill everyone, from young to old.
              		</p>
              		<p>
			<strong>The Time Elevator:</strong> Immerse yourself in virtual reality on a journey through the fascinating history of Jerusalem, with shaking seats and special effects that will amaze the youngsters among you.
              		</p>
              		<p>
			<strong>The Botanical Gardens:</strong> A stunning gem in the heart of the city featuring more than 6,000 species of plants from around the world, it is an interesting and tranquil location for anyone to enjoy.
              		</p>
              		<p>
			<strong>Segway Tours:</strong> Suitable for older teens to adults, Segway tours offer an unforgettable experience through fascinating areas, allowing you to enjoy the modern to the ancient character of the city.
              		</p>
              		<p>
			<strong>Mini Israel:</strong> Offering hundreds of mini replicas of Israeli landmarks, it offers a unique birds-eye view of historical, religious, and modern sites around the country.
              		</p>
              		<h3>
              			Jerusalem Museums
              		</h3>
              		<p>
              			<strong>Israel Museum:</strong> A leading art and archeological museum absorbing you in the rich history and culture of the country and its people, with exhibits to interest visitors of all ages.
              		</p>
              		<p>
			<strong>The Tower of David Museum:</strong> The historic entrance to the Old City of Jerusalem, the medieval citadel features 3D models, hidden passageways, and family tours and activities.
              		</p>
              		<p>
			<strong>Ein Yael Active Museum:</strong> Providing an experiential journey through an old Roman street, creative workshops, pita baking, and one-on-one meetings with period actors, families will love this day out.
              		</p>
              		<p>
			<strong>The Bloomfield Science Museum:</strong> A fantastic children oriented cultural and educational museum, that presents exhibitions and interactive exhibits on subjects of science and Technology. 
              		</p>

            	`,
      };
    },
  },

  {
    ctg: "telaviv",
    isVid: true,
    vidId: "ogEN7aRT0SM",
    id: "Party_Capital",
    bgImage: "/posts/bank/party-capital/1.jpg",
    mobBgImage: "/posts/bank/party-capital/M.jpg",
    title: "Party Capital",
    smltitle: "",
    html: function() {
      return {
        __html: `

						<div class="ac-cradit">
							<span class="ac-cradit-text">Credits:</span>
								<br/>
								<span class="ac-cradit-text-1">Tel Aviv Jaffa municipality<br/></span<
								<span class="ac-cradit-text-2">UDINI prodactions<br/></span>
							</div>
							<p></p>
						</div>

                            <h2>Epic Nights in the non stop city</h2>
              		        <p>Tel Aviv is rightly famous as one of the world’s great nightlife cities, with her warm Mediterranean climate making it ideal to party outdoors for most of the year. As the sun goes down the city transforms into a welcoming nighttime experience that’s pulsing with life.</p>

                            <h3>Tel Aviv by Night</h3>
                            <p>No matter what time it is, there’s always something going on in Tel Aviv. Watch the sun go down at a casual beach bar, feet in the warm sand and a cold drink in your hand, before moving on to taste craft brews in a packed, friendly pub, enjoy an exotic cocktail in a relaxed bar or eat something delicious before heading off to one of Tel Aviv’s pumping, pulsing clubs to dance the night away.</p>
                            
                            <p>Foodies will love the amazing cocktails mixed by Tel Aviv’s expert baristas, Israel’s lively pub scene serving craft beers and snacks, and the restaurants that range from elegant to casual to street pop-ups, offering every possible style and type of food. Eat your heart out!</p>
                            <div class="img-wrapper">
			                    <img src=${getImgUrl() +
                            "/posts/party-capital/1.jpg"} class="img-responsive" />
		                    </div>
                            <h3>Making the Most of Tel Aviv’s Nightlife</h3>
                            <p>Spend a relaxed evening in an upmarket wine bar in a trendy neighborhood like Neve Tzedek, where you’ll be introduced to some of Israel’s highly acclaimed wines. Move on to chill at one of the many bars that feature live bands, or enjoy some culture with your cocktails in one of Tel Aviv’s new and exciting gallery bars that display pieces by up and coming artists.</p>

                            <p>If you want a pumping party night on the town, Tel Aviv is the right place to find it. Tel Aviv’s nightclubs are world-famous, often hosting international DJs. During the long summer season some of the beaches transform into nightclubs for all-night raves, with throbbing beats, lasers and pulsing music. The party doesn’t reach full swing until 2am in most of Tel Aviv’s wildly popular nightclubs, manned by top DJs. You’ll find every time of club, from intimate to massive and from throwback dance to the newest electric indie beats.</p>

                            <p>The LGBTQ scene is also hot in Tel Aviv, with some of the best parties and music nights hosted by gay-friendly clubs and bars. Whether you want chilled or full-on, cultural or flirty, you’ll find countless places to hang out at every hour of the day and night.</p>
                            <p>Tel Aviv’s awesome nightlife scene has become famous worldwide. The city the doesn’t stop is teaming up with endless possibilities designed for an epic night out! </p>
                            <p>Start slow and easy in a bar at the chilled out Port of Tel Aviv, or grab yourself a shoreline table, perhaps at Jerusalem Beach. Order a beer, feel the sand between your toes, and watch the sunset.</p>
                            <p>Now that you’re in a mellow mood, it’s time to get your groove on. you’ll be spoiled for choice with upscale clubs, bracelet bars, and other hangouts around Tel Aviv’s White City, Rothschild Boulevard and nearby streets (Levontin, Yehuda HaLevi, Lillenblum, and Allenby), with their trendy see and be seen vibe, filled with young party people all night long. </p>
                            <div class="img-wrapper">
			                    <img src=${getImgUrl() +
                            "/posts/party-capital/2.jpg"} class="img-responsive" />
		                    </div>
                            <p>A five-minute cab ride southwest and you can visit the more mellow upscale bars in Neve Tzedek. Alternatively, a ten-minute ride south takes you to the underground scene in the newly-trendy hipster heaven of the Florentin neighborhood, and of course don’t miss the up and coming hipster style Flea Market area in Jaffa.</p>
                            <p>Want a more mainstream approach to a night on the town? Three streets – King George, Dizengoff, and Ibn Gabirol – will be just right for you, allowing you a chance to interact with the locals and be part of the authentic nightlife scene of the city.</p>
                            <p>Wherever you go, you will always find where to have an awesome night in nonstop Tel Aviv! </p>

            	`,
      };
    },
  },

  {
    id: "Mamilla_Avenue",
    bgImage: "/posts/bank/mamila-avenue/1.jpg",
    mobBgImage: "/posts/bank/mamila-avenue/M.jpg",
    title: "AVENUE MAMILLA UNE PROMENADE ARTISTIQUE",
    smltitle: "",
    ctg: "jerusalem",
    isVid: true,
    vidId: "V0Acsw3Hf_M",
    html: function() {
      return {
        __html: `
                               

		                            <br/><h2  class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Les magasins de luxe modernes se marient à la splendeur de l'ancienne Jérusalem</h2>
									<p>L'Avenue Alrov Mamilla se trouve au carrefour de l'ancienne et de la nouvelle Jérusalem, face aux magnifiques remparts de la ville ancienne et à seulement quelques pas de la Porte de Jaffa et du Mur occidental. Proche de la vieille ville, cette galerie marchande à ciel ouvert est aussi prisée des habitants que des touristes, parce qu'elle leur apporte le meilleur des deux mondes - une histoire riche, la culture locale et des commerces de luxe, dans un lieu privilégié de renommée internationale.</p>

									<p><strong>Un complexe moderne de divertissement au pied de la vieille ville de Jérusalem </strong></p>
									<p>Foulez les rues pavées de Jérusalem et intéressez-vous aux plaques qui relatent l'histoire des structures historiques du quartier.&nbsp; Assistez aux représentations de théâtre de rue, prenez place dans l'un (ou plus) des restaurants et cafés locaux et appréciez la qualité et la diversité des boutiques proposant des marques locales et internationales.</p>
									 <div class="img-wrapper">
			                             <img src=${getImgUrl() +
                                     "/posts/mamila-avenue/1.jpg"} class="img-responsive" />
		                             </div>
									<p>Le soir, allez-vous relaxer dans l'un des excellents bars du quartier. En levant la tête, vous pourrez admirer la vue spectaculaire de la vieille ville qui s'étend juste devant vous. Il n'existe aucun lieu semblable au monde.</p>
									<p><strong>Visitez les rues qui font le lien entre la ville ancienne et la ville moderne&nbsp; </strong></p>
									<p>L'avenue Mamilla est un complexe contemporain de divertissement qui offre aux visiteurs un aperçu de la culture riche, originale et toujours innovante de Jérusalem.</p>
									<p>Pour profiter pleinement de ce que l'avenue Mamilla a à vous offrir, allez la visiter par temps ensoleillé. En été, chaque nuit, des milliers de personnes déambulent sur l'avenue et assistent à toutes sortes d'événements culturels. Allez les rejoindre pour apprécier les foires d'art de rue et les expositions en plein air, le théâtre de rue, les clowns, les acrobates, les percussionnistes et les spectacles musicaux quotidiens.&nbsp;Il y a tant de choses à voir et à faire que vous ne voudrez plus partir.</p>

            	`,
      };
    },
  },

  {
    ctg: "jerusalem",
    isVid: true,
    vidId: "nLKWDp5uA-U",
    id: "First_Time_In_Jerusalem",
    bgImage: "/posts/bank/first-time-in-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/first-time-in-jerusalem/M.jpg",
    title: "FIRST TIME IN JERUSALEM",
    smltitle: "",
    html: function() {
      return {
        __html: `

				<h2>The must list for the first-time visitor</h2>

              		<p>
						Scour the globe it’s hard to match Jerusalem for history, culture, and significance! So rich in sites and activities, it’s difficult to know where to begin. Here are a few suggestions…
              		</p>
					<p>
						Jerusalem is the nexus of three of the world’s great faiths. As such, you might want to consider religious, spiritual, or historical locations that will be meaningful to you.
					</p>
					<p>
						Almost any itinerary will include Old City. Famous as the home of the Western Wall, and the Church of the Holy Sepulcher, you could spend days exploring its four quarters – Jewish, Christian, Muslim, and Armenian – and only see but a small part of its many treasures. Make sure to download the free Audio Tours of Jerusalem app, which offers dozens of walking routes, GPS maps, and geo-location alerts as you approach each site.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/first-time-in-jerusalem/1.jpg"} class="img-responsive" />
					</div>
					<p>
						A five-minute cab ride southwest and you can visit the more mellow upscale bars in Neve Tzedek. Alternatively, a ten-minute ride south takes you to the underground scene in the newly-trendy hipster heaven of the Florentin neighborhood, and of course don’t miss the up and coming hipster style Flea Market area in Jaffa.
					</p>
					<p>
						Want a more mainstream approach to a night on the town? Three streets – King George, Dizengoff, and Ibn Gabirol – will be just right for you, allowing you a chance to interact with the locals and be part of the authentic nightlife scene of the city.
					</p>
					<p>
						Wherever you go, you will always find where to have an awesome night in nonstop Tel Aviv!
					</p>
            	`,
      };
    },
  },

  {
    ctg: "telavivAndJerusalem",
    isVid: false,
    id: 44,
    bgImage: "/posts/bank/travelling-on-budget/1.jpg",
    mobBgImage: "/posts/bank/travelling-on-budget/M.jpg",
    title: "TRAVELLING ON A BUDGET",
    smltitle: "",
    html: function() {
      return {
        __html: `

              		 <h2>Making It Count in Tel Aviv and Jerusalem!</h2>

              		<p>
						So you’ve heard of the stunning beaches, the amazing sights and the fabulous cuisine and you are looking to travel to Jerusalem and Tel Aviv, but affordability is a concern. Well, pack your bags and worry no more! Both cities offer low-cost accommodations, transportation, and meals, as well as countless sites to see and things to do, which require little or no expense.
              		</p>
					<p>
						For affordable accommodation you can choose from the many hostels and smaller hotels, many of which are located only a few minutes’ walk from Tel Aviv’s Beaches and Jerusalem’s main attractions.
					</p>
					<p>
						Getting around? In both cities it’s a snap with a Rav Kav card. Purchase one for little more than a dollar at”Al Hakav” (on the line) Service centers at central stations and other locations around the city. Jerusalem also offers an affordable City Pass option, and in Tel Aviv, the Tel Ofan bicycle rental municipal service is a great and low cost way to get around in the city.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/80/1.jpg"} class="img-responsive" />
					</div>
					<p>
						What to do? Jerusalem and Tel Aviv are packed with sites, marketplaces, parks, nearby nature reserves and hiking trails. There are endless ways to not spend a dime and fill your trip with unforgettable experiences.
					</p>
					<p>
						Finally, everyone’s gotta eat, from hummus to gourmet, both cities are famous for great street food and low-price restaurants offering cheap lunch time dining.
					</p>
					<p>
						So come visit Tel Aviv and Jerusalem where you are guaranteed a fantastic time without breaking the bank.
					</p>
            	`,
      };
    },
  },

  {
    ctg: "jerusalem",
    isVid: false,
    id: 45,
    bgImage: "/posts/bank/upscale-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/upscale-jerusalem/M.jpg",
    title: "UPSCALE JERUSALEM",
    smltitle: "",
    html: function() {
      return {
        __html: `
                    <h2>Modern luxuries for the pampered traveler</h2>
              		<p>
						When it comes to luxury travel, high class accommodations, fine dining, and top-drawer shopping options Jerusalem is a city that’s truly arrived.
              		</p>
					<p>
						The city features numerous 5-star and boutique hotels ready to custom cater to your needs for comfort and relaxation, offering amazing rooftop views and inhouse spa treatments to boot.
					</p>
					<div class="img-wrapper">
						<img src=${getImgUrl() + "/thingsToDo/posts/81/1.jpg"} class="img-responsive" />
					</div>
					<p>
						Looking to delight your palette? Well, in 2018, several Jerusalem establishments were listed in the prestige French restaurant guide, Gault & Millau. Beyond that, the city features and is increasingly attracting some of the world’s best chefs.
					</p>
					<p>
						When it comes to style, fashion, and swanky shopping, Jerusalem has any number of places you’ll want to visit. Among these are Arlov Mamilla Avenue. This happening and trendy outdoor mall complex is a must for your go-to city destinations. Even better, it’s situated just steps away from the Old City’s Jaffa Gate.
					</p>
					<p>
						Another not-to-be-missed stop on your itinerary is the elegant The First Station. For over 100 years a railway depot, the site has been transformed into an urban shopping and culinary mecca that’s chock-a-block with restaurants, shops, art galleries and an artists’ marketplace three days a week, as well as live performances and more.
					</p>
					<p>
						And as long as you’re in the neighborhood, treat yourself to a romantic afternoon or evening on Emek Refaim Street, the German Colony’s main thoroughfare. Its beguiling architecture laid back mood, stylish boutiques, intimate restaurants, and 1920s-era cinema offer an absolute treat for all the senses.
					</p>
            	`,
      };
    },
  },

  // End Posts

  {
    id: 5,

    ctg: "deadsea",
    isVid: false,
    bgImage: "posts/bank/100/1.jpg",
    mobBgImage: "posts/bank/100/M.jpg",
    title: "Dead Sea Joys",
    smlTitle: "",
    html: function() {
      return {
        __html: `
					<h2>For a floating good time</h2>

			              <p>
			                              A geological wonder in a uniquely serene setting, the Dead Sea is an extremely popular tourist attraction. 
			                              Experience the calm tranquility of the water with its distinct healing properties while enjoying the unparalleled beauty of the surrounding landscape. 
			                              <strong>The Dead Sea, also known as the oldest natural spa in the world, is blessed with an extremely high salt concentration of 31.5%, 
			                              allowing tourists from far and wide the amazing experience of effortlessly floating on the waters of the lowest place on Earth. 
			                              While here, you can bathe</strong> in the healthy black mud of the area or explore the fascinating and historically rich nearby landscapes.
			              </p>

			              <p>
			                              Luxury hotels, varied cuisine from gourmet restaurants to fast food eateries, great souvenir shops, the extraordinary history of the nearby Masada, and many cultural activities throughout the year, make the Dead Sea a popular destination for local tourists as well as International visitors.
			              </p>
			              
			`,
      };
    },
  },

  // {
  // 	id:"Ultimate_Beach_Fun",
  //                bgImage : "/posts/bank/17/1.jpg",
  //         	mobBgImage : "/posts/bank/17/M.jpg",
  //               title : "ULTIMATE BEACH FUN",
  //               ctg:"telaviv",
  //               isVid:true,
  //               vidId:"I9a4BFWO_6w",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  //             		<p>Israel has a wide selection of beaches to choose from. The wide Mediterranean stretch along the west side of the country boasts wide golden sands and the gorgeous blue waves of the med.</p>

  //         		 	<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/24/1.jpg"} class="img-responsive" />

  // 					</div>

  //             		<p>Up North the Sea of Galilee have some lovely beaches where you can camp out, barbeque and really make a day of it. The Galilee offer boat hire and water sport equipment for some water fun!</p>

  //             		<div class="videoWrapper">
  // 						            <iframe width="100%" height="400px" src="https://www.youtube.com/embed/8p4qfkneH1c?autoplay=1&amp;controls=0&amp;loop=1&amp;rel=0&amp;playlist=8p4qfkneH1c&amp;modestbranding=1&amp;autohide=1&amp;showinfo=0" frameborder="0" allowfullscreen=""></iframe>
  // 						        </div>

  //                                 <p>The Dead Sea’s desert beaches possess a unique atmosphere in the clear air and of course a sea which is not for swimming but for floating and taking care of your skin.</p>

  //                                 <p>Last but not least the beaches in Eilat boast crystal clear blue waters of the Red Sea that are very seldom wavey. Eilat is known for its beautiful diving spots and swimming with dolphins. They have wonderful beach bars, restaurants, water sports and attractions a perfect destination for holiday makers.</p>

  //             	 `
  //     }
  //   }
  // },

  {
    id: "Purchases_In_Israel",
    bgImage: "/posts/bank/purches-in-israel/1.jpg",
    mobBgImage: "/posts/bank/purches-in-israel/M.jpg",
    title: "DES ACHATS UNIQUES À ISRAËL",
    ctg: "jerusalem",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `
              
              
                                <p>En Israël, le shopping va au-delà de la simple acquisition d'objets&nbsp;: c'est le meilleur moyen de penser à vos proches et à vos amis restés au pays, car vous allez leur rapporter (ou vous offrir à vous-même) un sac, une bouteille ou une boîte symbolisant les merveilles que vous avez vécues. En vous promenant sur les marchés, dans les boutiques et les galeries, vous verrez une incroyable variété de produits. Cela signifie que vous trouverez quelque chose pour tout le monde et que vous aurez du plaisir à faire votre choix.</p>
								
            		            
                                <p><strong>De magnifiques souvenirs du Moyen-Orient </strong></p>
								<p>Certains des souvenirs les plus chargés de sens vous attendent dans les lieux saints d'Israël, en Galilée et à Jérusalem. De superbes poteries arméniennes bleu et blanc ornées de thèmes familiers relatifs aux lieux saints sont très appréciées comme souvenirs, et utiles en tant que vaisselle. Le bois d'olivier et la nacre, des matériaux artisanaux utilisés depuis des siècles, ornent aujourd'hui des bibles, des boîtes, des broches et de nombreux autres articles qui seront un souvenir vivant de votre visite.</p>
								 <div class="img-wrapper">
						               <img src=${getImgUrl() +
                             "/posts/purches-in-israel/1.jpg"} class="img-responsive" />
						
					               </div>
								<p><strong>La Judée unique</strong></p>
								<p>Et quel meilleur moyen de se rappeler de Safed, Jérusalem, Jaffa et d'autres centres judaïques que de recouvrir votre table de Shabbat ou de jour saint avec une couverture de challah ou de matzah brodée à la main (légère et facile à emballer !), ou avec des bougies, une coupe de kiddouch ou une ménorah de Hannoucca de style contemporain ou traditionnel, en argent, étain, verre ou céramique. Les mezouzahs sont le parfait cadeau pour une pendaison de crémaillère, et un châle de prière constituera un souvenir pour un Bar/Bat Mitzvah.</p>
								<p><strong>Les produits minéraux de la mer Morte</strong></p>
								<p>Israël abrite le plus grand spa en plein air du monde – la mer Morte – et après un bain dans son eau richement minéralisée, votre peau et vos cheveux seront aussi doux que de la soie. Et oui, ils la mettent en bouteille&nbsp;! Vous pouvez acheter une gamme complète de produits minéraux de la mer Morte, tous magnifiquement emballés, pour un cadeau parfait en provenance d'Israël.</p>
								<p><strong>Shopping </strong></p>
								<p>Lors de votre séjour, vous voudrez certainement parcourir les magasins d'usine ou les boutiques de stylistes israéliens mondialement connus. D'adorables vêtements de bébé 100 % coton fabriqués en Israël rentreront sans problème dans votre valise déjà bien remplie et feront un magnifique cadeau pour fêter une naissance. Vos chaussures n'ont pas résisté à votre périple en Israël ? Avant la fin de votre séjour, achetez une paire de sandales ou chaussures légères fabriquées en Israël, à des prix que vous ne trouverez pas chez vous.</p>
								<p><strong>Joaillerie </strong></p>
								<p>Partout dans le monde, les bijouteries les plus réputées exposent les créations de joaillers israéliens. Étant en Israël, vous pouvez vous approvisionner directement à la source. Vous serez séduite par les bracelets tendance avec leurs cristaux et leurs perles multicolores offrant une infinité de motifs, tout comme par les créations en malachite vert-bleu (pierre d'Eilat). Lorsque vous les porterez, tout le monde saura que vous êtes allée en Israël.</p>
								<p>Israël est depuis longtemps célèbre pour ses diamants taillés et polis ainsi que pour l'expérience, les connaissances et les compétences de ses experts en diamant. Israël est un pays exportateur de diamants, ce qui vous permettra de bénéficier de tarifs avantageux. Pour tout apprendre sur cette activité, vous pouvez également visiter un atelier de taille et de polissage de diamant.</p>
								<p><strong>N'oubliez pas la nourriture </strong></p>
								<p>Israël est célèbre dans le monde entier pour la qualité de sa cuisine. Il ne faut donc pas hésiter à rapporter chez vous des produits alimentaires emballés. Pour votre chef favori, vous pouvez ramener des épices comme l'hysope de la Bible, des dattes sucrées joliment emballées qui seront appréciées par vos collègues de travail, et un large éventail de tisanes, miels, vins primés et d'autres produits.</p>
								<p>Et lorsque vous vous rendrez à l'aéroport avec vos cadeaux, vous apprécierez de bénéficier d'un remboursement de la TVA pour les achats de plus de 100$ réalisés dans les magasins participants.</p>
								            	

            	 `,
      };
    },
  },

  {
    id: "Jerusalem_Fun",
    bgImage: "/posts/bank/jerusalem-fun/1.jpg",
    mobBgImage: "/posts/bank/jerusalem-fun/M.jpg",
    title: "JERUSALEM FUN",
    ctg: "jerusalem",
    isVid: true,
    vidId: "nLKWDp5uA-U",
    smltitle: "",
    html: function() {
      return {
        __html: `
              
                               <p>Planning a trip to Jerusalem usually involves its many sights of culture and historical significance. However, just as important to many, Jerusalem’s has an amazingly cool after dark scene, filled with music, hipster hangouts, dance clubs, and much more.</p>
                                <div class="img-wrapper">
						               <img src=${getImgUrl() +
                             "/posts/jerusalem-fun/1.jpg"} class="img-responsive" />
						
					               </div>
                                 <p>To check it out, make your way to the <b>City Center</b> and explore the narrow streets just off <b>Jaffa Street</b>. There you’ll find bars and nightclubs that range from comfortably mainstream to eccentrically funky. <b>Rivlin Street</b> is a popular hangout for young people, while <b>Shoshan Street</b> and the surrounding area offers a more laid-back grown up vibe.</p>

                                 <p>Machane Yehuda market offers a surprisingly awesome night out as in the evening it transforms into a trendy hotspot where vendor stalls and shops become the setting for bars, DJs, live music, and dancing.</p>
                                 <p>Betzalel Street is famous for its student artsy vibe and the many little bars are a great place to befriend the locals who come for a drink and a jam session.</p>

                                 <p>For a daytime change of pace head to the <b>German Colony (Moshava)</b> and, particularly, the neighborhood of <b>Baka</b>. Start at <b>Beit Lechem Street</b> where you’ll have your choice of popular, contemporary restaurants and bars. Then stroll all the way up <b>Emek Refaim Street</b> or through <b>HaMesila (Railway) Park</b> until you reach The <b>First Station</b> – once a railroad depot in use for over a century, it transformed now into a trendy culinary, cultural, and retail delight.</p>
                           
            	 `,
      };
    },
  },

  // {
  // 	id:"Western_Wall_Wonders",
  //               bgImage : "/posts/bank/30/1.jpg",
  //               mobBgImage : "/posts/bank/30/M.jpg",
  //               title : "WESTERN WALL WONDERS",
  //               ctg :"jerusalem",
  //               isVid:false,
  //               player_id_post :"",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  // 				<p>
  // 					The Western Wall (or Kotel, in Hebrew) was part of the most magnificent building Jerusalem had ever seen, which was the Second Temple, built by the great King Herod.
  // 				</p>

  // 				<p>
  // 					The Second Temple was destroyed in the year 70 CE and despite the destruction that took place, all four of the Temple Mount support walls remained standing.  Throughout the generations since the Temple’s destruction, the Western Wall was the remnant closest to the site of the Temple’s ‘holies of holies - a place where only the Jewish High Priests were allowed, as it was there they believed God was present.  The actual remains of the Temple can be found the Western Wall Tunnels, which are an extraordinary journey through time.
  // 				</p>

  //              	<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/27/1.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					For centuries Jewish People from around the world have been going there to mourn the loss of this grand temple. You will often find hundreds of people of different nationalities and religions’ pouring out their heart with prayers as the wall is believed to have enormous spiritual significance.
  // 				</p>

  // 				<p>
  // 					It is tradition for the people that visit to write a note and place it in the cracks of the Western Wall, as it is believed the message will be taken to God. You will often find doves resting in the crevices of this impressive structure, which are a symbol of peace.
  // 				</p>

  // 				<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/27/2.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					The Western Wall is a national symbol as the ancient bricks have seen Israel and the Jewish peoples  birth, exile and redemption. It’s a very popular location for national ceremonies and even Bar Mitzvah to take place
  // 				</p>
  // 				<p>
  // 					For more information   <a  target="_blank" href="//www.thekotel.org">www.thekotel.org</a>
  // 				</p>

  //             	 `
  //     }
  //   }
  // },

  // {
  // 	id:28,
  //              bgImage : "/posts/bank/white-city-splendor/1.jpg",
  //               mobBgImage : "/posts/bank/white-city-splendor/M.jpg",
  //               title : "WHITE CITY SPLENDOR",
  //               ctg:"telaviv",
  //               isVid:false,
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  // 				<p>
  // 					Tel Aviv’s “WHITE CITY” is a UNESCO World Heritage Site, because the city is home to more Bauhaus, modern and “International” architecture than any city on earth.
  // 				</p>

  //              	<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/28/1.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					Tel Aviv was founded in 1909 as a garden suburb of the crowded port city of Jaffa. Very quickly it grew into a bustling metropolis so that by 1929, it was a flourishing city that was the apex of the Zionist dream. With the rise to power of Hitler in 1933, dozens of German Jewish architects escaped to Palestine – many of whom were students or graduates of the legendary Bauhaus school of design. The burgeoning of Tel Aviv required more and more buildings, and the arriving architects very quickly adapted their northern European Bauhaus design to the needs of the eastern Mediterranean heat. A walk through central Tel Aviv will bring you face to face with dozens of these extraordinary office buildings, apartment buildings and stores.
  // 				</p>

  // 				<p>
  // 					<a  target="_blank" href="//www.bauhaus-center.com/">www.bauhaus-center.com/</a>
  // 				</p>

  //             	 `
  //     }
  //   }
  // },

  // {
  // 	id:"Tower_Of_David_Museum",
  //               bgImage : "/posts/bank/30/1.jpg",
  //               mobBgImage : "/posts/bank/30/M.jpg",
  //               title : "TOWER OF DAVID MUSEUM",
  //               ctg:"jerusalem",
  //               isVid:false,
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  // 				<p>
  // 					Jerusalem’s Citadel, known as the “Tower of David”, is a historical and archaeological asset of international significance. The Tower is a medieval fortress that is located near the Jaffa Gate, the historical entrance to the Old City and has been the symbol for the city of Jerusalem for generations.
  // 				</p>

  //              	<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/29/1.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					At the Tower of David Museum you are presented with Jerusalem’s astounding story. While absorbing yourself in legends of the past and their dramatic chronicles it will not take you long to realise that the very stones of the museum are part of this city’s living history.
  // 				</p>

  // 				<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/29/2.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					The 500-year-old walls are part of the Turkish citadel; its name derives from a tower so massive that early Jerusalemites ascribed it to their great King David and despite the name being ‘The Tower of David’ it was actually build by King Herod.
  // 				</p>

  // 				<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/29/3.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					Your visit can begin with a breath-taking view of old and new Jerusalem from the top of the tower. Each ancient room has been revamped to showcase a different period, allowing the tempestuous events of 4,000 years to fall perfectly into place in your mind.
  // 				</p>

  // 				<div class="img-wrapper">
  // 						<img src=${getImgUrl() +  "/thingsToDo/posts/29/4.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					The windows frame glimpses of modern Jerusalem, and with each doorway you exit, you look down into the citadel’s central courtyard, where archaeologists have unearthed remains dating from the Maccabees to the Middle Ages. This incredible site really is a maze of time!
  // 				</p>

  // 				<p>
  // 					The museum also utilizes its unique space for multi-sensory exhibits by leading designers and artists from Israel and abroad. This One of a kind museum hosts the annual ‘Night Spectacular’ which is a unique sound and light show where the whole of the Citadel is lit up with stunning designs!
  // 				</p>

  // 				<p>
  // 					For more information:   <a href="//www.tod.org.il/en/">www.tod.org.il/en/</a>

  // 				</p>

  //             	 `
  //     }
  //   }
  // },

  {
    id: "Must_Eat_In_Jerusalem",
    bgImage: "/posts/bank/must-in-jerusalem/1.jpg",
    mobBgImage: "/posts/bank/must-in-jerusalem/M.jpg",
    title: "MESMERIZING AND MAGICAL CITY",
    ctg: "jerusalem",
    isVid: true,
    vidId: "2CSCe2WC7Ns",
    smltitle: "",
    html: function() {
      return {
        __html: `
            
                                <p>
						            Jerusalem is a mesmerizing and magical city. Many people who visit Jerusalem rave about the amazing atmosphere, the unforgettable sites, the breathtaking views and more. However, to truly understand what Jerusalem is all about, there are some things that you simply have to experience through your stomach. Here are just a few of the things you really should try while visiting Jerusalem:
						        </p>
                               <div class="img-wrapper">
						                 <img src=${getImgUrl() +
                               "/posts/must-in-jerusalem/1.jpg"} class="img-responsive" />
				                 </div>

							    <p><strong>Malabi:</strong> A unique a combination of beverage and dessert, made of a mixture of rosewater, milk, cornstarch and sugar. Malabi is a very popular Jerusalem dish, sold in many middle eastern restaurants and kiosks throughout the city. Guaranteed to be nothing like anything you have ever tasted.</p>

                                <p><strong>Knafe:</strong> A very interesting and sensationally tasty dish when served and eaten fresh. Knafe is essentially an Arabic desert made of melted goats cheese and topped with hairs of orange pastry hairs, dipped in sweet rosewater syrup. Finding the perfect Knafe is a mission, once you find it, eating it becomes an addiction.</p>

                                <p><strong>Jerusalem Pretzel:</strong> An absolute must when touring the fascinating sites of the old city is stopping by one of the small green carts and purchasing an authentic Jerusalem pretzel. Along with it, you will get a fragrant local green herb called Zaatar which goes great with the delicious warm doe.</p>

                                <p><strong>“Meorav Yerushalmi”:</strong> Directly translates to “Mixed Jerusalem” this delicious mix of different meats in a special local blend of spices is an absolute carnivores’ heaven.</p>

                                <p><strong>“Ashtanur”:</strong> Short in Hebrew for “fire in the oven” Ashtanur is an authentic local pitta bread which you can find in midtown or the markets during lunchtime. If you’re especially hungry, try it wrapped around a portion of shawarma or falafel.</p>

                                <p><strong>Sabich:</strong> an absolute original, the Sabich is a truly unique local dish comprised of a Pitta bread packed with fried eggplant, hard-boiled eggs, and pickles, usually topped by Amba, a local, flavorful condiment. Once you try it, you’ll be hooked for life.</p>
                                
                
            	 `,
      };
    },
  },

  {
    id: "Jerusalem_Arts",
    bgImage: "/posts/bank/jerusalem-art/1.jpg",
    mobBgImage: "/posts/bank/jerusalem-art/M.jpg",
    title: "JERUSALEM’S ART",
    ctg: "jerusalem",
    isVid: false,
    smltitle: "",
    html: function() {
      return {
        __html: `
            
                                <h3>Finding Inspiration in Jerusalem</h3>

                                <p>There's no doubt Jerusalem is one of the most fascinating cities in the world. Its fusion of diverse religions, traditions, ancient history and modern city life intrigues visitors for centuries. It's also what attracts artists there. Today's Jerusalem is full of Museums, galleries, marketplaces and cultural festivals, which together form a vivid and unique Art and Culture scene. Prepare to be inspired.</p>

                                <p>Discover. On a hill next to the Knesset and Israel's Supreme Court, situated Israel's largest cultural institution and one of the world's leading museums in art and archeology, The Israel Museum. Start with the archeological wing. Organized chronologically, the pieces there form the most extensive collection in the world for biblical and Holy Land archeology. Continue to the outstanding Jewish Art and Life wing, the impressive Fine Arts collection and the rotating contemporary art exhibitions. Don't miss few of the museum's highlights – The Shrine of The Book which holds the Dead Sea Scrolls and the stunning Art Garden looking over the Jerusalem Mountains. Tip: Give yourself time. It's an accessible, fascinating museum and there's so much to see.</p>
                                <div class="img-wrapper">
						                <img src=${getImgUrl() +
                              "/posts/jerusalem-art/1.jpg"} class="img-responsive" />
				                </div>
							    <small style="color:#000; display:block;">
                      		        Credit: Noam Chen
                      	        </small>

								<p>In close proximity to the Israel Museum you'll find the riveting <strong>Bible Lands Museum</strong>. Describes as "an interactive time capsule", it's the only museum of its kind in the world. Tour through the galleries and discover the wonders of the lives of ancient cultures in the Near East and their interrelations from the dawn on of civilization to the early Christian era.</p>

                                <p><strong>Experience</strong>. Go to <strong>The Artists' Colony of Jerusalem</strong> (Hutzot Hayotzer) and experience creativity. This Art and Craft complex is a workplace for artists and designers from various fields. Stroll down this picturesque boulevard of shops and galleries underneath the northern walls of the Old City and see artists at work. Hear stories, learn about traditional and more contemporary art techniques and purchase works directly from the artists.</p>

                                <p>See the <strong>Tower of David Light Show</strong>, known as the Jerusalem Night Spectacular. This truly stunning show combines modern technology with the city's history and the beauty of the Tower. You'll witness the walls and walkways comes alive with a 3D light show and vibrant music that pulls the viewer into an almost dreamlike experience.</p>

                                <p><strong>Celebrate</strong>. Jerusalem has rich history but it's also a bustling modern city that loves to celebrate. Make sure to check the city's rich schedule of festival and cultural events and enjoy of the best Jerusalem has to offer throughout the year.</p>

                                <p>Celebrate <strong>The Israel Festival</strong>, Israel's prominent multidisciplinary international festival that presents a large variety of outstanding theatre, contemporary dance, classical music and performance from all around the world. Join the Jerusalem Arts and Craft fair Hutzot Hayotzer where you'll meet Israeli and international artists and listen to great music; visit Jerusalem Night Market and stroll through the many stalls set by all types of artists and designers, showing off and selling their wares; Experience the Light in Jerusalem Festivalthat provides a dramatic unique and artistic dimension to the old city through use of light; listen to opera in the Jerusalem Opera Festival. Set in the Sultan pool, you'll watch great performance with the great Jerusalem night summer air and stunning view as a backdrop.</p>

                                <p>Don't miss the Jerusalem Sacred Music Festival. As part of the Jerusalem Season of Culture, this extraordinary festival brings together diverse artists from huge array of fields, cultures and traditions that show and explore 'sacred' music from all around the world.</p>
            	
                
            	 `,
      };
    },
  },

  {
    id: "All_Sensory_Markets",
    bgImage: "/posts/bank/1.jpg",
    mobBgImage: "/posts/bank/M.jpg",
    ctg: "jerusalem",
    isVid: false,
    title: "ALL SENSORY MARKETS",
    player_id_post: "",
    smltitle: "",
    html: function() {
      return {
        __html: `
            

				<p>
					For a genuine Middle Eastern experience you can’t beat a visit to one of Israel’s many markets (Shuks).  The different colours, textures, smells, tastes and sounds of these hives of activity can be a highlight of any Israel visit.  
				</p>

				<p>
					These markets are a melting pot of cultures and a great place to give your bartering skills a go. Through the winding cobbled streets you will find, fresh produce, souvenirs, art and handmade jewellery…the list is endless. Bring home a gift for your friends and family or just enjoy walking around and tasting different flavours.
				</p>
				
				
             	<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/30/1.jpg"} class="img-responsive" />
				</div>

				<h3>
					Tel Aviv
				</h3>
				<p>
					The Carmel Market, or Shuk HaCarmel, is the most famous of all Tel Aviv’s marketplaces. In recent years, it’s even joined the ranks of Tel Aviv’s trendy spots for bars, restaurants, coffee shops and chef-owned food stalls. It’s no wonder Shuk HaCarmel is Tel Aviv’s largest and most-centrally located shuk: From hand-made Jachnun, a traditional Yemenite dish, to boutique cheeses, and from one-off cotton clothes to designer threads, HaCarmel has it all. Plan your visit around your tastebuds and food preferences - salted fish, cured meats, Middle Eastern fare, fresh baked French pastries, and local-roasted coffee or fresh-pressed fruit or vegetable juice blends to wash it all down.
				</p>

				<p>
					<a target="_blank" href="//www.shuktlv.co.il/en/category/carmel-market">
						www.shuktlv.co.il/en/category/carmel-market
					</a>
				</p>

				<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/30/2.jpg"} class="img-responsive" />
				</div>

				<p>
					Nachlat Binyamin arts and crafts fair was established in 1988. It is the oldest and biggest of its kind in Israel, and one of the nicest in the world. The market is home to over two hundred artists who use materials such as wood, glass, fabric, plastic, paper…even rocks (almost anything) to hand-make what they sell on their stall. 
				</p>

				<p>
					<a target="_blank" href="//www.shuktlv.co.il/en/category/carmel-market">
						www.shuktlv.co.il/en/category/carmel-market
					</a>
				</p>

				<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/30/3.jpg"} class="img-responsive" />
				</div>
				<h3>
					Jerusalem
				</h3>

				<p>
					The Machane Yehuda market is widely recognized as a symbol of the Jerusalem, and for a very good reason: Jerusalemites see it as a place that represents them, symbolizes them, and gives them a unique identity in a larger Israeli social context. Jerusalem today has many shopping and entertainment centres, but there is something about the Machane Yehuda market that attracts people, even without a shopping list.  From the heady scent of spices to the colourful displays of fruits and vegetables, a trip to this market is pleasing for all your senses.
				</p>

				<div class="img-wrapper">
					<img src=${getImgUrl() + "/thingsToDo/posts/29/4.jpg"} class="img-responsive" />
				</div>

				<p>
					One option of experiencing this market is by buying a ‘Machane Yehuda Bites Card’.  This card is comprised of vouchers curated in order to give you a chance to try a variety of products, flavours and the aromas of the market - without having to depend on an organized group or tour.  For more information please click here: 
				</p>

				<p>
					<a target="_blank" href="//www.machne.co.il/en/">
						http://www.machne.co.il/en/
					</a>
				</p>
				
                
            	 `,
      };
    },
  },

  // {
  // 	id:31,
  //               bgImage : "/posts/bank/20/1.jpg",
  //               mobBgImage : "/posts/bank/20/M.jpg",
  //               title : "UNFORGETTABLE YAD VASHEM",
  //               ctg :"jerusalem",
  //               isVid:false,
  //               player_id_post :"",
  //               smltitle : "",
  //               html: function(){
  // 			return {
  // 				__html: `

  // 				<p>
  // 					Yad Vashem, Israel’s main Holocaust remembrance and education centre is situated on the green slopes of Har HaZikaron, (the Mount of Remembrance) in Jerusalem.
  // 				</p>

  // 				<p>
  // 					Israel’s Holocaust commemoration project began in 1953 with the task of perpetuating the memory of Holocaust victims and documenting the history of the Jewish people during the Holocaust so that it will be remembered by future generations. This project was an important step for the young nation of Israel at the time and was significant for the citizens of Israel, particularly for the survivors of the ghettos and concentration camps.
  // 				</p>

  //              	<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/thingsToDo/posts/31/1.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					The new Yad Vashem museum was opened to the public in 2005. The museum is designed in the shape of a prism penetrating the mountain. Divided into nine galleries, the museum relates the stories of the Jewish communities before the Second World War and the series of events beginning from the rise of the Nazis to power, the pursuit of the Jews, their eviction to the ghettos and ending with “the Final Solution” and mass genocide
  // 				</p>

  // 				<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/thingsToDo/posts/31/2.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					The personal experiences and feelings of the victims of the Holocaust constitute the groundwork for the museum’s exhibits. Photographs, films, documents, letters, works of art, and personal items found in the camps and ghettos are all an integral part of the exhibits. As you exit the Museum itself is the Hall of Names, an inspiring memorial containing over three million names of Holocaust victims that were submitted by their families and relatives. Names can still be submitted by visitors to the memorial and added to the computerized archive.
  // 				</p>

  // 				<p>
  // 					In addition to the Holocaust History Museum Yad Vashem has other memorials and monuments including  the Hall of Remembrance, where the ashes of the dead are buried and an eternal flame burns in commemoration; Yad Layeled, the children’s memorial, commemorating the one and a half million Jewish children who were murdered in the Holocaust;
  // 				</p>

  // 				<div class="img-wrapper">
  // 					<img src=${getImgUrl() +  "/thingsToDo/posts/31/3.jpg"} class="img-responsive" />
  // 				</div>

  // 				<p>
  // 					The Memorial to the Deportees, an authentic railroad car hanging over the cliff on the road winding down from the mountain. The car was used to transport Jews who had been banished from their homes to the concentration camps.
  // 				</p>

  // 				<p>
  // 					The Avenue of the Righteous Among the Nations has over 2,000 trees which were planted in honor of non-Jews who endangered their lives in order to rescue Jews from the Nazis; The archives and library of Yad Vashem House the world’s largest repository of material about the Holocaust;
  // 				</p>

  // 				<p>
  // 					Visiting the Yad Vashem museum is an emotional and heartrending experience, but seeing the exhibits and remembering the Holocaust gives the more than one million individuals, world leaders and dignitaries who pass through its doors annually a meaningful way to commemorate the six million Jewish victims of the Holocaust.
  // 				</p>

  // 				<p>
  // 					For more information   <a target="_blank" href="//www.yadvashem.org/">www.yadvashem.org</a>
  // 				</p>

  //             	 `
  //     }
  //   }
  // },

  {
    id: "What_To_Pack",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "CE QU'IL FAUT EMPORTER",
    smltitle: "",
    html: function() {
      return {
        __html: `

								
								

							    <p>Israël est un pays moderne et développé, et vous pouvez y acheter à peu près tout ce dont vous avez besoin pendant votre séjour, y compris des vêtements, cosmétiques et produits d'hygiène.</p>
								<p>Si vous visitez Israël en été, vous aurez besoin de vêtements légers&nbsp;: chemises à manches courtes et sans manches, shorts, sandales, chaussures de plage et maillot de bain.&nbsp; Il est également judicieux d'emporter un pull ou une veste, car les nuits dans les montagnes ou le désert peuvent être fraîches.&nbsp;</p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() + "/posts/what-to-pack/1.jpg"} class="img-responsive">
							    </div>
								<p>Si vous visitez Israël en hiver, emportez avec vous un manteau (et aussi un imperméable, si possible), de bonnes chaussures, un parapluie, des gants, une écharpe et d'autres vêtements chauds.&nbsp; Le climat en Israël n'est pas aussi froid qu'en Europe, mais les journées peuvent être pluvieuses et froides.&nbsp;</p>
								<p>Il est également judicieux d'emporter un petit sac pour les excursions d'une journée.&nbsp; Si vous allez à Eilat ou à la mer Morte, emportez un maillot de bain, car il y fait assez chaud pour vous baigner, même en hiver.</p>
								<p>Une crème solaire, un chapeau et des lunettes de soleil sont des accessoires indispensables tout au long de l'année.</p>
								<p>Si vous prévoyez de randonner, vous aurez besoin de bonnes chaussures et de beaucoup d'eau, que ce soit dans un bidon ou dans plusieurs bouteilles. Un sac de couchage, une tente, et un équipement de camping ne seront nécessaires que si vous prévoyez de dormir en plein air.&nbsp; La plupart des auberges de jeunesse fournissent draps et couvertures.</p>
																

		                        `,
      };
    },
  },
  {
    id: "Electrical_Appliances",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "APPAREILS ÉLECTRIQUES",
    smltitle: "",
    html: function() {
      return {
        __html: `
								<p>&#8203;En Israël, l’alimentation électrique est en 220 volts monophasé à 50 Hz. La plupart des prises de courant sont dotées de trois trous, mais un grand nombre d'entre elles fonctionnent avec les fiches européennes à deux broches. Les personnes souhaitant utiliser un rasoir, un fer à repasser de voyage ou tout autre petit appareil électrique, pourront avoir à utiliser un transformateur et un adaptateur.</p>
<p><a href="https://info.goisrael.com/en/things-to-do" target="_blank">Consulter les choses à faire du site d'informations touristiques</a><br><a href="https://info.goisrael.com/en/organized-tourism" target="_blank">Consulter les services touristiques du site d'informations touristiques</a></p>
                                <div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/electrical-appliances/1.jpg"} class="img-responsive">
							    </div>

		                        `,
      };
    },
  },
  {
    id: "Weather",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "LE CLIMAT",
    smltitle: "",
    html: function() {
      return {
        __html: `
								<p>Avec une moyenne d'environ 40 jours de pluie par an, Israël est connu pour son caractère ensoleillé. Ne perdez tout de même pas de vue que ce pays connaît 4 saisons. Les étés sont longs, ils durent d'avril à octobre, et les maximas de chaleur et d'humidité se situent vers les mois de juillet et août. L'automne et l'hiver durent de novembre à mars.</p>
<p>Eilat, la ville la plus au sud, jouit de près de 360 (!) jours de soleil par an, ce qui en fait la ville la plus chaude d'Israël (sans jeu de mots !).</p>
<p>Site Web du service météorologique d'Israël&nbsp;: <a href="//www.ims.gov.il" rel="nofollow" target="_blank"><u>www.ims.gov.i</u></a></p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/weather-planyour-trip/1.jpg"} class="img-responsive">
							    </div>

		                        `,
      };
    },
  },
  {
    id: "Transportation",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "TRANSPORTS",
    smltitle: "",
    html: function() {
      return {
        __html: `
								<p>Israël étant un petit pays, il peut être parcouru rapidement et de façon confortable. En Israël, on utilise couramment les taxis pour les parcours urbains et interurbains. Ils peuvent être hélés dans la rue ou réservés par téléphone ou avec des applications internationales comme GetTexi.</p>
								<p>Les principaux moyens de transport public sont les cars et le service ferroviaire national qui constituent tous deux un moyen pratique et peu onéreux de se rendre à quasiment n'importe quel endroit du pays.</p>
								<p>Services d'information sur les trains&nbsp;: <a href="//www.rail.co.il/en" rel="nofollow" target="_blank"><u>www.rail.co.il</u></a> / Téléphone : 08-6831222 or *5770.</p>
								<p>Services d'information sur les cars&nbsp;: <a href="//bus.gov.il/?language=en#/origindestination/1/0" rel="nofollow" target="_blank"><u>www.bus.co.il</u></a> / Téléphone : 1-900-72-1111</p>
								<p>Les billets peuvent être achetés aux guichets de la gare routière centrale de chaque ville ou village, ou directement au chauffeur.&nbsp;&nbsp;La plupart des lignes de cars ne fonctionnent pas pendant le Shabbat ou les jours fériés juifs.&nbsp;&nbsp;Le service se termine le vendredi après-midi et reprend le samedi soir.&nbsp;</p>
								<p>Les étudiants bénéficient de tarifs réduits sur les lignes de car interurbaines.&nbsp;&nbsp;Pour bénéficier du tarif réduit, ils doivent présenter une carte internationale d'étudiant au moment d'acheter le billet.</p>
								<p><strong>La Rav Kav, la carte de transport intelligente</strong></p>
								<p>Les touristes peuvent acheter une carte Rav Kav anonyme.&nbsp;Cette carte peut être achetée dans le car à un prix économique, puis rechargée avec un ticket pour un ou plusieurs trajets, en général dans la région même et en bénéficiant d'une réduction de 20%.</p>
								<div class="img-wrapper">
																   <img src=${getImgUrl() + "/posts//1.jpg"} class="img-responsive">
															    </div>
								<p>Les touristes ne peuvent pas utiliser de carte Rav Kav personnelle, car celle-ci contient des informations personnelles sur le passager et est réservée aux citoyens israéliens.</p>
								<p>&nbsp;Veuillez noter que&nbsp;:</p>
								<p>·&nbsp;La carte Rav Kav peut être utilisée pour régler le transport de plusieurs passagers,</p>
								<p>·&nbsp;Le tarif est le même pour un enfant ou un adulte.</p>
								<p>·&nbsp;La carte Rav Kav peut être utilisée dans une région mais pas entre deux régions, sauf si elle est expressément rechargée pour les itinéraires désirés.</p>
								<p>·&nbsp;Dans certaines régions, il est possible de bénéficier de trajets quotidiens illimités, mais uniquement dans cette région.</p>
								<p><strong>Vols intérieurs </strong></p>
								<p>Israël étant un petit pays, il n'est intéressant de prendre l'avion que pour circuler entre Eilat et Tel Aviv. Plusieurs compagnies assurent des vols entre Eilat et l'aéroport David Ben Gourion, ou l'aéroport Sdé Dov situé au nord de Tel Aviv.&nbsp; Les tarifs aériens sont raisonnables, mais plus élevés que pour les cars.&nbsp;</p>
								<p>Il existe également des compagnies privées qui assurent à la demande des vols spéciaux depuis n'importe quelle partie du pays.</p>
								<p>Arkia&nbsp;:&nbsp; <a href="//www.arkia.com/flights-in-israel" rel="nofollow" target="_blank"><u>www.arkia.com/flights-in-israel</u></a> Téléphone&nbsp;: 00 972 3 690 2222,</p>
								<p>Israair&nbsp;: <a href="//int.israirairlines.com/cat_domestic.asp" rel="nofollow" target="_blank"><u> int.israirairlines.com/cat_domestic.asp</u></a> Téléphone&nbsp;: 00 972 3 795 5777</p>
								<p><b>Location de voitures</b></p>
								<p>La plupart des sociétés internationales et locales de location de voitures ont des bureaux dans les grandes villes et à l'Aéroport Ben Gourion.&nbsp; Il est recommandé de réserver sa voiture à l'avance, depuis l'étranger.</p>
								<p>Pour louer une voiture en Israël, le conducteur doit avoir plus de 24 ans et détenir un permis de conduire international valide, ainsi qu'une carte de crédit internationale.</p>
								<p>Israël dispose d'un vaste réseau routier et d'une signalisation claire presque partout (en hébreu, anglais et arabe).&nbsp;</p>
								<p><strong>Conduire en Israël</strong></p>
								<p>L'<strong>âge minimum</strong> pour conduire en Israël est de 17 ans et la conduite se fait sur la droite de la chaussée. Les limitations de vitesse sont de 30 à 50 km/h dans les villes, 80-90 km/h sur les routes, 130 km/h sur les autoroutes et la Route n° 6. Les ceintures de sécurité sont obligatoires et si vous voulez aller en ville faire la fête la nuit, gardez à l'esprit qu'il y a une tolérance zéro concernant l'alcool au volant. Avant de vous amuser, désignez donc un conducteur qui devra rester sobre.</p>
								<p><strong>Autoroute 6</strong></p>
								<p>L'Autoroute 6 est une route à péage électronique sans barrières à l'entrée ou à la sortie et sans feux de signalisation, ce qui permet de se déplacer sans interruption. Le système informatique de pointe installé le long de l'autoroute comprend des péages électroniques, identifie les véhicules, catégorise les types de tarifs (abonnement ou non enregistré) et calcule le nombre de sections d'autoroute empruntées par chaque véhicule. Chaque trajet est automatiquement compilé et facturé. Les conducteurs bénéficient d'un trajet pratique et sûr, à une vitesse limitée à 130 kilomètres à l'heure.</p>
								<p>Les touristes ayant loué une voiture seront débités sur leur carte de crédit.&nbsp;&nbsp;Pour les conditions et les tarifs, veuillez vous informer auprès de la société de location.</p>
								<p>La plupart des sociétés de location de voitures ne proposent pas d'assurance pour les zones se trouvant en Cisjordanie, qui sont sous le contrôle de l'Autorité palestinienne.&nbsp; Les touristes désirant se rendre avec une voiture de location dans les zones contrôlées par l'Autorité palestinienne sont encouragés à souscrire une assurance appropriée.</p>
																
            	

		                        `,
      };
    },
  },
  {
    id: "Israeli_Currency",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "MONNAIE ISRAÉLIENNE",
    smltitle: "",
    html: function() {
      return {
        __html: `

								<p><a href="//www.boi.org.il/en/Markets/ExchangeRates/Pages/Default.aspx" rel="nofollow" target="_blank"><strong>Taux de change</strong></a></p>
								<p>La monnaie de l'État d'Israël est le nouveau shekel (NIS) ou shekel (dont le pluriel est shkalim en hébreu et shekels en anglais et en français). Un shekel est égal à 100 agorot (agorah au singulier). On trouve des billets de 20, 50, 100 et 200 NIS et des pièces de 10, 5, 2 et 1 NI et de 50 et 10&nbsp;agorot.</p>
								<p><strong>Changer de l'argent</strong></p>
								<p>Vous pouvez emporter en Israël n'importe quelle somme en devise locale ou étrangère, en espèces, chèques de voyage, cartes de crédit ou obligations de l'État d'Israël. Vous pouvez échanger n'importe quelle devise étrangère dans les aéroports, banques, bureaux de poste, la plupart des hôtels ou dans les bureaux de change autorisés des grandes villes. Un passeport est demandé en cas d'échange de chèques de voyage. Le taux varie selon l'établissement et les banques prennent une commission. Il est conseillé, mais non obligatoire, de transporter une petite somme en dollars américains du fait que certains sites touristiques, en particulier&nbsp;la&nbsp; vieille ville &nbsp;de Jérusalem, acceptent les paiements en dollars.&nbsp;&nbsp;<a href="https://www.boi.org.il/en/ConsumerInformation/Pages/Default.aspx" rel="nofollow" target="_blank">ici</a>.</p>
								<p><strong>Retrait d'espèces</strong></p>
								<p>Les titulaires d'une carte de crédit internationale peuvent retirer des devises locales ou étrangères dans les banques acceptant leur carte. Vous trouverez un distributeur automatique à l'extérieur de la plupart des banques.</p>
																
								<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/israeli-currency/1.jpg"} class="img-responsive">
							    </div>
            	

		                        `,
      };
    },
  },
  {
    id: "Immigration_Customs",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "Immigration et douane",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                <h2 class="ac-align-center ac-margin-top-20">Procédure aux postes frontières</h2>
                                <p class="ac-align-center ac-margin-bottom-20"><b>Contrôle des passeports</b></p>
                               
                                
							    <p>À leur arrivée en Israël, les visiteurs doivent se soumettre à un contrôle des passeports et présenter un passeport valide pendant au moins six mois après la <strong>date de leur retour</strong>.</p>
								<div class="img-wrapper">
																    <img src=${getImgUrl() +
                                      "/posts/immigration-customs/1.jpg"} class="img-responsive">
															    </div>
								<p>Notez qu'Israël a mis en place un nouveau système basé sur une technologie moderne pour répondre aux besoins des différentes autorités d'immigration, de sécurité, des aéroports et de tourisme. Ce système permet également aux touristes en règle de prouver le statut de leur visa sans qu'aucun tampon ne soit apposé sur leur passeport.&nbsp; Par simple pression sur un bouton, le poste de contrôle douanier imprime une carte récapitulant les principales informations concernant le voyageur, qui figurent en première page du passeport. La carte indique également la date d'arrivée et les informations de visa. Cette carte est appelée "Electronic Gate Pass".</p>
								<p><strong>Le Gate Pass constitue une forme d'identification officielle valable pendant la durée de votre séjour en Israël.&nbsp; Tous les touristes sont invités à garder cette carte sur eux en permanence afin de prouver leur statut.</strong></p>
								<p>Arrivée par avion et passage de la frontière – Après l'atterrissage, les passeports des passagers sont contrôlés puis ils sont dirigés vers la zone de réception des bagages. Des chariots sont mis à leur disposition. Ils se soumettent alors au contrôle douanier avant de se diriger vers la sortie.</p>
								<p><a href="//www.goisrael.com/Tourism_Eng/Tourist%20Information/Planning%20your%20trip/Documents/land%20gateways%202016%20ENGLISH.pdf" rel="nofollow" target="_blank">Informations concernant les points d'accès terrestres d'Israël&#8203;</a></p>
								<p><strong>Douanes</strong><br>Vous pouvez télécharger les informations générales sur les lois et réglementations de l'Autorité douanière :</p>
								<p><a href="https://taxes.gov.il/English/Pages/Guides.aspx" rel="nofollow" target="_blank">https://taxes.gov.il/English/Pages/Guides.aspx</a></p>
								<p><strong>Notez que la traversée du pont Allenby est soumise à des limitations et réglementations.&nbsp; À titre d'exemple, les visiteurs empruntant le pont Allenby entre Israël et la Jordanie ne sont pas autorisés à transporter plus de 2000 dinars jordaniens en espèces.</strong></p>
								<p><strong>Douane et TVA pour les touristes :</strong></p>
								<p><a href="https://taxes.gov.il/English/Vat/Pages/VatLobby.aspx" rel="nofollow" target="_blank">https://taxes.gov.il/English/Vat/Pages/VatLobby.aspx</a></p>
								<p><strong>À l'exception de la traversée du pont Allenby, tous les autres points d'accès, y compris les aéroports</strong> sont soumis aux réglementations présentées dans le guide suivant, rédigé par l'Autorité douanière et fiscale à l'intention des visiteurs :</p>
								<p><a href="https://taxes.gov.il/English/Vat/pages/guides/vat-refund-for-tourists.aspx" rel="nofollow" target="_blank">https://taxes.gov.il/English/Vat/pages/guides/vat-refund-for-tourists.aspx</a></p>
								<p><a href="https://taxes.gov.il/English/customs/PersonalImport/Pages/CustomsTuristGuide.aspx" rel="nofollow" target="_blank">https://taxes.gov.il/English/customs/PersonalImport/Pages/CustomsTuristGuide.aspx</a></p>
								<p>Remarque : lors du passage en douane, deux voies (une verte, une rouge) sont proposées à l'Aéroport&nbsp; Ben Gurion et aux autres points de passage de la frontière.&nbsp; Les visiteurs qui n'ont rien à déclarer doivent emprunter la voie verte à la sortie du hall d'arrivée des passagers.</p>
										         

		                        `,
      };
    },
  },
  {
    id: "Frequently_Asked_Questions",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "FAQ",
    smltitle: "",
    html: function() {
      return {
        __html: `
											<h3>Frequently Asked Questions about the COVID-19 </h3>

		                                    <p>
		                                        <ol start="1">
		                                              <li>
											          <strong>Je suis un touriste en Israël et je crains d'avoir le COVID-19, où dois-je aller ?</strong><br/>
										                Si vous avez une fièvre d’au moins 38°C ou plus, de la toux, des difficultés respiratoires ou d'autres symptômes respiratoires, vous devez immédiatement vous auto-isoler et appeler le 101 (MDA Emergency Services Hotline) pour un avis médical. Ne vous rendez pas dans une clinique ni dans une salle d'urgence.        
										              </li>
										              <li>
										                <strong>Quand Israël sera-t-il à nouveau ouvert aux visiteurs étrangers ?</strong><br/>
														’Il est à ce jour possible de se rendre en Israël selon les conditions requises et avec un passeport en règle. Il est demandé à chaque passager de remplir le formulaire d’entrée (voir sur : www.israelsafe.com) et de disposer d’une attestation d’assurance personnelle spécial COVID-19.										              </li>
											       
											    </ol>
		                                    </p>
											<p><strong>Israël c'est un peu loin, non&nbsp;?</strong></p>
											<p>Pas autant que vous le pensez : Israël est à seulement 4h15 de vol de Paris et moins de 4h de Marseille. De plus, vous pouvez rejoindre Israël via des douzaines de villes d'Europe.</p>
											<p><strong>De quels documents ai-je besoin pour venir en Israël&nbsp;?</strong></p>
											<p>Les citoyens français et belges doivent se munir d'un passeport valide au moins six mois après leur date d'arrivée en Israël. Il est inutile de se procurer un visa pour les séjours de moins de trois mois. Les mêmes conditions s'appliquent aux citoyens de la plupart des pays occidentaux. Pour vous en assurer, consultez le document: <a href="//mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf" rel="nofollow" target="_blank">http://mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf</a></p>
											<p><strong>Peut-on voyager sans danger en Israël&nbsp;?</strong></p>
											<p>Si ce n'était pas le cas, nous ne vous inviterions pas à venir. Chaque année, entre 3 et 4 millions de touristes viennent en vacances en Israël, et à l'exception de ceux qui tombent amoureux d'un(e) israélien(ne) - ou du pays lui-même&nbsp;! - tous rentrent chez eux sains et saufs. S'il y avait un risque, le pays ne serait pas relié par les avions de plus de 90 compagnies aériennes.&nbsp;</p>
											<p><strong>Il paraît qu'avant d'embarquer, il faut se soumettre à une enquête de sécurité...</strong></p>
											<p>Si vous prenez un vol EL AL Israel Airlines (ou si vous venez d'Europe sur un vol Arkia Israel Airlines ou Israir), sachez que les précautions de sécurité appliquées par les compagnies aériennes israéliennes sont légendaires et enviées de toutes les compagnies aériennes au monde. Au moment de l'enregistrement, vous devrez répondre à plusieurs questions dans le cadre d'un entretien de sécurité. Certaines questions peuvent sembler non politiquement correctes, indiscrètes, non pertinentes ou répétitives. Contentez-vous de répondre avec sincérité, de prendre les choses comme elles viennent, sans perdre votre sang froid. Gardez à l'esprit que ces questions ont pour seul objectif de garantir votre sécurité ainsi que celle des autres passagers. Lorsque vous quittez Israël, la procédure décrite ci-dessus est appliquée au départ par toutes les compagnies aériennes. &nbsp;</p>
											<p><strong>Puis-je combiner mon voyage en Israël avec une visite en Jordanie et/ou Egypte&nbsp;?</strong></p>
											<p>Absolument. Il existe des vols réguliers entre Tel Aviv et Le Caire et Tel Aviv et Amman. Vous pouvez vous y rendre par la terre, en traversant la frontière entre Israël et l'Egypte à Eilat/Taba, ou entre Israël et la Jordanie à Eilat ou en empruntant le pont Sheikh Hussein au sud de la mer de Galilée. Vous aurez besoin d'un visa pour la Jordanie et l'Egypte. Les citoyens américains peuvent s'en procurer un à la frontière. Les citoyens des autres pays sont invités à s'adresser à leur consulat local en Egypte ou en Jordanie, afin de connaître les formalités d'obtention de visa.</p>
											<p><strong>Et si je veux visiter un autre pays arabe&nbsp;?</strong></p>
											<p>Pas de problème. Comme de nombreux pays d'Europe, Israël n'appose plus de tampon sur le passeport de ses visiteurs. Par conséquent, votre passeport n'indique pas que vous êtes venu en Israël.</p>
											<p><strong>Puis-je visiter l'Autorité palestinienne&nbsp;?</strong></p>
											<p>Visiter Bethléem est extrêmement simple, des milliers de touristes qui se rendent en Israël le font chaque jour. Vous pouvez vous inscrire à une visite (voir à la réception de votre hôtel) ou prendre un taxi pour aller de Jérusalem à Bethléem pour ensuite prendre un taxi palestinien à Bethléem.&nbsp;</p>
											<p><strong>Que faut-il savoir en matière de santé, médicaments et vaccins&nbsp;?</strong></p>
											<p>Israël est un pays ultra-moderne et celui au monde qui compte le plus de médecins par habitant. Le système de santé et hospitalier du pays est envié dans le monde entier. Pour visiter Israël, aucun vaccin n'est exigé (à moins d'être allé récemment dans une région présentant un risque de fièvre jaune, choléra ou fièvre Ebola). Vous trouverez dans le commerce des médicaments équivalents à la plupart de ceux disponibles en Europe. Vous pouvez également emporter avec vous vos propres médicaments sur ordonnance. Si vous emportez des seringues ou flacons, n'oubliez pas de prendre avec vous la prescription de votre médecin attestant que vous en avez besoin, au cas où. Si vous avez besoin de consulter un médecin pendant votre séjour en Israël, demandez conseil à la réception de votre hôtel. Une assurance voyage (comprenant une couverture médicale) est toujours conseillée pour tous les voyages à l'étranger.</p>
											<p><strong>Comment s'habiller&nbsp;?</strong></p>
											<p>Comme presque partout dans le monde, vous pouvez porter des vêtements décontractés pour faire du tourisme.&nbsp; Emportez de bonnes chaussures de marche ou des baskets ainsi que des vêtements que vous pourrez superposer. Les Israéliens (en particuliers les femmes) adoptent un style "casual chic" le soir pour sortir à Tel Aviv et Jérusalem. Certains quartiers religieux<b> </b>exigent une tenue pudique (bras et jambes couverts et parfois pas de pantalons pour les femmes). N'oubliez pas votre maillot de bain et, pour vous baigner dans la mer Morte, des chaussures en plastique ou chaussettes aquatiques.</p>
											<p><strong>Et pour l'argent&nbsp;?</strong></p>
											<p>La monnaie israélienne est le shekel (officiellement le "nouveau shekel")&nbsp;; 1 Euro est égal à environ 4 Shekels.&nbsp;<a href="//www.boi.org.il/en/Markets/ExchangeRates/Pages/Default.aspx" rel="nofollow" target="_blank">Cliquez ici pour connaître le taux de change actuel</a>. Nous vous conseillons, à votre arrivée en Israël, d'utiliser votre carte de crédit pour retirer des devises à l'un des distributeurs automatiques disponibles dans les halls d'arrivée de l'aéroport Ben Gurion, ou de changer de petites sommes ou chèques de voyage à la banque de votre hôtel. Vous trouverez des distributeurs de billets partout en Israël et les cartes de crédit sont largement acceptées.</p>
											<p><strong>Électricité</strong></p>
											<p>La plupart des chambres d'hôtel sont équipées de sèche-cheveux et de prises pour rasoir.&nbsp; En Israël, l'électricité est en 220 V CA, monophasé 50 cycles. Vous pouvez utiliser un transformateur 110&nbsp;V-220&nbsp;V pour brancher les appareils électriques.&nbsp; Les prises israéliennes sont dotées de trois broches mais les raccords européens à deux broches fonctionnent généralement. En cas de problème, demandez conseil à la réception de votre hôtel ou dans une quincaillerie.</p>
											<p><strong>Communications</strong></p>
											<p>La plupart des hôtels proposent généralement une connexion wi-fi gratuite dans le hall, et parfois dans les chambres. De nombreux hôtels possèdent un Centre d'affaires permettant d'accéder gratuitement à Internet et à la messagerie électronique. Les téléphones portables américains qui fonctionnent à l'étranger fonctionneront également en Israël. Le décalage horaire est de + 1 heure: quand il est midi à Paris, il est 13 heures à Jérusalem ou Tel-Aviv.</p>
											<p><strong>Températures</strong></p>
											<p>Les températures peuvent être très variables : par conséquent, emportez des vêtements adaptés à la saison et tout ira bien.&nbsp; La transition entre les saisons n'est bien entendu pas franche, mais les consignes générales sont les suivantes&nbsp;:<br>&nbsp;<br>ÉTÉ (jun/jul/aou/début sep)&nbsp;:&nbsp; températures comprises entre 26 et 32ºC.&nbsp; Tel Aviv et Tibériade ont un climat chaud et humide (similaire à celui de New York ou Miami).&nbsp; Jérusalem possède un climat plus sec et plus frais, notamment la nuit.&nbsp; Massada et Eilat enregistrent des températures extrêmement élevées (+ de 43ºC&nbsp;!)... mais l'air y est sec.&nbsp; Vous n'aurez pas une goutte de pluie.<br>&nbsp;<br>PRINTEMPS/AUTOMNE (fin mar/avr/mai/fin sep/oct/nov)&nbsp;: températures diurnes très plaisantes dans la plus grande partie du pays (autour de 24°C) mais plus chaudes dans les régions de la mer Rouge et de la mer Morte). À Jérusalem, la température sera d'environ 21°C le jour et 10°C la nuit.&nbsp; Vous aurez de la pluie, mais peu abondante.<br>&nbsp;<br>HIVER (déc/jan/fév/début mar)&nbsp;: la météo peut être variable.&nbsp; Certains hivers sont doux et ensoleillés, d'autres rudes et nuageux. Les pluies fortes sont fréquentes, avec parfois de la neige en janvier et février. La température sera certainement comprise entre 10 et 15°C dans la plupart des régions, mais pourra descendre à 4°C à Jérusalem et en Galilée, voire descendre encore la nuit.</p>
											<p><strong>Déplacements</strong></p>
											<p><strong>BUS:</strong>&nbsp;Israël possède l'un des réseaux de bus les plus performants et économiques au monde puisqu'il relie la plupart des villes, villages et communes diverses.</p>
											<p><strong>TRAIN:&nbsp;</strong>des trains à grande vitesse relient l'Aéroport Ben Gurion à Tel Aviv, Jérusalem et Haïfa, et des trains rapides et bon marché sillonnent la majeure partie du pays.&nbsp; Le train est un moyen de transport bon marché et extrêmement simple à utiliser.&nbsp;<a href="//www.rail.co.il/EN/Pages/Homepage.aspx">Cliquez ici</a>&nbsp;pour obtenir des informations complètes.<br>&nbsp;<br><strong>AVION</strong>: Arkia, El Al et Israir proposent plusieurs liaisons quotidiennes pour Tel Aviv et Eilat, ainsi que des vols vers Haïfa et la Galilée.<br>&nbsp;<br><strong>TAXI:&nbsp;</strong>des taxis sont à votre disposition dans les villes et les chauffeurs vous transporteront avec plaisir d'une ville à l'autre. Consultez le tarif avant de convenir d'un trajet en taxi.<br>&nbsp;<br><strong>TAXI COLLECTIF:&nbsp;</strong>les taxis collectifs ou "Sherut" connaissent un vif succès. Des stations "Sherut" sont proposées dans toute la ville. Pour connaître la station la plus proche, adressez-vous à la réception de votre hôtel.<br>&nbsp;<br><strong>LOCATION DE VOITURE:&nbsp;</strong>La plupart des sociétés de location internationales possèdent des agences en Israël. Il existe également d'excellentes agences nationales. Votre permis de conduire européen est valable en Israël.</p>					
													                  
		                        `,
      };
    },
  },
  {
    id: "Passports_Visa",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: false,
    title: "PASSEPORTS ET VISA",
    smltitle: "",
    html: function() {
      return {
        __html: `
                               
							   <p>Toutes les personnes venant visiter Israël doivent avoir un passeport valide au moins six mois après la date de leur retour. Les personnes sans nationalité doivent détenir un laissez-passer valide, ainsi qu'un visa de retour vers le pays l'ayant émis.</p>
								<p>Les visiteurs sont autorisés à rester en Israël jusqu'à trois mois à partir de la date de leur arrivée, conformément aux conditions du visa qui leur a été accordé. Les visiteurs souhaitant travailler en Israël doivent demander un visa spécial au Ministère de l'intérieur.</p>
								<p>Israël ne tamponne plus les passeports dans les aéroports et dans la plupart des postes frontaliers.&nbsp; Néanmoins, du fait que des difficultés techniques peuvent parfois se produire, et à certains moments, le contrôle des frontières doit revenir à la méthode consistant à tamponner les passeports. Nous recommandons donc aux touristes quittant Israël pour aller dans les pays arabes de faire une <strong>demande officielle</strong> pour qu'aucun tampon israélien n'apparaisse sur leur passeport. Le touriste doit informer le fonctionnaire de cette demande avant que les documents ne soient tamponnés.</p>
								<div class="img-wrapper">
								   <img src=${getImgUrl() +
                     "/posts/passports-visa/1.jpg"} class="img-responsive">
							    </div> <br>
								<p><strong>La carte "Electronic Gate Pass".</strong></p>
								<p>Conformément à la section 13 de la loi de 1952 relative à l'entrée sur le territoire d'Israël, un inspecteur officiel ou un officier de police peut exiger une identification et une preuve de la légalité de la présence en Israël. À cette fin, par simple pression sur un bouton, le poste de contrôle douanier imprimera une carte récapitulant les principales informations concernant le voyageur, qui figurent en première page du passeport. La carte indique également la date d'arrivée et les informations de visa. Appelée «&nbsp;Electronic Gate Pass&nbsp;», cette carte est un nouveau système basé sur une technologie moderne pour répondre aux besoins des différentes autorités d'immigration, de sécurité, des aéroports et de tourisme. Elle permet également aux touristes en règle de prouver la validité de leur visa.&nbsp; <strong>La carte «&nbsp;Electronic Gate Pass&nbsp;» remplace le système consistant à tamponner les passeports</strong>&nbsp; À l'aéroport, cette carte permet aux voyageurs de quitter le terminal d'arrivée sans attente supplémentaire.</p>
								<p><strong>Le Gate Pass constitue une forme d'identification officielle valable pendant la durée de votre séjour en Israël.&nbsp; </strong>Tous les touristes sont invités à garder cette carte sur eux en permanence afin de prouver la validité de leur visa. À l'aéroport et à certains postes frontières, cette carte permet aux voyageurs de quitter le terminal d'arrivée pour se rendre à la zone de retrait des bagages.&nbsp;</p>
								<p><strong>Il est demandé aux touristes de conserver à tout moment cette carte à portée de main.</strong></p>
								<p><strong>Visas touristiques</strong></p>
								<p>Israël est heureux d'accueillir des visiteurs. De nombreux pays ont avec Israël un programme d'exemption de visa, qui permet à leurs citoyens de visiter Israël sans visa préalable. Avant de s'embarquer, les visiteurs désirant s'arrêter en Israël sur leur chemin vers d'autres destinations doivent vérifier s'ils ont besoin d'un visa touristique préalable. Le lien qui suit donne la liste des pays en provenance desquels les touristes doivent présenter un visa préalable.</p>
								<p><a href="//mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf" rel="nofollow" target="_blank">http://mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf</a></p>
								<p>Pour pénétrer en Israël sans visa préalable, tous les voyageurs bénéficiant d'un programme d'exemption de visa doivent présenter au point d'entrée un passeport lisible par machine, sans quoi un visa sera exigé. Cette disposition s'applique aux touristes arrivant avec une carte de passage depuis les pays ayant un programme d'exemption.</p>
								<p><strong>Prolongation de votre séjour </strong></p>
								<p>&#8203;Votre visa peut être prolongé (redevance exigée) en vous adressant au bureau du Ministère de l'intérieur le plus proche. Pour cela, veuillez appeler le centre d'appel du Ministère au&nbsp;: *3450 ou composez le 12223450.</p>
										              

		                        `,
      };
    },
  },

  {
    id: "Crazy_Night",
    ctg: "telaviv",
    bgImage: "/posts/bank/crazy-night/1.jpg",
    mobBgImage: "/posts/bank/crazy-night/M.jpg",
    isVid: true,
    vidId: "ogEN7aRT0SM",
    title: "À la recherche d'une vie nocturne de folie ?!",
    smltitle: "",
    html: function() {
      return {
        __html: `<div class="ac-cradit">
									<span class="ac-cradit-text">Credits:</span>
										<br/>
										<span class="ac-cradit-text-1">Tel Aviv Jaffa municipality<br/></span<
										<span class="ac-cradit-text-2">UDINI prodactions<br/></span>
									</div>
									<p></p>
									</div>
                               <h2>
                                   Réservez votre séjour à Tel-Aviv dès maintenant !
                               </h2>
                               <p>
                                 Amazing nightlife in Tel Aviv <a href="https://en.citiesbreak.com/Posts/telaviv/Amazing_Nightlife" target="_blank">Click here >> </a>
                               </p>
		                        `,
      };
    },
  },

  {
    id: "Heart_Of_The_World",
    ctg: "jerusalem",
    bgImage: "/posts/bank/heart-of-the-world/1.jpg",
    mobBgImage: "/posts/bank/heart-of-the-world/M.jpg",
    isVid: true,
    vidId: "nLKWDp5uA-U",
    title: "Jérusalem - le coeur du monde",
    smltitle: "",
    html: function() {
      return {
        __html: `
                               
		                        `,
      };
    },
  },
{
	id: "Neot_Semadar",
	ctg: "eilat-negev",
	bgImage: "/posts/bank/Neot_Semadar/1.jpg",
	mobBgImage: "/posts/bank/Neot_Semadar/M.jpg",
	isVid: false,
	title: "Neot Semadar",
	smltitle: "",
	html: function() {
	  return {
		__html: `
								

						<p>Niché au cœur du désert de la Arava au sud d’Israël, Neot Semadar offre aux voyageurs une expérience unique où se rencontrent l'art, l'écologie et la communauté. Ce remarquable kibboutz est bien plus qu'une simple destination - c'est une véritable toile vivante de créativité humaine et d'harmonie environnementale.</p>
						<p>Imaginez un lieu où l'exploit architectural côtoie l'innovation écologique. Le centre artistique du kibboutz se dresse comme un témoignage de design collaboratif, avec un bâtiment extraordinaire aux audacieuses structures arrondies, surmonté d'une tour d'observation panoramique de 38 mètres. Chaque élément raconte une histoire de vision collective et d'expression artistique.</p>
						<div class="img-wrapper">
									<img src=${getImgUrl() + "/posts/Neot_Semadar/1.jpg"} class="img-responsive">
						</div>
						<p>Les visiteurs peuvent explorer les multiples facettes de cette communauté du désert. </p>
						<p>Les ateliers d'artistes mettent en valeur l'artisanat local, notamment la peinture sur soie, la sculpture sur bois et le tissage. Le paysage environnant offre des panoramas à 360 degrés à couper le souffle, invitant les voyageurs à se connecter à la beauté brute de l'environnement naturel.</p>
						<p>Au-delà de l'esthétique, Neot Semadar représente un engagement profond envers un mode de vie durable. La communauté pratique l'agriculture biologique, propose des produits artisanaux et maintient une remarquable biodiversité qui attire les chercheurs scientifiques. Avec plus de 196 espèces de faune documentées, le kibboutz se distingue comme un sanctuaire écologique unique.</p>
						<div class="img-wrapper">
									<img src=${getImgUrl() + "/posts/Neot_Semadar/2.jpg"} class="img-responsive">
						</div>
						<p>Pour qui recherche une expérience immersive, le site propose des opportunités à s'engager dans la vie communautaire, à participer à des ateliers et à savourer des produits biologiques locaux. L'hébergement offre une retraite paisible au cœur du désert, permettant aux visiteurs de se déconnecter et de se reconnecter aux rythmes de la nature.</p>
						<p>Une visite à Neot Semadar dépasse le simple tourisme - c'est un voyage au sein d'une communauté inspirée et créative qui réinvente le potentiel humain en parfaite harmonie avec le paysage désertique.</p>
						<div class="img-wrapper">
									<img src=${getImgUrl() + "/posts/Neot_Semadar/3.jpg"} class="img-responsive">
						</div>
						<p>Pour obtenir des informations complémentaires sur le kibboutz et les options de visite, consultez notre site web: <a href="https://neot-semadar.com/en" rel="noopener" target="_blank">https://neot-semadar.com/en</a></p>
						 `,
	  };
	},
  },
  {
    id: "EILAT1",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/eilat1/1.jpg",
    mobBgImage: "/posts/bank/eilat1/M.jpg",
    isVid: true,
    vidId: "ZdnNT-GDJv4",
    title: "EILAT",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                

                        
                        <br/>
                        <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">
                        Un sentiment d'évasion pour un été sans fin</h2>
                         
                      
                                

							    <p>Capitale de la mer Rouge, Eilat est une cité balnéaire renommée qui attire chaque année quelque 2,8 millions de visiteurs qui choisissent de passer leurs vacances sur les magnifiques rives de la mer Rouge.</p>
								<p>Eilat, la ville la plus au sud d'Israël, est réputée pour la beauté de ses paysages désertiques, la splendeur de sa baie et un soleil qui brille toute l'année.&nbsp;<br><br>Que vous veniez à Eilat en famille, en couple ou seul, ce ne sont pas les lieux à visiter et les activités qui manquent. De nombreux types d'hébergement vous attendent également&nbsp;: luxueux hôtels 5 étoiles, logements de charme proposés par Airbnb ou auberges de jeunesse.&nbsp;&nbsp;</p>
								<p>Avec pas moins de 360 jours d'ensoleillement par an, Eilat est une destination extrêmement prisée des touristes qui viennent de loin pour échapper à la rigueur hivernale.&nbsp;<br>Une visite à Eilat est une expérience extrêmement plaisante car vous pouvez à la fois vous détendre, vous ressourcer et faire le plein d'énergie. Cette station balnéaire animée offre une multitude d'activités et attractions tout au long de l'année, ainsi que d'excellents restaurants, cafés, centres commerciaux, bars branchés et boîtes de nuit.<br>Et le mieux dans tout cela&nbsp;? À Eilat, tout n'est qu'à quelques pas de la plage.</p>
								<div class="img-wrapper">
								    <img src=${getImgUrl() + "/posts/eilat1/1.jpg"} class="img-responsive">
							    </div>
								<p><strong>Plongez dans la mer Rouge</strong></p>
								<p>Une fantastique attraction touristique en elle-même, la mer Rouge et les 10 kilomètres de côtes sublimes qui entourent Eilat constituent un des lieux les plus prisés de la région par les touristes de tous horizons.<br>Son eau propre, limpide et étonnamment fraîche offre un répit bienvenu à l'air chaud et sec de la ville. De plus, les nombreux centres d'intérêt et installations des plages d'Eilat en font le lieu idéal pour bronzer, se reposer et se détendre.</p>
								<p>Les amateurs de sensations fortes ne manqueront pas de participer aux activités proposées par les douzaines de clubs de sports aquatiques qui jalonnent les côtes nord et sud d'Eilat, telles que jet-ski, «&nbsp;banana boat&nbsp;», bouée tractée, kayak, etc.</p>
								<p><strong>L'ambiance des nuits d'Eilat </strong></p>
								<p>Quand vient le soir et que le soleil ardent du désert se couche sur Eilat, lorsque que les piscines et plages ferment, prenez une douche, changez-vous et participez à la vie nocturne animée de la ville.&nbsp; Eilat détient un record unique, celui du nombre de boîtes de nuit, bars et autres lieux de divertissement par habitant d'Israël. Vous trouverez donc à coup sûr l'endroit qui vous permettra de vous amuser jusqu'au bout de la nuit, tout comme vous l'avez fait pendant la journée.</p>
								<p><strong>L'aventure dans le désert</strong></p>
								<p>Au nord de la ville se trouve Arava, une région désertique qui offre des panoramas époustouflants. Elle figure parmi les lieux du pays à ne pas manquer où vous pourrez profiter de ses vastes étendues et admirer ses falaises abruptes, ses vallées et ses cours d'eau au gré des randonnées.</p>
								<div class="img-wrapper">
								    <img src=${getImgUrl() + "/posts/eilat1/2.jpg"} class="img-responsive">
							    </div>
								<p>Outre le fait qu'elles contribuent à l'extraordinaire panorama de la ville, les montagnes colorées et fascinantes de la région d'Eilat offriront une expérience inoubliable aux amoureux de la nature. Vous pourrez parcourir les nombreux itinéraires et sites à pied, à vélo, en voiture, à dos de chameau et même en escalade ou en descente, si vous aimez les sports extrêmes.&nbsp;</p>
								                        


						 `,
      };
    },
  },
  {
    id: "Ha_Arava",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev3/1.jpg",
    mobBgImage: "/posts/bank/negev3/M.jpg",
    isVid: false,
    title: "ARAVA: ETONNEZ-VOUS !",
    smltitle: "",
    html: function() {
      return {
        __html: `

						      

									<p>Situé entre le carrefour de Menucha au nord et le premier rond-point à l'entrée d’Eilat, Arava est bordé par Har haNegev et les montagnes d'Eilat à l'ouest et les montagnes d'Edom à l'est. En dépit de son étroitesse, cette bande de terre vous fera <em>ressentir</em> le désert et tout ce qu'il a à offrir, que vous soyez en couple, en famille ou en groupe. Pour découvrir Arava, les visiteurs ont le choix&nbsp;: à pied, en vélo, en voiture ou en car. En terme d'hébergement, le choix est aussi large puisque vous pourrez tout aussi bien dormir dans un hôtel de luxe, que faire du «&nbsp;glamping&nbsp;» ou dormir à la belle étoile. Voici quelques exemples de ce que vous pourrez voir et faire&nbsp;:</p>
									<p><strong>Parc national de Timna</strong></p>
									<p>Notre tout nouveau centre d’accueil, situé à l'entrée du parc, vous accueille avec une présentation des magnifiques paysages de Timna. Les grès rouges sculptés par la nature se juxtaposent à des rochers noirs et blancs pour créer un cadre d'une beauté à couper le souffle. En forme de fer à cheval, le parc de Timna recèle de trésors des différentes périodes et raconte l'histoire des mines de cuivre de l'Égypte ancienne qui produisent encore aujourd'hui du minerai, en laissant admirer de véritables vestiges ainsi que d'autres témoignages du passé.</p>
									<p>Timna propose plus de 25 pistes pour les randonneurs, les vélos (y compris des monotraces), et les véhicules motorisés, dont les pistes du <strong>Champignon</strong>, des <strong>Arches</strong>, des <strong>Piliers de Salomon</strong>, du <strong>Canyon rose</strong>, de la C<strong>orkscrew</strong> et des <strong>Visages</strong>. Sans oublier&nbsp;: le Tabernacle, une réplique exacte du tabernacle biblique porté par les Israélites durant leur périple dans le Sinaï ; un lac que vous pourrez explorer en pédalo ; la fabrication de bouteilles remplies de sables colorés et autres créations artisanales ; des locations de vélos ; un camping réglementé ; et l'Auberge du Roi Salomon où vous pourrez vous désaltérer et acheter des souvenirs.</p>
                                    <div class="img-wrapper">
											   <img src=${getImgUrl() + "/posts/ha-arava/1.jpg"} class="img-responsive">
								    </div>
									<p><strong>Réserve naturelle Hai-Bar</strong></p>
									<p>La Réserve naturelle de Hai-Bar a pour mission de réintroduire dans la nature les animaux mentionnés dans la Bible. Les animaux sont protégés et soignés dans leur habitat naturel qui est accessible aux visiteurs. Des circuits pour véhicules motorisés permettent aux visiteurs de partir en safari et de découvrir des oryx, des addax et même des autruches&nbsp;!... dans un cadre naturel où s'épanouit la flore du désert, notamment l'acacia mentionné dans la Bible. Des guides sur CD en différentes langues sont en vente dans notre boutique. Des visites guidées sont organisées le samedi à 11h... l'heure de la «&nbsp;collation&nbsp;» des animaux&nbsp;! Un camping tout équipé est à votre disposition.</p>
                                     <div class="img-wrapper">
											   <img src=${getImgUrl() + "/posts/ha-arava/2.jpg"} class="img-responsive">
								    </div>
									<p><strong>Ferme de la Route des épices, à Eilat</strong></p>
									<p>La ferme, qui participe à des recherches en mariculture, se trouve au point d'intersection entre les anciennes Routes des épices et la Route de la mer, face aux montagnes d'Edom. On y élève algues, palourdes, artémies et pseudochromis de la mer Rouge («&nbsp;poissons de Friedman&nbsp;» en hébreu, d'après le nom de l'éleveur à l'origine de leur découverte).</p>
									<p>Le centre d'accueil des visiteurs de la ferme est une véritable fête pour les sens puisqu'en franchissant l'entrée vous êtes accueillis par les parfums de douzaines d'épices, mélanges et infusions utilisés pour la cuisine ou pour leurs propriétés thérapeutiques. Vous y trouverez également des ustensiles de cuisine spéciaux dont notre personnel se fera un plaisir d'expliquer le fonctionnement.</p>
									<p><strong>L'agriculture biologique en vedette à Neót Smadár</strong></p>
									<p>Promenez-vous dans notre communauté et admirez notre splendide centre d'art, dont la construction a demandé 13 années de travail, nos terrains qui reflètent notre souci du détail et notre côté rustique, ainsi que nos vignobles et l'exploitation viticole la plus méridionale d'Israël&nbsp;!</p>
									<p>Notre centre d'art accueille les ateliers de nos artisans ainsi qu'une galerie où leurs produits sont exposés et proposés à la vente. Le centre de la structure, reconnaissable par sa tour, est un puit de refroidissement qui joue le rôle de climatiseur et rafraîchit tout le bâtiment. L'extérieur et l'intérieur du centre sont agrémentés de boiseries ornementales qui ont toutes été fabriquées par les membres de notre communauté.</p>
									<p><strong>Arava</strong><strong> de nuit</strong></p>
									<p>La nuit venue, le paysage change&nbsp;: les montagnes d'Edom se parent de nuances plus sombres de rouge et de violet sur fond de ciel parsemé d'étoiles et baigné par le clair de lune. C'est l'heure de dormir et nous allons vous aider à trouver le logement le plus confortable et le mieux adapté à vos besoins. Appelez notre ligne fixe au +972 (8) 661.6976&nbsp;!</p>							                               
											                     

		                        `,
      };
    },
  },
  {
    id: "Welcome_To_Eilat",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/eilat2/1.jpg",
    mobBgImage: "/posts/bank/eilat2/M.jpg",
    isVid: true,
    vidId: "ZdnNT-GDJv4",
    title: "UN SENTIMENT D'ÉVASION POUR UN ÉTÉ SANS FIN",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                    
                                   
                                   
									<p><strong>Capitale de la mer Rouge, Eilat est une cité balnéaire renommée qui attire chaque année quelque 2,8 millions de visiteurs qui choisissent de passer leurs vacances sur les magnifiques rives de la mer Rouge.</strong></p>
									<p>Eilat, la ville la plus au sud d'Israël, est réputée pour la beauté de ses paysages désertiques, la splendeur de sa baie et un soleil qui brille toute l'année.&nbsp;<br><br>Que vous veniez à Eilat en famille, en couple ou seul, ce ne sont pas les lieux à visiter et les activités qui manquent. De nombreux types d'hébergement vous attendent également&nbsp;: luxueux hôtels 5 étoiles, logements de charme proposés par Airbnb ou auberges de jeunesse.&nbsp;&nbsp;</p>
									<p>Avec pas moins de 360 jours d'ensoleillement par an, Eilat est une destination extrêmement prisée des touristes qui viennent de loin pour échapper à la rigueur hivernale.&nbsp;<br>Une visite à Eilat est une expérience extrêmement plaisante car vous pouvez à la fois vous détendre, vous ressourcer et faire le plein d'énergie. Cette station balnéaire animée offre une multitude d'activités et attractions tout au long de l'année, ainsi que d'excellents restaurants, cafés, centres commerciaux, bars branchés et boîtes de nuit.<br>Et le mieux dans tout cela&nbsp;? À Eilat, tout n'est qu'à quelques pas de la plage.</p>
									<p><strong>Plongez dans la mer Rouge</strong></p>
									<p>Une fantastique attraction touristique en elle-même, la mer Rouge et les 10 kilomètres de côtes sublimes qui entourent Eilat constituent un des lieux les plus prisés de la région par les touristes de tous horizons.<br>Son eau propre, limpide et étonnamment fraîche offre un répit bienvenu à l'air chaud et sec de la ville. De plus, les nombreux centres d'intérêt et installations des plages d'Eilat en font le lieu idéal pour bronzer, se reposer et se détendre.</p>
									 <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/welcome-to-eilat/1.jpg"} class="img-responsive">
									</div>
									<p>Les amateurs de sensations fortes ne manqueront pas de participer aux activités proposées par les douzaines de clubs de sports aquatiques qui jalonnent les côtes nord et sud d'Eilat, telles que jet-ski, «&nbsp;banana boat&nbsp;», bouée tractée, kayak, etc.</p>
									<p><strong>L'ambiance des nuits d'Eilat </strong></p>
									<p>Quand vient le soir et que le soleil ardent du désert se couche sur Eilat, lorsque que les piscines et plages ferment, prenez une douche, changez-vous et participez à la vie nocturne animée de la ville.&nbsp; Eilat détient un record unique, celui du nombre de boîtes de nuit, bars et autres lieux de divertissement par habitant d'Israël. Vous trouverez donc à coup sûr l'endroit qui vous permettra de vous amuser jusqu'au bout de la nuit, tout comme vous l'avez fait pendant la journée.</p>
									<p><strong>L'aventure dans le désert</strong></p>
									<p>Au nord de la ville se trouve Arava, une région désertique qui offre des panoramas époustouflants. Elle figure parmi les lieux du pays à ne pas manquer où vous pourrez profiter de ses vastes étendues et admirer ses falaises abruptes, ses vallées et ses cours d'eau au gré des randonnées.</p>
									<p>Outre le fait qu'elles contribuent à l'extraordinaire panorama de la ville, les montagnes colorées et fascinantes de la région d'Eilat offriront une expérience inoubliable aux amoureux de la nature. Vous pourrez parcourir les nombreux itinéraires et sites à pied, à vélo, en voiture, à dos de chameau et même en escalade ou en descente, si vous aimez les sports extrêmes.&nbsp;</p>
									<p>N'attendez plus. Visitez Eilat. Évadez-vous au soleil.</p>
									


		                        `,
      };
    },
  },
  {
    id: "The_Ultimate_Holiday",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/eilat1/1.jpg",
    mobBgImage: "/posts/bank/eilat1/M.jpg",
    isVid: false,
    title: "Pourquoi eilat est-elle la destination de vacances idéale ?",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                 

                               
								<p>Découvrez la ville au soleil éternel</p>
								<p><strong>Eilat, </strong>la ville la plus au sud d'Israël, possède tous les atouts nécessaires pour passer des vacances parfaites. Pour une escapade romantique, des vacances en famille, un séjour sous le signe de l'aventure et de l'action ou faire la fête entre amis, cette station balnéaire située sur les rives de la mer Rouge est le lieu qu'il vous faut. Soleil méditerranéen, eaux cristallines, spas apaisants, vie nocturne trépidante, achats détaxés et attractions à profusion&nbsp;: c'est cela Eilat&nbsp;!</p>
								<p><strong>Profitez du soleil. </strong>Cette ville bénéficie d'un soleil estival à longueur d'année. Le meilleur moment pour la visiter est donc... celui que vous voulez&nbsp;! Même lorsque toute l'Europe grelotte, Eilat permet d'échapper au froid. Sautez dans un avion et au bout de quelques heures vous arrêterez de frissonner, vous vous sentirez revigoré.</p>
								<p><strong>Choisissez où poser vos valises. </strong>Auberges, hôtels à bas coût, hôtels luxueux ou hôtels de caractère… Hébergement familial (ou de groupe) ou pied-à-terre retiré, calme et romantique&nbsp;; Eilat propose un vaste choix de lieux d'hébergement adaptés à tous les budgets et à tous les besoins.</p>
								<p><strong>Jetez-vous à l'eau.</strong> Avec plus de 7 kilomètres de superbes côtes bordant la mer Rouge, Eilat se prête aux activités aquatiques en tous genres. De la plongée avec tuba à la plongée sous-marine et à la planche à voile, en passant par le kite-surf ou la voile, etc. - tout est possible.</p>
								<p>Découvrez le <strong>Récif des dauphins</strong>, une plage familiale écologique dotée d'un magnifique jardin botanique, de bassins de détente et, l'attraction principale, la possibilité de regarder, toucher, nager et plonger avec les dauphins. (Soyez sans crainte<em>, toute interaction avec ces splendides créatures n'a lieu que quand elles le désirent</em>).</p>
								<div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/the-ultimate-holiday/1.jpg"} class="img-responsive">
								</div>
								<p>Visitez l'<strong>Observatoire sous-marin</strong>, une des attractions touristiques les plus populaires d'Eilat, où votre famille et vous pourrez admirer et apprendre à connaître la vie marine unique de la mer Rouge. À travers d'immenses baies vitrées, vous verrez évoluer requins, tortues, raies et poissons multicolores de la mer Rouge. En embarquant sur un navire à la coque transparente, vous aurez l'impression de faire partie intégrante de ce royaume sous-marin magique.</p>
								<p>Ne manquez pas la<strong> Réserve naturelle de la Plage des Coraux </strong>de renommée mondiale et sa splendide barrière de corail<strong>. </strong>Plongez avec masque et tuba ou avec bouteilles pour observer les poissons colorés et les magnifiques plantes aquatiques de cet habitat naturel, rare et délicat.</p>
								<p><strong>Vivez une grande aventure dans le désert. </strong>Le désert du Néguev offre certains des parcours scéniques les plus spectaculaires d'Israël. En randonnée, à vélo ou en jeep, vous pourrez partir en exploration et vous émerveiller devant la beauté qui vous entoure.</p>
								<p>À seulement 25 kilomètres au nord d'Eilat, vous trouverez la <strong>vallée du parc de Timna</strong>. Partez en balade et explorez la splendide campagne environnante ainsi que le site antique de la première mine de cuivre au monde, et profitez des nombreuses attractions proposées aux familles et aux plus téméraires.</p>

    


<p>Vous voulez poursuivre votre aventure&nbsp;? Eilat permet d'accéder rapidement à tout le pays. Allez passer une journée au bord de la mer Morte ou à Jérusalem.</p>
<p><strong>Prenez le temps de vous détendre. </strong>Eilat est une ville calme qui permet vraiment de ralentir le rythme et de se reposer. Elle propose également de superbes spas dispensant des soins très variés allant des massages traditionnels à la balnéothérapie. <em>Faites-nous confiance, vous ne le regretterez pas&nbsp;!</em></p>
<p><strong>Faites du shopping, mangez, buvez et faites la fête. </strong>Faites des achats au marché de la promenade de la ville, dans les boutiques de luxe et dans les nombreuses galeries marchandes<strong> - </strong>vous ne paierez pas les taxes&nbsp;<strong>!</strong></p>
<p><strong>Passez une nuit en ville.</strong> Admirez le magnifique spectacle son et lumière de la fontaine&nbsp;; préparez-vous à avoir le souffle coupé par un spectacle digne de Broadway combinant danse, effets lumineux acrobatiques, bande sonore de haute qualité et bien d'autres surprises.</p>
<p>Dînez dans un des nombreux restaurants et bars de la ville puis sortez en boîte de nuit.</p>
<p>Que demander de plus&nbsp;?!</p>

							  


		                        `,
      };
    },
  },
  // {
  // 		id:"Eilat_Calling",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"ZdnNT-GDJv4",
  //         title : "365 DAYS OF NONSTOP SUNNY JOY",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 							<p>Incredible adventure in Israel’s no. 1 vacation resort by the red sea.</p>
  // 							<p>The capital of the red sea, Eilat is Israel's famous resort city drawing nearly 2.8 million visitors a year who come to vacation by the shores of the stunning red sea.</p>
  // 							<p>The southernmost city in Israel, Eilat is renowned for its spectacular combination of the surrounding desert landscape, the beautiful bay and the summer sun that shines all year round.</p>
  // 							<p>A visit to Eilat is a fun-filled experience where you get to relax, recharge and get energized all at the same time. Eilat boasts a whopping 360 sunny days a year, making it extremely popular with tourists from far and wide looking to get away from their cold winter climate.</p>
  // 							<p>This lively resort city offers a multitude of year-round activities and attractions, excellent restaurants and cafés, shopping centers and trendy bars and clubs.</p>
  // 									                        `
  //     }
  //   }
  // },
  {
    id: "Eilat_Doolphin_Reef",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/eilat1/1.jpg",
    mobBgImage: "/posts/bank/eilat1/M.jpg",
    isVid: true,
    vidId: "3Cvz8GoxNzA",
    title: "LE RÉCIF DES DAUPHINS À EILAT",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                 
                                 <br/>
                                 <h2 class="ac-align-center ac-margin-top-20">Une Rencontre De Rêve Avec La Vie Sauvage la faune</h2>
                                 <p class="ac-align-center ac-margin-bottom-20"><strong>Nagez avec </strong><strong>les dauphins dans un lieu unique à Eilat</strong></p>
									<p>Situé sur les rives de la mer Rouge, à Eilat, le Récif des Dauphins est un véritable écrin pour la faune. Nature et détente y côtoient l'aventure. Les visiteurs du Récif pénètrent dans un lieu magique où ils peuvent interagir avec des dauphins dans leur milieu naturel, une superbe plage, où la vie végétale est en pleine floraison et à la beauté saisissante.</p>
									<p>Un long ponton permet d'observer les dauphins locaux «&nbsp;bottlenose&nbsp;» dans leurs activités quotidiennes, de les voir se nourrir, jouer, chasser, se reproduire et interagir. Il leur arrive même de chercher le contact avec les visiteurs du site.&nbsp; Les visiteurs qui le souhaitent peuvent essayer d'entrer en contact avec les dauphins dans le cadre des diverses activités proposées au public.</p>
									<p>Assister au repas des dauphins, à horaires fixes, est une expérience captivante. Vous aimerez la joie enfantine et le caractère joueur des dauphins lorsqu'ils attendent impatiemment que leurs soigneurs les nourrissent.&nbsp; La joie pure qu'ils expriment lorsqu'ils prennent leurs repas déclenche presque instinctivement les applaudissements de tout le public. Les visiteurs sont aussi excités et satisfaits que s'ils avaient été nourris eux-mêmes.</p>
									
									<p>Toute la beauté du Récif des Dauphins réside dans le fait que les visiteurs ne sont pas contraints de se tenir à distance : ils peuvent plonger avec les dauphins pour les observer dans leur écosystème unique, nager jusqu'à une profondeur de six mètres et découvrir la vie magnifique et secrète qui se déroule naturellement sous l'eau. Ils peuvent aussi chausser masque et tuba et rester à la surface, flotter au milieu des dauphins et jouer avec eux.</p>
									<p>Dans les "bassins de détente" du Récif des Dauphins, les visiteurs peuvent oublier tous leurs soucis et se laisser flotter au son d'une musique relaxante. Les différents restaurants sur site permettent de reprendre des forces et de se faire plaisir sans avoir à sortir de ce petit sanctuaire de beauté naturelle.</p>
																  
		                        `,
      };
    },
  },
  // {
  // 		id:"Action_Packed_Eilat",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "ACTION PACKED EILAT",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                              <p>So, you’ve heard about the fabulous beaches, the awesome nightlife and fantastic atmosphere of year round sunny Eilat, but aren’t you wondering, amongst all the leisure, what to do with the excess energy? Well wonder no more. Here are just some of the amazing ways to have some action-packed fun in the sun:</p>

  //                                  <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/action-packed-eilat/1.jpg"} class="img-responsive">
  // 							</div>
  // 						   <p>Eilat’s stunning red sea offers loads of fantastic adventures. For one, its gorgeous underwater environment is known as a world-famous <b>scuba diving destination</b>. Not a pro? No problem. There are short courses that run for 1-2 days.</p>
  // 						   <p>Atop the waves, you’ll find, <b>windsurfing</b>, <b>kitesurfing</b>, and <b>stand-up paddle boarding</b> options for which it’s always an ideal time in Eilat, with its pristine beaches, calm waters, and perfect sunny weather almost year-round. By the way, don’t worry about equipment or experience, as there are plenty of options for rentals and individual or group lessons for all ages as well as all-inclusive packages. You’ll be flying across the sea in no time!</p>
  // 						   <p>Looking to flex a few more muscles? Eilat’s nearby desert area offers <b>fantastic hikes</b> in stunning trails where you can <b>walk or bike</b> through breathtaking desert scenery.<span class="Apple-converted-space">&nbsp; </span>Feeling adventurous? Check out the huge array of unique action attractions from unforgettable camel rides to <b>adrenaline charged ATV rides</b> to thrilling off cliff <b>paragliding,</b> guaranteed to get the heart racing.</p>
  // 						   <p>If your holidays are all about breathtaking adventures, Eilat is definitely the place for you!</p>

  //                         `
  //     }
  //   }
  // },
  {
    id: "Eilat_Ultimate_Beachside",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/eilat1/1.jpg",
    mobBgImage: "/posts/bank/eilat1/M.jpg",
    isVid: true,
    vidId: "ZdnNT-GDJv4",
    title: "FAITES LE GRAND PLONGEON",
    smltitle: "",
    html: function() {
      return {
        __html: `
                               
								   <br/>
								   <h2 class="ac-align-center ac-margin-top-20">Découvrez Les Attractions Aquatiques D'Eilat</h2>
								   <p class="ac-align-center ac-margin-bottom-20"><strong>Profitez des lieux aquatiques qui font d'Eilat une destination de bord de mer incontournable</strong></p>
									<p>Entourée d'eau, Eilat, la ville la plus au sud d'Israël, est un lieu propice à l'aventure en milieu naturel et aquatique, comme nulle part ailleurs. Grâce à son climat chaud, Eilat permet de profiter de superbes plages, sports aquatiques, activités et attractions tout au long de l'année.</p>
									<p>Trempez vos orteils dans les eaux bleues et cristallines des plages d'Eilat qui s'étendent sur plus de douze kilomètres de sable, promenades, hôtels et attractions commerciales. Détendez-vous sur l'une des plages les plus au sud, parmi les plus tranquilles et retirées, et nagez au milieu des récifs coralliens, ou optez pour une des plages du nord de la ville, plus animées, où hôtels, restaurants et boutiques répondront à tous vos besoins. Vous pouvez aussi visiter la région en yacht, naviguant à votre gré, pour profiter du soleil, vous détendre et faire des rencontres.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/eilat-ultimate-beachside/1.jpg"} class="img-responsive">
									</div>
									<p>Découvrez le milieu unique de la Réserve naturelle de la Plage des Coraux d'Eilat. Mettez masque et tuba pour observer et interagir avec les créatures marines locales qui évoluent autour de vous.</p>
									<p>Pour vivre des aventures aquatiques extrêmes, c'est à Eilat qu'il vous faut aller. Sentez le vent dans vos cheveux et le soleil sur votre visage en vous laissant séduire par une sortie en ski nautique, jet-ski, «&nbsp;banana boat&nbsp;», surf, ou bateau à fond transparent. Glissez sur les flots et laissez-vous griser par la vitesse. Vous préférez rester au-dessus de l'eau&nbsp;? En parachute ascensionnel, vous aurez une vue aérienne imprenable sur la baie d'Eilat.</p>
									<p>Vous aimez la vie sauvage&nbsp;? Nagez ou plongez avec les dauphins au Récif des Dauphins d'Eilat. Ce site écologique unique, niché sur une plage paradisiaque, permet aux visiteurs de s'immerger dans la vie des dauphins et de vivre une aventure extrême passionnante. Envie d'une expérience sous-marine sans vous mouiller&nbsp;? Visitez l'Observatoire sous-marin d'Eilat afin d'observer la vie sous la surface de la mer, participez aux activités interactives et assistez à des animations spéciales.</p>
																	   
								   

		                        `,
      };
    },
  },
  // {
  // 		id:"One_Day_In_Eilat",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "ONE DAY IN EILAT",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 						   <p><b>Suggestions for an awesome day in the sun</b></p>
  // 						   <p>Whether you’re staying in one of the city’s 5 star hotels, a hostel or have opted for the cool camping alternative, we recommend to start your day with a delicious breakfast and make your way to the <b>Dolphin Reef</b>. This is one of the most popular attractions in Eilat, where you can touch, swim and dive with these beautiful creatures. Watch the dolphins in their natural habitat, visit the underwater photo center, or take part in either scuba diving or snorkeling. Check out also <b>Coral Beach</b>, the natural underwater reserve that extends for 1,200 meters along the coast and gives you the opportunity to go snorkeling with an extraordinary variety of tropical fish in a beautiful coral reef.</p>
  // 						   <div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/one-day-in-eilat/1.jpg"} class="img-responsive">
  // 							</div>

  // 						   <p>Once you’ve dried off, head to the stunning <b>Botanical Gardens</b> within Eilat. You’ll find there more than 1,000 types of trees and plants from all around the world, streams, waterfalls, a rainforest and bird sanctuaries.</p>
  // 						   <p>To end of your day with something slightly different, head just outside of Eilat to the <b>Red Canyon,</b> where you can track through the riverbed and between the red Nubian sandstone walls that have been sculpted over the centuries by wind and water.</p>
  // 						   <p>When evening comes, make your way to the buzzing Eilat promenade ,stroll by the shops and market stands which are open until late. You can treat yourself to a meal in any of the dozens of the excellent restaurants and cafés or a drink in any of the lively seaside pubs and bars.</p>

  //                         `
  //     }
  //   }
  // },
  {
    id: "Majestic_Desert",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev1/1.jpg",
    mobBgImage: "/posts/bank/negev1/M.jpg",
    isVid: false,
    title: "LE NÉGUEV - LE MAJESTUEUX DÉSERT D'ISRAËL",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                   
								  
                                    <div class="responisve-iframe">
							           <iframe width="560" height="315" src="https://www.youtube.com/embed/yXzhH92kREg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
						           </div>
						           <br/>
						           <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">L'aventure et l'inspiration vous y attendent</h2>

									<p>DESTINATION IDÉALE POUR LES VOYAGEURS EN QUÊTE D'AVENTURES DANS DES PAYSAGES SOMPTUEUX, LE SUD D'ISRAËL EST PEU PEUPLÉ, MAIS REGORGE DE SITES ET ACTIVITÉS FASCINANTS.&nbsp;<br><br>Avec sa beauté et ses merveilles naturelles, le sud offre des vues magnifiques à couper le souffle, de l'aube au crépuscule.&nbsp;<br><br>Paradoxalement, ce désert regorge de choses à voir et à faire, à commencer par ses nombreuses merveilles géologiques, ses monuments historiques emblématiques et ses superbes réserves naturelles où vous pourrez marcher, faire du vélo, randonner à dos de chameau ou vivre en 4x4 des raids chargés d'adrénaline.&nbsp;&nbsp;<br><br>Pour tout dire, cette majestueuse région méridionale est l'un des principaux atouts du pays et un passage obligé sur votre itinéraire.</p>
									<p><strong>Le cratère Ramon</strong></p>
									<p>Le cratère Ramon se trouve au cœur du vaste désert israélien du Néguev. Également appelé Machtesh Ramon, il s'agit du plus grand cratère d'érosion au monde. Comportant une grande variété de roches aux formes et aux couleurs fantastiques, ce phénomène naturel envoûtant mesure 40 km de long et entre 2 et 10 km de large. De la forme d'un cœur allongé, il est le grand parc national d'Israël&nbsp;: la Réserve naturelle de Ramon.</p>
									<p>Loin de la foule et des lumières de la ville, le cratère Ramon se caractérise par ses grès multicolores, ses roches volcaniques et ses fossiles. On en parle souvent comme du Grand Canyon d'Israël.</p>
									<p>Dominant le site du haut de ses 300 mètres, un belvédère vous offre une vue imprenable sur le Machtesh Ramon. Toute l'année, des touristes du monde entier s'y pressent pour admirer ce véritable décor hollywoodien.</p>
									<p><strong>Sde Boker</strong></p>
									<p>Témoignage de l’histoire de l’État d’Israël, Sde Boker est un kibboutz construit par des pionniers au début des années 50 dans le but de coloniser le désert du Néguev.</p>
									<p>Sde Boker est connu pour avoir été le lieu de résidence de David Ben Gourion, ancien premier ministre d’Israël. Sa maison est aujourd’hui un musée ouvert au public.</p>
									<div class="clear"></div>
									<div class="responisve-iframe">
							           <iframe width="560" height="315" src="https://www.youtube.com/embed/QL3BGy2p77g" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
						            </div>
									<p><strong>Vidor Center</strong></p>
									
									<p>Un lieu réellement unique qui permet aux visiteurs de mieux connaître la nature exceptionnelle de la région d’Arava à travers une expérience multi sensorielle. Ils peuvent y découvrir des méthodes agricoles avancées, la flore et la faune locales, les problèmes climatiques et les propriétés particulières du sol et de l’eau du désert.</p>
									<p><strong>Nevatim</strong></p>
									<p>La visite de Nevatim, où s’établirent les Juifs du Cochin, est une expérience fascinante. Originaires d’Inde, les Juifs du Cochin ont immigré en Israël après la création de l’État. Ils se considèrent comme l’ une des communautés juives les plus anciennes au monde.</p>
									<p>Le Centre du patrimoine des Juifs du Cochin du moshav Nevatim raconte l’histoire de cette communauté unique</p>
									 <div class="img-wrapper">
												<img src=${getImgUrl() + "/posts/majestic-desert/1.jpg"} class="img-responsive">
												Credit: Daphna Tal
									</div>
									<p><strong>L'expérience des Bédouins </strong></p>
									<p>Vivre l'hospitalité des Bédouins est une expérience inoubliable et enrichissante qui n'a pas d'équivalent.</p>
									<p>Les Bédouins d'Israël sont un groupe de tribus nomades indigènes dont l'origine remonte à de nombreux siècles. Continuant à vivre de façon traditionnelle, ils ouvrent aux visiteurs leur cœur, leur foyer et leur mode de vie, pour partager leurs coutumes et leur hospitalité réputées dans le monde entier.</p>
									<p>Vous pourrez faire une randonnée à dos de chameau, goûter aux plats traditionnels bédouins et même passer une nuit dans une tente bédouine. Ces attractions très appréciées par les touristes vous permettront de découvrir et d'apprécier un mode de vie oublié.</p>
									<p><strong>Les Reines de la gastronomie de Yeruham</strong></p>
									<p>Pour une expérience vraiment inoubliable, ne manquez pas l’hospitalité des Reines de la gastronomie de Yeruham. Grâce à un projet unique, des habitantes de Yeruham accueillent des touristes à leur table et leur proposent un excellent repas traditionnel, au cours duquel ils découvriront des odeurs, des couleurs et des saveurs uniques qui resteront gravées dans leur mémoire.</p>
									<p>Découvrez le quotidien des habitants de la région à travers leurs histoires passionnantes tout en dégustant de délicieuses spécialités locales et en profitant de leur l’hospitalité exceptionnelle.</p>
									<p><strong>La ville ancienne de Beer-Sheva</strong></p>
									<p>Il est dit que Beer-Sheva a été fondée par Abraham, figure centrale de la Bible. De fait, on y a découvert un établissement datant de plusieurs milliers d'années, et cette ville est l'une des plus anciennes du pays. Outre son caractère historique, la vieille ville de Beer-Sheva offre une mosaïque fascinante d'espaces urbains. Son exploration vous révèlera son architecture unique, sa longue histoire et des récits remontant à la nuit des temps.</p>
									<p><strong>Parc scientifique Carasso</strong></p>
									<p>Nouveau lieu situé dans la vieille ville de Beer-Sheva, le Parc scientifique Carasso, qui s’étend sur 1,61 hectare, est le plus grand parc scientifique d’Israël.</p>
									<p>Divertissant et adapté à tous les publics, il accueille un musée interactif et un jardin scientifique proposant des jeux et des activités pratiques. Le parc propose également dix expositions interactives dans différents domaines&nbsp;: génétique, communication, microélectronique, énergie nucléaire, etc.</p>
									<p><strong>Arad </strong></p>
									<p>L'Arad du nouveau millénaire est une ville jeune mais particulièrement intéressante. Arad et ses environs bénéficient de paysages magnifiques, de la tranquillité du désert et de nombreux sentiers pédestres parcourant des coins préservés du désert, qui conviendront à tous les âges et tous les styles.</p>
									 <div class="img-wrapper">
												<img src=${getImgUrl() + "/posts/majestic-desert/2.jpg"} class="img-responsive">
									</div>
									<p>Avec grand nombre d'attractions et de sites touristiques au sein et à proximité de la ville, Arad est un point de départ idéal et une porte naturelle pour des vacances parfaites dans le désert.</p>
									<p><strong>Parc de Timna</strong></p>
									<p>Avec sa vallée de 60 kilomètres carrés en forme de fer-à-cheval, le Parc de Timna offre un paysage époustouflant et ravira les passionnés de randonnée. Vous y découvrirez l’œuvre de la nature ainsi que les animaux, plantes et arbres étonnants qui vivent dans le désert malgré son extrême aridité.</p>
									<p>Avec ses nombreux centres d’intérêt, ses sables colorés et ses montagnes escarpées, le Parc de Timna n’a pas son pareil pour attirer les touristes.</p>
									<p>The south of Israel is a total dream destination for adventure-hungry travelers. Its unique and challenging terrain make for an ideal setting for various extreme sports and activities including abseiling down steep ravens and canyons, dirt biking and off road cycling which are extremely popular in this area as are the 4x4 adventure drives which are all the rage for locals and tourists alike.</p>
                                      <div class="img-wrapper">
												<img src=${getImgUrl() + "/posts/majestic-desert/3.jpg"} class="img-responsive">
												Credit: Daphna Tal
									</div>
									<p><strong>Nature </strong></p>
									<p><strong>Yotvata Hai-Bar </strong></p>
									<p>La réserve naturelle Yotvata Hai-Bar est le plus grand centre de reproduction et de réhabilitation d'animaux de la région, avant leur réintroduction dans la nature. La réserve offre des attractions passionnantes qui séduiront les amis des animaux, comme le centre des prédateurs avec ses <strong>spécimens</strong> vivants et ses petits animaux du désert, une pièce obscure permettant d'observer les animaux nocturnes et 12 kilomètres carrés de terres parcourus en toute liberté par des hardes d'herbivores.&nbsp;</p>
									<p><strong>Des aventures extrêmes </strong></p>
									<p>Le sud d'Israël est une destination de rêve pour les voyageurs en quête d'aventures.&nbsp; Son terrain unique et exigeant en fait un lieu idéal pour un large éventail de sports et activités extrêmes. Citons la descente en rappel des ravins et canyons, le motocross et le vélo tout terrain qui sont extrêmement populaires dans cette région, tout comme les raids aventure en 4x4 très en vogue, que ce soit chez les locaux ou les touristes.</p>
                                    <div class="img-wrapper">
												<img src=${getImgUrl() + "/posts/majestic-desert/4.jpg"} class="img-responsive">
												Credit: Daphna Tal
									</div>

		                        `,
      };
    },
  },
  {
    id: "Negev1",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev2/1.jpg",
    mobBgImage: "/posts/bank/negev2/M.jpg",
    isVid: true,
    vidId: "yXzhH92kREg",
    title: "BOUGER ET PRENDRE DU BON TEMPS DANS LE DÉSERT ISRAÉLIEN",
    smltitle: "",
    html: function() {
      return {
        __html: `
                              
									
										
											


											<p>Vous pensez que le désert est vide&nbsp;? Avec ses panoramas somptueux, ses sites historiques et une multitude d’activités ludiques, le désert israélien ne correspond en rien à ce cliché&nbsp;!</p>
											<h2>Le désert, un cadre unique</h2>
											<p>Vous serez séduit par la beauté naturelle des quatre principales régions désertiques d'Israël&nbsp;: la mer Morte, la chaîne de montagnes d'Eilat, le Néguev et le désert de Judée. Vivez une expérience hors du commun en partant randonner dans les paysages colorés et les formations rocheuses uniques du cratère Ramon, et dans les roches irisées rougeoyantes du parc Timna, à proximité d'Eilat. Quoi de mieux, après avoir dépassé vos limites en descendant en rappel des rochers multicolores ou en randonnant sur les sentiers poussiéreux, que de plonger dans les eaux fraîches d'une oasis telle que Ein Gedi, près de la mer Morte. Et si vous passez la nuit dans un des nombreux campings tout équipés, vous verrez plus d’étoiles que vous n’en avez jamais vues. Vous aurez peut-être même la chance d'observer les animaux qui ne sortent qu'à la nuit tombée&nbsp;!</p>
											<div class="img-wrapper">
																					<img src=${getImgUrl() + "/posts/negev/1.jpg"} class="img-responsive">
																					</div>
											<p>Le printemps, l'automne et l'hiver sont les saisons les plus propices pour affronter le climat aride et vivifiant du désert israélien. Sur le site de la forteresse de Massada, remontez le temps et redécouvrez le destin funeste des derniers Juifs luttant contre les Romains, et admirez la grandeur du palais d'Hérode. Explorez des ruines byzantines inattendues et découvrez la culture stupéfiante des cités nabatéennes creusées dans la roche.</p>
											<h2>Bouger et prendre du bon temps dans le désert</h2>
											<p>Le désert israélien offre de nombreuses activités divertissantes. Faites-vous secouer en jeep lors d'une expédition dans le Néguev ou louez des VTT pour dépasser vos limites sur les pistes du désert ou entre les rochers colorés qui confèrent une beauté surnaturelle au parc Timna. Ralentissez le rythme en visitant le désert de Judée ou les montagnes d'Eilat à cheval, en famille ou avec des amis, ou dégustez un thé à la menthe accompagné de dattes savoureuses en profitant de l'authentique hospitalité bédouine dans le désert du Néguev. Vous pouvez même faire une balade en chameau pour vous mettre dans la peau des Israélites de l'époque antique&nbsp;!</p>
											<p>Pourquoi ne pas prendre un bain de boue aux propriétés thérapeutiques sur les rives de la mer Morte en admirant les magnifiques chaînes de montagne et l'eau bleue qui s'étendent devant vous. Les amoureux de sports extrêmes ne manqueront pas de s'initier au sandsurfing. Quelle montée d'adrénaline en dévalant à toute vitesse les dunes de sable du Néguev&nbsp;!</p>
											<div class="img-wrapper">
																						<img src=${getImgUrl() + "/posts/negev/2.jpg"} class="img-responsive">
																						</div>
											<p>Jamais vous n'auriez imaginé vous amuser autant dans les déserts d'Israël.</p>

		                        `,
      };
    },
  },
  {
    id: "Location_And_Approach",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev3/1.jpg",
    mobBgImage: "/posts/bank/negev3/M.jpg",
    isVid: true,
    vidId: "5AAqIhkq_tQ",
    title: "LE NÉGUEV - COMMENT S’Y RENDRE?",
    smltitle: "",
    html: function() {
      return {
        __html: `
                              
								    <br/>
								    <h2>Emplacement et accès</h2>
								    <p>Arrivée à l'aéroport d’Ovda ou d'Eilat, puis transport vers Mitzpé-Ramon ou Sdé Boker:</p>
									<p><strong>Transports publics:</strong></p>
									<p><strong>Bus 392</strong> au départ d'Eilat pour Mitzpé-Ramon et Beer-Sheva&nbsp;; arrêt à l'aéroport d’<strong>Ovda</strong> le <strong>dimanche</strong> aux horaires suivants&nbsp;: 07h13, 08h41, 09h43, 14h12, 15h41, 17h43.</p>
									<p>Arrivée à la gare routière centrale de Mitzpé-Ramon environ une heure et demi après.</p>
									<p><strong>Lundi - jeudi&nbsp;:</strong> 07h13, 07h41, 09h43, 14h12, 15h41, 17h43.</p>
									<p><a href="//www.egged.co.il/HomePage.aspx" target="_blank">Service de bus</a></p>
									<p><span dir="RTL"><a href="https://eilatshuttle.com/" target="_blank"><span>Navettes depuis l'Aéroport Ovda</span></a></span></p>
									<p><strong>Location de voiture à Eilat, Mitzpé-Ramon et Beer-Sheva:</strong></p>
									<p>De nombreuses options de location de voitures sont proposées dans ces villes.</p>
									<p>Vous trouverez des agences de location israéliennes et internationales.</p>
									<p>Arrivée à l'aéroport International de Ben-Gourion (près de Tel-Aviv) et transport vers le Néguev, à Mashabei Sadeh / Sdé-Boker / Mitzpé-Ramon</p>
									<p><strong>Transports publics:</strong></p>
									<ul>
									<li>Bus n°370, 380 de Tel-Aviv vers Beer-Sheva,</li>
									<li>Bus n°446, 470 de Jérusalem vers Beer-Sheva.</li>
									<li>Train de l'Aéroport Ben-Gourion ou Tel-Aviv vers Beer-Sheva.</li>
									<li>De Beer-Sheva, bus n° 60, 64, 65, 660. Départs tous les matins à partir de 6h (environ toutes les 20 minutes). Arrivée à Mashabei Sadeh en 35 minutes / Sdé-Boker en 55 minutes / Mitzpé-Ramon en 1 heure 20 minutes.</li>
									</ul>
									<p>Des informations complémentaires sur les moyens de transport publics sont proposées sur les liens suivants: <a href="https://www.bus.co.il/otobusimmvc?Language=en" target="_blank">www.bus.co.il</a>;&nbsp;<a href="//www.egged.co.il/HomePage.aspx" target="_blank">www.egged.co.il</a></p> 

		                        `,
      };
    },
  },
  {
    id: "Stay_In_The_Negev",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev4/1.jpg",
    mobBgImage: "/posts/bank/negev4/M.jpg",
    isVid: false,
    title: "UN SÉJOUR DANS LE NÉGUEV",
    smltitle: "",
    html: function() {
      return {
        __html: `

						           
								   <p>Une visite du Néguev a bien plus à offrir que les panoramas impressionnants et l'atmosphère de tranquillité que l'on associe en général au mot désert. Si le Néguev offre bien la beauté naturelle, le calme et les sites époustouflants recherchés par les touristes qui se rendent dans le désert, il est également particulièrement intéressant, «&nbsp;occidentalisé&nbsp;» et aménagé pour offrir d'innombrables activités et aventures, proposant même tout le confort d’un séjour moderne.</p>
									<p>Le Néguev offre des possibilités d'hébergement extrêmement variées. Bien plus qu'un simple lieu où poser vos valises, le type d'hébergement que vous choisirez vous offrira l'opportunité de découvrir le joyau incontesté du Néguev&nbsp;: sa communauté locale. Des résidents des kibboutzim aux fermiers isolés en passant par les bédouins locaux, vous constaterez que les habitants du Néguev sont chaleureux, hospitaliers et toujours prêts à apporter leur aide. Voici quelques exemples d'hébergement que vous trouverez dans le Néguev:</p>
									<p>Hôtels – le Néguev propose un choix très large d'hébergements en hôtel, des établissements économiques aux hôtels internationaux de luxe 5 étoiles et primés dans lesquels vous pourrez vous détendre dans un cadre raffiné durant votre périple dans le désert.</p>
									<p>Auberges – un type de logement économique destiné à une clientèle de jeunes voyageurs. Les touristes qui y séjournent ont l'occasion de faire connaissance avec d'autres voyageurs du monde entier partageant le même état d'esprit, et de passer leurs soirées à échanger et parfois tisser des liens d'amitié durables.</p>
									<p>Zimmers – version israélienne des Bed and Breakfast, ces logements généralement indépendants du domicile du propriétaire offrent souvent l'intimité et le confort recherchés pour une escapade paisible et romantique.&nbsp;</p>
									<div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/stay-in-the-negev/1.jpg"} class="img-responsive">
								     </div>
									<p>Tentes bédouines – indubitablement le must pour se loger dans le Néguev, ce mode d'hébergement véritablement unique et authentique vous accueille dans la tradition de la communauté bédouine et offre une occasion exceptionnelle de s'initier aux coutumes de ce peuple, au sein même de son environnement naturel – hautement recommandé.</p>
									<p>Khans – eux aussi uniques au Néguev, ces vastes camps sont constitués de huttes et de dortoirs et offrent toutes les commodités de base. S'ils constituent souvent une forme d'hébergement plus rustique et basique, ils offrent un excellent moyen de goûter à la tranquillité du désert, de faire connaissance avec d'autres voyageurs et avec la population locale, et d'avoir le sentiment de faire partie intégrante du milieu naturel du désert.</p>
									<p>Fermes isolées – apparues plus récemment, ces fermes sont en fait des chambres d'hôtes situées dans des fermes familiales pittoresques et retirées, dans toute la région du Néguev.&nbsp; Combinant tranquillité et confort domestique, les fermes isolées permettent de bénéficier d'une grande intimité, de vues exceptionnelles et d'une façon authentique d'apprécier l'atmosphère impressionnante du désert du Néguev.</p>
									<p>kibboutz -&nbsp;une forme d'hébergement communautaire typiquement israélienne, le séjour en kibboutz permet de se loger à un prix économique. Le véritable attrait du kibboutz est toutefois son atmosphère singulière et son esprit communautaire, ainsi que ses membres chaleureux, accueillants et hospitaliers, grâce auxquels vous passerez immanquablement un séjour agréable et mémorable.</p>

								  
		                        `,
      };
    },
  },
  {
    id: "Pure_Desert_Magic",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev1/1.jpg",
    mobBgImage: "/posts/bank/negev1/M.jpg",
    isVid: false,
    title: "LE DÉSERT DU NÉGUEV - TOUT SIMPLEMENT MAGIQUE!",
    smltitle: "",
    html: function() {
      return {
        __html: `
						              

									   <p>Avec ses paysages à couper le souffle et ses attractions multiples, le désert israélien est le lieu idéal pour passer ses vacances. Le Néguev est une invitation au voyage offrant quantité de possibilités…</p>
									<p>Israël est un petit pays recouvert à 62&nbsp;% par le désert du Néguev. Son paysage aux tons rouges se caractérise par d'impressionnantes formations rocheuses. Le visiteur dispose d’un point de vue unique sur une immensité intacte, silencieuse et majestueuse.</p>
									<p>On y trouve les traces des civilisations passées et de leur agriculture, ainsi que des sites archéologiques. Le Néguev propose un cadre idéal pour aller au contact des tribus bédouines, les habitants du désert.</p>
									 <div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/pure-desert-magic/1.jpg"} class="img-responsive">
								       </div>
										<p>
											<strong>Le désert israélien est unique pour plusieurs raisons</strong>:
										</p>
										<ul>
											<li>
												<strong>Il est très proche</strong> - à seulement 4 heures de vol de l'Europe. Israël étant doté de deux aéroports internationaux, Tel-Aviv/Ben-Gourion et Eilat/Ovda, tous les voyageurs n'ont qu'un court trajet à effectuer pour accéder au désert (entre une demi-heure et une heure et demie de route).
											</li>
										</ul>
										<p>Dès novembre, des vols directs relieront l'Europe et la Russie à l'aéroport d’Eilat-Ovda, notamment par
											<em>
												<strong>Ryanair</strong>, 
												<strong>Wizzair</strong>
											</em>et
											<em>
												<strong>SAS</strong>
											</em>.
										</p>
										<p>Pour plus d'informations, consultez le lien suivant: 
											<a href="//www.iaa.gov.il/en-US/airports/ovda/Pages/default.aspx" target="_blank">www.iaa.gov.il</a>
										</p>
										<ul>
											<li>
												<strong>Facile d'accès à pied et à vélo:</strong> de nombreux sentiers balisés sont proposés. Israël est équipé du réseau de chemins de randonnée le plus étendu au monde, et plusieurs centaines de chemins permettent de se rendre dans le désert israélien en toute sécurité. Les sites suivants proposent une sélection de pistes&nbsp;: 
												<a href="//www.negevtour.co.il" target="_blank">www.negevtour.co.il</a> ; 
												<a href="//www.en.aravaway.co.il" target="_blank">www.en.aravaway.co.il</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
											</li>
											<li>
												<strong>Une population locale accueillante</strong>: l'amabilité et l'hospitalité des habitants font de l'exploration du désert une expérience agréable, chaleureuse et passionnante.
											</li>
											<li>
												<strong>Activités touristiques:</strong> outre l'augmentation de la capacité d'hébergement, la grande diversité des activités touristiques a permis au Néguev de s'imposer ces dernières années comme une destination populaire, curieuse, diverse et originale.
											</li>
											<li>
												<strong>Des paysages magnifiques:</strong> aujourd'hui, de très nombreux touristes viennent admirer l'immense variété de paysages du Néguev
																		
												<ul>
													<li>Les spectaculaires dunes de sable au nord.</li>
													<li>Dans sa partie centrale, le cratère Ramon avec ses falaises et ses sources d'eau saisonnières.</li>
													<li>Le désert africain à l'est avec ses vastes étendues de savane et ses acacias.</li>
													<li>Au sud, des paysages de granit rouge et noir, qui offrent un contraste saisissant avec les contreforts de grès aux couleurs harmonieuses.</li>
												</ul>
											</li>
										</ul>
										<p>Un voyage de 3 heures dans le désert permet d'admirer tous les types de paysages désertiques et de profiter d'une diversité de panoramas que l'on ne peut rencontrer dans les autres déserts qu'au prix d'un long voyage.</p>
										<p>De nombreux touristes décident de séjourner 2 ou 3 jours dans chaque région du Néguev.</p>
										
											<p>
												<strong>Le Néguev ne présente aucun danger.</strong> En cas d’urgence, les services de secours de la région sont parmi les mieux formés au monde et sont toujours à proximité. Si vous avez besoin de voir un médecin, Israël propose des services médicaux de haute qualité comparables à ceux des pays occidentaux.
											</p>
											<p>
												<strong>Informations complémentaires et conseils pour l'hébergement:</strong>
											</p>
											<p>
												<a href="//www.negevtour.co.il" target="_blank">www.negevtour.co.il</a><br/>
											
												<a href="//www.en.aravaway.co.il" target="_blank">www.en.aravaway.co.il</a>
											</p>
											<p>Bons plans voyage</p>                         
						 `,
      };
    },
  },
  {
    id: "Action_Fun_In_The_Desert",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev2/1.jpg",
    mobBgImage: "/posts/bank/negev2/M.jpg",
    isVid: true,
    vidId: "yXzhH92kREg",
    title: "ACTION FUN IN THE ISRAELI DESERT",
    smltitle: "",
    html: function() {
      return {
        __html: `

						          <p><strong>The Uniqueness of the Desert</strong></p>
								   <p>You’ll be wowed by the natural beauty of Israel’s four main desert areas: the Dead Sea, the Eilat mountain range, the Negev and the Judean desert. Tourists can step out-of-this-world on a hike through the unique colors and rock formations of the Ramon Crater and the deeply glowing hues of Timna Park outside Eilat. Rappelling down multicolored cliffs or challenging yourself on dusty, challenging hike is even better when you end it with a refreshing plunge into a desert oasis like Ein Gedi near the Dead Sea. You’ll see more stars than you could have believed if you camp overnight at one of the many fully serviced campsites. You might even glimpse some of the desert’s shy nocturnal wildlife!</p>
								   <p>Spring, Fall and Winter are the best times to visit the dry, bracing climate of Israel’s desert. Step back in time at the famous Masada fortress to rediscover the bitter end of the last Jews fighting against the Romans and be awed by the grandeur of Herod’s palace. Explore Unexpected Byzantine ruins and the astonishing culture of the Nabateans’ ancient settlements carved out of the desert rock are waiting for you to explore them.</p>
								    <div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/action-fun-in-the-desert/1.jpg"} class="img-responsive">
								       </div> 
								       <p><strong>Action Fun in the Desert</strong></p>
								   <p>Israel’s desert is full of fun activities. An exciting jeep tour will bounce you through the unique terrain of the Negev, or you can hire mountain bikes to challenge yourself in the unearthly beauty of Timna Park’s colorful rocks or across desert paths. Slow down to bond as a family or with friends on a calming horseback ride in the Judean desert or Eilat mountains, or sip mint tea and eat plump dates as you experience real Bedouin hospitality in the Negev. You can even ride on a camel to feel like a true ancient Israelite!</p>
								   <p>You could slather on the therapeutic mineral mud on the shores of the Dead Sea as you marvel at the towering mountains around you and the blue water beside you. Lovers of extreme sports can try their hand at sandsurfing down the Negev’s sweeping sand dunes, feeling the thrill of racing across acres of sand.</p>
								   <p>Israel’s deserts are full of more fun than you’d believe.</p>
								   <p>photo credit:</p>
								   <p>Alon Ron,&nbsp;Dafna Tal.</p>                          
		                        `,
      };
    },
  },
  {
    id: "The_Incense_Route",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev3/1.jpg",
    mobBgImage: "/posts/bank/negev3/M.jpg",
    isVid: true,
    vidId: "5AAqIhkq_tQ",
    title: "LA ROUTE DE L'ENCENS",
    smltitle: "",
    html: function() {
      return {
        __html: ` 
						           
						           <br/>
						           <h2 class="ac-align-center ac-margin-top-20">L'histoire d'une réussite commerciale datant de 2000 ans…</h2>
								  

								    <p class="ac-align-center ac-margin-bottom-20"><b>La légendaire ‘’Route de l'encens’’ retrace l'histoire d'un succès commercial né il y a 2000 ans.</b></p>
									<p>En ce temps-là, où n'existait aucun moyen de transport, route ou carte, de longues caravanes de chameaux empruntaient des pistes périlleuses et affrontaient voleurs, pilleurs, embûches et monarques régnant en maître. Des biens précieux étaient transportés par cette route qui, partant du Yémen à l'est, traversait l'Arabie saoudite et la Jordanie pour s'achever en Israël, au port de Gaza. Les produits étaient alors chargés à bord de navires marchands en partance pour l'Europe. Les femmes de l'Empire romain pouvaient ainsi jouir du parfum de l'encens et de la myrrhe, des saveurs des épices orientales, et des sels utilisés pour la cuisine et la conservation des aliments.</p>
									<p>Il fallait six mois pour parcourir les 2400 kilomètres de la route de l'encens. Les caravanes de chameaux - qui réunissaient plusieurs milliers de personnes - se déplaçaient très lentement et faisaient 56 arrêts durant lesquels les voyageurs se reposaient, prenaient soin des animaux et reprenaient des forces pour les jours suivants.</p>
									<p>La route de l'encens traversait Israël sur 150 kilomètres. Dans le désert du Néguev, on trouve encore des ruines de la route et de nombreux visiteurs choisissent de s'arrêter aux étapes successives pour découvrir le désert et se faire une idée du mode de vie des maîtres du désert. Les vestiges de plusieurs lieux de halte sont encore visibles, comme l'oasis de Moa dans le désert de la Arava, sur la frontière jordanienne, où l'on peut encore voir les ruines d'une auberge, d'un poste de garde, de caves, de celliers et d'un aqueduc.</p>
									<div class="img-wrapper">
												<img src=${getImgUrl() +
                          "/posts/the-incense-route/1.jpg"} class="img-responsive">
								    </div> 
									<p>De là, la route continue vers le nord-ouest jusqu'à Mamshit, une grande ville dont les ruines impressionnantes comprennent une auberge, des églises, des bains publics, des bassins de collecte d'eau de pluie et d'autres infrastructures.</p>
									<p>L'arrêt suivant était la ville d'Avdat, située en hauteur sur une colline. On y trouve ici aussi les vestiges d'une forteresse, d'églises, d'une presse à huile, d'un atelier de céramique, de maisons, d'un bain public et même de grottes funéraires.</p>
									<p>La caravane poursuivait sa route d'Avdat jusqu'à Shivta, une petite ville dotée d'un système sophistiqué de récupération des eaux, de bassins, de presses à huile et de quelques églises. L'avant-dernier arrêt, et le plus au nord, était Halutsa, où l’on peut encore voir les ruines d'un théâtre et d'une église. Les caravanes partaient ensuite pour Gaza. Quelques postes mineurs jalonnaient aussi l'itinéraire des caravanes, tels que Kasra, Nekarot, Makhmal et Grafon, ainsi qu'une autre auberge, Ein-Saharonim, dont il reste une cour entourée d'ateliers et un bain public.</p>
									<p>La route était jalonnée de réservoirs, tours de guet, lieux de rituel, installations de bains publics et de repères qui marquaient l'itinéraire.</p>
									<p>Moa, Mamshit, Avdat, Shivta et Haluza, tout comme Ein-Saharonim, sont accessibles à tous les types de véhicules. La route elle-même, qui traverse le désert, n'est praticable qu'en jeep, bien que les cyclistes et piétons puissent également l'emprunter. En 2005, la route de l'encens a été inscrite au Patrimoine mondial de l'UNESCO… Israël vous invite à découvrir les déserts du Néguev et de la Arava pour marcher dans les pas des nomades et revivre une période tumultueuse de l’histoire qui a laissé derrière elle, ce témoin silencieux et impressionnant.</p> 
								     
										                        `,
      };
    },
  },
  // {
  // 		id:"Mount_Karkom",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "MOUNT KARKOM",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                                 <p>In the heart of the western Negev lies a site considered one of the most significant landmarks in Christian history- the mysterious and beautiful Mount Karkom.</p>
  // 						   <p>Featuring a wildly unspoiled landscape - an 847-meter-high limestone plateau scored by dramatic ravines, mount Karkom is believed by some scholars to be the site of the biblical Mount Sinai – mentioned often in the book of Exodus as the place where Moses received the Ten Commandments.</p>
  // 						   <p>Walking down the eight-kilometer-long loop-trail, on the banks of the Karkom dry riverbed are two rows of standing stones and a rounded wall, reminiscent of nomadic shrine of the type built by the Israelites of the time. Looking closely, one can even spot 12 standing stones, believed by some to represent the 12 tribes of Israel.</p>
  // 							<div class="img-wrapper">
  // 										<img src=${getImgUrl()+ "/posts/mount-karkom/1.jpg"} class="img-responsive">
  // 						       </div>
  // 						       <p>Adding to the mystery and appeal, Mount Karkom features many famous rock drawings, depicting worshipping figures, animals and enigmatic symbols.</p>
  //                                   <p>To visit the area Hikers must coordinate tour to the site in advance and use a Society for the Protection of Nature (SPNI) trail map (available in Hebrew only) to explore Mount Karkom.</p>

  // 								                        `
  //     }
  //   }
  // },
  // {
  // 		id:"Machtesh_Ramon",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "MACHTESH RAMON",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                               <p>At the heart of Israel’s vast Negev Desert, lies the Ramon Crater, the world’s largest erosion crater, also known as Machtesh Ramon. Encompassing a vast diversity of rocks of fantastic colors and forms, this mesmerizing natural phenomenon measures 40km in length and between 2 and 10km in width, shaped like an elongated heart, and forms Israel’s largest national park, the Ramon Nature Reserve.</p>
  //                         <div class="img-wrapper">
  // 							<img src=${getImgUrl()+ "/posts/machtes-ramon/1.jpg"} class="img-responsive">
  // 						</div>
  // 						<p>Far from the city lights and crowds, featuring multicolored sandstone, volcanic rock, and fossils, the Ramon Crater is often described as Israel’s very own Grand Canyon.</p>
  // 						<p>The truly stunning views from the 300m edge lookout point of Machtesh Ramon, reminiscent of a Hollywood backdrop offer a powerful experience for tourists from all over the world, all year round.</p>
  // 						<p>A visit to Machtesh Ramon offers a range of exciting experiences and attractions specifically geared towards tourists and world travelers:</p>
  // 						<p><strong>Ramon Crater Visitor Center</strong>&nbsp;–&nbsp; Built on the crater’s edge, the visitor center overlooks the awesome views from the Machtesh and offers an opportunity to learn about its unique natural phenomena, and also about the life and work of Ilan Ramon, the first Israeli astronaut.</p>
  // 						<p><strong>Hai Ramon</strong>&nbsp;- Raising awareness to the local animal population, The Hai Ramon animal park offers a fascinating encounter with the often obscure and unseen small animals of the desert, The site features about 40 species of animals: lizards, snakes, turtles, spurs, hedgehogs, falcons, pheasants and more.</p>
  // 						<p><strong>Kahn Saharonim</strong>&nbsp;– a short walk from this once station on the Nabatean Spice Route, is Ein Saharonim, a beautiful spring (dry in the summer) which features rich vegetation and the footprints of the many animals that come to enjoy its waters.</p>
  // 						<p><strong>The Carpentry</strong>&nbsp;– a fascinating geological phenomenon, The Carpentry is a concentration of elongated stones in the form of prisms formed when the sandstone was "baked" at the high temperature created by a hot lava flow from the depths of the earth. During its cooling, the rock formed into thousands of ribbed columns, and the fragments of the columns act as the prisms.</p>
  // 						<p><strong>The Ammonite Wall</strong>&nbsp;- a rock wall featuring fossils of ammonites - marine animals that lived millions of years ago in the sea which then covered the entire Negev area.</p>
  // 						<p>A trip to Machtesh Ramon is a fascinating experience, one guaranteed to create a strong impression and a lasting memory.</p>

  //                         `
  //     }
  //   }
  // },
  {
    id: "Epic_Masada",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev4/1.jpg",
    mobBgImage: "/posts/bank/negev4/M.jpg",
    isVid: true,
    vidId: "XxWa_MNm5x8",
    title: "AU CŒUR DU DÉSERT DE JUDÉE, EXPLOREZ MASSADA",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                   <br/>
                                   <h2 class="ac-align-center ac-margin-top-20">Le Plus Haut Symbole Du Courage</h2>
                                   

								    <p  class="ac-align-center ac-margin-bottom-20"><strong>Au Sommet De Cette Fortification Emblématique, Revivez L'épopée Glorieuse Des Combattants De La Liberté</strong></p>
									<p>Prenez votre départ vers le parc national de Massada, l'ancienne fortification solitaire perchée au sommet d'une falaise du désert de Judée, qui surplombe la proche oasis de la mer Morte. Escaladez le sinueux chemin du Serpent ou l'escalier romain en partant de la base des fortifications. Vous pouvez également emprunter le téléphérique à partir du centre des visiteurs de Massada pour vous rendre au sommet du site et vous plonger dans un épisode glorieux de l'histoire ancienne, comme s'il était en train de se dérouler sous vos yeux.</p>
									
									<p><strong>Explorez ces ruines majestueuses et plongez-vous dans l'Histoire</strong></p>
									<p>Découvrez les vestiges d'anciens palais luxueux qui furent le dernier bastion des combattants de la liberté. Suite à la destruction du Second Temple, ces hommes courageux menèrent une guerre héroïque contre l'Empire romain. Sur ce site, l'histoire est encore si présente que les murs de pierres semblent littéralement pleurer les âmes des braves qui préférèrent la mort à une vie d'esclave sous le joug de l'ennemi.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/epic-masada/1.jpg"} class="img-responsive">
								    </div>
									<p><strong>Une expérience culturelle et spirituelle sans équivalent</strong></p>
									<p>Baladez-vous dans les ruines du château et découvrez les pièces et les constructions, les découvertes archéologiques qui permettent de reconstituer la vie à Massada pendant le siège des Romains. Pénétrez dans le Château Nord, les ruines du palais fortifié privé du roi Hérode. Murmurez une prière dans l'ancienne synagogue, où les juifs se rassemblaient trois fois par jour afin de prier pour leur salut. Rendez hommage aux défunts combattants de la liberté, qui se réunirent dans la «&nbsp;Chambre du tirage au sort&nbsp;» pour déterminer dans quel ordre mourraient les hommes, jusqu'à ce que le dernier d'entre eux mette lui-même fin à ses jours.</p>
									<p>Admirez les vestiges d'une église de l'époque byzantine et ses magnifiques mosaïques, qui fut peut-être utilisée dès le 1er siècle par des moines chrétiens en fuite, sur une période d'environ 600 ans.</p>
									<p>Explorez Massada, l'un des sites du patrimoine mondial de l'UNESCO, et assistez à son spectacle son et lumière. Le soir, au pied de la fortification, ce spectacle reconstitue le mode de vie et les batailles que ce site a connus il y a des siècles.</p>
								  
							    `,
      };
    },
  },
  // {
  // 		id:"The_Bedouin_Experience",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "THE BEDOUIN EXPERIENCE",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 				           <p>The Bedouin hospitality is a truly unrivalled experience, one which is both highly enjoyable and culturally engaging.</p>
  //                                  <p>A group of nomadic tribes indigenous to the area and dating back many hundreds of years, the Bedouins of Israel continue to live in traditional ways, opening their hearts, their homes and their way of life to the public, to share in their customs and their world-renowned hospitality.</p>
  //                                  <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/the-bedouin-experience/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>From camel riding to traditional Bedouin meals and even overnight stays in traditional Bedouin tents - all these are immensely popular attractions with tourists in the region, and an opportunity to discover and connect with a long-forgotten way of life.</p>
  //                         `
  //     }
  //   }
  // },
  // {
  // 		id:"The_Israel_National_Trail",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "THE ISRAEL NATIONAL TRAIL",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                                <p>The Israel National Trail (“Shvil Israel”) is a national project, paving a marked and safe hiking route across the country. Over 900km long, the route is one of the most rewarding ways to experience the nature and community in Israel.</p>
  //                           <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/the-israel-national-trail/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>The Israel Bike Trail (Part of The Israel National Trail Project) is a national initiative to create mountain biking trail that crosses the country from north to south, connecting Mt. Hermon at one end with Eilat at the other. Perfectly suited for bicycle tourism, the trail passes through national sites and amazing landscapes, allowing riders to experience Israel's diversity of culture and types of communities along the way.The trail is one of the longest demarcated trails in the world suited to, and with appropriate signage for, mountain biking.</p>

  //                         `
  //     }
  //   }
  // },
  {
    id: "Timna_Treasures",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev4/1.jpg",
    mobBgImage: "/posts/bank/negev4/M.jpg",
    isVid: true,
    vidId: "i_4QKtXIeto",
    title: "LE PARC DE TIMNA",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                   
                                   <br/>
                                   <h2 class="ac-align-center ac-margin-top-20">Une aventure exaltante dans le désert</h2>

                                  
								   

								    <p  class="ac-align-center ac-margin-bottom-20"><strong>Explorez la beauté naturelle et les attractions captivantes du parc de Timna </strong></p>
									<p>Situé à 20 minutes seulement d'Eilat, au cœur du désert enchanté d'Israël et niché dans des paysages naturels à couper le souffle, le parc de Timna vous fera vivre une expérience unique. Avec des attractions et des activités qui combinent nature, antiquités historiques et aventure, ce vaste site enchantera et suscitera l'engouement de tous les visiteurs, quels que soient leurs centres d'intérêt ou leur âge.</p>
									<p><strong>Soyez témoin de phénomènes naturels extraordinaires</strong></p>
									<p>Parcourez le parc à pied et admirez les formations rocheuses uniques du site, aux formes rares et aux noms intrigants. Vous pourrez toucher de vos mains le "Champignon", le "Champignon et demi", le "Canyon rose", les "Arches", les "Piliers de Salomon" et la "Vallée des dessins rupestres&nbsp;», qui illustrent une époque depuis longtemps révolue. Vous vous sentirez le témoin de quelque chose de réellement spectaculaire.</p>
									 <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/timna-treasures/1.jpg"} class="img-responsive">
								   </div>
									<p><strong>Partez en </strong><strong>randonnée dans les grands espaces</strong></p>
									<p>Lancez-vous sur l'un des 20<strong> chemins de randonnée</strong> bien balisés, offrant des niveaux de difficulté variés, et sélectionnez celui qui correspond le mieux aux exigences et aux capacités de votre groupe. Randonnez sur ces fabuleux sentiers parsemés de curiosités géologiques et archéologiques, ou optez pour la tranquillité et le repos au bord du <strong>Lac Timna</strong>, ses terrains de camping et son restaurant King Solomon's Khan. Ici, vous pourrez remplir une bouteille de sables de différents coloris, ou louer un pédalo pour un tour sur le lac.</p>
									<p>Vous êtes plutôt attiré par les <strong>sports extrêmes</strong> ? Testez la tyrolienne, les descentes en rappel et les circuits à vélo du parc. Soyez certain que chacune de ces activités vous fortifiera et vous satisfera.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/timna-treasures/2.jpg"} class="img-responsive">
								   </div>
									<p><strong>Faites l'expérience des temps anciens</strong></p>
									<p>Découvrez l'histoire biblique du désert, à l'occasion d'une visite guidée du <strong>Tabernacle</strong> reconstruit, complété d'une réplique de l'Autel, du Saint des saints et de l'Arche. Observez comment les jeunes visiteurs s'émerveillent de la reproduction de la structure sainte que Dieu ordonna aux Juifs de construire dans le désert, et comment les visiteurs plus âgés étudient l'authenticité de la reconstruction, en apprenant une ou deux choses au passage.</p>
									<p>Le parc de Timna… Là où l'Histoire rencontre l'aventure, au cœur du désert israélien.</p>
								   
		                        `,
      };
    },
  },
  {
    id: "Negev_Desert_Dont_Miss",
    ctg: "eilat-negev",
    bgImage: "/posts/bank/negev1/1.jpg",
    mobBgImage: "/posts/bank/negev1/M.jpg",
    isVid: false,
    title: "DÉSERT DU NÉGUEV – À NE PAS MANQUER",
    smltitle: "",
    html: function() {
      return {
        __html: `
                                   
								    <p><strong>Faire du sandboard dans le désert</strong></p>
									 <p>Une activité emblématique du désert. Laissez-vous griser par la vitesse en dévalant assis ou debout les somptueuses dunes de sable du désert du Néguev. Lorsque vous maîtriserez cette technique très simple, vous pourrez vous considérer comme un véritable surfeur des sables. Quoi de plus génial&nbsp;?</p>

									<p><strong>Le Néguev de nuit</strong></p>
									<p>Il n’est rien de plus envoûtant que le ciel du Néguev de nuit. Levez la tête une fois la nuit tombée, et vous serez frappé par la splendeur des étoiles scintillant dans le ciel bleu-noir et le parant d’un éclat que l’on ne trouve que dans le désert.</p>
                                     <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/negev-desert-dont-miss/1.jpg"} class="img-responsive">
								    </div>
									<p><strong>Balade à dos de chameau</strong></p>
									<p>Véritable retour aux origines, il s’agit toujours de la façon la plus authentique d’explorer le désert. Plusieurs élevages de chameaux du Néguev proposent des promenades en chameau, et c’est à coup sûr une expérience qui restera gravée dans votre mémoire.</p>

									
									<p><strong>Festival MidBurn</strong></p>
									<p>Version israélienne du fameux festival «&nbsp;Burning Man&nbsp;», cette manifestation de 6 jours voit une ville éphémère s’élever dans le désert du Néguev. Elle devient alors un lieu de vie communautaire, propice à la créativité, à l’art et à une expression personnelle radicale.</p>
									<p><strong>Lever de soleil à Massada</strong></p>
									<p>Seuls ceux qui seront suffisamment courageux pour gravir la montagne à pied pourront admirer le lever de soleil à Massada, une expérience à ne manquer sous aucun prétexte lors de votre séjour en Israël. Le soleil s’élevant lentement au-dessus des montagnes jordaniennes du Moab et de la mer Morte, dorant de ses rayons les paysages désertiques environnants, est un spectacle que vous n’êtes pas près d’oublier.</p>
									     

		                        `,
      };
    },
  },
  // {
  // 		id:"Negev_Charms",
  //        	ctg : "eilat-negev",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"3UddwPEzDXo",
  //         title : "ESCAPE TO THE NEVEG",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  //                                 <p>A desert holiday is unlike any other - the tranquility, the awe inspiring grand vistas, the clear star-studded night skies, all come together to create a truly mesmerizing and exotic experience most of us do not to partake in during our day to day lives.</p>
  //                                 <p>The Negev is so much more than just a Desert. While it still offers all the natural beauty, calmness and wonderous sites which the desert tourist is looking for, it is also extremely westernized and packed with activities and adventures while offering all the comforts of a holiday. This is exactly what makes a trip to the Negev the perfect destination for travelers from all over the world. Another gem of the Negev is undoubtedly its local community, from the Kibbutz residents to the lone farm dwellers and the local Bedouin folk, the people of the Negev are warm, hospitable and always ready to lend a hand. The Negev is rich in geological and archeological treasures and offers loads of exciting activities for the more adventurous travelers.</p>
  //                           <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/negev-charms/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>At the same time, visitors looking for relaxation are sure to find it in the tranquil surroundings, and for some urban excitement, the nearby cities provide a wide range of city fun from culinary treats to exciting nightlife.</p>

  //                         `
  //     }
  //   }
  // },

  // {
  // 		id:"Galilee",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"5Ep3GgxELag",
  //         title : "GALILEE",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  // 				          <p>Most of northern Israel is generically known as The Galilee (Galil in Hebrew). It stretches virtually from the Mediterranean to the harp-shaped Sea Of Galilee and River Jordan on whose shores vast history has been made. Here is Mount Gilboa where King Saul and his son, Jonathan, died in battle against the Phillistines. Here is Hazor, where Deborah killed Sisera. Here, at Mount Meron, is the grave of Rabbi Hillel. Here in Tzippori, Hamat Tveriya and Bet Alpha, gorgeous 1,800-year-old synagogue mosaics have been discovered. Here is Armageddon (Megiddo) where Solomon built giant stables. Here is the lakeshore city of Tiberias, one of the “Four Holy Cities of Judaism” (another is Galilee’s Safed), which reached fame 2,000 years ago as one of the chief locations in which the Talmud was written.</p>
  //                                 <h3 >Galilee</h3>
  //                                 <div class="responisve-iframe">
  // 					           <iframe width="560" height="315" src="https://www.youtube.com/embed/lzYzxyvnfng" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
  // 				           </div>
  // 				           <p>The restoration of the Jewish homeland in the period beginning in the 1880’s was largely centered in the Galilee, and in the ensuing 130 years a much neglected landscape of not much more than olive trees has been transformed into one of the most fertile areas in the world. Here are dozens of kibbutzim and independently owned farms – whose produce feeds not only Israelis but is also flown daily to the grocery stores and flower markets of Europe. Here are some of Israel’s 300+ vineyards producing award winning wines. And here are pretty villages, towns and cities including Nazareth and Carmiel.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/galilee/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>In addition to hotels and very comfortable kibbutz guest houses, the Galilee is filled with dozens of country bed-and-breakfast accommodations, known as zimmerim. Many offer luxurious accommodations, including pools, and make a delightful base for relaxing and touring.</p>

  //                         `
  //     }
  //   }
  // },

  {
    id: "Galilee_1",
    ctg: "north",
    bgImage: "/posts/bank/north2/1.jpg",
    mobBgImage: "/posts/bank/north2/M.jpg",
    isVid: true,
    vidId: "5Ep3GgxELag",
    title: "DÉCOUVREZ LES JOYAUX CACHÉS DE GALILÉE",
    smltitle: "",
    html: function() {
      return {
        __html: `  
						         
						          <br/>
						          <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Vos vacances de rêve dans un Israël insoupçonné</h2>
						          <p>Découvrez la campagne luxuriante du nord d'Israël, les villes pittoresques qui couronnent les collines de la Haute et Basse Galilée, des régions où caves à vin et restaurants côtoient sites historiques antiques. Séjournez dans un hôtel de luxe ou profitez de véritables vacances à la campagne dans un des fameux «&nbsp;<em>zimmers&nbsp;» </em>de Galilée, des pavillons de vacances gérés en famille et nichés dans de petits villages… Et découvrez Israël sous un nouveau jour.</p>
									<p><strong>Où l'</strong><strong>Histoire</strong><strong> prend vie</strong></p>
									<p>La Galilée regorge de sites historiques. Visitez les villages antiques de Kfar Nahum (Capharnaüm) et Migdal (Magdala) et pénétrez dans la Maison de St Pierre, à Capharnaüm. Admirez les impressionnants monastères et églises qui entourent la mer de Galilée et qui marquent les débuts du christianisme. Respirez l'air de Safed, une des quatre villes saintes du judaïsme, et explorez le plus important centre kabbalistique au monde. Découvrez les synagogues les plus anciennes au monde sur des sites tels que Baram et visitez les forteresses de Montfort et Nimrod, datant des croisades. Rendez hommage à Maïmonide dans la ville antique de Tibériade, et admirez les merveilles d'Acre (Akko), comme la ville souterraine des Croisés, la forteresse ou le tunnel des Templiers...</p>
									<p><strong>La Galilée&nbsp;: un paradis pour les gourmets</strong></p>
									<p>Partout en Galilée vous trouverez des caves à vin et des fromageries artisanales. Vous pourrez ainsi vous régaler d'authentiques mets druzes et arabes cuits sur des feux ouverts. Dégustez les produits directement chez les producteurs, dans les fermes biologiques, arrêtez-vous dans un restaurant raffiné familial et consommez des fruits frais que vous aurez cueillis vous-même dans les vergers. Découvrez Israël, où le lait et le miel ne sont pas les seuls produits disponibles en abondance. Vous y trouverez aussi une profusion de vins, huiles d'olive, fromages de chèvre et fruits savoureux.</p>
									 <div class="img-wrapper">
																		   <img src=${getImgUrl() + "/posts/galilee/1.jpg"} class="img-responsive">
																	   </div>
									<p><strong>Des activités passionnantes dans des paysages époustouflants</strong></p>
									<p>Le paysage vallonné et verdoyant de Basse Galilée est sillonné de rivières et parfait pour se promener dans un cadre ombragé. Les amateurs d'adrénaline pourront partir à l'assaut des hauteurs et descendre en rappel les sommets de Haute Galilée, ou dévaler en rafting les eaux turbulentes du fleuve Jourdain. De superbes balades en jeep, à cheval ou à vélo, des parties de paint-ball et des activités aquatiques vous attendent également. Si vous préférez les activités plus calmes, observez la vie sauvage dans les vastes réserves naturelles du pays ou partez en croisière sur les eaux calmes du lac de Tibériade. Vous pouvez même pratiquer les sports d'hiver sur les pentes enneigées du Mont Hermon, à l'extrême nord du pays.</p>
									<p>Pour passer les vacances de vos rêves, visitez le nord d'Israël.</p>
									
						         
								   
		                        `,
      };
    },
  },

  // {
  // 		id:"Caesarea",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"eLZ433_S6HI",
  //         title : "CAESAREA",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `  <p>The Roman port city of Caesarea is one of Israel’s wonders, combining ancient structures, archeology and a picture-perfect harbor, and adapting them for modern use.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/caesarea/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>Built by Rome’s Judean Governor, Pontius Pilate, two millennia ago, Caesarea was one of the largest and most magnificent ports in the Mediterranean, with giant piers stretching out into the sea to accommodate dozens of ships. The city of Caesarea contained a giant hippodrome, aqueduct and theater; a thousand years later the Crusaders arrived and built a giant fortress, and then came the Ottomans, who turned it into a seaside town. Today, the Roman theatre is a venue for concerts, the Crusader fortress is thrilling to visit and the Ottoman harbor and beach are full of cafes, restaurants and a visitors’ center. Caesarea is 45 minutes’ drive from Tel Aviv, 20 from Haifa.</p>

  //                         `
  //     }
  //   }
  // },

  {
    id: "Caesarea_1",
    ctg: "north",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: true,
    vidId: "eLZ433_S6HI",
    title: "CÉSARÉE : QUAND LITTORAL FLIRTE AVEC HISTOIRE…",
    smltitle: "",
    html: function() {
      return {
        __html: `  
								   <p>Située au bord des eaux étincelantes de la Méditerranée, Césarée est une ville de toute beauté qui allie romantisme et sites de grande valeur historique et archéologique, en dépit du souffle de modernité et de luxe dont elle fait l'objet. À moins d'une heure de voiture de Tel Aviv, cette ville offre des plaisirs très variés avec ses ruines antiques, son parcours de golf verdoyant et ses manifestations artistiques.</p>

									<p><strong>Un voyage dans le temps</strong></p>
									<p>La vieille ville et ses splendeurs archéologiques témoignent du rôle de Césarée à travers les époques. Une visite au parc national de Césarée, au vieux port, à l'hippodrome romain et à l'amphithéâtre rénové, ou une balade dans les ruines de l'impressionnant palais d'Hérode vous feront faire un bond dans le temps et vous donneront l'illusion qu’un navire romain s'apprête à accoster et à décharger sa riche cargaison.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/caesarea/1.jpg"} class="img-responsive">
								   </div>

									<p>À la «&nbsp;Time Tower&nbsp;» (Tour du temps), assistez à un spectacle son et lumière magique retraçant l'histoire de la ville ou partez à la rencontre des héros qui ont fait l'histoire avec «&nbsp;Caesarea Stars&nbsp;» (Étoiles de Césarée), une présentation technologique. Ces spectacles abordent l'histoire antique sous un angle moderne et sont à la fois divertissants et instructifs pour les visiteurs de tous âges, quels que soient leurs centres d'intérêt.</p>
									<p><strong>À la croisée des ruines antiques et du confort moderne</strong></p>
									<p>La beauté éblouissante du littoral de Césarée - les vagues qui viennent mourir sur les murailles du vieux port - combinée aux plaisirs modernes de la ville, comme les restaurants locaux pittoresques, les cafés, les boutiques, le musée d'art Ralli et l'unique parcours de golf du pays, éveillent un profond sentiment de détente et de plaisir. Et lorsque vous assisterez aux diverses représentations données par les artistes locaux et internationaux dans l'amphithéâtre romain, vous vous laisserez envelopper dans l'atmosphère spéciale d'un concert moderne donné dans un cadre resté inchangé depuis des siècles.</p>
																	   
		                        `,
      };
    },
  },

  {
    id: "Caesarea_2",
    ctg: "north",
    bgImage: "/posts/bank/north2/1.jpg",
    mobBgImage: "/posts/bank/north2/M.jpg",
    isVid: true,
    vidId: "eLZ433_S6HI",
    title: "CÉSARÉE VOYAGEZ À TRAVERS LE TEMPS",
    smltitle: "",
    html: function() {
      return {
        __html: `  
								<p><strong>Explorez les merveilles du passé, érigées </strong><b>par l’un des&nbsp;</b><strong>plus grands bâtisseurs de l'antiquité, Hérode 1<sup>er</sup> Le Grand.</strong></p>
								<p>Au bord des eaux turquoises étincelantes de la Méditerranée, à moins d'une heure de route de Tel Aviv, s'étend la magnifique cité antique de Césarée.&nbsp;</p>
								<p>La ville et ses splendeurs archéologiques témoignent du rôle de Césarée à travers les époques.&nbsp; Une promenade au parc national et au port antique, une visite de l'hippodrome et de l'amphithéâtre romains, une balade dans l'impressionnant palais vous permettront de découvrir quelques uns des nombreux trésors historiques de la cité et de remonter le temps jusqu'à l'époque des grands empires.</p>
								<div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/caesarea/1.jpg"} class="img-responsive">
								   </div>
								<p>Surtout, ne manquez pas le mini-spectacle de sons et lumières "Voyage dans le temps", une expérience fascinante et émouvante qui vous restituera toute la magie de l'histoire de Césarée à travers les âges.&nbsp;</p>
								<p>Pendant votre visite, vous serez également séduit par la beauté du bord de mer de Césarée et goûterez aux plaisirs de la modernité, tels que ses restaurants et <em>cafés</em> délicieusement pittoresques et son parcours de golf, le seul du pays.</p>
																  
		                        `,
      };
    },
  },

  {
    id: "Acre",
    ctg: "north",
    bgImage: "/posts/bank/north3/1.jpg",
    mobBgImage: "/posts/bank/north3/M.jpg",
    isVid: true,
    vidId: "KlXXyToCmCM",
    title: "LA VIEILLE VILLE D'ACRE - OU SAINT-JEAN D’ACRE",
    smltitle: "",
    html: function() {
      return {
        __html: ` 

						<br/>
						<h2 class="ac-align-center ac-margin-top-20">Suivez les traces des croisés</h2>

						<p  class="ac-align-center ac-margin-bottom-20"><strong>Au nord d'Israël, une ancienne cité fortifiée devenue pôle culturel</strong></p>
						<p>La vieille ville d'Acre est l'un des sites les plus exceptionnels d'Israël. C'est une cité côtière entourée de vieux remparts en pierres qui abrite d'innombrables trésors historiques et culinaires. La vieille ville d'Acre dégage une atmosphère unique et sublime, sans équivalent dans le pays.</p>
						
						<p><strong>À la rencontre d'un patrimoine historique captivant</strong></p>
						<p>Préparez-vous à visiter des sites et attractions fascinants évoquant la vie et les pratiques des croisés qui contrôlèrent autrefois la vieille ville d'Acre. Contemplez <b>les anciens et magnifiques</b> <b>remparts</b> qui entourent la vieille ville et qui ont protégé les habitants d'Acre pendant le siège de la ville par Napoléon. En visitant le <b>port d'Acre</b>, vous pourrez fermer les yeux, respirer l'air frais de la mer et imaginer le site tel qu'il était autrefois. Ce port important était l'aboutissement de liens maritimes avec l'Occident, et le principal point d'entrée des pèlerins découvrant la Terre Sainte.</p>
						<div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/acre/1.jpg"} class="img-responsive">
								   </div>
						<p>Découvrez un spectaculaire site souterrain, connu sous le nom de <strong>tunnel des Templiers</strong>. Dans le passé, ce passage en pierres aboutissait à une forteresse stratégique défendant le port d'Acre pour permettre aux pèlerins d'accomplir leur voyage en Israël. Aujourd'hui considéré comme un symbole de coopération et de persévérance, son franchissement est véritablement une expérience à couper le souffle. Continuez jusqu'à la <strong>Forteresse des Hospitaliers</strong> (salle des chevaliers), bâtie par le roi Richard Cœur de Lion durant la troisième croisade. Les ruines de ce qui fut autrefois l'ancienne cour centrale du fort, entourée d'arches, constituent un véritable témoignage des liens profonds forgés dans la ville en ces temps difficiles.</p>
						
						<p><strong>Un mariage rare d'authenticité et de cultures</strong></p>
						<p>Parmi les sites anciens et les attractions, c'est le <b>marché</b> d'Acre qui illustre le mieux l'authentique réseau de cultures orientales et occidentales sur lequel la ville portuaire a été fondée et continue de prospérer. Le marché est un lieu riche en parfums et saveurs, où des individus des quatre coins du monde proposent aux visiteurs des nourritures spirituelles et terrestres. Vous y trouverez une large variété de délices culinaires, comme des pâtisseries orientales, des épices préparées sur place, des produits frais et du poisson encore vivant. En vous dirigeant vers le sud du marché, vous pourrez visiter la Synagogue Ramchal et la maison de l'artiste Chaim Parchi, deux lieux qui apportent leur charme et leur vitalité à un pôle culturel déjà animé.</p>
								 
								   <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/acre/2.jpg"} class="img-responsive">
								   </div>						   
		                        `,
      };
    },
  },

  // No translation for this post in Frncias
  // {
  // 		id:"Haifa",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"3ahATaKkhBk",
  //         title : "HAIFA",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `  <p>Haifa is Israel’s third-largest city, Israel’s chief port and home to 400,000.  Draped around the slopes of biblical Mount Carmel, it is a 100-year-old city whose importance burgeoned in the 1920’s and 1930’s as Britain followed its League of Nations mandate over Palestine to create a Jewish homeland. The bustling lower Carmel neighborhood is the port area and where much of Haifa’s daily business is conducted. The slopes of central Carmel are largely residential, and the mountaintop Upper Carmel is home to museums, many hotels and shops.  from the top to the bottom of Mount Carmel is achieved by the Carmelit subway, the Bat Ganim cable car and, of course, by road.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/haifa/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>Haifa’s iconic symbol is the golden-domed Baha’i Shrine of the Bab, completed in 1953, that abuts the international headquarters of the Baha’i Faith, a network of giant white Greco-Roman buildings whose beauty stuns the visitor. The Shrine of the Bab was further beautified with the completion in 2001 of the “hanging gardens” (a UNESCO World Heritage Site) magnificent terraced gardens that lead from the shrine to the bottom of Mount Carmel. Here is the restored Templer Colony – where the homes and workshops of 19th-century German Christian “Templer” immigrants are now a network of chic stores, bars and restaurants.</p>
  // 						   <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/haifa/2.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>Haifa is home to a dozen museums – including a museum of Japanese Art, Israel’s Railway Museum and the Af-Al-Pi-Chen Museum of Illegal Immigration. It is also home to the Technion, Israel’s version of MIT. Haifa’s Wadi Nisnas neighborhood is the center of multi-holiday celebrations reflecting Haifa’s identity as city that is home to Jews, Christians, Muslims and Baha’is.</p>
  // 						   <p><strong>MUST SEES:</strong></p>
  // 						   <p><em>Baha’i Shrine of the Bab</em></p>
  // 						   <p><em>Baha’i “Hanging Gardens”</em></p>
  // 						   <p><em>Panorama of Haifa Bay from Upper Carmel</em></p>
  // 						   <p><em>Templer Colony</em></p>
  // 						   <p><strong>IF YOU HAVE MORE TIME:</strong></p>
  // 						   <p><em>Af-Al-Pi-Chen Museum of Illegal Immigration</em></p>
  // 						   <p><em>Israel Railway Museum</em></p>
  // 						   <p><em>Museum of Japanese Art</em></p>
  // 						   <p><em>Technion</em></p>
  // 						   <p><em>Wadi Nisnas</em></p>
  //                         `
  //     }
  //   }
  // },

  {
    id: "Haifa_1",
    ctg: "north",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: true,
    vidId: "3ahATaKkhBk",
    title: "HAÏFA LA PORTE VERS LE NORD D'ISRAËL",
    smltitle: "",
    html: function() {
      return {
        __html: `  
								   

								    <p>Troisième plus grande ville d'Israël et de loin l'une des plus captivantes, Haïfa est parfois désignée "Capitale du Nord".</p>
									<p>Au printemps ou en été, vous aurez le plaisir de vous baigner ou de prendre le soleil sur une de ses splendides plages. Tout au long de l’année Haïfa regorge d’activités à ne pas manquer.</p>
									
									<p>Sise sur les pentes de l'impressionnant Mont Carmel (à ne pas manquer), la ville est aussi surnommée "le San Francisco israélien" et se montre à la hauteur de cette comparaison avec ses plages magnifiques, ses panoramas inoubliables, ses nuits animées et sa scène musicale avant-gardiste.</p>
									<p><strong>Jardins Bahaïs - Beauté, grandeur et inspiration</strong></p>
									<p>En juillet 2008, les jardins bahaïs ont été inscrits au Patrimoine mondial de l'UNESCO pour leur "valeur universelle exceptionnelle" en tant que lieu saint de pèlerinage de la foi bahaïe.</p>
									<p>Le mausolée et les jardins bahaïs sont des lieux inspirés qui allient beauté, grandeur et conception exquise dans une atmosphère paisible sans égal. Parmi les sites les plus visités du pays, ces jardins attirent plus d'un million de visiteurs par an.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/haifa/2.jpg"} class="img-responsive">
								    </div>
									<p><strong>Mont Carmel - une montagne à la végétation luxuriante près de la Méditerranée</strong></p>
									<p>Symbole de beauté et de floraison le Mont Carmel est l ‘un des principaux points d'intérêt du pays, et la destination idéale pour une randonnée ou un pique-nique en famille. De plus, vous n'aurez nul besoin de vous fatiguer pour admirer les vues spectaculaires depuis le sommet puisque vous pourrez emprunter le Carmelit, un funiculaire.</p>
									<p><strong>Art et culture</strong></p>
									<p>Haïfa est une ville créative et animée qui propose de très belles galeries d'art et des événements culturels au détour de chaque rue. Ne manquez pas Madatech, le musée national des sciences, de la technologie et de l'espace d'Israël, le Musée d'art de Haïfa, et le zoo, situés sur le Mont Carmel<span dir="RTL">.</span></p>
									<p>Haïfa propose également un large éventail d'événements culturels tels que le «&nbsp;Holiday of Holidays Festival&nbsp;», qui célèbre les fêtes juives, chrétiennes et musulmanes qui se déroulent toutes en décembre. Ne manquez pas non plus le Festival international du film de Haïfa, tous les ans en septembre, qui présente une centaine de films de tous genres.</p>
																	
		                        `,
      };
    },
  },

  {
    id: "Haifa_Beauty",
    ctg: "north",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: false,
    title: "HAÏFA LA BEAUTÉ SOURCE D'INSPIRATION",
    smltitle: "",
    html: function() {
      return {
        __html: `  
								   

								   <p><strong>Tranquillité urbaine et paysages enchanteurs </strong></p>
									<p>Avec ses falaises escarpées qui viennent mourir sur les rives de la Méditerranée et ses collines verdoyantes qui surplombent le port, la troisième ville d'Israël offre au regard des paysages parmi les plus spectaculaires du pays. Belle, tranquille et véritable modèle de cohabitation entre les différentes communautés religieuses, Haïfa est plus qu'un lieu, c'est un mode de vie. Marchez sous les pins et profitez de la diversité culturelle de la ville, de son milieu intellectuel actif, de son atmosphère paisible et de sa beauté indiscutable. Vous serez forcément enthousiasmé.&nbsp;&nbsp;&nbsp;&nbsp;</p>
									<p><strong>Entourez-vous de sérénité et de beauté </strong></p>
									<p>Les <strong>Jardins bahaïs</strong>, connus dans le monde entier, constituent l’une des principales attractions touristiques de Haïfa. Inscrit depuis 2008 au Patrimoine mondial de l'UNESCO pour sa "valeur universelle exceptionnelle", ce lieu de toute beauté accueille plus d'un million de visiteurs par an.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/haifa-beauty/1.jpg"} class="img-responsive">
								     </div>
									<p>Commencez votre visite au sommet du Mont Carmel, sur l'agréable Promenade Louis. Admirez la vue exceptionnelle qui s'étend de la ville de Haïfa à l'ensemble de la côte et au-delà jusqu'aux Montagnes de Galilée.</p>
									<p>Explorez les jardins seul ou dans le cadre d'une visite gratuite. Descendez les terrasses en cascade et contemplez les haies et massifs de fleurs amoureusement entretenus. Visitez le Mausolée du Bab, orné d'un dôme doré, dans lequel repose le prophète HERALD de la religion bahaïe. Émerveillez-vous devant les couleurs et formes géométriques de ces jardins suspendus uniques et imprégnez-vous de leur sérénité.</p>
									<p><strong>Découvrez le cœur de la scène culturelle de Haïfa </strong></p>
									<p>Les Jardins bahaïs surplombent le quartier de la colonie allemande. Bâti dans les années 1860 par les membres de la Société du Temple allemande, ce quartier est aujourd'hui le cœur de la scène culturelle de la ville et un haut lieu touristique, avec ses restaurants, bars, galeries et hôtels de charme. Flânez dans les rues pavées, visitez les galeries et appréciez l'architecture de qualité. Restaurez-vous dans les cafés et restaurants locaux, profitez de la vie nocturne et mêlez-vous à la foule hétéroclite. Lorsque la nuit s'achève, ne manquez pas de lever la tête pour regarder les splendides illuminations qui ornent les Jardins bahaïs de bas en haut.&nbsp;Vous serez comblé.</p>
																	  
		                        `,
      };
    },
  },

  {
    id: "Safed",
    ctg: "north",
    bgImage: "/posts/bank/north2/1.jpg",
    mobBgImage: "/posts/bank/north2/M.jpg",
    isVid: true,
    vidId: "i3_ihL51bHo",
    title: "SAFED – OÙ LE MYSTIQUE CÔTOIE LE TERRESTRE",
    smltitle: "",
    html: function() {
      return {
        __html: `  

						<br/>
						<h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Plongez-vous dans l'art et la spiritualité pour une nouvelle interprétation de la vie</h2>
                        

								   <p>Avec ses paysages à perte de vue et son air pur, Safed saura vous captiver dès l'instant où vous y poserez le pied. Connue comme la capitale du mysticisme juif, hier comme aujourd'hui, cette superbe ville antique perchée sur la colline est la ville la plus élevée de Galilée et d'Israël, tant sur le plan géologique que spirituel. Une des quatre villes sacrées du judaïsme, Safed offre une expérience véritablement mystique dont l'énergie profonde éveillera votre fascination.</p>
									<p>À une courte distance en voiture du lac de Tibériade, Safed vous accueille avec ses pittoresques allées pavées et son architecture numineuse. Écoutez les âmes qui ont fait l'histoire, vous confier leurs secrets dans l'ancienne forteresse érigée par les Croisés, sous les influences mameloukes, ottomanes et britanniques, le Monument de la guerre d'indépendance, ainsi que les synagogues et tombeaux anciens, véritables témoins de l'histoire profondément sacrée du lieu.</p>
                                     <div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/safed/1.jpg"} class="img-responsive">
								   </div>
									<p><strong>La capitale de la Kabbale éternelle</strong></p>
									<p>De Rabbi Shimon Bar-Yohai, auteur du livre essentiel de la Kabbale au 2<sup>ème</sup> siècle connu sous le nom de Zohar, à Ari HaKadosh, le père de la Kabbale contemporaine, Safed est la terre d'accueil de la plus haute mystique du judaïsme et de ses élèves dévots. C'est au 16<sup>ème</sup> siècle qu’Ari HaKadosh a «&nbsp;démocratisé&nbsp;» les enseignements de la Kabbale en apportant une nouvelle compréhension qui la rendait accessible au profane.</p>
									<p>En cheminant à pied d'une synagogue à l'autre, vous comprendrez comment Safed est devenue le lieu d'accueil d'une si longue lignée d'aspirants spirituels, quels qu'aient été les événements placés sur leur chemin au cours de l'histoire. La synagogue Abuhav dont l'architecture incarne le mysticisme numérique, la synagogue ashkénaze Ari dédiée à Ari HaKadosh et la synagogue Yosef Caro vous emporteront dans un voyage à travers le temps et dans les mondes les plus élevés du mysticisme.</p>
									<p><strong>Une vieille ville source d'inspiration</strong></p>
									<p>Vivez d'autres moments inoubliables au cours de votre voyage en vous promenant dans les allées pavées sinueuses de la vieille ville, en contemplant d'incomparables édifices en pierre et en poursuivant votre chemin jusqu'à la Colonie des artistes. Dédiée aux amoureux des arts, cette partie de la ville abrite des galeries de qualité qui vous donneront l'occasion de découvrir les œuvres des artistes locaux, notamment un vaste choix de Judaïca. Les amateurs de culture ne manqueront pas de visiter le Musée de la poupée et le Musée de l'art de l'impression.</p>
									<p>Safed nourrira votre corps comme votre esprit - les nombreux lieux de restauration de la vieille ville sauront satisfaire tous les palais et toutes les bourses. Des crêpes yéménites et de la cuisine de rue aux mets inattendus proposés dans les restaurants, vous trouverez de quoi satisfaire vos envies, et bien plus encore, dans cette ville pleine de grâce aux traditions profondément ancrées.</p>
																	   							   
		                        `,
      };
    },
  },

  // {
  // 		id:"The_Bahai_Gardens",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"JV_AmfRULOo",
  //         title : "THE STUNNING BAHA’I GARDENS",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  // 				          <p><strong>Visit the Baha’i Gardens</strong></p>
  //                                 <p>Picture yourself standing on the nineteenth terrace which is the very top of this breath taking monument where you can see the rolling hills of the Galilee, the city of Haifa, Akko and the Mediterranean Sea.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/bahai-gardens/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>Beauty, grandeur, and inspired design combined with the meticulous gardening by generations of dedicated gardeners and a variety of cultures create the unique atmosphere of the Baha’i shrine and gardens in Haifa. While each garden offers a different experience they all share the same theme of gravelling paths, unique hedges and flourishing flower beds. A picture so perfect you must see it with your own eyes to believe the precision and symmetry.</p>
  // 						   <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/bahai-gardens/2.jpg"} class="img-responsive">
  // 						   </div>
  // 						     <p>This mystical iconic is site where members of the Baha’i faith have established their shrine and world centre because of its significance to their faith.</p>
  //                                  <p>The Baha’i faith had its origins from Iran. Its founder Baha'u'llah, was exiled from his homeland at the end of the 19th century, and came to Akko (Acre) and Haifa after suffering persecution in neighbouring countries.&nbsp; He was impressed with the beauty of Mount Carmel and expressed the desire that the Bab (one of the central figures of the Baha’i faith) would be buried there. About 20 years later the bones of the Bab were laid to rest in Haifa on the site that then developed into the centre of The Baha’i faith which is visited by half a million people every year.</p>
  //                         `
  //     }
  //   }
  // },

  // {
  // 		id:"The_Sea_Of_Galilee",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"haG-t3wwuMc",
  //         title : "THE SEA OF GALILEE (KINNERET )",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `

  //                         `
  //     }
  //   }
  // },

  {
    id: "Rosh_Pina",
    ctg: "north",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: true,
    vidId: "_qKbHL5-qrQ",
    title: "ROSH PINA",
    smltitle: "",
    html: function() {
      return {
        __html: `  
						           
                                   <br/>
                                   <h2 class="ac-align-center ac-margin-top-20">La destination touristique pastorale secrète de la Galilée</h2>
						           
								    <p class="ac-align-center ac-margin-bottom-20"><strong>Remontez le temps dans un village pittoresque et authentique de Galilée </strong></p>
									<p>Connu sous le nom de Princesse de la Galilée, Rosh Pina offre une combinaison parfaite de sites naturels, culturels, historiques et de divertissement. Rosh Pina est un village du nord, magnifiquement restauré, où les vieux oliviers et les maisons pittoresques sont entourés de luxuriants champs dorés. C'est l'endroit parfait pour vivre des vacances tranquilles et décontractées, et retrouver la vie d'un village telle qu'elle se déroulait il y a plus d'un siècle.</p>
									<p><strong>Seul le chant des oiseaux vient briser la magie du silence</strong></p>
									<p>Vous recherchez un lieu serein blotti dans la nature, qui rappelle la Toscane ou la Provence ? En vous dirigeant vers le nord jusqu'à Rosh Pina, où les paysages ruraux à couper le souffle se marient harmonieusement aux attraits du village, vous vous sentirez transporté dans le passé. Posez vos bagages dans une des nombreuses maisons d'hôtes équipées pour vous assurer un confort optimal, qui parsèment les ruelles romantiques du village. Ressourcez-vous au sein de cette communauté accueillante au charme désuet, épargnée par l'agitation des grandes villes.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/rosh-pina/1.jpg"} class="img-responsive">
								   </div>
									<p>Profitez de la beauté naturelle des lieux et baladez-vous dans la verdure, le long des superbes <strong>chemins de randonnée</strong> environnant la rivière de Rosh Pina ou les <strong>Jardins du Baron de Rotschild</strong>, dont on dit qu'ils s'inspirent des grands jardins de Versailles. Au cours de votre promenade, respirez l'air frais et imprégnez-vous de la beauté de la nature jusqu'à ne faire plus qu'un avec elle. Ressourcez-vous.</p>
									<p><strong>Un lieu de villégiature au charme artistique unique</strong></p>
									<p>Le long des rues pavées du village, qui rappellent les vieux villages européens, vous pourrez jouir d'une agréable atmosphère culturelle et artistique, dans ce site qu'entourent les magnifiques montagnes de la Galilée. Le village abrite des cafés branchés, des restaurants gastronomiques, des galeries d'art, des musées, des festivals, des sites historiques et un centre commercial. Il regorge d'antiquités, de lieux culturels et naturels, de délices culinaires qui évoquent toute l'histoire de la première «&nbsp;moshava de Galilée&nbsp;» (ville) et de l'implantation des premières communautés juives en Israël.</p>
																	  						   
		                        `,
      };
    },
  },

  {
    id: "Nazareth",
    ctg: "north",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: true,
    vidId: "1M7N5BcmjFM",
    title: "NAZARETH LE BERCEAU DU CHRISTIANISME",
    smltitle: "",
    html: function() {
      return {
        __html: ` 

						        

								   <p><b>Une ville ancienne, riche de sites archéologiques fascinants, d'une culture moderne et du charme du Moyen-Orient</b><strong>&#8203;</strong></p>
									<p>Nazareth, ou Natsrat tel que prononcé en hébreu, est le berceau du christianisme. C'est la ville où, selon la tradition, l'ange Gabriel annonça à Marie qu'elle concevrait par la puissance du Saint-Esprit, et l'endroit où Jésus passa son enfance et sa jeunesse. Située en basse Galilée, Nazareth est blottie au cœur d'une vallée entourée de montagnes et abrite plusieurs lieux saints chrétiens parmi les plus importants. C'est une ville de religion et de foi, de spiritualité et de sainteté, mais également une ville qui a une histoire riche, des vestiges archéologiques fascinants, une culture moderne et un charme moyen-oriental.</p>
									<p><strong>Le berceau du christianisme</strong></p>
									<p>À sa naissance il y 2000 ans, Nazareth n’était qu'un petit village juif. Quelques centaines d'années plus tard, au cours de la période byzantine, elle devint une place forte du christianisme. Durant cette période, le nom de Nazareth se répandit au loin, et le désir de découvrir le lieu où vécurent la Vierge Marie et Jésus firent de la ville un site de pèlerinage très fréquenté. Ces visites conduisirent à la construction de la première église de la ville, la basilique de l'Annonciation, à l'endroit où la tradition situe la maison de Joseph et Marie. De nombreuses autres églises ont été construites dans la ville, pour être détruites et reconstruites au fil des siècles, sous la domination successive des musulmans et des chrétiens. Au 19ème siècle, Nazareth suscita un nouvel engouement : des chrétiens revinrent y vivre et rebâtirent des églises et des monastères. Aujourd'hui, Nazareth est la plus grande ville arabe d'Israël. Elle compte environ 30 églises et monastères, ainsi que des mosquées et d'anciennes synagogues.</p>
									<p><strong>Un avant-goût de la vieille ville </strong></p>
									<p>La visite de Nazareth nous fait revivre plusieurs époques. Chacune d'entre elles a laissé derrière elle un symbole puissant qui, à l'époque moderne, est devenu un site touristique de premier ordre. La plupart des sites se trouvent dans la vieille ville, qui fut construite au milieu du 19<sup>ème</sup> siècle dans un style architectural qui lui confère un charme moyen-oriental. Rien ne vaut une balade dans ses ruelles étroites bordées de maisons pittoresques. Ne vous pressez pas, il faut marcher lentement pour apprécier pleinement leur beauté.</p>
									<p>La vieille ville recèle un grand nombre d'églises anciennes, la basilique de l'Annonciation étant la première d'entre elles. L'église rebâtie a conservé des éléments des églises précédentes, datant de la période byzantine et des croisades. Elle abrite également une impressionnante collection de peintures.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/nazareth/1.jpg"} class="img-responsive">
								   </div>
									<p>À deux pas de la basilique se trouve l'Église Saint-Joseph, bâtie sur les ruines de bâtiments agricoles où, selon la tradition, Joseph, l'époux de Marie, avait son atelier de charpentier. Alors que la basilique de l'Annonciation a été construite sur le site de la maison de Marie, l'Église grecque orthodoxe de l'Annonciation est construite à l'emplacement de la source du Puits de Marie, dont il est dit que la mère de Jésus a bu l'eau. Cette construction datant des croisades abrite des fresques intéressantes. <strong>Tout près du Puits de Marie se trouve l'Église orthodoxe grecque de l'Annonciation</strong>, dans une construction datant des croisés. Selon la tradition, ici se trouvait la synagogue dans laquelle allait prier Jésus.</p>
									<p>Parmi les nombreuses autres églises de Nazareth, on compte l'Église de la Mensa Christi, l'Église maronite, l'Église Saint-Gabriel et l'Église salésienne. La vieille ville compte également d'importants bâtiments de la période ottomane, dont le Saraya, ou palais du gouvernement, construit par Daher el Omar, gouverneur de la Galilée au 18ème siècle, et la Mosquée blanche, aujourd'hui utilisée comme maison de prière et centre culturel. La Mosquée blanche abrite également un musée dont les collections documentent l'histoire de Nazareth.</p>
									<p>Aucune visite de la vieille ville de Nazareth ne serait complète sans une visite du marché local, qui est devenu une attraction appréciée et bien connue grâce à ses éventaires colorés et à la variété de ses marchandises. Vous pourrez y admirer le festin visuel des étoffes, goûter aux épices et aliments locaux, et acquérir des objets artisanaux et des souvenirs. Tous ces sons, spectacles, odeurs et saveurs vous feront vivre une expérience authentiquement moyen-orientale.</p>
									<p><strong>Un aperçu du charme du Moyen-Orient</strong></p>
									<p>Nazareth regorge d'endroits fascinants et charmants qui ne pourront que vous séduire. La promenade qui longe la chaîne de montagnes Nabi Sain est un autre lieu à ne pas manquer. Cette balade à pied vous fera découvrir une vue magnifique sur la Galilée. Vous pouvez visiter les anciens bains turcs découverts pendant la rénovation de l'un des magasins de la ville, et découvrir un élégant manoir qui vous dévoilera la riche existence et les coutumes de la haute société ottomane au 19<sup>ème</sup> siècle, ainsi que ses fresques magnifiques. La maison de l'évêque grec orthodoxe vaut également le détour. Vous pourrez y parcourir un réseau de passages souterrains qui ont été découverts dans la cour. Un autre site intéressant est le complexe construit par les Russes, destiné à servir d'auberge pour les pèlerins.</p>
									<p>Nazareth accueille des pèlerins depuis des siècles. Ses auberges chrétiennes et ses hôtels de luxe assureront le confort des nombreux touristes visitant la ville, en particulier pendant la période de Noël. La gastronomie n'est pas en reste, avec des dizaines de restaurants élaborant une cuisine savoureuse dont les merveilleux arômes attirent les visiteurs tout au long de l'année. C'est à Noël que Nazareth apparaît dans toute sa gloire, lorsque la ville est décorée et que ses couleurs et sa ferveur s'unissent à l'atmosphère sainte et à l'écho des prières provenant des églises de la ville.</p>
																	  							   
		                        `,
      };
    },
  },

  {
    id: "Nazareth_1",
    ctg: "north",
    bgImage: "/posts/bank/north3/1.jpg",
    mobBgImage: "/posts/bank/north3/M.jpg",
    isVid: true,
    vidId: "1M7N5BcmjFM",
    title: "NAZARETH : UN JOYAU AUX MULTIPLES FACETTES",
    smltitle: "",
    html: function() {
      return {
        __html: ` 

						        
                                    <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Un cœur sacré antique aux fascinants accents de modernité</h2>
								    <p>Connue dans le monde entier comme la ville où Jésus a grandi, Nazareth est une destination clé pour les pèlerins chrétiens et constitue un véritable joyau n'attendant qu'à être dévoilé. Les papes Jean-Paul II et Benoît XVI n'ont pas manqué de faire figurer la ville dans leur programme de visite dans la région, comme le font les dizaines de milliers de touristes qui se rendent à Nazareth chaque année.</p>
									<p>Une kyrielle de sites religieux sains, un riche passé, des marchés colorés, une scène gastronomique particulièrement active, une hospitalité exceptionnelle, et d'innombrables attractions touristiques ne sont que quelques raisons pour lesquelles aucune visite en Israël ne saurait être complète sans un détour par Nazareth.</p>
									<p>Laissez-vous séduire par cette ville multiculturelle fascinante et passionnante, et découvrez ses multiples visages. Vous ne pourrez qu'en tomber amoureux.</p>
									<p><strong>Marchez dans les pas de Jésus de Nazareth</strong></p>
									<p>Découvrez le berceau du christianisme et imprégnez-vous de l'atmosphère spirituelle unique de la ville. Marchez sur les traces de Jésus, qui y a passé son enfance et sa jeunesse entouré de sa famille.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() + "/posts/nazareth/1.jpg"} class="img-responsive">
								    </div>
									<p>Visitez la superbe <strong>basilique de l'Annonciation</strong> qui, selon la croyance chrétienne, a été construite à l'endroit même où l'ange Gabriel a annoncé à la Vierge Marie qu'elle était enceinte de Jésus. Contemplez la charmante <strong>église Saint Gabriel</strong> et traversez le <strong>Puit de Marie</strong> dont les eaux, dit-on, possèdent des vertus curatives. Ne manquez pas l'<strong>église de la synagogue, </strong>qui aurait été bâtie sur les ruines de l'ancienne synagogue de Jésus.</p>
									<p>Poursuivez votre exploration et découvrez les nombreux sites touristiques de la ville. Visitez le <strong>Village de Nazareth Village</strong> et le <strong>centre international «&nbsp;Marie de Nazareth&nbsp;»</strong>, où vous verrez l'histoire prendre littéralement vie. Gravissez le <strong>Mont du Précipice</strong> où, selon la tradition, le peuple de Nazareth a tenté de jeter Jésus de la falaise. Imprégnez-vous del ‘énergie spirituelle du lieu et profitez de la vue panoramique exceptionnelle.</p>
									<p>Un conseil&nbsp;: il y a tant à faire et à voir, pourquoi ne pas participer à une visite guidée&nbsp;? Rien de mieux pour découvrir un lieu que de le voir à travers les yeux d'une personne qui y habite.</p>

									<p><strong>Découvrez les nombreux centres d'intérêt de Nazareth ainsi que son hospitalité renommée</strong></p>
									<p>Pas de doute, la plus grande ville arabe d'Israël a fait son chemin depuis l'époque romaine où elle n'était encore qu'un petit village. Aujourd'hui, c'est une ville cosmopolite moderne et animée qui jouit d'une vie culturelle riche, d'une scène gastronomique bouillonnante et d'une grande hospitalité.</p>
									<p>Embarquez-vous dans une aventure urbaine. Déambulez dans les allées pavées des marchés animés et imprégnez-vous des odeurs, des saveurs et des sons. Installez-vous dans un café et vivez une expérience culturelle et culinaire authentique et de qualité. Musique et conversations passionnantes sont inscrites au menu. Attablez-vous dans les restaurants locaux et dégustez certains des plats les plus créatifs et les plus savoureux que vous n’ayez jamais mangés. Notre conseil&nbsp;: ne faites pas l'impasse sur le dessert.</p>
									<p>Explorez aussi l'architecture et les musées de la ville, sans oublier la fabrique de «&nbsp;halva&nbsp;». Séjournez dans un des nombreux hôtels, pensions, auberges et lieux d'hébergement divers. Au loin, écoutez les cloches retentir en parfaite harmonie chaque jour à midi en mémoire de l'annonciation. À Nazareth, la vie prend tout son sens.</p>
									<p><span>photo credit: &nbsp;Dafna Tal, Mordagan</span></p>
															  							   
		                        `,
      };
    },
  },

  // {
  // 		id:"Cheers_To_Israel",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"Cxii1yKqKwI",
  //         title : "GREAT WITH WHITE OR RED",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `  <p>Over the past decade, Israeli wine-making has become a vital and thriving industry.</p>
  //                                  <p>The fertile land of the area has been recognized worldwide as an excellent setting for burgeoning vineyards, and the local scene is trendy and opulent.</p>
  //                                  <p>In the north, the general atmosphere reminiscent of French or Italian wine regions while the south&nbsp;has become renowned for its burgeoning&nbsp;wine scene, thanks to pioneering farmers and their use of computerized drip irrigation.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/cheers-to-israel/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						    <p><span style="font-family: arial,sans-serif;">The Israeli wine scene allows visitors a fantastic experience combining delectable wine tastings with the stunning vistas and energy this has to offer.</span></p>
  // 						   <p>So come get a taste of Israel’s wine country through its many fantastic tours of the vineyards and boutique wineries, the fantastic wine and music festivals and year-round wine-themed events.</p>
  // 						   <p>FYI, a visit to Israel goes great with white or red.</p>

  //                         `
  //     }
  //   }
  // },

  {
    id: "A_Galilean_Treat",
    ctg: "culinarynorth",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: true,
    vidId: "kF808ENuuTQ",
    title: "DES VACANCES GASTRONOMIQUES EN GALILÉE",
    smltitle: "",
    html: function() {
      return {
        __html: `  
						          <br/>
						          <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Un paradis pour les gourmets</h2>                          
                                  
								   <p>Une visite en Galilée vous permettra de découvrir des saveurs et parfums que vous n'avez encore jamais rencontrés. Fromages régionaux fabriqués dans des fromageries artisanales, vins de classe mondiales à découvrir dans les domaines viticoles, restaurants familiaux raffinés servant des fruits et légumes fraîchement cueillis et riches en saveurs&nbsp;: la Galilée est vraiment le paradis des gourmets.</p>
									<p><strong>Une région où lait et vin coulent à flot</strong></p>
									<p>Visitez une fromagerie artisanale, découvrez la diversité des fromages de Galilée et assistez à leur fabrication. Laissez-vous guider par un fromager expérimenté qui vous fera déguster un assortiment de fromages uniques de la région, à pâte molle, ferme et semi-ferme. Vous goûterez au <em>labané,</em> un fromage doux et crémeux à base de lait de brebis ou de chèvre, à la texture similaire à celle du yoghourt, et souvent vendu mélangé à des herbes locales, comme c'est le cas du za’atar, ou du <em>zefatit</em>, un fromage salé à base de lait caillé de brebis moulé dans un panier et portant le nom de la région de <em>Zefat</em>, ou Safed, d'où il est originaire.</p>
									<p>Si vous aimez boire du vin pour accompagner votre fromage, vous ne serez pas déçu. Chaque vin est meilleur que le précédent&nbsp;! La révolution qu'a connue récemment la fabrication du vin a entraîné la multiplication des caves viticoles sur l'ensemble du terroir extrêmement varié de Galilée, chaque vignoble produisant un cépage à la saveur unique due au sol sur lequel il a poussé. Caressez du regard les plaines tapissées de vignes pendant que vous savourez un vin rouge fruité et profond ou un vin blanc frais que vous auront conseillés de grands viticulteurs israéliens. Découvrez les combinaisons de cépages qui ont servi à produire des vins primés lors de foires aux vins internationales - et commercialisés seulement en Israël pour un grand nombre.</p>
                                    <div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/galilean-treat/1.jpg"} class="img-responsive">
								    </div>
									<p><strong>Goûtez la récolte</strong></p>
									<p>Visitez des vergers dans lesquels vous pouvez ramasser vos propres fruits, et dégustez des baies, pommes, cerises, pêches, prunes et même des figues de barbarie charnues, juteuses et débordantes de saveur. Faites halte dans les fermes d'épices pour humer et goûter un choix sans cesse renouvelé d'herbes et d'épices. Vous en reconnaîtrez certaines, mais vous en découvrirez que vous n'avez jamais rencontrées. Découvrez les parfums de la Galilée et créez vos propres infusions et mélanges d'épices.</p>
									<p>Une autre récolte importante vous attend en Galilée&nbsp;: celle de l'olive. Si vous pensiez que toutes les huiles d'olive ont le même goût, une visite dans une fabrique familiale d'huile d'olive de la région vous fera changer d'avis. Goûtez différentes huiles d'olive pour découvrir ce qui les différencie et passez un bon moment en participant à la récolte des olives et à leur pressage à l'ancienne. Vous fabriquerez ainsi votre propre huile d'olive extra-vierge.</p>
									<p><strong>Marchés et restaurants</strong></p>
									<p>Les villes anciennes de Galilée proposent de nombreux marchés sur lesquels vous pourrez acheter les meilleurs produits locaux et artisanaux, souvent vendus par les personnes qui les ont fabriqués. Flânez sur les marchés pour goûter aux délices qui vous attendent au détour de chaque allée, ou suivez un guide spécialisé qui vous conduira aux meilleurs étals et aux mets les plus fins.</p>
									<p>En vous laissant guider par vos papilles, vous découvrirez en Galilée des restaurants de grande qualité dans les lieux les plus improbables. La meilleure cuisine du pays est parfois servie dans des restaurants sans prétention offrant un panorama magnifique. Un grand nombre d'entre eux sont gérés en famille et servent des plats élaborés avec amour à partir d'ingrédients cultivés ou produits à seulement quelques kilomètres de là. Mais pour apprendre à vraiment connaître les produits fabriqués en Galilée, vous devrez participer à un atelier cuisine. Ils sont animés par des chefs locaux qui connaissent le terroir sur le bout des doigts et qui ne demandent qu'à partager leurs secrets concernant le choix, la préparation et la dégustation des produits locaux les plus savoureux. Souvent, vous irez choisir vos ingrédients avant de les cuisiner puis vous confectionnerez les plats les plus délectables que vous n’aurez jamais préparés.</p>
									<p><strong>L'expérience unique de la Galilée</strong></p>
									<p>Or, la Galilée ne se limite pas à ses délicieuses saveurs. Visitez des forteresses en ruine et des sites bibliques dans lesquels Jésus a prêché et où des batailles ont été livrées. Passez les vacances de vos rêves en Galilée, en gravissant des montagnes, en vous lançant dans des descentes en eaux vives ou en vous promenant le long de ruisseaux...</p>
																	  		   
		                        `,
      };
    },
  },

  {
    id: "Galilee_Action",
    ctg: "north",
    bgImage: "/posts/bank/north2/1.jpg",
    mobBgImage: "/posts/bank/north2/M.jpg",
    isVid: true,
    vidId: "5Ep3GgxELag",
    title: "BOUGEZ EN GALILÉE",
    smltitle: "",
    html: function() {
      return {
        __html: ` 


						           

								    <br/>
								    <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Des activités inattendues en Galilée</h2>
								    <p>En Galilée, les occasions de se divertir sont nombreuses pour les aventuriers de tous âges&nbsp;: sur les rivières, sur les lacs ou en bord de mer. Les amateurs de frissons pourront sentir les embruns sur leurs visages lorsqu'ils défieront leurs amis dans une course de kayak en eau vive, tandis que familles et couples pourront se détendre en voyant défiler doucement les rivages verdoyants d'une des nombreuses rivières de Galilée. Vous pouvez vous rafraîchir en participant à une des nombreuses activités nautiques proposées sur le lac de Tibériade, comme le ski nautique, la banane tractée ou le kite surf. Les touristes adorent se faire dorer sur les plages de sable qui longent la côte ou visiter les grottes de Rosh Hanikra, d'une beauté presque surnaturelle.</p>
									<p>Vous pourrez pratiquer des sports extrêmes aussi bien sur terre, que dans l'air ou dans l'eau. Les plus sportifs pourront faire monter l'adrénaline en s'essayant à des activités comme le parachutisme, la randonnée en jeep sur les pistes montagneuses abruptes ou la descente de falaises en rappel. En hiver, profitez de la neige sur le mont Hermon, en pratiquant le ski ou le snowboard sur des pistes de tous niveaux.</p>

									<h2>La Galilée&nbsp;: une nature généreuse d'une beauté saisissante</h2>
									<p>La Galilée regorge de splendides paysages naturels dans lesquels familles, amoureux et groupes d'amis peuvent se promener, observer la vie sauvage ou tout simplement pique-niquer dans un cadre paisible. Que vous partiez à cheval sur des sentiers retirés ou empruntiez des pistes soigneusement balisées à pied ou à vélo&nbsp;: beauté, plaisir et divertissement seront au rendez-vous. Si vous avez envie de calme, partez à la rencontre de la nature en observant les oiseaux et la vie sauvage dans la réserve naturelle de la vallée de la Houla, ou admirez la magie de la mosaïque de forêts, champs et rivières qui s'étale sous vos yeux lorsque vous vous élevez dans les airs en montgolfière depuis le mont Guilboa. Pour ne rien oublier, laissez-vous gagner par la spiritualité en visitant des sites saints chrétiens, juifs et bahaï.</p>
									<div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/galilee-action/1.jpg"} class="img-responsive">
								    </div>
									<p>Les nombreux chemins de randonnée de Galilée attirent les promeneurs de tous âges, tout au long de l'année. Si vous préférez les promenades ombragées le long des ruisseaux, l'escalade et la descente en rappel, ou le plaisir simple d'un splendide panorama au terme d'une montée difficile, vous trouverez la piste qui répondra à vos attentes. En Galilée, tout est possible.</p>
									
								   
								   
		                        `,
      };
    },
  },

  // {
  // 		id:"Bet_Shean",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "BET SHE’AN",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `  <p>South of the Sea of Galilee are the remains of one of the largest cities in the Roman-Byzantine Empire, Bet She’an. One of ten ancient cities (hence “Decapolis”) that included Philadelphia (present day Amman in Jordan) and Jerash, Scythopolis ((Bet She’an) was the only decapolis city west of the Jordan river.  It was very grand, with a giant theater, streets of tall columns, shops, bathhouses a hippodrome and hundreds of homes.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/bet-shean/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>However, the splendid city was toppled in 749 by a massive earthquake, and never rebuilt. Over the centuries the ruins were overgrown – and it was not until the mid-20th century that Israeli archeologists pulled Bet She’an out of the murk, discovering (and restoring) the theater, the Cardo, the columns and much more.</p>

  //                         `
  //     }
  //   }
  // },

  // {
  // 		id:"Zichron_Yaakov",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "ZICHRON YA’AKOV",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: ` <p>Zichron Ya’akov is a wonderful town for tourists, both local and foreign. This picturesque moshava semi-cooperative farming community built at the tip of the Carmel mountain range is the first moshava ever built in Israel and is a main tourism and vacation site in this region.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/zichron-yaakov/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						    <p>Anyone who visits&nbsp;<strong>Zichron&nbsp;Ya’akov&nbsp;</strong>goes straight to Ha-Nadiv Street, and Ha-Meyasdim Street in the town center, which has become a very popular pedestrian mall, thanks to the special atmosphere in this place. The streets are paved with stones and pass between the moshava’s original houses (some of which have been reconstructed), which are bustling with activity.</p>
  // 						   <p>There are many quaint and charming restaurants and coffee shops, interspersed between beautifully designed stores that sell local art works and lovely souvenirs. There are art galleries, unique artists' studios and workshops. New, modern buildings stand alongside old ones, such as the synagogue and the administration building, an old courtyard with a display of antique agricultural implements.</p>
  // 						   <p>From its early days,&nbsp;<strong>Zichron Ya’akov</strong>&nbsp;had two main characteristics: wine and tranquility. The moshava’s founding farmers cultivated vineyards and the large winery built here in 1889 became the area’s most important industry. During the British Mandate period (1917-1948), the moshava became a holiday resort and rural vacations site, and to this day has hotels, spas and guesthouses.</p>

  //                         `
  //     }
  //   }
  // },

  // {
  // 		id:"Discover_The_Wine_Routes",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:true,
  //        	vidId:"Cxii1yKqKwI",
  //         title : "DISCOVER THE WINE ROUTES",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `  <p>Discover a different Israel through it's wineries and vineyards, through the passion of the people who are crafting award winning wines from home grown grapes.</p>
  //                                  <p>Enjoy vintage wines, gourmet foods, and gorgeous scenery. Spend time experiencing Israel as you never have before, as a Wine Connoisseur! The beauty of these routes in Israel is of course the authentic wine but also the incredible landscapes that surround the wineries. Many of the wineries are situated near ‘Zimmers’ which are little spa complexes that are dotted around northern Israel. They have little cabins with Jacuzzis that face out to the magnificent views of the rolling green hills. You can relax in your personal cabin with a splendid glass of wine from the local winery.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/discover-the-wine-routes/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <div class="wpb_wrapper"><p>The Middle East &amp; Eastern Mediterranean was the cradle of wine production, and the ancient land of Canaan is in fact one of the earliest countries to cultivate wine over 2,000 years before the vine came to Europe.</p><p>There are currently over 25 commercial wineries and over 150 boutique wineries in Israel where wine making has become a personal obsession with wine makers striving to produce world class wines.</p><p>Israel like other 'long' countries such as Chile or Italy enjoys a variety of microclimates. While the northern region gets much rain and even snow in the winter, just a few hours away Israel's southern region is very arid with desert conditions. This range in microclimates supports many grape varieties, which can grow on several different types of soil, yielding excellent results.</p><p>As always in matters of taste, you must visit Israel’s wineries and vineyards and decide for yourself which is your favourite!</p><p></p></div>

  //                         `
  //     }
  //   }
  // },

  {
    id: "Birdtastic_Hula_Lake",
    ctg: "north",
    bgImage: "/posts/bank/north1/1.jpg",
    mobBgImage: "/posts/bank/north1/M.jpg",
    isVid: true,
    vidId: "ImobrsxsKl8",
    title: "LAC DE LA HOULA",
    smltitle: "",
    html: function() {
      return {
        __html: `  
						<br/>
						<h2 class="ac-align-center ac-margin-top-20">La Nature Dans Toute Sa Splendeur</h2>
						
								   

								   <p  class="ac-align-center ac-margin-bottom-20"><strong>Découvrez l’un des principaux sites ornithologiques au monde</strong></p>
									<p>Au cœur de la très pittoresque Vallée de la Houla, en Haute Galilée, à seulement deux heures de route du nord à Tel Aviv, se trouve le Lac de la Houla, un lieu d'une extraordinaire beauté entre deux chaînes montagneuses. Cette réserve marécageuse écologique de renommée internationale est également l’un des plus importants sites ornithologiques au monde, véritable oasis pour les oiseaux et les amoureux de la nature. Grâce à l'opportunité unique qui vous est offerte de profiter d'une nature sans barrières ni limites, vous vivrez une expérience unique.</p>
									
								<p><strong>Suivez les oiseaux et les merveilles de la nature&nbsp;&nbsp; </strong></p>
								<p>À chaque saison de migration (printemps et automne), plus de 500 millions d'oiseaux et près de 400 espèces passent au-dessus du Lac de la Houla. Ce paradis marécageux est la halte parfaite pour les sauvagines, cormorans, hérons, pélicans, rapaces, cigognes et grues.</p>
								<p>Classé par la BBC Wildlife parmi les dix principaux sites ornithologiques mondiaux, le Lac de la Houla (Agamon Hula en hébreu), attire des ornithologues de toutes nationalités. Participez au festival international des oiseaux de Houla, organisé chaque année à l'automne, et vivez une expérience inoubliable.&nbsp;</p>
								<div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/birdtastic-hula-lake/1.jpg"} class="img-responsive">
								   </div>
								<p>Pour profiter pleinement du festival, plusieurs possibilités s'offrent à vous. À vous de choisir l'aventure que vous souhaitez vivre.</p>
								<p><strong>Parcourez les chemins</strong>. Aventurez-vous sur les chemins du parc naturel. À pied, à vélo ou en voiturette électrique, c'est vous qui choisissez. Entre les vergers, vous traverserez des canaux et aurez un aperçu de la vie sauvage dans les marécages.&nbsp;</p>
								<p><strong>Partez en tracteur. </strong>Inscrivez-vous à une visite guidée "Safari Wagon", en tracteur, pour vous enfoncer encore plus dans le lac Agamon. Dissimulé dans la remorque du tracteur, vous pourrez approcher ces magnifiques oiseaux au plus près.&nbsp;</p>
								<p><strong>Au lever du soleil ou de nuit.</strong> Pour les plus aventureux, deux visites spéciales sont proposées. La première ("Sunrise Tour"), a lieu au lever du soleil, et permet d'observer et photographier les oiseaux dans les meilleures conditions. La seconde ("Night Owl Tour") offre une autre perspective de la réserve. Près d'un feu de camp et sous les étoiles, vous observerez les chats sauvages, rapaces nocturnes et roussettes.&nbsp;</p>
								<p><strong>Vivez une expérience enrichissante et observez les opérations menées pour préserver la nature&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </strong></p>
								<p><em>Agamon</em> Hula est reconnu dans le monde entier comme un système écologique durable qui trouve le juste équilibre entre nature, tourisme et agriculture.</p>
								<div class="img-wrapper">
									   <img src=${getImgUrl() +
                       "/posts/birdtastic-hula-lake/2.jpg"} class="img-responsive">
								   </div>
								<p>Visitez le centre de baguage du parc et observez ce qui est fait pour protéger la nature. Participez à la visite "bird Island tour" et vous aurez peut-être la chance d'aider à relâcher un oiseau dans son milieu naturel. On ne fait pas mieux !</p>
								<p>Grâce à ses innombrables espèces animales et au travail accompli pour protéger la nature de manière originale, le Lac de Houla offre bien plus qu'une promenade sympathique dans cadre magnifique : c'est une expérience dont vous sortirez enrichi, le cœur et l'esprit plus ouverts.&nbsp;</p>
																	                        
		                        `,
      };
    },
  },

  // {
  // 		id:"The_Kibbutz_Experience",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "THE INCOMPARABLE KIBBUTZ EXPERIENCE",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  // 				           <p>Predominantly based amongst beautiful landscape settings dotted around the country the Kibbutz life is a modern day phenomenon and a totally unique way of living. The movement which started in 1905 is a collective community way of living traditionally based on agriculture. Each kibbutz would sell its own produce.  The people living on them would all collectively work together to preserve it and work the land.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/kibbutz-experience/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						    <p>The word ‘Kibbutz’ in Hebrew means group.&nbsp;The point being it is a voluntary democratic community where people live and work together to generate economically. It is founded on the principles of communal ownership of property and social equality.</p>
  //                                  <p>Some would describe the beautiful settings and a life of equality a utopia and why not experience it for yourself?&nbsp; Many of the Kibbutzim are open to visitors whether you would like to stay a few hours or a few months learning what this life is all about.</p>

  //                         `
  //     }
  //   }
  // },

  // {
  // 		id:"National_Parks",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "NATIONAL PARKS",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `

  // 				          <p>Despite Israel being small its scenery varies immensely! You will find new cities and old, beaches and lakes, deserts and green mountains. Israel’s National parks and nature reserves make all this possible for you to experience the wondrous landscapes.</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/national-parks/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>In the south of the country you will find the expanse of the golden and orange plains of the desert. The Negev, Arava and Eilat are the fiery beautiful landscapes of the south that home the Dead Sea, Mitzpe Ramon and the beautiful desert oasis of En gedi not mention some wonderful hiking and cycling trails. When the sun sets the south turns in to a red illuminous sea of magic and when dark the sky turns in to a blanket of sparkles as the vast scenery makes it possible to see every star.</p>
  //                                  <p>In the North of the country you are welcomed with Luscious green hills and mountains including the snow-capped Mount Hermon.&nbsp; The Golan Heights home to magnificent mountainous scenery and an array of cultures.&nbsp; There are endless forest trails and water fall hikes for all the family to enjoy. The view from the mountain tops is breath taking as your eyes take you all the way out to the Mediterranean. Below the mountains you will find the green slopes of the Galilee home to the famous Kinneret, wineries and some wonderful relaxation spa’s. It really is a wonderland.</p>
  // 						   <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/national-parks/2.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>The national parks offer exciting cultural and natural adventures. You have the opportunity to visit magnificent historical sites and follow wonderful nature trails while searching for some of the countries species i.e. The desert ibex and leopards, Eagles in the Golan. The impressive diversity of natural wonders, encounters with unspoiled nature and with plants.</p>
  //                         `
  //     }
  //   }
  // },

  // {
  // 		id:"Tiberias",
  //        	ctg : "north",
  //         bgImage : "/HomeSlider/desktop/4.jpg",
  //         mobBgImage : "/HomeSlider/M/3.jpg",
  //        	isVid:false,
  //         title : "TIBERIAS (TVERYA)",
  //         smltitle : "",
  //         html: function(){
  // 			return {
  // 				__html: `
  // 				           <p>Located at the shores of the Sea of Galilee, Tiberias, the capital of the Galilee, was established in the early Roman period and has served as a religious, administrative and culture center of the Jewish people for many years.</p>
  //                                 <p>In addition to its rich history and significance, modern day Tiberias is synonymous with holiday in Israel. Here one can enjoy a variety of activities the city has to offer, and experience a wonderful mix of relaxation, nature and history, along with contemporary attractions, active water sports, pilgrimage sites and unique tourist attractions</p>
  //                                 <div class="img-wrapper">
  // 							   <img src=${getImgUrl()+ "/posts/tiberias/1.jpg"} class="img-responsive">
  // 						   </div>
  // 						   <p>A visit to Tiberias is not complete without a visit to its surrounding area, which features many must-see sights, including The city Bet Shean, one of the oldest cities in the world, and one of the country’s largest archaeological sites; Magdala (Migdal) the ancient town on the Sea of Galilee which was home to many of Jesus’s disciples and is said to have been the home of Mary Magdalene; Megiddo, a beautiful and impressive national park and one of the most important archeological sites in Israel from the time of the Bible. Once an ancient city of critical strategic importance, Megiddo is a UNESCO World Heritage Site, and an inspiring location for lovers of history and archeology.</p>

  //                         `
  //     }
  //   }
  // },

  {
    id: "Privacy_Policy",
    ctg: "telaviv",
    bgImage: "/HomeSlider/desktop/1.jpg",
    mobBgImage: "/HomeSlider/M/3.jpg",
    isVid: false,
    title: "PRIVACY POLICY",
    smltitle: "",
    html: function() {
      return {
        __html: `


							<p><u><span>Last updated</span></u><span>: March 4, 2020</span></p>
							
							<h3><span>OUR COMMITMENT TO YOU</span><span>&nbsp;</span></h3>
							<p>We, at&nbsp;The Israeli government, the Ministry of Tourism ("<strong>us</strong>", "<strong>we</strong>" or the<strong>&nbsp;"Ministry</strong>") respect the privacy of our users (each, a "<strong>User</strong>" or "<strong>you</strong>") and are committed to protect the privacy of Users who access, download, install, register, use or engage with our website, our mobile application(s), and any other service we provide (the<strong>&nbsp;</strong>"<strong>Website</strong>" and "<strong>App</strong>" respectively, and collectively the "<strong>Service(s)</strong>"). &nbsp;</p>
							<p>We've prepared this Privacy Policy to outline our practices with respect to collecting, using and disclosing your information when you use the Services. We encourage you to read this Privacy Policy carefully and use it to make informed decisions. By using the Services, you agree to the terms of this Privacy Policy and your continued use of the Services constitutes your ongoing agreement to the Privacy Policy.</p>
							
							<h3><span>CONTENTS</span></h3>
							<p>
							  <a href="#Grounds" style="color:#000"><span>1. </span>GROUNDS FOR DATA COLLECTION</a><br/>

							  <a href="#WhatType" style="color:#000"><span>2. </span>WHAT TYPE OF DATA WE COLLECT?</a><br/>

							  <a href="#HowDoWeUse" style="color:#000"><span>3. </span>HOW DO WE USE THE DATA WE COLLECT?</a><br/>

							  <a href="#Tracking" style="color:#000"><span>4. </span>TRACKING TECHNOLOGIES</a><br/>

							  <a href="#WitWhom" style="color:#000"><span>5. </span>WITH WHOM DO WE SHARE YOUR PERSONAL DATA?</a><br/>

							  <a href="#HowWeProtect" style="color:#000"><span>6. </span>HOW WE PROTECT YOUR INFORMATION</a><br/>

							  <a href="#Retention" style="color:#000"><span>7. </span>RETENTION</a><br/>

							  <a href="#UserRigths" style="color:#000"><span>8. </span>USER RIGHTS</a><br/>

							  <a href="#Transfer" style="color:#000"><span>9. </span>TRANSFER OF DATA OUTSIDE THE EEA</a><br/>

							  <a href="#OurPolicy" style="color:#000"><span>10. </span>OUR POLICY TOWARD CHILDREN</a><br/>

							  <a href="#HowToContactUs" style="color:#000"><span>11. </span>HOW TO CONTACT US?</a><br/>

							  <a href="#Updates" style="color:#000"><span>12. </span>UPDATES TO THIS POLICY</a><br/>
							</p>

							
							<h3 id="Grounds"><span>GROUNDS FOR DATA COLLECTION</span><span>&nbsp;</span></h3>
							<p><span>Processing of your “<strong>Personal Data</strong>” (meaning any information which may potentially allow your identification, either directly or by using reasonable means) is necessary for the performance of our contractual obligations towards you, for providing you with our Services and the operation of our Website, to protect our legitimate interests and for compliance with legal and regulatory obligations to which we are subject.</span></p>
							<p><span>When you use our Services, you consent to the collection, storage, use, disclosure and other uses of your Personal Information as described in this Privacy Policy.</span></p>
							
							<h3 id="WhatType"><span>WHAT TYPE OF DATA WE COLLECT?</span></h3>
							<h3><span>Personal Data</span></h3>
							<p><span>In the course of using the Services, we may collect certain Personal Data to provide and improve the Services, to contact or identify you, to enable you to access certain parts of the Service</span><span>&nbsp;or as otherwise indicated in this Policy. We collect the following Personal Data about you</span><span>:</span></p>
							<ul style="list-style-type: disc;margin-left:0in;">
							  <li><span>When you send us an email&nbsp;</span><span>or contact us through a contact form on the Website, we will collect your name and email address so we could respond to your inquiry. We may also collect any Personal Data that you choose to include in your inquiry to us.</span></li>
							  <li><span>Our webserver may also automatically collect your IP address, and unique online identifiers. These details are pseudonymized (cannot directly identify you) and are collected for the purpose of delivering relevant content and operating and improving our Service.</span></li>
							</ul>
							<h3><span>Non-Personal Data</span></h3>
							<p><span>We also collect data about the use of our Service and the characteristics and activities of users, in order to operate it and improve it. We may collect the following non-Personal Data:&nbsp;</span><span>Your operating system, device type, session start/stop time, time zone, network connection type (e.g., Wi-Fi, cellular), your general location (city and country), and general information regarding your browser and device.</span></p>
							<p><span>If we combine Personal Data with non-Personal Data, the combined data will be treated as Personal Data.&nbsp;</span></p>
							
							<h3 id="HowDoWeUse"><span>HOW DO WE USE THE DATA WE COLLECT?</span></h3>
							<ul>
							  <li><strong><span>Provision of the Service</span></strong><em><span>&nbsp;–&nbsp;</span></em><span>we will use the Personal Data you provide us for the provision and improvement of our Service, providing customer support and to respond to your queries.&nbsp;</span></li>
							  <li><strong><span>Service announcements</span></strong><span>&nbsp;- we will use your Personal Data to communicate with you and to keep you informed of our latest updates to our Service and offer you service offers.</span></li>
							  <li><strong><span>Analytics, surveys and research</span></strong><span>&nbsp;- from time to time, we may conduct surveys or test features, and analyze the data we have to develop, evaluate and improve these features, all in order to improve our Services and offerings, and think of new and exciting features for our users.</span></li>
							  <li><strong><span>Protecting our interests</span></strong><em><span>&nbsp;-&nbsp;</span></em><span>we may use your Personal Data when we believe it’s necessary in order to take precautions against liabilities, investigate and defend ourselves against any third party claims or allegations, investigate and protect ourselves from fraud, protect the security or integrity of our services and protect the rights and property of the Ministry, its users and/or partners.&nbsp;</span></li>
							  <li><strong><span>Enforcing of policies</span></strong><span>&nbsp;- we may use your Personal Data in order to enforce our policies, including but not limited to our <a href="https://goisrael.com/Posts/telaviv/Privacy_Policy" style="text-decoration:underline;color:#000" target="_blank"> Terms </a></span><span style="line-height:115%;font-family:Calibri;font-size:8.0pt;color:windowtext;">
								 
								</span><span style="line-height:;font-family:Calibri;line-height:;color:windowtext;">.&nbsp;</span></li>
							  <li><strong><span>Compliance with legal and regulatory requirements</span></strong><span>&nbsp;- we may use your Personal Data to investigate violations, and as required by law, regulation or other governmental authority, or to comply with a subpoena or similar legal process.</span></li>
							  <li><strong><span>Newsletter</span></strong><span>&nbsp;- we may use your Personal Data in order to send you our newsletter, if you subscribed to it. &nbsp;</span>
								<ol style="list-style-type: circle;">
								  <li><u><span>Opt-out of receiving our newsletter</span></u><span>&nbsp;- You may choose not to receive our newsletter by clicking on the “unsubscribe” link contained therein. Please note that even if you unsubscribe, we may continue to send you Service-related updates and notifications, or reply to your queries and feedback you provide us.&nbsp;</span></li>
								</ol>
							  </li>
							</ul>
							
							<h3 id="Tracking"><span>TRACKING TECHNOLOGIES</span></h3>
							<p><span>When you visit or access our Services we use (and authorize 3<sup>rd</sup> parties to use) pixels, cookies, events and other technologies (collectively, "<strong>Tracking Technologies</strong>"). Those allow us to automatically collect information about you, your device and your online behavior, in order to enhance your navigation in our Services, improve our Services’ performance, perform analytics and customize your experience. In addition, we may merge data we have with data collected through these tracking technologies and data we may obtain from other sources and, as a result, such data may become Personal Data.</span></p>
							<p>If you do not accept the use of cookies by us, please disable cookies by following the instructions below. However, please note that disabling cookies might seriously affect the function, User experience and other features of our Services.</p>
							<h3>Types of Tracking Technologies We Use</h3>
							<p>There are two broad categories of cookies: (a) <strong>First party cookies</strong>, served directly by us to your computer or mobile device, and (b) <strong>Third party cookies</strong>, served by a third party. We use third party cookies for functionality, performance and analytics, and social media purposes.</p>
							<p>Cookies can remain on your computer or mobile device for different periods of time. Some cookies are "session cookies" and expires upon closing of your browser. Other cookies are "persistent cookies", meaning that they survive after your browser is closed. They can be used by websites to recognize your computer when you open your browser and browse the Internet again.</p>
							<p>For example, we use a performance tracking technology tool called “<strong>Google Analytics</strong>” to collect information about the use of the Website. Google Analytics collects information such as how often users visit this site, what pages they visit when they do so, and what other sites they used prior to coming to this Site. We use the information we get from Google Analytics to maintain and improve the Site and our products. We do not combine the information collected through the use of Google Analytics with personally identifiable information. Google’s ability to use and share information collected by Google Analytics about your visits to this Site is restricted by the Google Analytics Terms of Service, available at 
							  <a href="//www.google.com/analytics/terms/us.html" target="_blank" style="text-decoration:underline;color:#000">www.google.com/analytics/</a>, and the Google Privacy Policy, available at 
							  <a href="//www.google.com/policies/privacy/" target="_blank" style="text-decoration:underline;color:#000">www.google.com/policies/</a>. You can opt-out of Google's collection of Personal Data through Google Analytics by downloading and installing the Google Analytics Opt-out Browser Add-on, available at 
							  <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" style="text-decoration:underline;color:#000">tools.google.com/dlpage/gaoptout</a>.
							</p>
							<h3><span>Interest-Based Advertising &amp; User Choice</span></h3>
							<p>Through our Services, we may display advertisements that are tailored to you, for example ads or partner services that are based on your recent browsing behavior. In order to tailor advertisements and services in which you might be interested, we as well as certain third parties may use Tracking Technologies to display advertisements based on your visits to the Websites, to target advertisements to you for products and services in which you might be interested, and to measure the effectiveness of the ads. You can turn off certain third party Tracking Technologies used for behavioral advertising purposes by visiting the Network Advertising Initiative&nbsp;or by visiting the&nbsp;DAA opt-out program&nbsp;or the&nbsp;EDAA consumer choice page&nbsp;(if you reside in the EU) using the links provided below. Please note that certain Tracking Technologies operate at the device and browser level, so to fully opt-out across devices, you will need to do so on each device and browser individually, as described below as well.</p>
							<h3><span>How to Manage Your Tracking Technologies Settings</span></h3>
							<p>There are various ways in which you can manage and control your Tracking Technologies settings. Please remember that, by deleting or blocking Tracking Technologies, some of the features of the Services may not work properly or as effectively.</p>
							<p style="margin-bottom:6.0pt;"><strong>Turning off cookies via your web browser
								<br>&nbsp;
							  </strong>Most web browsers will provide you with some general information about cookies, enable you to see what cookies are stored on your device, allow you to delete them all or on an individual basis, and enable you to block or allow cookies for all websites or individually selected websites. You can also normally turn off third party cookies separately. Please note that the settings offered by a browser or device often only apply to that particular browser or device. Information about cookies is usually found in the "Help" section of the web browser. Below are some links to some commonly used web browsers:</p>
							<p>
							  <a href="https://support.google.com/chrome/answer/95647?hl=en" target="_blank" style="text-decoration:underline;color:#000"><span>Google Chrome</span></a><br/>

							  <a href="https://support.microsoft.com/en-us/kb/260971" target="_blank" style="text-decoration:underline;color:#000"><span>Internet Explorer</span></a><br/>

							  <a href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer" target="_blank" style="text-decoration:underline;color:#000"><span>Mozilla Firefox</span></a><br/>

							  <a href="https://support.apple.com/kb/PH5042?locale=en_US" target="_blank" style="text-decoration:underline;color:#000"><span>Safari (Desktop)</span></a><br/>

							  <a href="https://support.apple.com/en-us/HT201265" target="_blank" style="text-decoration:underline;color:#000"><span>Safari (Mobile)</span></a><br/>

							  <a href="//support.google.com/ics/nexus/bin/answer.py?hl=en&amp;answer=2425067" target="_blank" style="text-decoration:underline;color:#000"><span>Android Browser</span></a><br/>

							  <a href="//www.opera.com/help" target="_blank" style="text-decoration:underline;color:#000"><span>Opera</span></a><br/>

							  <a href="//www.opera.com/help/mobile/android#privacy" target="_blank" style="text-decoration:underline;color:#000"><span>Opera Mobile</span></a>
							</p>
							<p>For other browsers, please consult the documentation that your browser manufacturer provides.</p>
							<p style="margin-bottom:6.0pt;"><strong>Turning off third party cookies
								<br>&nbsp;
							  </strong>You can turn off certain third party targeting/advertising cookies by visiting the following link:&nbsp;
							  <a href="//www.networkadvertising.org/choices/" target="_blank" style="text-decoration:underline;color:#000">Network Advertising Initiative</a>.
							</p>
							<h3><span>Other helpful resources</span><br/></h3>
							<p>
							<span>To learn more about advertisers’ use of cookies the following links may be helpful:</span><br/>
							  <a href="//www.youronlinechoices.eu/" target="_blank" style="text-decoration:underline;color:#000"><span>European Interactive Digital Advertising Alliance (EU)</span></a><br/>

							  <a href="//www.iab.net/" target="_blank" style="text-decoration:underline;color:#000"><span>Internet Advertising Bureau (US)</span></a><br/>

							  <a href="//www.iabeurope.eu/" target="_blank" style="text-decoration:underline;color:#000"><span>Internet Advertising Bureau (EU)</span></a>
							</p>
							<p style="margin-top:6.0pt;margin-right:0in;margin-bottom:.0001pt;margin-left:0in;text-align:justify;"><strong>Turning off cookies on a mobile device</strong></h3>
							<p>You can-opt out of certain types of interest-based advertising, by accessing the “settings” on your device:</p>
							<ul style="list-style-type: disc;margin-left:undefined;">
							  <li><strong><span>If you're using an Apple device</span></strong><span>&nbsp;you can configure your device to limit ad tracking to by clicking on "settings" &gt; "privacy" &gt; "advertising" and toggling "limit ad tracking" to ‘on.’</span></strong></li>
							  <li><strong><span>If you're using an Android device</span></strong><span>&nbsp;you can opt out of most app-based tracking for advertising by opening the "Google Settings" app on your device, selecting "Ads", and then selecting the option to opt-out of interest-based ads.</span></strong></li>
							</ul>
							<p>Please note that the above information may change when manufacturers update their systems. Also note, that your device may use another platform, not described above. In that case, please consult the manufacturer documentation for further instructions.</p>
							
							<h3 id="WitWhom"><span>WITH WHOM DO WE SHARE YOUR PERSONAL DATA?</span></h3>
							<ul>
							  <li><strong><span>Internal concerned parties</span></strong><span>&nbsp;- we may share your information with other</span><span style="color:windowtext;">&nbsp;</span><span>government ministries, as well as our employees, as needed to provide our Services.</span></li>
							  <li><strong><span>Business partners</span></strong><span>&nbsp;- we may share your information with business partners such as storage and analytics providers who help us provide you with our Services. These third parties may have access to your Personal Data so that they may perform these tasks on our behalf, but they are obligated to comply with the highest security standards and applicable data protection legislation, and may not use your Personal Data for any other purpose.</span></li>
							  <li><strong><span>Compliance with laws and law enforcement entities</span></strong><span>&nbsp;- we cooperate with other governmental agencies and law enforcement officials to enforce and comply with the law. We will disclose Personal Data about you to government or law enforcement officials or private parties if we, in our sole discretion, believe necessary or appropriate to respond to claims and legal process (including but not limited to subpoenas), to protect our or a third party's property and rights, to protect the safety of the public or any person, or to prevent or stop any activity we may consider to be, or to pose a risk of being, illegal, unethical, inappropriate or legally actionable.&nbsp;</span></li>
							</ul>
							
							<h3 id="HowWeProtect"><span>HOW WE PROTECT YOUR INFORMATION</span></h3>
							<p><span>We have implemented administrative, technical, and physical safeguards to help prevent unauthorized access, use, or disclosure of your Personal Data. Your data is stored on secure servers and isn’t publicly available. We limit access of your information only to those employees or partners on a “need to know” basis, in order to enable the carrying out of the agreement between us.&nbsp;</span></p>
							<p><span>While we seek to protect your information to ensure that it is kept confidential, we cannot absolutely guarantee its security. You should be aware that there is always some risk involved in transmitting information over the internet. While we strive to protect your Personal Data, we cannot ensure or warrant the security and privacy of your Personal Data or other content you transmit using the Service, and you do so at your own risk.&nbsp;</span></p>
							
							<h3 id="Retention"><span>RETENTION</span></h3>
							<p><span>We will retain your Personal Data for as long as necessary to provide our Services, and as necessary to comply with our legal obligations, resolve disputes, and enforce our policies. Retention periods will be determined taking into account the type of information that is collected and the purpose for which it is collected, bearing in mind the requirements applicable to the situation and the need to destroy outdated, unused information at the earliest reasonable time. Under applicable regulations, we will keep records containing Personal Data, communications and anything else as required by applicable laws and regulations.&nbsp;</span></p>
							
							<h3  id="UserRigths"><span>USER RIGHTS</span></h3>
							<h4><strong><span style="font-family:&quot;Calibri&quot;,sans-serif;color:windowtext;font-style:normal;">EU User Rights</span></strong></h4>
							<p><span>As an EU resident, you may request to:&nbsp;</span></p>
							<ol start="1" style="list-style-type: lower-alpha;margin-left: 0px;">
							  <li><span>Receive confirmation as to whether or not Personal Data concerning you is being processed, and access your stored Personal Data, together with supplementary information.&nbsp;</span></li>
							  <li><span>Receive a copy of Personal Data you directly volunteer to us in a structured, commonly used and machine-readable format.&nbsp;</span></li>
							  <li><span>Request rectification of your Personal Data that is in our control.</span></li>
							  <li><span>Request erasure of your Personal Data.&nbsp;</span></li>
							  <li><span>Object to the processing of Personal Data by us.&nbsp;</span></li>
							  <li><span>Request to restrict processing of your Personal Data by us.</span></li>
							  <li><span>Lodge a complaint with a supervisory authority.</span></li>
							</ol>
							<p><span>Please note that these rights pertain to EU residents only, are not absolute, and may be subject to our own legitimate interests and regulatory requirements.&nbsp;</span></p>
							<p><span>Users Outside the EU -&nbsp;</span></strong><span>Some of the aforementioned rights are applicable in certain jurisdictions outside the EU as well. Users residing outside the EU are welcome to contact us for any questions or requests by using the details provided below.</span></p>
							
							<h3 id="Transfer"><span>TRANSFER OF DATA OUTSIDE THE EEA</span><span>&nbsp;</span></h3>
							<p><span>If you reside in the European Union ("<strong>EU</strong>"), please note that some data recipients may be located outside the EEA. In such cases we will transfer your data only to such countries as approved by the European Commission as providing adequate level of data protection, or enter into legal agreements ensuring an adequate level of data protection.</span></p>
							
							<h3 id="OurPolicy"><span>OUR POLICY TOWARD CHILDREN</span></h3>
							<p>We do not knowingly collect or solicit personal information from anyone under 18 years of age, (or the age of consent as determined under the applicable laws where the individual resides; “<strong>Age of Consent</strong>”). By accessing, using or interacting with our Services, you certify to us that you are not under the Age of Consent. In the event that we learn that we have collected personal information from an individual under the Age of Consent without verification of parental consent, we will delete that information upon discovery. If you believe that we might have any information from or about an individual under the Age of Consent, then please contact us through the contact details available below.</p>
							
							<h3 id="HowToContactUs"><span>HOW TO CONTACT US?</span></h3>
							<p><span>If you wish to exercise any of the aforementioned rights, or receive more information, please contact us using the details below:</span><br/>Email:<a href="mailto:Dpo@tourism.gov.il" style="text-decoration:underline;color:#000"> Dpo@tourism.gov.il</a>
							</p>
							
							<h3 id="Updates"><span>UPDATES TO THIS POLICY</span></h3>
							<p>This Privacy Policy is subject to changes from time to time, in our sole discretion. The most current version will always be posted on our Services (as reflected in the "Last Updated" heading). You are advised to check for updates regularly. By continuing to access or use our Services after any revisions become effective, you agree to be bound by the updated Privacy Policy.&nbsp;</p>

						   
							`,
      };
    },
  },

  {
    id: "Destination_For_All",
    ctg: "TouristInfo",
    bgImage: "/posts/bank/plan-your-trip/1.jpg",
    mobBgImage: "/posts/bank/plan-your-trip/M.jpg",
    isVid: true,
    vidId: "QWA7qwsbbGY",
    title: "UNE DESTINATION POUR TOUS",
    smltitle: "",
    html: function() {
      return {
        __html: `
		
		
					<p>Le nombre de visiteurs en Israël connaît une croissance sans précédent. Les touristes du monde entier sont de plus en plus nombreux à réaliser leur rêve : découvrir Israël. Le ministère du tourisme s'est engagé à permettre à tous ceux qui le souhaitent, de fouler le sol de la Terre promise, quelle que soit leur éventuelle déficience.</p>
<p>En matière d'accessibilité, Israël est un leader mondial en termes de législation. De l'infrastructure au service, le pays s'adapte pour permettre un séjour agréable et accueillant.</p>
<p>Vous trouverez ci-dessous les liens vers les prestataires qui pourront vous aider et vous assurer un séjour harmonieux, sans le moindre obstacle.</p>
<div class="img-wrapper">
					   <img src=${getImgUrl() +
               "/posts/destination-for-all/1.jpg"} class="img-responsive">
					</div><br>
					<h2 class="ac-margin-bottom-20">ONG et voyages</h2>
					<p><b>Keren Kayemeth LeIsrael (KKL, Fonds national juif)</b></p>
					<p><u>Forêt, parcs et sites accessibles en Israël</u><br/>
					Ces dernières années, le KKL s'est efforcé d’installer des équipements adaptés aux personnes à mobilité réduite dans ses forêts et ses parcs. Notre objectif est d'ouvrir la nature à tous les secteurs de la population, en créant un environnement dans lequel les personnes à mobilité réduite peuvent se déplacer en tout confort et toute sécurité. Nous avons également fait un pas en avant et introduit la nature à l'école avec la mise en place de projets uniques dans les établissements d'éducation spécialisée.
					<a href="//www.kkl-jnf.org/tourism-and-recreation/accessible-forests-parks-sites-israel/" target="_blank"> www.kkl-jnf.org</a>
				   </p>
		
				   <p><b>L’Autorité israélienne de la nature et des parcs</b></p>
				   <p>Ces dernières années, l'Autorité de la nature et des parcs a entrepris de rendre ses sites accessibles aux personnes handicapées. Dans tous les parcs nationaux, réserves naturelles, sites d'antiquités et sites patrimoniaux, des travaux sont en cours pour améliorer l'accessibilité et proposer des solutions d’aide à l'accès.<br/>
L’organisme met tout en œuvre pour augmenter le nombre de visiteurs à mobilité réduite qui peuvent profiter de ses sites et de leurs activités.<br/>


					Pour obtenir de plus amples informations et consulter nos cartes, rendez-vous sur notre site Internet :<a href="https://www.parks.org.il/en/accessibility/" target="_blank">www.parks.org.il</a></p>
					 
					<div class="img-wrapper">
					<img src=${getImgUrl() +
            "/posts/destination-for-all/2.jpg"} class="img-responsive">
				 </div><br>
					 <p><b>Yad Sarah pour les Touristes</b></p>
					 <p>Voyager à l'étranger présente des défis particuliers pour les personnes à besoins spécifiques. Yad Sarah pour les Touristes propose une assistance qui garantira des vacances agréables et relaxantes à toute personne à besoins spécifiques et à sa famille. Une fois les réservations finalisées avec l'office du tourisme, le visiteur pourra se détendre, sachant que tous les arrangements seront alors entre les mains compétentes d'un représentant de Yad Sarah.</p>
				   
						<p> <u>Parmi les services disponibles</u>:<br/>
						 
						• Prêt de matériel médical. Possibilité de livraison à l'hôtel ou au lieu de résidence pour une somme symbolique.<br/>
• Equipement de votre chambre d'hôtel pour rendre votre séjour plus confortable, y compris lits ou chaises adaptés, etc.<br/>
• Prêt de bouteilles à oxygène / concentrateurs d'oxygène.<br/>
• Transport dans des fourgonnettes avec système de retenue pour fauteuils roulants, y compris les transferts depuis et vers l'aéroport et les visites touristiques.<br/>
• Recommandation de guides touristiques spécialisés dans l'accompagnement de touristes à mobilité réduite et à besoins spécifiques, et conseils sur les sites touristiques faciles d'accès.<br/>

						<br/>
						 Le service personnalisé de Yad Sarah est disponible, sur arrangement préalable avec l’office du tourisme, pour tout visiteur à besoins spécifiques.<br/>
				
		
				 <br/>
		
					Le service est disponible dans tout Israël.<br/>
                    Pour plus de détails, ou pour organiser un transport ou une visite, veuillez contacter l’office du tourisme au +972-2-6444382 ou par mail :  <a href="tel:+97226444382">+972-2-6444382</a> or e-mail us: <a href="mailto:chaimvi@yadsarah.org.il">chaimvi@yadsarah.org.il</a></p>
					<div class="img-wrapper">
					<img src=${getImgUrl() +
            "/posts/destination-for-all/3.jpg"} class="img-responsive">
				 </div><br>
					<p><b>Access Israel</b></p>
					<p>Access Israel est une organisation à but non lucratif qui encourage l'accessibilité et l'inclusion des personnes handicapées et des personnes âgées dans tous les secteurs de la vie. Access Israel a vu le jour en 1999 sous l’impulsion de Youval Wagner, ancien pilote d'hélicoptère qui s'est retrouvé en fauteuil roulant à la suite d'un accident d'hélicoptère. L’association mène divers projets pour parvenir à une société pleinement accessible et inclusive, y compris des efforts de sensibilisation dans les écoles, conseils en accessibilité pour les entreprises, cours d'accessibilité, cours de langue des signes, conférences sur divers sujets et plus encore. De plus, Access Israel travaille à ancrer l'accessibilité dans la loi israélienne, gère un centre de plaintes en matière d'accessibilité et organise des événements de sensibilisation pour le public. L’organisme promeut l'accessibilité et l'inclusion dans tous les domaines de la vie et en matière d'éducation, de tourisme, de culture, de situations d'urgence et plus encore. 
						<a href="https://www.aisrael.org/?CategoryID=3030" target="_blank">Le tourisme accessible sur le site Internet d'Access Israel</a></p>
		
						<p><u>LOTEM</u>est la plus grande organisation d’Israël en matière d’activités d'apprentissage en extérieur pour les enfants à besoins spécifiques. Elle propose des activités éducatives de plein air ainsi que des randonnées accessibles. Surin Hershko, un héros de guerre gravement blessé lors de l'opération Entebbe en 1976, est le fondateur et président de LOTEM. Son inspiration vient du cœur : « Accorder aux enfants le droit fondamental de vivre leur vie en plein air constitue mon objectif, et cela me remplit de joie ». Le site principal, Emek HaShalom (La vallée de la Paix), est une ferme de 16 hectares située dans le nord d'Israël, près de Yokneam. Nichée au cœur d'une magnifique vallée, elle a pour environnement immédiat une nature florissante et le ruissellement paisible de l'eau. Elle offre une expérience d'apprentissage de terrain avec un jardin éducatif, des pressoirs à olive et à vin, ainsi qu’une boulangerie et des sentiers de randonnées, le tout, accessible en fauteuil roulant.</p>
						<p><u>LOTEM</u> a bien conscience du rôle vital que le plein air joue dans la vie des Israéliens, et l'impact incommensurable que peut avoir le fait de rendre la société accessible, non seulement sur l'individu à besoins spécifiques, mais aussi sur sa famille et l’ensemble de la communauté. Dans le cadre de son travail pour s’assurer qu'aucun membre de la société ne soit laissé pour compte, LOTEM donne la possibilité aux enfants et adultes à besoins spécifiques d'apprendre et de participer à des activités de plein air dans tout le pays. 
						<a href="https://www.lotem.net/?page_id=386" target="_blank">www.lotem.net</a></p>
		
						<h2 class="ac-margin-bottom-20 ac-margin-top-20"> Transport</h2>
						<p><b>L’Autorité aéroportuaire d'Israël</b></p>
						<p>Selon la loi, l'Autorité aéroportuaire d'Israël est chargée de fournir l'infrastructure physique pour l'activité des entreprises de services aux passagers assistés. Cependant, selon la réglementation des transports, la responsabilité de la prise en charge des passagers assistés et de leurs bagages, dès leur entrée dans l'aérogare ou leur débarquement de l'avion, incombe à la compagnie aérienne qui assure leur transport. Actuellement, à l'aéroport Ben Gourion, le service aux passagers assistés est assuré par des sociétés d'assistance au sol. Le service comprend l'accompagnement et l’aide des passagers handicapés lors des procédures d’embarquement et de débarquement. 
						<a href="https://www.iaa.gov.il/en-us/airports/bengurion/pages/accessibility.aspx" target="_blank">www.iaa.gov.il</a></p>
						<p><b>Voici les sociétés d'assistance au sol: </b></p>
						<pAero Handling: <a href="//www.aerohandling.com/" target="_blank">www.aerohandling.com</a><br/>
						Laufer Aviation: GHI <a href="//lauferghi.com/" target="_blank">www.lauferghi.com</a><br/>
						QAS: <a href="//www.qasisrael.co.il" target="_blank">www.qasisrael.co.il</a><br/>
		
		
						</p>
						<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/destination-for-all/4.jpg"} class="img-responsive">
					 </div><br>
		
						<p>Ministry of Transportation help line (local call) <a href="tel:5678*">5678*</a></p>
						
						<p><b>PTransport public</b></p>
						<p>Trains - Si vous avez besoin de l'aide d'un membre du personnel de la gare pour embarquer ou descendre du train, veuillez coordonner votre trajet à l'avance avec ‘Israel Railways’, les chemins de fer israéliens, via leur site Internet ou leur hotline au <a href="tel:*5770">*5770</a>.</p>
						 
						<p><u>'Israel Railways'</u> fera de son mieux pour vous offrir le meilleur service possible, même si vous n'avez pas planifié votre voyage à l'avance.</p>
						<p>Dans tous les cas, veuillez coordonner à l’avance tout trajet prévu entre 20h et 6h, ou le samedi soir.</p>
						<p><u>Bus</u> - Toutes les lignes de bus interurbaines sont adaptées pour accueillir tous les voyageurs. Les bus intra-urbains sont partiellement accessibles. </p>
						<p><u>Taxis</u> - Il est rare de pouvoir héler un taxi accessible dans la rue. Il est recommandé de le commander à l’avance à partir de cette liste. <a href="https://www.aisrael.org/?CategoryID=2657&ArticleID=64179" target="_blank">https://www.aisrael.org/?CategoryID=2657&ArticleID=64179</a>.</p>
		
		
						<h2  class="ac-margin-bottom-20 ac-margin-top-20">Hébergement</h2>
						<p>A partir de 7 chambres ou plus, tous les types d'hébergement en Israël sont tenus par la loi de proposer au moins 1 chambre accessible. A partir de 25 employés, tous les prestataires de services doivent compter dans leurs équipes un superviseur en matière d’accessibilité. Grâce à ces lois, il n'existe pas d’endroit en Israël sans une solution d'hébergement parfaitement adaptée. Une courte coordination de vos attentes par mail, avant votre départ, est toutefois toujours recommandée.</p>
						<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/destination-for-all/5.jpg"} class="img-responsive">
					 </div><br>
						
						
						<div id="ac-left-nav">
						<h2 class="ac-margin-bottom-20 pr-fs-28 chapter-title inline-block">
											<!-- ngIf: Guide.ShowChaptersIndex -->
											<span class="ng-binding">Accessibility for those with special needs at the beaches:</span>
										</h2>
						<ul id="chaptersList" class="list-unstyled xs-mb-0">
							
								<!-- ngRepeat: chapter in Guide.Chapters -->
								<li data-show="1" class="ac-active ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope light-gray-e7-background blue-border-right-5px" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0">
									<!-- ngIf: Guide.ShowChaptersIndex -->
									<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt nounderline  ng-binding reforma-bold">Northern District</span>						                  
									<img src="${getImgUrl() +
                    "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
								
								</li><!-- end ngRepeat: chapter in Guide.Chapters -->
								<li data-show="2" class="ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0" >
									<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt reforma nounderline  ng-binding">Haifa District</span>
									<img src="${getImgUrl() +
                    "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
								</li><!-- end ngRepeat: chapter in Guide.Chapters -->
								<li data-show="3" class="ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0" >
									<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt reforma nounderline  ng-binding">Central District</span>
									<img src="${getImgUrl() +
                    "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
							
								</li><!-- end ngRepeat: chapter in Guide.Chapters -->
								<div class="clear show-on-mobile"></div>
								<li data-show="4" class="ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0" >
									<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt reforma nounderline  ng-binding">Tel Aviv District</span>
									<img src="${getImgUrl() +
                    "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
							
								</li>
								<!-- end ngRepeat: chapter in Guide.Chapters --><li data-show="5" class="ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope" ng-repeat="chapter in Guide.Chapters" ng-class="getDecorationForLi($index)" ng-click="openChapterMenu(false,$index);updateChapterIndex($index);" role="button" tabindex="0" >
									<span ng-class="CurrChapterindex == ($index) ? 'reforma-bold ': ''" class="blue-txt description-txt reforma nounderline  ng-binding">Southern District</span>
									<img src="${getImgUrl() +
                    "/a-down.png"}" class="img-responsive a-arrow-img" alt="">
							
								</li><!-- end ngRepeat: chapter in Guide.Chapters -->
								<div class="clear"></div>
							</ul>
						</div>
		
						<div id="res">
							<!-- ac part -->
							<div class="ac-part ac-part-1 ac-part-active">
		
								<div ng-include="chapterItem" class="row row-gov ng-scope">
									<!-- Sub Title -->
									<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
										<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
											<!-- ngIf: Guide.ShowChaptersIndex -->
											<span class="ng-binding">Northern District</span>
										</h2>
									</div>
		
									<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
										<!-- IMAGE TAG  ------->
										<!--- Image-->
		
								<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
									<div class="position-relative col-lg-10 lg-p-0">
										<!-- ngIf: CurrChapter.Image.ClickURLRef -->
		
										<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
										</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
										<!--Image desc-->
										<div>
											<div class="position-absolute">
												<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
											</div>
											<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
												<span class="small-txt ng-binding"></span>
												<span class="small-txt ng-binding"></span>
											</div><!-- end ngIf: CurrChapter.Image -->
										</div>
									</div>
								</div><!-- end ngIf: CurrChapter.Image -->
															<!-- End IMAGE TAG  ------->
		
															<div class="row row-gov no-gutters">
																<!--Content Text-->
																<div id="GuidesChapterContent-1" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
									<tbody>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Kineret Municipal Unio</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking&nbsp;&nbsp; &nbsp;</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Tzinbari</td>
											<td>Yes&nbsp;&nbsp; &nbsp;</td>
											<td>Yes&nbsp;&nbsp; &nbsp;</td>
											<td>No</td>
											<td>No</td>
											<td>Yes&nbsp;&nbsp; &nbsp;</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Berniki</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>At the nearby Shikmim beach</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Shikmim</td>
											<td>Yes&nbsp;&nbsp; &nbsp;</td>
											<td>Yes&nbsp;&nbsp; &nbsp;</td>
											<td>Yes&nbsp;&nbsp; &nbsp;</td>
											<td>Yes&nbsp;&nbsp; &nbsp;</td>
											<td>Yes&nbsp;&nbsp; &nbsp;</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Hukok</td>
											<td>Yes&nbsp;&nbsp; &nbsp;</td>
											<td>Yes&nbsp;&nbsp; &nbsp;</td>
											<td>No</td>
											<td>No</td>
											<td>Yes&nbsp;&nbsp; &nbsp;</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Amnon</td>
											<td>Yes&nbsp;</td>
											<td>Yes&nbsp;&nbsp; &nbsp;</td>
											<td>No</td>
											<td>No</td>
											<td>Yes&nbsp;&nbsp; &nbsp;</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Kinar</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Doga</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>Closed</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Tze’elon</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Kursi</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>At the nearby Levanon beach</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Levanon</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Halukim</td>
											<td>At the nearby Levanon beach</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>At the nearby Levanon beach</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Shizaf</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Dugit – Golan</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Gofra</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Municipality of Tiberias</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Guy</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Galei Kineret - Rimonim</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Leonardo Pacific</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>&nbsp;</td>
											<td>Closed for renovations</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Coco Hot / Holiday Inn</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Jordan Valley Regional Council</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Ein Gev Vacation</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Ginnosar</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Migdal Regional Council</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Restal Magdala</td>
											<td>Yes</td>
											<td>No</td>
											<td>&nbsp;</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td class="rtecenter" colspan="6"><strong>Mateh Asher Regional Council</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Banana Beach Achziv</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Municipality of Nahariya</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Sokolov</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Galil Central</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Municipality of Acco</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Argaman Central</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Hatmarim</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
										</tr>
									</tbody>
								</table></div></div>
		
								<p>&nbsp;</p>
								</div>
		
																<!--Chapters/Collapse-->
																<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
																	<!-- ngRepeat: collapse in CurrChapter.Collapses -->
																</div>
		
																<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
																<!--End of Chapters/Collapse-->
		
																<div class="col-12 xs-mb-25 lg-mb-30">
																	<!-- Files for Download-->
																	<!-- Files for Download-->
								<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->
		
																	<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">
		
																		<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
																			<!-- horizontal line -->
																			<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
																				<div class="horizontal-line"></div>
																			</div>
																		</div><!-- end ngIf: Guide.Chapters.length > 1 -->
		
																		<!--arrows subject nav  דפדוף-->
																		<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
																			<!--  לדף הקודם -->
																			<!-- ngIf: CurrChapterindex > 0 -->
		
																			<!--  לדף הבא -->
																			<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="false">
																				<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
																					<span class="small-txt gray-txt width-100">Next page:</span>
																					<span class="reforma description-txt blue-txt width-100 ng-binding">Haifa District</span>
																				</div>
																				<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
																			</div>
																		</div>
																	</div><!-- end ngIf: !isOnPrintMode -->
																</div>
															</div>
														</div>
													</div>
		
							</div>
							<!-- ac- part -->
		
							<!-- ac part 2 -->
							<div class="ac-part ac-part-2">
							<div ng-include="chapterItem" class="row row-gov ng-scope">
							<!-- Sub Title -->
							<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
								<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
									<!-- ngIf: Guide.ShowChaptersIndex -->
									<span class="ng-binding">Haifa District</span>
								</h2>
							</div>
		
							<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
								<!-- IMAGE TAG  ------->
								<!--- Image-->
		
		<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
		<div class="position-relative col-lg-10 lg-p-0">
			<!-- ngIf: CurrChapter.Image.ClickURLRef -->
		
			<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
			</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
			<!--Image desc-->
			<div>
				<div class="position-absolute">
					<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
				</div>
				<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
					<span class="small-txt ng-binding"></span>
					<span class="small-txt ng-binding"></span>
				</div><!-- end ngIf: CurrChapter.Image -->
			</div>
		</div>
		</div><!-- end ngIf: CurrChapter.Image -->
								<!-- End IMAGE TAG  ------->
		
								<div class="row row-gov no-gutters">
									<!--Content Text-->
									<div id="GuidesChapterContent-2" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table align="left" cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
		<tbody>
			<tr style="background-color: rgb(255, 255, 255);">
				<td class="rtecenter" colspan="6"><strong>Municipality of Kiryat Yam</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Zevulun</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td class="rtecenter" colspan="6"><strong>Municipality of Haifa</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Zamir 1</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Zamir 2</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Neot Kiryat Haim Central</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Bat Galim 1</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Bat Galim 2</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td class="rtecenter" colspan="6"><strong>Hof Hacarmel Regional Council</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Dor Central 2</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
				<td>No</td>
				<td>Yes</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Neve Yam</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
				<td>No</td>
				<td>Yes</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Aqueduct</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
				<td>No</td>
				<td>Yes</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td class="rtecenter" colspan="6"><strong>Jisr a-Zarka Regional Council</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Jisr</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td class="rtecenter" colspan="6"><strong>Municipality of Hadera</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Kfar Yam&nbsp;</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Olga Central 2</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
		</tbody>
		</table></div></div>
		
		<p>&nbsp;</p>
		</div>
		
									<!--Chapters/Collapse-->
									<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
										<!-- ngRepeat: collapse in CurrChapter.Collapses -->
									</div>
		
									<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
									<!--End of Chapters/Collapse-->
		
									<div class="col-12 xs-mb-25 lg-mb-30">
										<!-- Files for Download-->
										<!-- Files for Download-->
		<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->
		
										<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">
		
											<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
												<!-- horizontal line -->
												<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
													<div class="horizontal-line"></div>
												</div>
											</div><!-- end ngIf: Guide.Chapters.length > 1 -->
		
											<!--arrows subject nav  דפדוף-->
											<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
												<!--  לדף הקודם -->
												<!-- ngIf: CurrChapterindex > 0 --><div ng-if="CurrChapterindex > 0" class="col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope" ng-click="updateChapterIndex(CurrChapterindex - 1)" role="button" tabindex="0">
													<i class="icon-arrow-right toflipInEng h3 blue-txt" aria-hidden="true"></i>
													<div class="xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100">
														<span class="small-txt gray-txt width-100"> Previous page:</span>
														<span class="reforma description-txt blue-txt width-100 ng-binding">Northern District</span>
													</div>
												</div><!-- end ngIf: CurrChapterindex > 0 -->
		
												<!--  לדף הבא -->
												<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="false">
													<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
														<span class="small-txt gray-txt width-100">Next page:</span>
														<span class="reforma description-txt blue-txt width-100 ng-binding">Central District</span>
													</div>
													<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
												</div>
											</div>
										</div><!-- end ngIf: !isOnPrintMode -->
									</div>
								</div>
							</div>
						</div>
							</div>
							<!-- end ac part-2 -->
		
							<!-- ac-part-3 -->
							<div class="ac-part ac-part-3">
														<div ng-include="chapterItem" class="row row-gov ng-scope">
														<!-- Sub Title -->
														<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
															<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
																<!-- ngIf: Guide.ShowChaptersIndex -->
																<span class="ng-binding">Central District</span>
															</h2>
														</div>
								
														<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
															<!-- IMAGE TAG  ------->
															<!--- Image-->
								
								<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
									<div class="position-relative col-lg-10 lg-p-0">
										<!-- ngIf: CurrChapter.Image.ClickURLRef -->
								
										<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
										</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
										<!--Image desc-->
										<div>
											<div class="position-absolute">
												<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
											</div>
											<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
												<span class="small-txt ng-binding"></span>
												<span class="small-txt ng-binding"></span>
											</div><!-- end ngIf: CurrChapter.Image -->
										</div>
									</div>
								</div><!-- end ngIf: CurrChapter.Image -->
															<!-- End IMAGE TAG  ------->
								
															<div class="row row-gov no-gutters">
																<!--Content Text-->
																<div id="GuidesChapterContent-3" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
									<tbody>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Emek Hefer Regional Council</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Michmoret – Station number 1</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Michmoret – Station number 2</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>Joint with number 1</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Beit Yannai</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>NeUrim Beach</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Municipality of Netanya</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Kiryat Tzanz</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>HaOnot Beach</td>
											<td>Parking</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Ampi Beach</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Herzl</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>No</td>
											<td>Yes</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Sironit Beach A</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Sironit Beach B</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>Yes</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Argaman Beach</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Poleg Beach</td>
											<td>Yes</td>
											<td>Bathrooms only</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td class="rtecenter" colspan="6"><strong>Hof Hasharon Regional Council</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Shefayim (Ga’ash)</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td class="rtecenter" colspan="6"><strong>Municipality of Rishon Le-Zion</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Beach number 1 – Hakachol (Blue) Beach</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Beach number 2 – Neve Hof Beach</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>Yes</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Beach number 3 – Hofit Beach</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Beach number 4 – Tel Yonah Beach</td>
											<td>No</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Beach number 5 – Hayeladim (Children’s) Beach</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td>Beach number 6 – separate beach</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td class="rtecenter" colspan="6"><strong>Gan Raveh Regional Council</strong></td>
										</tr>
										<tr style="background-color: rgb(255, 255, 255);">
											<td><strong>Name of beach</strong></td>
											<td><strong>Parking</strong></td>
											<td><strong>Bathrooms and showers</strong></td>
											<td><strong>Access to shade</strong></td>
											<td><strong>Access to water</strong></td>
											<td><strong>Bathing chairs for the disabled</strong></td>
										</tr>
										<tr style="background-color: rgb(244, 244, 244);">
											<td>Palmahim Beach</td>
											<td>Yes</td>
											<td>Yes</td>
											<td>No</td>
											<td>No</td>
											<td>No</td>
										</tr>
									</tbody>
								</table></div></div>
								
								<p>&nbsp;</p>
								</div>
								
																<!--Chapters/Collapse-->
																<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
																	<!-- ngRepeat: collapse in CurrChapter.Collapses -->
																</div>
								
																<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
																<!--End of Chapters/Collapse-->
								
																<div class="col-12 xs-mb-25 lg-mb-30">
																	<!-- Files for Download-->
																	<!-- Files for Download-->
								<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->
								
																	<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">
								
																		<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
																			<!-- horizontal line -->
																			<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
																				<div class="horizontal-line"></div>
																			</div>
																		</div><!-- end ngIf: Guide.Chapters.length > 1 -->
								
																		<!--arrows subject nav  דפדוף-->
																		<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
																			<!--  לדף הקודם -->
																			<!-- ngIf: CurrChapterindex > 0 --><div ng-if="CurrChapterindex > 0" class="col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope" ng-click="updateChapterIndex(CurrChapterindex - 1)" role="button" tabindex="0">
																				<i class="icon-arrow-right toflipInEng h3 blue-txt" aria-hidden="true"></i>
																				<div class="xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100">
																					<span class="small-txt gray-txt width-100"> Previous page:</span>
																					<span class="reforma description-txt blue-txt width-100 ng-binding">Haifa District</span>
																				</div>
																			</div><!-- end ngIf: CurrChapterindex > 0 -->
								
																			<!--  לדף הבא -->
																			<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="false">
																				<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
																					<span class="small-txt gray-txt width-100">Next page:</span>
																					<span class="reforma description-txt blue-txt width-100 ng-binding">Tel Aviv District</span>
																				</div>
																				<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
																			</div>
																		</div>
																	</div><!-- end ngIf: !isOnPrintMode -->
																</div>
															</div>
														</div>
													</div>
							</div>
							<!-- end ac-part-3 -->
		
							<!-- ac-part-4 -->
							<div class="ac-part ac-part-4">
							<div ng-include="chapterItem" class="row row-gov ng-scope">
					<!-- Sub Title -->
					<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
						<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
							<!-- ngIf: Guide.ShowChaptersIndex -->
							<span class="ng-binding">Tel Aviv District</span>
						</h2>
					</div>
		
					<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
						<!-- IMAGE TAG  ------->
						<!--- Image-->
		
		<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
		<div class="position-relative col-lg-10 lg-p-0">
		<!-- ngIf: CurrChapter.Image.ClickURLRef -->
		
		<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
		</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
		<!--Image desc-->
		<div>
		<div class="position-absolute">
			<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
		</div>
		<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
			<span class="small-txt ng-binding"></span>
			<span class="small-txt ng-binding"></span>
		</div><!-- end ngIf: CurrChapter.Image -->
		</div>
		</div>
		</div><!-- end ngIf: CurrChapter.Image -->
						<!-- End IMAGE TAG  ------->
		
						<div class="row row-gov no-gutters">
							<!--Content Text-->
							<div id="GuidesChapterContent-4" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
		<tbody>
		<tr style="background-color: rgb(255, 255, 255);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Herzliya</strong></td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Nof Yam</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Hasharon&nbsp;&nbsp; &nbsp;Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Zevulun</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Acadia North Beach&nbsp;&nbsp; &nbsp;</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Acadia South Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>Yes</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Acadia South Beach – Disabled</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>Yes</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Separate beach</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Tel Aviv - Jaffa</strong></td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>HaTzuk Beach – Station number 1</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Tel Baruch Beach – Station number 1</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Nordau (Metzitzim) Beach</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Nordau separate beach</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>Yes</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Gordon</td>
		<td>No</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Bograshov</td>
		<td>No</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Allenby (Jerusalem)</td>
		<td>No</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Charles Clore</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Jaffa – Givat HaAliyah</td>
		<td>Yes</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Hilton North</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>HaTzuk Beach – Station number 2</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Frishman</td>
		<td>No</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Aviv Beach</td>
		<td>No</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>Yes</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td class="rtecenter" colspan="6"><strong>Municipality of Bat Yam</strong></td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td><strong>Name of beach</strong></td>
		<td><strong>Parking</strong></td>
		<td><strong>Bathrooms and showers</strong></td>
		<td><strong>Access to shade</strong></td>
		<td><strong>Access to water</strong></td>
		<td><strong>Bathing chairs for the disabled</strong></td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>HaSela – Station number 1</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>HaSela – Station number 2</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>HaSela – Station number 3</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Sample Beach</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Riviera</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(244, 244, 244);">
		<td>Separate beach</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		<tr style="background-color: rgb(255, 255, 255);">
		<td>Tayo</td>
		<td>Yes</td>
		<td>Bathrooms only</td>
		<td>No</td>
		<td>No</td>
		<td>No</td>
		</tr>
		</tbody>
		</table></div></div>
		
		<p>&nbsp;</p>
		</div>
		
							<!--Chapters/Collapse-->
							<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
								<!-- ngRepeat: collapse in CurrChapter.Collapses -->
							</div>
		
							<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
							<!--End of Chapters/Collapse-->
		
							<div class="col-12 xs-mb-25 lg-mb-30">
								<!-- Files for Download-->
								<!-- Files for Download-->
		<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->
		
								<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">
		
									<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
										<!-- horizontal line -->
										<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
											<div class="horizontal-line"></div>
										</div>
									</div><!-- end ngIf: Guide.Chapters.length > 1 -->
		
									<!--arrows subject nav  דפדוף-->
									<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
										<!--  לדף הקודם -->
										<!-- ngIf: CurrChapterindex > 0 --><div ng-if="CurrChapterindex > 0" class="col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope" ng-click="updateChapterIndex(CurrChapterindex - 1)" role="button" tabindex="0">
											<i class="icon-arrow-right toflipInEng h3 blue-txt" aria-hidden="true"></i>
											<div class="xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100">
												<span class="small-txt gray-txt width-100"> Previous page:</span>
												<span class="reforma description-txt blue-txt width-100 ng-binding">Central District</span>
											</div>
										</div><!-- end ngIf: CurrChapterindex > 0 -->
		
										<!--  לדף הבא -->
										<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="false">
											<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
												<span class="small-txt gray-txt width-100">Next page:</span>
												<span class="reforma description-txt blue-txt width-100 ng-binding">Southern District</span>
											</div>
											<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
										</div>
									</div>
								</div><!-- end ngIf: !isOnPrintMode -->
							</div>
						</div>
					</div>
				</div>
							</div>
							<!-- end ac-part-4 -->
		
							<!-- ac-part-5 -->
							<div class="ac-part ac-part-5">
							<div ng-include="chapterItem" class="row row-gov ng-scope">
							<!-- Sub Title -->
							<div class="col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope">
								<h2 class="h2 gray-txt pr-fs-28 chapter-title inline-block">
									<!-- ngIf: Guide.ShowChaptersIndex -->
									<span class="ng-binding">Southern District</span>
								</h2>
							</div>
		
							<div class="col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope">
								<!-- IMAGE TAG  ------->
								<!--- Image-->
		
		<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="row row-gov no-gutters ng-scope">
		<div class="position-relative col-lg-10 lg-p-0">
			<!-- ngIf: CurrChapter.Image.ClickURLRef -->
		
			<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if="!CurrChapter.Image.ClickURLRef" class="ng-scope">
			</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->
			<!--Image desc-->
			<div>
				<div class="position-absolute">
					<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->
				</div>
				<!-- ngIf: CurrChapter.Image --><div ng-if="CurrChapter.Image" class="xs-mb-10 ng-scope">
					<span class="small-txt ng-binding"></span>
					<span class="small-txt ng-binding"></span>
				</div><!-- end ngIf: CurrChapter.Image -->
			</div>
		</div>
		</div><!-- end ngIf: CurrChapter.Image -->
								<!-- End IMAGE TAG  ------->
		
								<div class="row row-gov no-gutters">
									<!--Content Text-->
									<div id="GuidesChapterContent-5" style="overflow: hidden;" ng-bind-html="CurrChapter.Content | to_trusted" fixed-tables="" class="xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding"><div class="table-responsive"><div><div class="changeWidth0" style="width: auto;"></div><table cellpadding="1" cellspacing="1" style="width: 100%;" class="table ui-responsive" data-mode="reflow" data-role="table">
		<tbody>
			<tr style="background-color: rgb(255, 255, 255);">
				<td class="rtecenter" colspan="6"><strong>Municipality of Ashdod</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Mei Ami Beach</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Lido</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>&nbsp;</td>
				<td>&nbsp;</td>
				<td>&nbsp;</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Oranim</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>No</td>
				<td>Yes</td>
				<td>Yes</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Hakshatot</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Separate beach</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Rova K</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Riviera</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td colspan="6" style="text-align: center;"><strong>Hof Ashkelon Regional Council</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Nitzanim</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Zikim</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td class="rtecenter" colspan="6"><strong>Municipality of Ashkelon</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Bar Kochva North</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Bar Kochva South</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Delila North</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Delila South</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Ashkelon National Park Beach</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Separate beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>לא</td>
				<td>לא</td>
				<td>לא</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td class="rtecenter" colspan="6"><strong>Tamar Regional Council</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Mazor Springs</td>
				<td>Yes</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Meridian Beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Hod Hotel Beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Tzel Harim</td>
				<td>Yes</td>
				<td>Under construction&nbsp;&nbsp; &nbsp;</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Crown Plaza Beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Lot</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Lot’s Wife</td>
				<td>Yes</td>
				<td>Under construction&nbsp;&nbsp; &nbsp;</td>
				<td>Under construction&nbsp;&nbsp; &nbsp;</td>
				<td>Under construction&nbsp;&nbsp; &nbsp;</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Ein Bokek South</td>
				<td>Yes</td>
				<td>Under construction&nbsp;&nbsp; &nbsp;</td>
				<td>Under construction&nbsp;&nbsp; &nbsp;</td>
				<td>Under construction&nbsp;&nbsp; &nbsp;</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Daniel Hotel Beach</td>
				<td>Yes</td>
				<td>Under construction&nbsp;&nbsp; &nbsp;</td>
				<td>Under construction&nbsp;&nbsp; &nbsp;</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Solarium Beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Isrotel Beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>International Beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Leonardo Plaza Beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Zohar Springs (North)</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td>Separate beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Leonardo Club Beach</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>Yes</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td class="rtecenter" colspan="6"><strong>Municipality of Eilat&nbsp;&nbsp; &nbsp;</strong></td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td><strong>Name of beach</strong></td>
				<td><strong>Parking</strong></td>
				<td><strong>Bathrooms and showers</strong></td>
				<td><strong>Access to shade</strong></td>
				<td><strong>Access to water</strong></td>
				<td><strong>Bathing chairs for the disabled</strong></td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td><br>
				Separate beach</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
				<td>No</td>
			</tr>
			<tr style="background-color: rgb(255, 255, 255);">
				<td>Herod’s beach</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
			</tr>
			<tr style="background-color: rgb(244, 244, 244);">
				<td><br>
				Northwestern Beach</td>
				<td>Yes</td>
				<td>Bathrooms only</td>
				<td>No</td>
				<td>No</td>
				<td>Yes</td>
			</tr>
		</tbody>
		</table></div></div>
		
		<p>&nbsp;</p>
		</div>
		
									<!--Chapters/Collapse-->
									<div class="col-12" id="accordion" role="tablist" aria-multiselectable="true">
										<!-- ngRepeat: collapse in CurrChapter.Collapses -->
									</div>
		
									<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->
									<!--End of Chapters/Collapse-->
		
									<div class="col-12 xs-mb-25 lg-mb-30">
										<!-- Files for Download-->
										<!-- Files for Download-->
		<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->
		
										<!-- ngIf: !isOnPrintMode --><div ng-if="!isOnPrintMode" class="ng-scope">
		
											<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if="Guide.Chapters.length > 1" class="ng-scope">
												<!-- horizontal line -->
												<div class="row row-gov xs-mb-25 lg-mb-30 xs-mb-25 ">
													<div class="horizontal-line"></div>
												</div>
											</div><!-- end ngIf: Guide.Chapters.length > 1 -->
		
											<!--arrows subject nav  דפדוף-->
											<div class="row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-start" ng-class="{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]">
												<!--  לדף הקודם -->
												<!-- ngIf: CurrChapterindex > 0 --><div ng-if="CurrChapterindex > 0" class="col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope" ng-click="updateChapterIndex(CurrChapterindex - 1)" role="button" tabindex="0">
													<i class="icon-arrow-right toflipInEng h3 blue-txt" aria-hidden="true"></i>
													<div class="xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100">
														<span class="small-txt gray-txt width-100"> Previous page:</span>
														<span class="reforma description-txt blue-txt width-100 ng-binding">Tel Aviv District</span>
													</div>
												</div><!-- end ngIf: CurrChapterindex > 0 -->
		
												<!--  לדף הבא -->
												<div ng-show="CurrChapterindex < lastIndex" class="col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer ng-hide" ng-click="updateChapterIndex(CurrChapterindex + 1)" role="button" tabindex="0" aria-hidden="true">
													<div class="guideBreakLine xs-ml-10 pull-left width-100 text-left height100">
														<span class="small-txt gray-txt width-100">Next page:</span>
														<span class="reforma description-txt blue-txt width-100 ng-binding"></span>
													</div>
													<i class="icon-arrow-left toflipInEng h3 blue-txt" aria-hidden="true"></i>
												</div>
											</div>
										</div><!-- end ngIf: !isOnPrintMode -->
									</div>
								</div>
							</div>
						</div>
							</div>
							<!-- end ac-part-5 -->
		
						</div>
						<div class="img-wrapper">
						<img src=${getImgUrl() +
              "/posts/destination-for-all/6.jpg"} class="img-responsive">
					 </div><br>
							
							`,
      };
    },
  },
];



// WEBPACK FOOTER //
// ./src/Posts/PostsData.js